
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kc6xi", function(module, exports) {
$parcel$export(module.exports, "Carousel", function () { return (parcelRequire("iL9dx")).Carousel; });
$parcel$export(module.exports, "VideoCarousel", function () { return (parcelRequire("g85aC")).VideoCarousel; });
parcelRequire("hJfqz");
parcelRequire("iL9dx");
parcelRequire("g85aC");

});
parcelRegister("hJfqz", function(module, exports) {
$parcel$export(module.exports, "ArrowButton", function () { return $5af61a161d3fd22c$export$15d663f77d176497; });
$parcel$export(module.exports, "PlayPauseButton", function () { return $5af61a161d3fd22c$export$e0201548afaa4886; });
/* carouselButtons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $du1ua = parcelRequire("du1ua");

var $dcl1M = parcelRequire("dcl1M");
const $5af61a161d3fd22c$var$iconButtonStyles = null;
const $5af61a161d3fd22c$export$15d663f77d176497 = ({ onClick: onClick, icon: icon, "aria-label": ariaLabel })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: onClick,
        "aria-label": ariaLabel,
        className: (0, $2jatx.default)([
            "_19it8cnq _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _1bah1h6o _80omtlke _4t3izwfg _1bsbzwfg"
        ]),
        children: icon
    });
};
const $5af61a161d3fd22c$export$e0201548afaa4886 = ({ onClick: onClick, isRotating: isRotating })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        onClick: onClick,
        className: (0, $2jatx.default)([
            "_19it8cnq _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _1bah1h6o _80omtlke _4t3izwfg _1bsbzwfg"
        ]),
        children: isRotating ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($du1ua))), {
            label: intl.formatMessage({
                id: "confluence.paid.lp.carousel.pause",
                defaultMessage: "Pause carousel"
            })
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dcl1M))), {
            label: intl.formatMessage({
                id: "confluence.paid.lp.carousel.play",
                defaultMessage: "Play carousel"
            })
        })
    });
};

});
parcelRegister("du1ua", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9dac8ccc4d1b894102a944d61ac4f665>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d0f3ab364c7e6c4$var$_react = $9d0f3ab364c7e6c4$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9d0f3ab364c7e6c4$var$_baseNew = $9d0f3ab364c7e6c4$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $9d0f3ab364c7e6c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPause".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pause video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9d0f3ab364c7e6c4$var$VideoPauseIcon = (props)=>/*#__PURE__*/ $9d0f3ab364c7e6c4$var$_react.default.createElement($9d0f3ab364c7e6c4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$9d0f3ab364c7e6c4$var$VideoPauseIcon.displayName = 'VideoPauseIcon';
var $9d0f3ab364c7e6c4$var$_default = module.exports.default = $9d0f3ab364c7e6c4$var$VideoPauseIcon;

});

parcelRegister("dcl1M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92409a0bcef1d03143cf6035c99e88da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99bcb506388daa58$var$_react = $99bcb506388daa58$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $99bcb506388daa58$var$_baseNew = $99bcb506388daa58$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $99bcb506388daa58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for play video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $99bcb506388daa58$var$VideoPlayIcon = (props)=>/*#__PURE__*/ $99bcb506388daa58$var$_react.default.createElement($99bcb506388daa58$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.112C2 1.592 3.63.627 4.963 1.36l8.902 4.888c1.383.76 1.383 2.747 0 3.506l-8.902 4.888C3.63 15.373 2 14.408 2 12.888zm2.24-.438a.5.5 0 0 0-.74.438v9.776a.5.5 0 0 0 .74.438l8.903-4.888a.5.5 0 0 0 0-.876z" clip-rule="evenodd"/>`
    }, props));
$99bcb506388daa58$var$VideoPlayIcon.displayName = 'VideoPlayIcon';
var $99bcb506388daa58$var$_default = module.exports.default = $99bcb506388daa58$var$VideoPlayIcon;

});


parcelRegister("iL9dx", function(module, exports) {
$parcel$export(module.exports, "Carousel", function () { return $7acb0827f4cf9b6c$export$144901db2ea8e967; });
/* carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $7IesZ = parcelRequire("7IesZ");

var $9BG80 = parcelRequire("9BG80");

var $jtmAK = parcelRequire("jtmAK");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $hJfqz = parcelRequire("hJfqz");
const $7acb0827f4cf9b6c$var$carouselSlideStyle = null;
const $7acb0827f4cf9b6c$var$imageStyle = null;
const $7acb0827f4cf9b6c$var$infoContainerStyle = null;
const $7acb0827f4cf9b6c$var$textContainerStyle = null;
const $7acb0827f4cf9b6c$var$primaryTextStyle = null;
const $7acb0827f4cf9b6c$var$subTextStyle = null;
const $7acb0827f4cf9b6c$var$anchorPrimaryTextStyle = null;
const $7acb0827f4cf9b6c$var$anchorSubTextStyle = null;
const $7acb0827f4cf9b6c$var$plainImageContainer = null;
const $7acb0827f4cf9b6c$export$cabb5ccfbd60cbd4 = ({ primaryText: primaryText, description: description, imgSrc: imgSrc, imgAltText: imgAltText, id: id, stylingType: stylingType, usePlainContainer: usePlainContainer })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        role: "tabpanel",
        id: id,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz"
        ]),
        children: [
            stylingType === "anchor" ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                image: {
                    src: imgSrc,
                    alt: ""
                },
                className: (0, $2jatx.default)([
                    "_1bsb1osq"
                ])
            }) : usePlainContainer ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                    src: imgSrc,
                    alt: imgAltText,
                    className: (0, $2jatx.default)([
                        "_1bsb1osq"
                    ])
                })
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jtmAK.Adg4RaisedMedia), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                    src: imgSrc,
                    alt: imgAltText,
                    className: (0, $2jatx.default)([
                        "_1bsb1osq"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1yb4 _4cvr1h6o _195g1tcg _zulp7vkz _1tke53f4"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_k48pni7l",
                                stylingType === "anchor" && "_y3gn1h6o _syaz1hlo _ect41pz4 _1wyb1k8s _k48p1fw0 _vwz4l07h _6rth14y2"
                            ]),
                            style: {
                                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                            },
                            children: primaryText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_k48p1nn1",
                                stylingType === "anchor" && "_y3gn1h6o _syaz1hlo _1wyb1j6v _vwz41k8s"
                            ]),
                            style: {
                                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                            },
                            children: description
                        })
                    ]
                })
            })
        ]
    });
};
const $7acb0827f4cf9b6c$var$carouselTabListStyle = null;
const $7acb0827f4cf9b6c$var$dotStyle = null;
const $7acb0827f4cf9b6c$var$currentDotStyle = null;
const $7acb0827f4cf9b6c$var$carouselStyles = null;
const $7acb0827f4cf9b6c$var$controlsContainerStyles = null;
const $7acb0827f4cf9b6c$var$centeredControlsContainerStyles = null;
const $7acb0827f4cf9b6c$var$rightAlignedControlsContainerStyles = null;
const $7acb0827f4cf9b6c$export$144901db2ea8e967 = ({ "aria-label": ariaLabel, slides: slides, "id": carouselId, showPlayButton: showPlayButton = true, stylingType: stylingType, usePlainContainer: usePlainContainer })=>{
    const intl = (0, $8e22h.default)();
    const cycleTime = 7000;
    const timeoutRef = (0, $1oC0p.useRef)(null);
    const tabsRef = (0, $1oC0p.useRef)({});
    const [visibleSlideIndex, _setVisibleSlideIndex] = (0, $1oC0p.useState)(0);
    const visibleSlide = slides[visibleSlideIndex];
    if (visibleSlide === undefined) throw new Error("Slide index out of bounds.");
    const setVisibleSlideIndex = (newState, moveFocus = false)=>{
        _setVisibleSlideIndex((prevState)=>{
            var _tabsRef_current_calculatedState;
            let calculatedState;
            if (typeof newState === "function") calculatedState = newState(prevState);
            else calculatedState = newState;
            moveFocus && (tabsRef === null || tabsRef === void 0 ? void 0 : (_tabsRef_current_calculatedState = tabsRef.current[calculatedState]) === null || _tabsRef_current_calculatedState === void 0 ? void 0 : _tabsRef_current_calculatedState.focus());
            return calculatedState;
        });
    };
    const moveToPreviousSlide = (moveFocus = false)=>{
        setVisibleSlideIndex((prev)=>{
            return prev === 0 ? slides.length - 1 : prev - 1;
        }, moveFocus);
    };
    const moveToNextSlide = (0, $1oC0p.useCallback)((moveFocus = false)=>{
        setVisibleSlideIndex((prev)=>{
            return prev === slides.length - 1 ? 0 : prev + 1;
        }, moveFocus);
    }, [
        slides.length
    ]);
    const [isRotating, setIsRotating] = (0, $1oC0p.useState)(true);
    const stopRotating = ()=>{
        (timeoutRef === null || timeoutRef === void 0 ? void 0 : timeoutRef.current) !== null && window.clearInterval(timeoutRef.current);
        setIsRotating(false);
    };
    const startRotating = ()=>{
        timeoutRef.current = window.setInterval(()=>{
            moveToNextSlide();
        }, cycleTime);
        setIsRotating(true);
    };
    const toggleRotating = ()=>{
        isRotating ? stopRotating() : startRotating();
    };
    (0, $1oC0p.useEffect)(startRotating, [
        moveToNextSlide
    ]);
    const handleKeyDown = (e)=>{
        switch(e.key){
            case "ArrowRight":
                moveToNextSlide(true);
                break;
            case "ArrowLeft":
                moveToPreviousSlide(true);
                break;
            case "Home":
                setVisibleSlideIndex(0, true);
                break;
            case "End":
                setVisibleSlideIndex(slides.length - 1, true);
                break;
            default:
                return;
        }
        stopRotating();
        e.preventDefault();
    };
    const handleTabClick = (index)=>{
        stopRotating();
        setVisibleSlideIndex(index);
    };
    const handlePreviousClick = ()=>{
        stopRotating();
        moveToPreviousSlide();
    };
    const handleNextClick = ()=>{
        stopRotating();
        moveToNextSlide();
    };
    const getSlideId = (suffix)=>`${carouselId}-${suffix}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        "aria-label": ariaLabel,
        "aria-roledescription": "carousel",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-atomic": false,
                "aria-live": isRotating ? "off" : "polite",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($7acb0827f4cf9b6c$export$cabb5ccfbd60cbd4, (0, $dPABA._)((0, $6ogO3._)({}, visibleSlide), {
                    id: getSlideId(visibleSlideIndex),
                    stylingType: stylingType,
                    usePlainContainer: usePlainContainer
                }), visibleSlide.primaryText)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _1lmceh92 _yv0e1n6q _zulpe2fx"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_nd5l1h6o _1e0c1txw _4cvr1h6o _zulp7vkz"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hJfqz.ArrowButton), {
                                onClick: handlePreviousClick,
                                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7IesZ))), {
                                    label: ""
                                }),
                                "aria-label": intl.formatMessage({
                                    id: "confluence.paid.lp.carousel.previous.label",
                                    defaultMessage: "Previous slide"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                role: "tablist",
                                "aria-label": intl.formatMessage({
                                    id: "confluence.paid.lp.carousel.tablist.label",
                                    defaultMessage: "Choose a slide to display."
                                }),
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _zulp1tcg"
                                ]),
                                children: slides.map((slide, index)=>{
                                    const isVisibleTab = visibleSlideIndex === index;
                                    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        "aria-controls": getSlideId(index),
                                        "aria-selected": isVisibleTab,
                                        role: "tab",
                                        "aria-label": intl.formatMessage({
                                            id: "confluence.paid.lp.carousel.tab.label",
                                            defaultMessage: `Slide {slideNumber}`
                                        }, {
                                            slideNumber: `${index + 1}`
                                        }),
                                        tabIndex: isVisibleTab ? 0 : -1,
                                        onKeyDown: handleKeyDown,
                                        onClick: ()=>handleTabClick(index),
                                        ref: (node)=>{
                                            if (node) tabsRef.current[index] = node;
                                        },
                                        className: (0, $2jatx.default)([
                                            "_2rko1ssb _80omtlke _1bsb1crf _4t3i1crf _bfhkcd5j",
                                            isVisibleTab && "_bfhkrbzz"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                        }
                                    }, `${slide.primaryText}-${index}`);
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hJfqz.ArrowButton), {
                                onClick: handleNextClick,
                                "aria-label": intl.formatMessage({
                                    id: "confluence.paid.lp.carousel.next.label",
                                    defaultMessage: "Next slide"
                                }),
                                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                                    label: ""
                                })
                            })
                        ]
                    }),
                    showPlayButton && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_nd5lusic"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hJfqz.PlayPauseButton), {
                            onClick: toggleRotating,
                            isRotating: isRotating
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("g85aC", function(module, exports) {
$parcel$export(module.exports, "VideoCarousel", function () { return $94d5d3babf1768b0$export$402838bbb52a01c9; });
/* videoCarousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $jKShK = parcelRequire("jKShK");

var $8e22h = parcelRequire("8e22h");

var $7IesZ = parcelRequire("7IesZ");

var $9BG80 = parcelRequire("9BG80");

var $jtmAK = parcelRequire("jtmAK");

var $kbpa7 = parcelRequire("kbpa7");

var $hJfqz = parcelRequire("hJfqz");
const $94d5d3babf1768b0$var$carouselSlideStyle = null;
const $94d5d3babf1768b0$var$infoContainerStyle = null;
const $94d5d3babf1768b0$var$textContainerStyle = null;
const $94d5d3babf1768b0$var$primaryTextStyle = null;
const $94d5d3babf1768b0$var$subTextStyle = null;
const $94d5d3babf1768b0$var$videoStyle = null;
const $94d5d3babf1768b0$var$rightAlignedControlsContainerStyles = null;
const $94d5d3babf1768b0$export$542984e3b3a8582e = ({ primaryText: primaryText, description: description, videoSrcMp4: videoSrcMp4, videoSrcWebm: videoSrcWebm, videoPreviewSrc: videoPreviewSrc, id: id, loop: loop, onEnded: onEnded })=>{
    const { ref: containerRef, inView: sectionIsVisible } = (0, $jKShK.useInView)({
        initialInView: true,
        threshold: 0.3
    });
    const videoRef = /*#__PURE__*/ (0, $1oC0p.createRef)();
    (0, $1oC0p.useEffect)(()=>{
        const videoElem = videoRef.current;
        if (!videoElem) return;
        // Pause the video when it's out of view
        if (!sectionIsVisible && !videoElem.paused) videoElem.pause();
        // Play the video when it's in view
        if (sectionIsVisible && videoElem.paused) {
            videoElem.currentTime = 0;
            videoElem.play().catch(()=>{
            // Ignore error likely due to autoplay restrictions
            });
        }
    }, [
        videoRef,
        sectionIsVisible
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        role: "tabpanel",
        id: id,
        ref: containerRef,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jtmAK.Adg4RaisedMedia), {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
                    width: 1920,
                    height: 1080,
                    playsInline: true,
                    muted: true,
                    preload: "auto",
                    poster: videoPreviewSrc,
                    autoPlay: true,
                    loop: loop,
                    ref: videoRef,
                    onEnded: onEnded,
                    // Use onLoadedMetadata to trigger a Safari autplay workaround
                    onLoadedMetadata: (videoEvent)=>{
                        try {
                            videoEvent.currentTarget.currentTime = 0; // Set currentTime to workaround Safari not autplaying
                            if (videoEvent.currentTarget.parentElement) videoEvent.currentTarget.play().catch(()=>false); // Call play() as backup to ensure the video is playing
                        } catch (error) {
                            console.log("Error calling play method on video after onCanPlay is invoked.");
                        }
                    },
                    className: (0, $2jatx.default)([
                        "_p12f1osq _4t3i1wug"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                            src: videoSrcMp4,
                            type: `video/mp4`
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                            src: videoSrcWebm,
                            type: `video/webm`
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1yb4 _4cvr1h6o _zulp7vkz _1tke53f4"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _1bsb1osq _y3gn1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                            className: (0, $2jatx.default)([
                                "_k48p53lb _1wyba982 _vwz41i72 _1dyzzyni _6rthi2wt _ect4qlpn _so7dlb34"
                            ]),
                            style: {
                                "--_1h6bnby": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.display"))
                            },
                            children: primaryText
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_k48p1nn1 _1wyb7vkz _vwz41tcg"
                            ]),
                            children: description
                        })
                    ]
                })
            })
        ]
    });
};
const $94d5d3babf1768b0$var$carouselTabListStyle = null;
const $94d5d3babf1768b0$var$dotStyle = null;
const $94d5d3babf1768b0$var$currentDotStyle = null;
const $94d5d3babf1768b0$var$carouselStyles = null;
const $94d5d3babf1768b0$var$controlsContainerStyles = null;
const $94d5d3babf1768b0$var$centeredControlsContainerStyles = null;
const $94d5d3babf1768b0$export$402838bbb52a01c9 = ({ "aria-label": ariaLabel, slides: slides, "id": carouselId })=>{
    const intl = (0, $8e22h.default)();
    const tabsRef = (0, $1oC0p.useRef)({});
    const [visibleSlideIndex, _setVisibleSlideIndex] = (0, $1oC0p.useState)(0);
    const visibleSlide = slides[visibleSlideIndex];
    if (visibleSlide === undefined) throw new Error("Slide index out of bounds.");
    const setVisibleSlideIndex = (newState, moveFocus = false)=>{
        _setVisibleSlideIndex((prevState)=>{
            var _tabsRef_current_calculatedState;
            let calculatedState;
            if (typeof newState === "function") calculatedState = newState(prevState);
            else calculatedState = newState;
            moveFocus && (tabsRef === null || tabsRef === void 0 ? void 0 : (_tabsRef_current_calculatedState = tabsRef.current[calculatedState]) === null || _tabsRef_current_calculatedState === void 0 ? void 0 : _tabsRef_current_calculatedState.focus());
            return calculatedState;
        });
    };
    const moveToPreviousSlide = (moveFocus = false)=>{
        setVisibleSlideIndex((prev)=>{
            return prev === 0 ? slides.length - 1 : prev - 1;
        }, moveFocus);
    };
    const moveToNextSlide = (0, $1oC0p.useCallback)((moveFocus = false)=>{
        setVisibleSlideIndex((prev)=>{
            return prev === slides.length - 1 ? 0 : prev + 1;
        }, moveFocus);
    }, [
        slides.length
    ]);
    const [isRotating, setIsRotating] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>setIsRotating(true), [
        moveToNextSlide
    ]);
    const handleKeyDown = (e)=>{
        switch(e.key){
            case "ArrowRight":
                moveToNextSlide(true);
                break;
            case "ArrowLeft":
                moveToPreviousSlide(true);
                break;
            case "Home":
                setVisibleSlideIndex(0, true);
                break;
            case "End":
                setVisibleSlideIndex(slides.length - 1, true);
                break;
            default:
                return;
        }
        setIsRotating(false);
        e.preventDefault();
    };
    const handleTabClick = (index)=>{
        setIsRotating(false);
        setVisibleSlideIndex(index);
    };
    const handlePreviousClick = ()=>{
        setIsRotating(false);
        moveToPreviousSlide();
    };
    const handleNextClick = ()=>{
        setIsRotating(false);
        moveToNextSlide();
    };
    const getSlideId = (suffix)=>`${carouselId}-${suffix}`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        "aria-label": ariaLabel,
        "aria-roledescription": "carousel",
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-atomic": false,
                "aria-live": isRotating ? "off" : "polite",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($94d5d3babf1768b0$export$542984e3b3a8582e, (0, $dPABA._)((0, $6ogO3._)({}, visibleSlide), {
                    id: getSlideId(visibleSlideIndex),
                    loop: !isRotating,
                    onEnded: ()=>moveToNextSlide()
                }), visibleSlide.primaryText)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _1lmceh92 _yv0e1n6q _zulpe2fx _1pfh1crf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_nd5l1h6o _1e0c1txw _4cvr1h6o _zulp7vkz"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hJfqz.ArrowButton), {
                                onClick: handlePreviousClick,
                                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7IesZ))), {
                                    label: ""
                                }),
                                "aria-label": intl.formatMessage({
                                    id: "confluence.paid.lp.carousel.previous.label",
                                    defaultMessage: "Previous slide"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                role: "tablist",
                                "aria-label": intl.formatMessage({
                                    id: "confluence.paid.lp.carousel.tablist.label",
                                    defaultMessage: "Choose a slide to display."
                                }),
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _zulp1tcg"
                                ]),
                                children: slides.map((slide, index)=>{
                                    const isVisibleTab = visibleSlideIndex === index;
                                    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        "aria-controls": getSlideId(index),
                                        "aria-selected": isVisibleTab,
                                        role: "tab",
                                        "aria-label": intl.formatMessage({
                                            id: "confluence.paid.lp.carousel.tab.label",
                                            defaultMessage: `Slide {slideNumber}`
                                        }, {
                                            slideNumber: `${index + 1}`
                                        }),
                                        tabIndex: isVisibleTab ? 0 : -1,
                                        onKeyDown: handleKeyDown,
                                        onClick: ()=>handleTabClick(index),
                                        ref: (node)=>{
                                            if (node) tabsRef.current[index] = node;
                                        },
                                        className: (0, $2jatx.default)([
                                            "_2rko1ssb _80omtlke _1bsb1crf _4t3i1crf _bfhkcd5j",
                                            isVisibleTab && "_bfhkrbzz"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                        }
                                    }, `${slide.primaryText}-${index}`);
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hJfqz.ArrowButton), {
                                onClick: handleNextClick,
                                "aria-label": intl.formatMessage({
                                    id: "confluence.paid.lp.carousel.next.label",
                                    defaultMessage: "Next slide"
                                }),
                                icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                                    label: ""
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_nd5lusic"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hJfqz.PlayPauseButton), {
                            onClick: ()=>setIsRotating(!isRotating),
                            isRotating: isRotating
                        })
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("3LcIp", function(module, exports) {
$parcel$export(module.exports, "BanditsProvider", function () { return $6869915d6a46ae95$export$ed6616ed0f76d929; });
$parcel$export(module.exports, "BanditsHeaderWrapper", function () { return $6869915d6a46ae95$export$1cb749e21ac9e393; });
$parcel$export(module.exports, "BanditsAssetWrapper", function () { return $6869915d6a46ae95$export$f9fbacfdb5ded657; });
/* bandits-components.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable complexity */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $eUwCn = parcelRequire("eUwCn");

var $7VwhR = parcelRequire("7VwhR");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $l7lLR = parcelRequire("l7lLR");

var $gx3aw = parcelRequire("gx3aw");
const $6869915d6a46ae95$var$BanditsContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    banditsContent: null,
    loading: false,
    error: null,
    isExperimentEnabled: false
});
const $6869915d6a46ae95$export$ed6616ed0f76d929 = ({ product: product, keyword: keyword, isExperimentEnabled: isExperimentEnabled = false, useCase: useCase = (0, $l7lLR.BANDITS_USE_CASE).ANCHOR_JOURNEY, subAnchor: subAnchor = "", channel: channel = "", utmContent: utmContent = "", utmCampaign: utmCampaign = "", children: children })=>{
    const anonymousId = decodeURIComponent((0, $gx3aw.Cookie).readCookie("ajs_anonymous_id") || "").replace(/['"]+/g, "");
    const [banditsContent, setBanditsContent] = (0, $1oC0p.useState)(isExperimentEnabled ? null : (0, $l7lLR.nullBanditsContent));
    const [loading, setLoading] = (0, $1oC0p.useState)(isExperimentEnabled);
    const [error, setError] = (0, $1oC0p.useState)(null);
    (0, $1oC0p.useEffect)(()=>{
        if (!isExperimentEnabled) return;
        const getBanditsContent = async ()=>{
            const content = await (0, $l7lLR.getGrsAndContentfulContent)({
                keyword: keyword || "",
                product: product,
                locale: "en-US",
                anonymousId: anonymousId,
                useCase: useCase,
                subAnchor: subAnchor,
                channel: channel,
                utmContent: utmContent,
                utmCampaign: utmCampaign
            });
            if (content === null || content === void 0 ? void 0 : content.recoSessionId) {
                // Map BanditsProduct to a productKey string for storage
                const productKey = product === "jira" ? (0, $7VwhR.ProductKey).JIRA_SOFTWARE : (0, $7VwhR.ProductKey).CONFLUENCE;
                (0, $l7lLR.setGrsDataToLocalStorage)({
                    recoSessionId: content.recoSessionId,
                    recoEntityId: content.recoEntityId
                }, productKey);
            }
            setBanditsContent(content);
        };
        try {
            getBanditsContent();
        } catch (e) {
            setError(e);
        } finally{
            setLoading(false);
        }
    }, [
        isExperimentEnabled,
        keyword,
        product,
        anonymousId,
        useCase,
        subAnchor,
        channel,
        utmContent,
        utmCampaign
    ]);
    const value = (0, $1oC0p.useMemo)(()=>({
            banditsContent: banditsContent,
            loading: loading,
            error: error,
            isExperimentEnabled: isExperimentEnabled
        }), [
        banditsContent,
        loading,
        error,
        isExperimentEnabled
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($6869915d6a46ae95$var$BanditsContext.Provider, {
        value: value,
        children: children
    });
};
const $6869915d6a46ae95$export$d85787cef2955e0c = ()=>{
    const context = (0, $1oC0p.useContext)($6869915d6a46ae95$var$BanditsContext);
    if (!context) console.info("useBanditsContext is not used within a BanditsProvider");
    return context;
};
// Wrapper Components
const $6869915d6a46ae95$var$imgContainer = null;
const $6869915d6a46ae95$var$confluenceImgContainer = null;
const $6869915d6a46ae95$export$1cb749e21ac9e393 = ({ product: product, type: type = "header", children: children })=>{
    var _banditsContent_headline, _banditsContent_headline1;
    const { banditsContent: banditsContent, loading: loading, error: error, isExperimentEnabled: isExperimentEnabled } = $6869915d6a46ae95$export$d85787cef2955e0c();
    const SkeletonComponent = product === "jira" ? $6869915d6a46ae95$export$15339ba7c5b3a2b8 : $6869915d6a46ae95$export$ce1a828edc281b5e;
    if (loading || !banditsContent && isExperimentEnabled) return /*#__PURE__*/ (0, $7VQPk.jsx)(SkeletonComponent, {
        type: type
    });
    if (error || !(banditsContent === null || banditsContent === void 0 ? void 0 : banditsContent.headline)) return children;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: type === "header" ? banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_headline = banditsContent.headline) === null || _banditsContent_headline === void 0 ? void 0 : _banditsContent_headline.title : banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_headline1 = banditsContent.headline) === null || _banditsContent_headline1 === void 0 ? void 0 : _banditsContent_headline1.subheading
    });
};
const $6869915d6a46ae95$export$f9fbacfdb5ded657 = ({ product: product, showChildren: showChildren = false, children: children })=>{
    var _banditsContent_asset, _banditsContent_asset1, _banditsContent_asset2, _banditsContent_asset3, _banditsContent_asset_video1Mp4, _banditsContent_asset4, _banditsContent_asset_image1, _banditsContent_asset5, _banditsContent_asset_video1Mp41, _banditsContent_asset6, _banditsContent_asset_video1Webm, _banditsContent_asset7, _banditsContent_asset_image11, _banditsContent_asset8, _banditsContent_asset_image12, _banditsContent_asset9;
    const { banditsContent: banditsContent, loading: loading, error: error, isExperimentEnabled: isExperimentEnabled } = $6869915d6a46ae95$export$d85787cef2955e0c();
    if (loading || !banditsContent && isExperimentEnabled) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _p12fcv93 _1bah1h6o _1e0cglyw _181n1txw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($6869915d6a46ae95$export$8a7df558a5bc35a7, {})
    });
    if (showChildren || error || !(banditsContent === null || banditsContent === void 0 ? void 0 : banditsContent.asset) || (banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset = banditsContent.asset) === null || _banditsContent_asset === void 0 ? void 0 : _banditsContent_asset.id) === (0, $l7lLR.JIRA_FEATURES_ASSET_CONTROL) || (banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset1 = banditsContent.asset) === null || _banditsContent_asset1 === void 0 ? void 0 : _banditsContent_asset1.id) === (0, $l7lLR.CONFLUENCE_FEATURES_ASSET_CONTROL) || (0, $l7lLR.isConfluenceSubAnchorAssetControl)(banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset2 = banditsContent.asset) === null || _banditsContent_asset2 === void 0 ? void 0 : _banditsContent_asset2.id)) return children;
    const image1OrangeLogic = banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset3 = banditsContent.asset) === null || _banditsContent_asset3 === void 0 ? void 0 : _banditsContent_asset3.image1OrangeLogic;
    var _image1OrangeLogic_alt;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _c71lstmo _1bsb1osq _p12f1kpv",
            product === "confluence" && "_1ul91178 _p12f1osq _16jlkb7n _1o9zkb7n _i0dl1osq _sugaglyw",
            image1OrangeLogic && "_1bsb1wug _16jlidpf _1o9zkb7n _i0dl1wug"
        ]),
        children: (banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset4 = banditsContent.asset) === null || _banditsContent_asset4 === void 0 ? void 0 : (_banditsContent_asset_video1Mp4 = _banditsContent_asset4.video1Mp4) === null || _banditsContent_asset_video1Mp4 === void 0 ? void 0 : _banditsContent_asset_video1Mp4.url) ? /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true,
            preload: "auto",
            poster: banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset5 = banditsContent.asset) === null || _banditsContent_asset5 === void 0 ? void 0 : (_banditsContent_asset_image1 = _banditsContent_asset5.image1) === null || _banditsContent_asset_image1 === void 0 ? void 0 : _banditsContent_asset_image1.url,
            controls: true,
            className: (0, $2jatx.default)([
                "_c71lcv93 _p12f1osq"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                    src: banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset6 = banditsContent.asset) === null || _banditsContent_asset6 === void 0 ? void 0 : (_banditsContent_asset_video1Mp41 = _banditsContent_asset6.video1Mp4) === null || _banditsContent_asset_video1Mp41 === void 0 ? void 0 : _banditsContent_asset_video1Mp41.url,
                    type: "video/mp4"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                    src: banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset7 = banditsContent.asset) === null || _banditsContent_asset7 === void 0 ? void 0 : (_banditsContent_asset_video1Webm = _banditsContent_asset7.video1Webm) === null || _banditsContent_asset_video1Webm === void 0 ? void 0 : _banditsContent_asset_video1Webm.url,
                    type: "video/webm"
                })
            ]
        }) : image1OrangeLogic ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_p12fcv93 _c71l1ogm"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                src: image1OrangeLogic.assetUrl || "",
                alt: (_image1OrangeLogic_alt = image1OrangeLogic.alt) !== null && _image1OrangeLogic_alt !== void 0 ? _image1OrangeLogic_alt : ""
            })
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
            image: {
                src: (banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset8 = banditsContent.asset) === null || _banditsContent_asset8 === void 0 ? void 0 : (_banditsContent_asset_image11 = _banditsContent_asset8.image1) === null || _banditsContent_asset_image11 === void 0 ? void 0 : _banditsContent_asset_image11.url) || "",
                alt: (banditsContent === null || banditsContent === void 0 ? void 0 : (_banditsContent_asset9 = banditsContent.asset) === null || _banditsContent_asset9 === void 0 ? void 0 : (_banditsContent_asset_image12 = _banditsContent_asset9.image1) === null || _banditsContent_asset_image12 === void 0 ? void 0 : _banditsContent_asset_image12.description) || ""
            },
            className: (0, $2jatx.default)([
                "_c71lcv93"
            ])
        })
    });
};
// Skeleton Components
const $6869915d6a46ae95$var$sectionGap = null;
const $6869915d6a46ae95$var$desktopDisplay = null;
const $6869915d6a46ae95$var$tabletDisplay = null;
const $6869915d6a46ae95$var$mobileDisplay = null;
const $6869915d6a46ae95$var$containerStyles = null;
const $6869915d6a46ae95$export$15339ba7c5b3a2b8 = ({ type: type })=>{
    if (type === "subheader") return;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "hero-header-skeleton",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _dm251ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _dh1a1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "420px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "360px",
                                height: "64px"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _kzvi1ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _dh1a1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "680px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "460px",
                                height: "64px"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _suga1ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _dh1a1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "320px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "280px",
                                height: "64px"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_6rthu2gc"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                                width: "240px",
                                height: "64px"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $6869915d6a46ae95$export$ce1a828edc281b5e = ({ type: type })=>{
    if (type === "subheader") return;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthu2gc"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                    width: "280px",
                    height: "32px"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthu2gc"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                    width: "300px",
                    height: "32px"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_6rthu2gc"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                    width: "320px",
                    height: "32px"
                })
            })
        ]
    });
};
const $6869915d6a46ae95$export$8a7df558a5bc35a7 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "data-testid": "hero-asset-skeleton",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _dm251ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                    width: "600px",
                    height: "480px"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _kzvi1ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                    width: "420px",
                    height: "280px"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _suga1ule"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eUwCn.Adg4Skeleton), {
                    width: "250px",
                    height: "200px"
                })
            })
        ]
    });
};

});

parcelRegister("a5uC7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("leg8m")).default; });

var $leg8m = parcelRequire("leg8m");

var $7Eo8a = parcelRequire("7Eo8a");

});
parcelRegister("leg8m", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4722f7927f6b8e0d$export$2e2bcd8739ae039; });
/* image-checklist-side.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $a0utR = parcelRequire("a0utR");
parcelRequire("jJLMp");
var $i5Yp0 = parcelRequire("i5Yp0");
parcelRequire("8eFsx");
var $kQNvM = parcelRequire("kQNvM");

var $imIsw = parcelRequire("imIsw");

var $jMhSx = parcelRequire("jMhSx");
// ================================================
// CSS
// ================================================
const $4722f7927f6b8e0d$var$checklistWithNoPullQuoteStyle = null;
const $4722f7927f6b8e0d$var$titleStyles = null;
// ================================================
// Rendering Functions
// ================================================
const $4722f7927f6b8e0d$var$HorizontalRuleMobile = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0cglyw _7n83ssan _suga1ule"
            ])
        })
    });
const $4722f7927f6b8e0d$var$ChecklistWithImage = ({ title: title, listItems: listItems, rawHtmlContent: rawHtmlContent, imageSrc: imageSrc, imageAlt: imageAlt, isIncludeTestimony: isIncludeTestimony = false, quoteBlurb: quoteBlurb, quoteName: quoteName, quoteCompany: quoteCompany, testimonyImageSrc: testimonyImageSrc, testimonyImageAlt: testimonyImageAlt, isShowTestimonyBorder: isShowTestimonyBorder = true, testimonyIsUsingTextQuotationMarks: testimonyIsUsingTextQuotationMarks = false, isSmallQuote: isSmallQuote = false, isIncludeHorizontalMobileRule: isIncludeHorizontalMobileRule = true })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            !isIncludeTestimony && "_xlt1zwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jMhSx.Row), {
                layout: "4-8",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                className: (0, $2jatx.default)([
                                    "_1pfhidpf _k48pbfng _syaz1bqd _1dyzidpf _1gw8ahaf"
                                ]),
                                children: title
                            }),
                            listItems && listItems.length && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kQNvM.default), {
                                listItems: listItems
                            }),
                            rawHtmlContent && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: "tab-content",
                                dangerouslySetInnerHTML: {
                                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($a0utR)))(rawHtmlContent)
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Image), {
                            src: imageSrc,
                            alt: imageAlt
                        })
                    })
                ]
            }),
            isIncludeTestimony && isIncludeHorizontalMobileRule && /*#__PURE__*/ (0, $7VQPk.jsx)($4722f7927f6b8e0d$var$HorizontalRuleMobile, {}),
            isIncludeTestimony && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    isSmallQuote ? "_1q511wqb" : "_1q517vkz"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i5Yp0.PullQuote), {
                    logoSrc: testimonyImageSrc,
                    logoAltText: testimonyImageAlt,
                    quoteBlurb: quoteBlurb || "",
                    quoteCompany: quoteCompany || "",
                    quoteName: quoteName || "",
                    isShowBorder: isShowTestimonyBorder,
                    isUsingTextQuotationMarks: testimonyIsUsingTextQuotationMarks,
                    isSmall: isSmallQuote
                })
            })
        ]
    });
};
var $4722f7927f6b8e0d$export$2e2bcd8739ae039 = $4722f7927f6b8e0d$var$ChecklistWithImage;

});
parcelRegister("jJLMp", function(module, exports) {
$parcel$export(module.exports, "PullQuote", function () { return (parcelRequire("i5Yp0")).PullQuote; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("i5Yp0")).PullQuote; });

var $i5Yp0 = parcelRequire("i5Yp0");

});
parcelRegister("i5Yp0", function(module, exports) {
$parcel$export(module.exports, "PullQuote", function () { return $49cc36364de70f98$export$f32a6ca59ed1d5d5; });
/* pull-quote.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $imIsw = parcelRequire("imIsw");

var $jMhSx = parcelRequire("jMhSx");
const $49cc36364de70f98$var$pullQuoteCss = null;
const $49cc36364de70f98$var$borderCss = null;
const $49cc36364de70f98$var$smallBorderCss = null;
const $49cc36364de70f98$var$smallWidthCss = null;
const $49cc36364de70f98$var$quoteCss = null;
const $49cc36364de70f98$var$quotationMarkStyle = {
    height: "24px"
};
const $49cc36364de70f98$var$quoteBlurbCss = null;
const $49cc36364de70f98$var$nameAndCompanyContainerCss = null;
const $49cc36364de70f98$var$quoteNameCss = null;
const $49cc36364de70f98$var$smallQuoteNameCss = null;
const $49cc36364de70f98$var$quoteCompanyCss = null;
const $49cc36364de70f98$var$smallQuoteCompanyCss = null;
const $49cc36364de70f98$var$pullQuoteImgContainerCss = null;
const $49cc36364de70f98$var$pullQuoteImgCss = null;
const $49cc36364de70f98$export$f32a6ca59ed1d5d5 = ({ logoSrc: logoSrc, logoAltText: logoAltText, quoteBlurb: quoteBlurb, quoteName: quoteName, quoteCompany: quoteCompany, isShowBorder: isShowBorder = false, isUsingTextQuotationMarks: isUsingTextQuotationMarks = false, isSmall: isSmall = false })=>{
    const isShowQuoteLogo = !!logoSrc;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
        layout: "10",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1q51zwfg _85i5zwfg _1e0c1txw _2lx21bp4 _1bah1yb4 _16ng1h6o _ae4v1h6o _1lp7vrvc",
                isShowBorder && !isSmall && "_mqm2136u _179r136u",
                isShowBorder && isSmall && "_mqm21bu1 _179r1bu1",
                isSmall && "_1bsb12it _10fp1h6o"
            ]),
            children: [
                isShowQuoteLogo && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_y3gn1h6o _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _6rthzwfg _12l2idpf _1ob9idpf _1lvazwfg"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                        src: logoSrc || "",
                        alt: logoAltText || "",
                        className: (0, $2jatx.default)([
                            "_5ralzm06 _4t3iuuw1 _1bsb1osq _1xlo1osq _14b5mgvx _glte1wdt"
                        ])
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_y3gn1e5h"
                    ]),
                    children: [
                        !isUsingTextQuotationMarks && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                            style: $49cc36364de70f98$var$quotationMarkStyle,
                            image: {
                                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/41knb7g4sf3cg6sj54o2uubv0r3r3n33.svg",
                                alt: "Quotation mark"
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _4t3i1w8u _1bah1yb4"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                    className: (0, $2jatx.default)([
                                        isSmall ? "_syazl4fm" : "_1wybgktf _vwz41f4h _k48pb4wl _1s181f4h _17gq1ylp",
                                        isSmall ? "body-sm" : ""
                                    ]),
                                    children: [
                                        isUsingTextQuotationMarks ? "\u201C" : "",
                                        quoteBlurb,
                                        "\u201D"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                            className: (0, $2jatx.default)([
                                                isSmall ? "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p9y44 _1wyb1crf _vwz4qslr _1p1dangw" : "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p8n31 _1wyb7vkz _vwz41tcg"
                                            ]),
                                            children: quoteName
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                            className: (0, $2jatx.default)([
                                                isSmall ? "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1 _1wyb1crf _vwz4qslr _1p1dangw" : "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb7vkz _vwz41tcg"
                                            ]),
                                            children: quoteCompany
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});


parcelRegister("8eFsx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("kQNvM")).default; });

var $kQNvM = parcelRequire("kQNvM");

});
parcelRegister("kQNvM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b8763b42cfbf25b2$export$2e2bcd8739ae039; });
/* checklist.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jMhSx = parcelRequire("jMhSx");
const $b8763b42cfbf25b2$var$listItemStyles = null;
const $b8763b42cfbf25b2$var$Checklist = ({ listItems: listItems })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        className: (0, $2jatx.default)([
            "_qtt8glyw _lswu1mzw _19bvgktf _19pkidpf _1mswidpf _53os1tcg _f0hdh2mm _2ts0glyw _138k1fm0 _1u82o7ao _s22yzwfg _59281o8l _rus87vkz _1vhestnw _mz937vkz _f1xm7vkz _oonc1y44 _13421l7b _3p611o8l _4fnt7vkz _1exr7vkz _ivf7r3uz _1v9r1j6v _1mmx1k8s"
        ]),
        children: listItems.map((listItem, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Icon), {
                        name: "checkmarkbasic",
                        color: "#6554c0",
                        size: "xs"
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        children: listItem
                    })
                ]
            }, index))
    });
};
var $b8763b42cfbf25b2$export$2e2bcd8739ae039 = $b8763b42cfbf25b2$var$Checklist;

});



parcelRegister("7Eo8a", function(module, exports) {

var $7VQPk = parcelRequire("7VQPk");
const $14a73e0d98186b4e$export$9a4e871e025287ef = (props)=>/*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            props.strongText ? /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                children: props.strongText
            }) : "",
            props.plainText
        ]
    });

});


parcelRegister("kZQhV", function(module, exports) {
$parcel$export(module.exports, "HorizontalRule", function () { return $e49e6c38dcb8d4a0$export$841e9c95e6429474; });
$parcel$export(module.exports, "PaidLandingTemplate", function () { return $e49e6c38dcb8d4a0$export$b9ca3a4496ce259; });
/* paid-landing.template.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable complexity */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $k1xqL = parcelRequire("k1xqL");

var $53RJr = parcelRequire("53RJr");

var $lzfAX = parcelRequire("lzfAX");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");

var $4Jdkw = parcelRequire("4Jdkw");

var $8LaTa = parcelRequire("8LaTa");
parcelRequire("jkEFt");
var $loOqH = parcelRequire("loOqH");

var $cDJ3u = parcelRequire("cDJ3u");

var $3riD8 = parcelRequire("3riD8");

var $ea4mV = parcelRequire("ea4mV");

var $j6FQw = parcelRequire("j6FQw");

var $icTHu = parcelRequire("icTHu");

var $5IbWH = parcelRequire("5IbWH");

var $gQSoJ = parcelRequire("gQSoJ");

var $1SFKa = parcelRequire("1SFKa");

var $hbUAT = parcelRequire("hbUAT");

var $cqYjz = parcelRequire("cqYjz");

var $cf7Ff = parcelRequire("cf7Ff");
const $e49e6c38dcb8d4a0$export$841e9c95e6429474 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
        layout: "12",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_179r137p"
            ]),
            style: {
                "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
            }
        })
    });
const $e49e6c38dcb8d4a0$export$b9ca3a4496ce259 = ({ landingType: landingType, pageId: pageId, showHorizontalRule: showHorizontalRule, productNavProps: productNavProps, bannerAlertProps: bannerAlertProps, heroProps: heroProps, bannerProps: bannerProps, tabsProps: tabsProps, customSection: customSection, customHeroSection: customHeroSection, carouselHeroProps: carouselHeroProps, alternatingTextAndImageProps: alternatingTextAndImageProps, ctaProps: ctaProps, ctaWithPolyGonProps: ctaWithPolyGonProps, testimonialProps: testimonialProps, animatedJiraTourProps: animatedJiraTourProps, hideNavigationBar: hideNavigationBar, heroImageSubheader: heroImageSubheader, resultSectionDivider: resultSectionDivider, hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, heroBgColor: heroBgColor = "bgWhite", auxiaResponse: auxiaResponse })=>{
    const { isUserLoggedIn: isUserLoggedIn } = (0, $3riD8.useLoggedInUser)();
    const [jiraFflExposureFired, fireJiraFflExposure] = (0, $ea4mV.useExperimentExposure)((0, $ea4mV.experiments).cfind4666JiraFfl);
    // Temporary solution to show animated hero only for logged out users on anchor pages
    // This can be removed once we implement a way to configure this via CMS
    const showAnimatedHero = !isUserLoggedIn && (pageId === "paid-lp-jsw-features" || !!heroProps.useNewHero);
    const showStaticTestimonials = !heroProps.animatedSocialBanner;
    const hasBannerAlert = bannerAlertProps ? true : false;
    const defaultPaidArgs = (0, $dPABA._)((0, $6ogO3._)({}, heroProps), {
        animatedJiraTourProps: animatedJiraTourProps,
        subheader: heroProps.secondaryText,
        header: heroProps.headerText,
        hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles,
        heroImageSubheader: heroImageSubheader,
        carouselHeroProps: carouselHeroProps,
        hasBannerAlert: hasBannerAlert,
        heroBgColor: heroBgColor,
        auxiaResponse: auxiaResponse,
        pageId: pageId
    });
    (0, $1oC0p.useEffect)(()=>{
        if (!jiraFflExposureFired) fireJiraFflExposure();
    }, [
        jiraFflExposureFired,
        fireJiraFflExposure
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
        id: "content",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $j6FQw.ParentScrollTracking), {
            pageId: pageId,
            scrollTrackingEnabled: pageId ? true : false,
            children: [
                !hideNavigationBar && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lzfAX.ProductNavBar), (0, $6ogO3._)({}, productNavProps)),
                bannerAlertProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $53RJr.default), (0, $dPABA._)((0, $6ogO3._)({}, bannerAlertProps), {
                    hasProductNavBar: !hideNavigationBar
                })),
                customHeroSection ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gQSoJ.PaidCustomHeroSection), {
                    customHeroSection: customHeroSection
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cqYjz.PaidHeroSectionTypes), {
                    darkSolidTheme: heroProps.darkSolidTheme,
                    landingType: landingType,
                    heroComponent: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hbUAT.PaidHeroSectionTemplate), (0, $6ogO3._)({}, defaultPaidArgs)),
                    showAnimatedHero: showAnimatedHero,
                    showNewHero: defaultPaidArgs.useNewHero
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cf7Ff.PaidTabsSection), (0, $6ogO3._)({}, tabsProps)),
                customSection && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1SFKa.PaidCustomSection), {
                    customSection: customSection
                }),
                showHorizontalRule && /*#__PURE__*/ (0, $7VQPk.jsx)($e49e6c38dcb8d4a0$export$841e9c95e6429474, {}),
                bannerProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cDJ3u.SimpleImageTextSide), (0, $6ogO3._)({}, bannerProps)),
                resultSectionDivider && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_6rth1cg9"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $k1xqL.Adg4SectionDivider), {
                        bgColor: resultSectionDivider.color,
                        variation: resultSectionDivider.variation
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $icTHu.PaidAlternatingImageText), {
                    landingType: landingType,
                    alternatingImageTextProps: alternatingTextAndImageProps
                }),
                ctaProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5IbWH.PaidCtaSection), {
                    ctaProps: ctaProps,
                    landingType: landingType
                }),
                ctaWithPolyGonProps && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                resultSectionDivider && "_bfhkyt3g _1pfh1cg9 _4t3iuuw1"
                            ]),
                            style: {
                                "--_1he1i5": (0, $6ZVlx.default)(resultSectionDivider === null || resultSectionDivider === void 0 ? void 0 : resultSectionDivider.color)
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                resultSectionDivider && "_1pfh1snh"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4Jdkw.ADG4CtaWithPolygonBackground), (0, $6ogO3._)({}, ctaWithPolyGonProps))
                        })
                    ]
                }),
                showStaticTestimonials && testimonialProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $loOqH.PaidSocialProof), (0, $6ogO3._)({}, testimonialProps)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
            ]
        })
    });
};

});
parcelRegister("jkEFt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("loOqH")).PaidSocialProof; });

var $loOqH = parcelRequire("loOqH");

});
parcelRegister("loOqH", function(module, exports) {
$parcel$export(module.exports, "PaidSocialProof", function () { return $f018c88e44a87b10$export$ebcf40293fae7986; });
/* paid-social-proof.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $imIsw = parcelRequire("imIsw");
const $f018c88e44a87b10$var$customerSectionStyles = null;
const $f018c88e44a87b10$var$h3Styles = null;
const $f018c88e44a87b10$var$containerStyles = null;
const $f018c88e44a87b10$var$imageStyles = null;
const $f018c88e44a87b10$var$largeLogoStyles = null;
const $f018c88e44a87b10$var$smallLogoStyle = null;
const $f018c88e44a87b10$export$ebcf40293fae7986 = ({ headerText: headerText, logos: logos, logoSize: logoSize = "small" })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1bah1h6o _4cvr1h6o _y3gn1h6o _ca0q1j6v _u5f3idpf _n3tdviql _19bvidpf _1k9l12bs _1qwm12bs"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_1wyb1tcg _vwz411ph _k48pbfng _syaz1bqd _ca0q1j6v _u5f31j6v _n3tdviql _19bv1j6v _1moun7od _3fcw10xh"
                ]),
                children: headerText
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _zulpzb0d _4cvr1h6o _y3gn1h6o _1n261g80 _195g1wug _p12f1fra _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1xf6vrvc _fukk1fhb _e47i1j6v _ldth1j6v _bjh61j6v _1nny1j6v"
                ]),
                children: logos === null || logos === void 0 ? void 0 : logos.map((inlineLogo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4t3i66rk _bna71osq _mezj1wug",
                            logoSize === "small" ? "_1u7oldb6" : "_19rt1w81 _1u7o16xz"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                            image: (0, $6ogO3._)({}, inlineLogo)
                        })
                    }, index))
            })
        ]
    });
};
$f018c88e44a87b10$export$ebcf40293fae7986.displayName = "PaidSocialProof";

});


parcelRegister("icTHu", function(module, exports) {
$parcel$export(module.exports, "PaidAlternatingImageText", function () { return $f11b78698fc43615$export$45a2817884af97dc; });
/* paid-alternating-image-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $bSwKq = parcelRequire("bSwKq");
const $f11b78698fc43615$var$anchorPageStyles = null;
const $f11b78698fc43615$var$confluenceAnchorStyles = null;
const $f11b78698fc43615$export$45a2817884af97dc = ({ alternatingImageTextProps: alternatingImageTextProps, landingType: landingType })=>{
    if (!alternatingImageTextProps) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            landingType === "jira-software-anchor" && "_7e8vgktf",
            landingType === "confluence-rebranded-anchor" && "_vussviql _1b6r1fw0 _p1061k92"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSwKq.ThreeAlternatingImageText), (0, $6ogO3._)({}, alternatingImageTextProps))
    });
};
$f11b78698fc43615$export$45a2817884af97dc.displayName = "PaidAlternatingImageText";

});
parcelRegister("bSwKq", function(module, exports) {
$parcel$export(module.exports, "ThreeAlternatingImageText", function () { return $1f7cfd3057b21b6f$export$51a3e3286a1cf2b5; });
/* three-alternating-image-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $cDJ3u = parcelRequire("cDJ3u");
const $1f7cfd3057b21b6f$export$51a3e3286a1cf2b5 = ({ backgroundColor: backgroundColor, backgroundImage: backgroundImage, horizontalRuleColor: horizontalRuleColor, imageWidth: imageWidth, rowHeaderType: rowHeaderType = "h2", rowPropsOdd: rowPropsOdd = "6-6", rowPropsEven: rowPropsEven = "6-6", imageTextSideRowOnePadding: imageTextSideRowOnePadding, imageTextSideRowOnePaddingBelowLargeScreen: imageTextSideRowOnePaddingBelowLargeScreen, rowOneHeader: rowOneHeader, rowOneLozenge: rowOneLozenge, rowOneBody: rowOneBody, rowOneImageLink: rowOneImageLink, rowOneImageAltText: rowOneImageAltText, rowOneImagePosition: rowOneImagePosition = "left", rowOneEyebrowText: rowOneEyebrowText, imageTextSideRowTwoPadding: imageTextSideRowTwoPadding, imageTextSideRowTwoPaddingBelowLargeScreen: imageTextSideRowTwoPaddingBelowLargeScreen, rowTwoHeader: rowTwoHeader, rowTwoLozenge: rowTwoLozenge, rowTwoBody: rowTwoBody, rowTwoImageLink: rowTwoImageLink, rowTwoImageAltText: rowTwoImageAltText, rowTwoImagePosition: rowTwoImagePosition = "right", rowTwoEyebrowText: rowTwoEyebrowText, imageTextSideRowThreePadding: imageTextSideRowThreePadding, imageTextSideRowThreePaddingBelowLargeScreen: imageTextSideRowThreePaddingBelowLargeScreen, rowThreeHeader: rowThreeHeader, rowThreeLozenge: rowThreeLozenge, rowThreeBody: rowThreeBody, rowThreeImageLink: rowThreeImageLink, rowThreeImageAltText: rowThreeImageAltText, rowThreeImagePosition: rowThreeImagePosition = "left", rowThreeEyebrowText: rowThreeEyebrowText, imageTextSideRowFourPadding: imageTextSideRowFourPadding, imageTextSideRowFourPaddingBelowLargeScreen: imageTextSideRowFourPaddingBelowLargeScreen, rowFourHeader: rowFourHeader, rowFourLozenge: rowFourLozenge, rowFourBody: rowFourBody, rowFourImageLink: rowFourImageLink, rowFourImageAltText: rowFourImageAltText = "Alt Text", rowFourImagePosition: rowFourImagePosition, rowFourEyebrowText: rowFourEyebrowText })=>{
    const imageWidthValue = imageWidth !== null && imageWidth !== void 0 ? imageWidth : "550px";
    const imageTextSideRowOnePaddingValue = imageTextSideRowOnePadding !== null && imageTextSideRowOnePadding !== void 0 ? imageTextSideRowOnePadding : "64px 0 16px";
    const imageTextSideRowOnePaddingBelowLargeScreenValue = imageTextSideRowOnePaddingBelowLargeScreen !== null && imageTextSideRowOnePaddingBelowLargeScreen !== void 0 ? imageTextSideRowOnePaddingBelowLargeScreen : "64px 0 16px";
    const imageTextSideRowTwoPaddingValue = imageTextSideRowTwoPadding !== null && imageTextSideRowTwoPadding !== void 0 ? imageTextSideRowTwoPadding : "32px 0";
    const imageTextSideRowTwoPaddingBelowLargeScreenValue = imageTextSideRowTwoPaddingBelowLargeScreen !== null && imageTextSideRowTwoPaddingBelowLargeScreen !== void 0 ? imageTextSideRowTwoPaddingBelowLargeScreen : "16px 0";
    const imageTextSideRowThreePaddingValue = imageTextSideRowThreePadding !== null && imageTextSideRowThreePadding !== void 0 ? imageTextSideRowThreePadding : "16px 0 64px";
    const imageTextSideRowThreePaddingBelowLargeScreenValue = imageTextSideRowThreePaddingBelowLargeScreen !== null && imageTextSideRowThreePaddingBelowLargeScreen !== void 0 ? imageTextSideRowThreePaddingBelowLargeScreen : "16px 0 64px";
    const imageTextSideRowFourPaddingValue = imageTextSideRowFourPadding !== null && imageTextSideRowFourPadding !== void 0 ? imageTextSideRowFourPadding : "16px 0 64px";
    const imageTextSideRowFourPaddingBelowLargeScreenValue = imageTextSideRowFourPaddingBelowLargeScreen !== null && imageTextSideRowFourPaddingBelowLargeScreen !== void 0 ? imageTextSideRowFourPaddingBelowLargeScreen : "16px 0 64px";
    const ThreeAlternatingImageTextStyles = null;
    const isShowHorizontalRule = !!horizontalRuleColor;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_j2qggma6 _cotpidpf _u5lc1ule _hm0s1wug _ceny1wug _o4bz1oh5 _17xw1bqd _vussviql _i80qidpf _1y3uidpf _vq3z1tcg _1x7sidpf _18m21038 _27c31k8s _e87pidpf _6mt8idpf _vljsdlk8 _1j6nidpf _yza7idpf _1vbdidpf _13r21ylp _dcnaidpf _vbkqidpf _9by51q87 _1of01mpp _5wk3idpf _1fus1j99 _19y1l3tq _1ltr7ip2 _1g391fux _amtq1col _kju2v4do _1djgx7vm _1drv1abn"
        ]),
        style: {
            "--_bwa4xl": (0, $6ZVlx.default)(imageWidthValue),
            "--_1cdekw0": (0, $6ZVlx.default)(horizontalRuleColor),
            "--_1o5bebe": (0, $6ZVlx.default)(imageTextSideRowOnePaddingValue),
            "--_1dlh24j": (0, $6ZVlx.default)(imageTextSideRowOnePaddingBelowLargeScreenValue),
            "--_1nsshok": (0, $6ZVlx.default)(imageTextSideRowTwoPaddingValue),
            "--_1e6od0m": (0, $6ZVlx.default)(imageTextSideRowTwoPaddingBelowLargeScreenValue),
            "--_1u1sozo": (0, $6ZVlx.default)(imageTextSideRowThreePaddingValue),
            "--_1div133": (0, $6ZVlx.default)(imageTextSideRowThreePaddingBelowLargeScreenValue),
            "--_1rnt45i": (0, $6ZVlx.default)(imageTextSideRowFourPaddingValue),
            "--_15kis35": (0, $6ZVlx.default)(imageTextSideRowFourPaddingBelowLargeScreenValue)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_bfhkaxbu _1itk1u11",
                "background-side-by-side"
            ]),
            style: {
                "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
                "--_1jwom28": (0, $6ZVlx.default)(backgroundImage)
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cDJ3u.default), {
                    headerType: rowHeaderType,
                    headerText: rowOneHeader,
                    lozenge: rowOneLozenge,
                    bodyText: rowOneBody,
                    imageLink: rowOneImageLink,
                    imageAltText: rowOneImageAltText,
                    imagePosition: rowOneImagePosition,
                    horizontalRule: isShowHorizontalRule,
                    className: "image-text-side-row-1",
                    eyebrowText: rowOneEyebrowText,
                    rowProps: rowPropsOdd
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cDJ3u.default), {
                    headerType: rowHeaderType,
                    headerText: rowTwoHeader,
                    lozenge: rowTwoLozenge,
                    bodyText: rowTwoBody,
                    imageLink: rowTwoImageLink,
                    imageAltText: rowTwoImageAltText,
                    horizontalRule: isShowHorizontalRule,
                    imagePosition: rowTwoImagePosition,
                    className: "image-text-side-row-2",
                    eyebrowText: rowTwoEyebrowText,
                    rowProps: rowPropsEven
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cDJ3u.default), {
                    headerType: rowHeaderType,
                    headerText: rowThreeHeader,
                    lozenge: rowThreeLozenge,
                    bodyText: rowThreeBody,
                    imageLink: rowThreeImageLink,
                    imageAltText: rowThreeImageAltText,
                    imagePosition: rowThreeImagePosition,
                    horizontalRule: isShowHorizontalRule,
                    className: "image-text-side-row-3",
                    eyebrowText: rowThreeEyebrowText,
                    rowProps: rowPropsOdd
                }),
                rowFourImageLink ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cDJ3u.default), {
                    headerType: rowHeaderType,
                    headerText: rowFourHeader,
                    lozenge: rowFourLozenge,
                    bodyText: rowFourBody,
                    imageLink: rowFourImageLink,
                    imageAltText: rowFourImageAltText,
                    imagePosition: rowFourImagePosition,
                    horizontalRule: isShowHorizontalRule,
                    className: "image-text-side-row-4",
                    eyebrowText: rowFourEyebrowText,
                    rowProps: rowPropsEven
                }) : null
            ]
        })
    });
};
$1f7cfd3057b21b6f$export$51a3e3286a1cf2b5.displayName = "ThreeAlternatingImageText";

});


parcelRegister("5IbWH", function(module, exports) {
$parcel$export(module.exports, "PaidCtaSection", function () { return $233fe779bf480799$export$5e5db24264a78d; });
/* paid-cta-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("jAgX3");
var $kS9hn = parcelRequire("kS9hn");
const $233fe779bf480799$var$ctaStyles = {
    "jira-software": "_syaz1m8h _12vemgnk _ouxl1ssb _1lrw1dfr _1itk14uh _1dhs103n",
    "jira-software-paid-ai": "_12vemgnk _ouxl1ssb _1lrw1dfr _bfhkcs0v _1itkg4np _1dhs2iov",
    "jira-software-anchor": "_syazr3uz _bfhkoelr _6vsiidpf _t0odidpf _mqkjidpf _xz03idpf",
    "jira-software-rebranded-anchor": "_syazr3uz _bfhkoelr _6vsiidpf _t0odidpf _mqkjidpf _xz03idpf",
    "jira-service-management": "_syazu67f _1itkj4zg _ouxl1ssb _1lrw1dfr _12vemgnk",
    "jira-service-management-anchor": "_syazu67f _1itk1k2f _ouxl1ssb _1lrw1dfr _12vemgnk",
    "confluence-paid": "_syazu67f _1itkuuyn _ouxl1ssb _1lrw1dfr _12vemgnk",
    "confluence-anchor": "_1itk1gd4 _ouxl1ssb _12vemgnk _1lrw1dfr _ol8u1keg _1rmvwbzg _1f9f995e _r2cimgnk _u6yg1f51",
    "confluence-rebranded-anchor": "_1itk1gd4 _ouxl1ssb _12vemgnk _1lrw1dfr _ol8u1keg _1rmvwbzg _1f9f995e _r2cimgnk _u6yg1f51"
};
const $233fe779bf480799$export$5e5db24264a78d = ({ ctaProps: ctaProps, landingType: landingType })=>{
    const { layout: ctaLayout = "10" } = ctaProps, otherCtaProps = (0, $aPnCa._)(ctaProps, [
        "layout"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            $233fe779bf480799$var$ctaStyles[landingType]
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
            layout: ctaLayout,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kS9hn.PaidCtaPrimary), (0, $6ogO3._)({}, otherCtaProps))
        })
    });
};
$233fe779bf480799$export$5e5db24264a78d.displayName = "PaidCta";

});
parcelRegister("jAgX3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("kS9hn")).PaidCtaPrimary; });

var $kS9hn = parcelRequire("kS9hn");

});
parcelRegister("kS9hn", function(module, exports) {
$parcel$export(module.exports, "PaidCtaPrimary", function () { return $d6db1ae86de58bc4$export$a88d1ab51f344f2e; });
/* paid-cta-primary.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
parcelRequire("9MMEE");
var $amfUr = parcelRequire("amfUr");
const $d6db1ae86de58bc4$var$ctaSectionBaseStyle = null;
const $d6db1ae86de58bc4$export$a88d1ab51f344f2e = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_xgyx1k8s _1xcsahaf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $amfUr.CTAPrimary), (0, $6ogO3._)({
            className: "cta-primary",
            backgroundProperties: {
                /* this is deprecated, but need it temporarily to override current behavior */ textColor: "n0"
            }
        }, props))
    });
};

});
parcelRegister("9MMEE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("amfUr")).CTAPrimary; });

var $amfUr = parcelRequire("amfUr");

});
parcelRegister("amfUr", function(module, exports) {
$parcel$export(module.exports, "CTAPrimary", function () { return $ee0917f296746ee7$export$2803c38b17523474; });
/* cta-primary.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2tb46 = parcelRequire("2tb46");

var $jMhSx = parcelRequire("jMhSx");
const $ee0917f296746ee7$var$ctaPrimaryStyle = null;
const $ee0917f296746ee7$export$2803c38b17523474 = ({ headerText: headerText, bodyText: bodyText, className: className, eyebrowText: eyebrowText, footNoteText: footNoteText, ctaProps: ctaProps, backgroundProperties: backgroundProperties })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.StyledBackground), (0, $dPABA._)((0, $6ogO3._)({}, backgroundProperties), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1akovbgk _c7s7idpf _4puvvbgk _1r3vidpf _y3gn1h6o _i6jxckbl _1lh7idpf _z3ncckbl _wpaiidpf _1kmxzwfg _1ggmidpf _1ykzzwfg _1maeidpf _1916oxwj _jti51ul9 _xjyr1wug _2thuidpf _hbr31wug",
                className
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: "primary-cta-content",
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2tb46.ContentBlock), {
                        isCentered: true,
                        headerText: headerText,
                        headerType: "h2",
                        eyebrowText: eyebrowText,
                        bodyText: bodyText,
                        ctaProps: ctaProps
                    }),
                    footNoteText ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: "footnote-text",
                        children: footNoteText
                    }) : null
                ]
            })
        })
    }));
};

});





parcelRegister("gQSoJ", function(module, exports) {
$parcel$export(module.exports, "PaidCustomHeroSection", function () { return $b8a06be8a2fd88ae$export$a51999b742dcc5f1; });

var $7VQPk = parcelRequire("7VQPk");
const $b8a06be8a2fd88ae$export$a51999b742dcc5f1 = ({ customHeroSection: // eslint-disable-next-line react/prop-types
customHeroSection })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: customHeroSection
    });
};
$b8a06be8a2fd88ae$export$a51999b742dcc5f1.displayName = "CustomHero";

});

parcelRegister("1SFKa", function(module, exports) {
$parcel$export(module.exports, "PaidCustomSection", function () { return $b72bd2469708963e$export$4781d68a90c3d141; });

var $7VQPk = parcelRequire("7VQPk");
const $b72bd2469708963e$export$4781d68a90c3d141 = ({ customSection: // eslint-disable-next-line react/prop-types
customSection })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: customSection
    });
};
$b72bd2469708963e$export$4781d68a90c3d141.displayName = "Custom";

});

parcelRegister("hbUAT", function(module, exports) {
$parcel$export(module.exports, "PaidHeroSectionTemplate", function () { return $900a26def99a782c$export$b2d485e7a33c4d4a; });
/* paid-hero-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $2u2Jd = parcelRequire("2u2Jd");

var $a0utR = parcelRequire("a0utR");
parcelRequire("kc6xi");
var $iL9dx = parcelRequire("iL9dx");
var $g85aC = parcelRequire("g85aC");

var $7kIQK = parcelRequire("7kIQK");

var $imIsw = parcelRequire("imIsw");

var $kbpa7 = parcelRequire("kbpa7");

var $1Q6XY = parcelRequire("1Q6XY");

var $3LcIp = parcelRequire("3LcIp");

var $32ng3 = parcelRequire("32ng3");

var $2gCne = parcelRequire("2gCne");

var $2ve7k = parcelRequire("2ve7k");

var $2opLs = parcelRequire("2opLs");
const $900a26def99a782c$var$formColumn = null;
const $900a26def99a782c$var$formColumnWithEyelash = null;
const $900a26def99a782c$var$HeaderEyelashStyle = null;
const $900a26def99a782c$var$contentStyle = null;
const $900a26def99a782c$var$withAnimation = null;
const $900a26def99a782c$var$signupFormContainer = null;
const $900a26def99a782c$var$headingBasicStyles = null;
const $900a26def99a782c$var$heavyFontWeightStyles = null;
const $900a26def99a782c$var$subheaderStyles = null;
const $900a26def99a782c$var$whiteFontColor = null;
const $900a26def99a782c$var$subheaderStylesWithEyelash = null;
const $900a26def99a782c$var$imgContainer = null;
const $900a26def99a782c$var$staticImageContainer = null;
const $900a26def99a782c$var$animationHeroContainer = null;
const $900a26def99a782c$var$carouselContainerStyles = null;
const $900a26def99a782c$var$squaresContainer = null;
const $900a26def99a782c$var$squareOne = null;
const $900a26def99a782c$var$squareTwo = null;
const $900a26def99a782c$var$eyelashStyle = null;
const $900a26def99a782c$var$serviceCollectionStyle = null;
const $900a26def99a782c$var$underlineStyles = null;
const $900a26def99a782c$var$strokeRight = null;
const $900a26def99a782c$var$accentImgStyles = null;
const $900a26def99a782c$var$AnimatedJiraTourStyles = null;
const $900a26def99a782c$var$heroImageSubheaderStyles = null;
const $900a26def99a782c$var$Squares = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _1bsb1osq _4t3i1lk2 _1e0c1txw _2lx21bp4"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _152tidpf _rjxpidpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                    width: "311",
                    height: "220",
                    viewBox: "0 0 311 220",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                            children: "square one"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M7.34559 1.71298L310.956 0.712733L305.579 218.935L0.637246 219.618L7.34559 1.71298Z",
                            fill: "#FFA900"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _u7coidpf _1e02idpf"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                    width: "252",
                    height: "219",
                    viewBox: "0 0 252 219",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("title", {
                            children: "square two"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M2.76007 0.226074H251.614V212.007L0.0842285 218.146L2.76007 0.226074Z",
                            fill: "#82B536"
                        })
                    ]
                })
            })
        ]
    });
};
const $900a26def99a782c$var$EyeLash = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        className: (0, $2jatx.default)([
            "_y44vlrv9 _kqswh2mm",
            "_kqswstnw _1e0c1o8l _152t1mi1 _1e02bx3o _1bsb1wpv _4t3ickbl _1s4pd6z3 _1kne1wpv _1rfm1f4h _tnru1u1b",
            "eyelash"
        ]),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/f0scafs8p034p4uxb1r3f84m05g8s742.svg",
            alt: "eyelash",
            width: 99,
            height: 50
        }
    });
};
const $900a26def99a782c$var$Scribble = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        className: (0, $2jatx.default)([
            "_y44vlrv9 _kqswh2mm",
            "_4t3i7vkz _1bsbl1r9 _6rth7vkz _dh1a1e5h _ag851e5h",
            "scribble"
        ]),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/4g12qeh147330006huh36yys682jpa05.svg",
            alt: "scribble",
            width: 90,
            height: 16
        }
    });
};
const $900a26def99a782c$var$ServiceCollectionLogoBrand = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/171f20t4om07135ujka42le40wvkp613.svg",
            alt: "service collection mark brand",
            width: 160
        }
    });
};
const $900a26def99a782c$var$AnimationWrapper = ({ lottieAnimationPromise: lottieAnimationPromise, riveAnimation: RiveAnimation })=>{
    const [lottieAnimationData, setLottieAnimationData] = (0, $1oC0p.useState)();
    (0, $1oC0p.useEffect)(()=>{
        (async ()=>{
            if (lottieAnimationPromise && !RiveAnimation) {
                const lottieAnimation = await lottieAnimationPromise;
                setLottieAnimationData(lottieAnimation);
            }
        })();
    }, [
        RiveAnimation,
        lottieAnimationPromise
    ]);
    if (RiveAnimation) return /*#__PURE__*/ (0, $7VQPk.jsx)(RiveAnimation, {});
    else if (lottieAnimationData) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2u2Jd))), {
        options: {
            loop: false,
            autoplay: true,
            animationData: lottieAnimationData,
            rendererSettings: {
                preserveAspectRatio: "xMidYMid slice"
            }
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        "data-testid": "default-animation",
        viewBox: "0 0 600 350",
        width: "600",
        height: "350",
        style: {
            width: "100%"
        }
    });
};
const $900a26def99a782c$export$b2d485e7a33c4d4a = ({ header: header, subheader: subheader, image: image, darkSolidTheme: darkSolidTheme, showAnimatedHero: showAnimatedHero, carouselHeroProps: carouselHeroProps, animatedJiraTourProps: animatedJiraTourProps, heroImageSubheader: heroImageSubheader, hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, showScribble: showScribble, showEyeLash: showEyeLash, animation: animation, hasBannerAlert: hasBannerAlert = false, heroBgColor: heroBgColor = "bgWhite", showFourSocialButtons: showFourSocialButtons, auxiaResponse: auxiaResponse, pageId: pageId })=>{
    var _carouselHeroProps_slides_, _carouselHeroProps_slides;
    // the default behavior is to show the animated hero image based on darkSolidTheme
    // however we can override this behavior if showAnimatedHero is explicitly set
    const showAnimated = showAnimatedHero !== undefined ? showAnimatedHero : !darkSolidTheme;
    (0, $1oC0p.useEffect)(()=>{
        const getaaCompleteQueryObj = (0, $2gCne.getLocalStorage)((0, $1Q6XY.AA_AUTOCOMPLETE_POTENTIAL_CONVERSION_EVENT_LOCAL_STORAGE_KEY));
        if (getaaCompleteQueryObj) {
            const parsedStringifyAttributes = JSON.parse(getaaCompleteQueryObj);
            (0, $1Q6XY.sendConversionEventAlgolia)({
                objectID: parsedStringifyAttributes.objectID,
                queryID: parsedStringifyAttributes.queryID,
                position: parsedStringifyAttributes.position
            });
        }
    }, []);
    const anchorsWithServiceCollectionHeader = [
        "anchor-lp-jsm-esm",
        "anchor-lp-jsm-team-operations",
        "paid-lp-jsm-features",
        "paid-lp-jsm-itsm"
    ];
    const showServiceCollectionHeader = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).gwp9287JSMAnchorUpdates) && Boolean(pageId && anchorsWithServiceCollectionHeader.includes(pageId));
    const enhableCustomerServiceManagementVariant = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).enableCsmAjLogo) && pageId === "anchor-lp-jsm-csm";
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _zulpzwfg _85i5gad4 _1bah1h6o _4cvr1h6o _ogq01wqb _p56c1wqb _na0i1bp4 _v736zwfg _chtuzwfg",
            animation && "_na0i1sxn",
            !hasBannerAlert && "_1q512to5"
        ]),
        style: {
            "--_1grn0ad": (0, $6ZVlx.default)(darkSolidTheme ? "60px" : "40px")
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _16jlkb7n _10jxdgin _dh1a1h6o",
                    showEyeLash && "_10jx1kx4",
                    heroBgColor !== "bgWhite" && "_syazcd5j"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            showEyeLash && "_kqswh2mm"
                        ]),
                        children: [
                            showEyeLash && /*#__PURE__*/ (0, $7VQPk.jsx)($900a26def99a782c$var$EyeLash, {}),
                            (enhableCustomerServiceManagementVariant || showServiceCollectionHeader) && /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                className: (0, $2jatx.default)([
                                    "_1e0c116y _4cvr1h6o _zulp1xs6 _k48p1kze"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        children: "PART OF"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($900a26def99a782c$var$ServiceCollectionLogoBrand, {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                                className: (0, $2jatx.default)([
                                    "_1dyzidpf _1pfhidpf _6rthidpf _k48pbfng _1wybviql _vwz410nf _y3gn1h6o _uj6k1e5h _1hwfyn4p _cr9zzz36 _1awl7vkz _h60i1wto _s3b91k7u _1qir1tcg",
                                    hasRebrandedSignupFormStyles && "_k48p9y44"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsHeaderWrapper), {
                                    product: "confluence",
                                    type: "header",
                                    children: header
                                })
                            })
                        ]
                    }),
                    darkSolidTheme && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_6rth7vkz _y3gn1h6o _uj6k1e5h",
                            heroBgColor !== "bgWhite" && "_syazcd5j"
                        ]),
                        style: {
                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                        },
                        children: subheader
                    }),
                    showScribble && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                className: (0, $2jatx.default)([
                                    "_syaz1hlo _ect4bzd7 _1wyb7vkz _zg8l4jg8 _k48p1nn1 _vwz41tcg _1mjb1txw _o5kc1e5h"
                                ]),
                                style: {
                                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                    "--_1ikmwd8": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("font.charlie.text"))
                                },
                                children: subheader
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)($900a26def99a782c$var$Scribble, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_p12f1feq _1bsb1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ve7k.ClientOnly), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2opLs.PaidAccountCreation), {
                                darkSolidTheme: darkSolidTheme,
                                showFourSocialButtons: showFourSocialButtons,
                                auxiaResponse: auxiaResponse,
                                pageId: pageId
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _p12fcv93"
                ]),
                children: [
                    animation && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($900a26def99a782c$var$AnimationWrapper, (0, $6ogO3._)({}, animation))
                    }),
                    showAnimated && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_kqswh2mm _1h1th1c8 _4t3i1wug _1tket94y _1bsb1osq _1ul91c3h _p12f1c3h _1e0c1txw _4cvr1h6o _1bah1h6o _s6371ogm _1y8o1c3h _1mjbglyw _ca0q1ul9 _u5f31ul9 _n3td1ul9 _19bv1ul9"
                        ]),
                        children: [
                            (darkSolidTheme || hasRebrandedSignupFormStyles) && /*#__PURE__*/ (0, $7VQPk.jsx)($900a26def99a782c$var$Squares, {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7kIQK.AnimatedJiraTour), (0, $dPABA._)((0, $6ogO3._)({}, animatedJiraTourProps), {
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _152t16gx _rjxp9by0 _1e029by0 _u7co16gx _1pbyzo7u"
                                ])
                            }))
                        ]
                    }),
                    carouselHeroProps ? ((_carouselHeroProps_slides = carouselHeroProps.slides) === null || _carouselHeroProps_slides === void 0 ? void 0 : (_carouselHeroProps_slides_ = _carouselHeroProps_slides[0]) === null || _carouselHeroProps_slides_ === void 0 ? void 0 : _carouselHeroProps_slides_["videoSrcMp4"]) ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _1e0c1txw _1bah1h6o _1bsbcv93 _4t3i1ogm _1rfm1osq _tnru1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g85aC.VideoCarousel), (0, $6ogO3._)({}, carouselHeroProps))
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3LcIp.BanditsAssetWrapper), {
                        product: "confluence",
                        showChildren: false,
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4cvr1h6o _1e0c1txw _1bah1h6o _1bsbcv93 _4t3i1ogm _1rfm1osq _tnru1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iL9dx.Carousel), (0, $6ogO3._)({}, carouselHeroProps))
                        })
                    }) : (image || heroImageSubheader) && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            showAnimated ? "_1e0cglyw _1mjb1txw _o5kc1h6o _na0i1bp4" : "_1bsbstmo _1wpz1h6o _1mjb1txw _o5kc1h6o _na0i1bp4 _1rfm1wug"
                        ]),
                        children: [
                            image && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                                image: image,
                                style: {
                                    maxWidth: "100%",
                                    height: "auto"
                                }
                            }),
                            heroImageSubheader && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: (0, (/*@__PURE__*/$parcel$interopDefault($a0utR)))(heroImageSubheader)
                                },
                                className: (0, $2jatx.default)([
                                    "_ca0qidpf _u5f39by0 _n3tdidpf _19bv9by0",
                                    heroBgColor !== "bgWhite" && "_syazcd5j"
                                ]),
                                style: {
                                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$900a26def99a782c$export$b2d485e7a33c4d4a.displayName = "PaidHero";

});
parcelRegister("7kIQK", function(module, exports) {
$parcel$export(module.exports, "AnimatedJiraTour", function () { return $6bd89d44ae526403$export$d6ccd257c217bac1; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $jbJhA = parcelRequire("jbJhA");

var $kBmd7 = parcelRequire("kBmd7");

var $14aie = parcelRequire("14aie");

var $fECb5 = parcelRequire("fECb5");
const $6bd89d44ae526403$export$d6ccd257c217bac1 = (props)=>{
    const [{ animationStep: animationStep }, { setMessages: setMessages }] = (0, $fECb5.useAnimatedJiraBoardStore)();
    const isCardTyping = (0, $1oC0p.useMemo)(()=>{
        return animationStep === (0, $kBmd7.AnimationSteps).CARD_TYPING;
    }, [
        animationStep
    ]);
    const intl = (0, $8e22h.default)();
    const messages = {
        toDo: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.toDo",
            defaultMessage: "To Do"
        }),
        inProgress: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.inProgress",
            defaultMessage: "In Progress"
        }),
        done: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.done",
            defaultMessage: "Done"
        }),
        todoStaticLabel: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.todoStaticLabel",
            defaultMessage: "Design AI shopping suggestions for homepage"
        }),
        inProgStaticLabel1: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.inProgStaticLabel1",
            defaultMessage: "Create AI-generated shopping suggestions for homepage"
        }),
        inProgStaticLabel2: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.inProgStaticLabel2",
            defaultMessage: "Add advanced analytics tracking events"
        }),
        doneStaticLabel1: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.doneStaticLabel1",
            defaultMessage: "Improve payment checkout time on mobile"
        }),
        doneStaticLabel2: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.doneStaticLabel2",
            defaultMessage: "Define requirements to use new AI integrations"
        }),
        animatedCardHeading: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.animatedCardHeading",
            defaultMessage: "Design new billing API"
        }),
        createIssueModalIssueTypeAssetLabel1: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalIssueTypeAssetLabel1",
            defaultMessage: "Issue type: Task"
        }),
        createIssueModalIssueTypeAssetLabel2: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalIssueTypeAssetLabel2",
            defaultMessage: "Issue type: Story"
        }),
        createIssueModalIssueTypeAssetLabel3: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalIssueTypeAssetLabel3",
            defaultMessage: "Issue type: Bug"
        }),
        createIssueModalPriorityAssetLabel1: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalPriorityAssetLabel1",
            defaultMessage: "Priority: High"
        }),
        createIssueModalPriorityAssetLabel2: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalPriorityAssetLabel2",
            defaultMessage: "Priority: Critical"
        }),
        createIssueModalPriorityAssetLabel3: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalPriorityAssetLabel3",
            defaultMessage: "Priority: Blocker"
        }),
        createIssueModalPriorityAssetLabel4: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalPriorityAssetLabel4",
            defaultMessage: "Priority: Minor"
        }),
        createIssueModalAssigneeAssetLabel1: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalAssigneeAssetLabel1",
            defaultMessage: "Assignee: Alvin"
        }),
        createIssueModalAssigneeAssetLabel2: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalAssigneeAssetLabel2",
            defaultMessage: "Assignee: Jane"
        }),
        createIssueModalAssigneeAssetLabel3: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.createIssueModalAssigneeAssetLabel3",
            defaultMessage: "Assignee: Blake"
        }),
        epicNameFeatures: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicNameFeatures",
            defaultMessage: "features"
        }),
        epicNameAnalytics: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicNameAnalytics",
            defaultMessage: "analytics"
        }),
        epicNamePayments: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicNamePayments",
            defaultMessage: "payments"
        }),
        priorityHigh: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.priorityHigh",
            defaultMessage: "high"
        }),
        priorityCritical: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.priorityCritical",
            defaultMessage: "critical"
        }),
        priorityMinor: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.priorityMinor",
            defaultMessage: "minor"
        }),
        priorityBlocker: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.priorityBlocker",
            defaultMessage: "blocker"
        }),
        issueTypeBug: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.issueTypeBug",
            defaultMessage: "bug"
        }),
        issueTypeStory: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.issueTypeStory",
            defaultMessage: "story"
        }),
        issueTypeTask: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.issueTypeTask",
            defaultMessage: "task"
        }),
        epicNameAssets: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicNameAssets",
            defaultMessage: "assets"
        }),
        epicNameStrategy: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicNameStrategy",
            defaultMessage: "strategy"
        }),
        epicNameBudget: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicNameBudget",
            defaultMessage: "budget"
        }),
        epicNameQ1Campaign: intl.formatMessage({
            id: "animated-jira-tour.constants.messages.epicQ1Campaign",
            defaultMessage: "q1 campaign"
        })
    };
    (0, $1oC0p.useState)(()=>{
        setMessages(messages);
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            isCardTyping && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbJhA.AnimatedTypingCard), {
                card: props.animatedJiraCardOverride
            }),
            !isCardTyping && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $14aie.JswAnimatedBoard), {
                inProgressCardsOverride: props.inProgressCardsOverride,
                doneCardsOverride: props.doneCardsOverride
            })
        ]
    });
};

});
parcelRegister("jbJhA", function(module, exports) {
$parcel$export(module.exports, "AnimatedTypingCard", function () { return $a4a4019f0ef6700f$export$6e2fcd8758e3fff8; });
/* animated-typing-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $kBmd7 = parcelRequire("kBmd7");
parcelRequire("b6pjw");
var $hqndQ = parcelRequire("hqndQ");
var $lUW15 = parcelRequire("lUW15");

var $fECb5 = parcelRequire("fECb5");
const $a4a4019f0ef6700f$var$cardStyles = null;
const $a4a4019f0ef6700f$var$cardTitleWrapper = null;
const $a4a4019f0ef6700f$var$cardTitle = null;
const $a4a4019f0ef6700f$var$issueTypeContainer = null;
const $a4a4019f0ef6700f$var$typePriorityAssigneeRow = null;
const $a4a4019f0ef6700f$var$animateCard = null;
const $a4a4019f0ef6700f$export$6e2fcd8758e3fff8 = (props)=>{
    // constants
    const id = (0, $kBmd7.ANIMATED_CARD_ID);
    const issueType = (0, $kBmd7.IssueTypeName).STORY;
    const [{ messages: messages }, { animateIssue: animateIssue, nextAnimationStep: nextAnimationStep }] = (0, $fECb5.useAnimatedJiraBoardStore)();
    const cardDetails = (0, $1oC0p.useMemo)(()=>{
        return (0, $dPABA._)((0, $6ogO3._)({
            summary: messages.animatedCardHeading,
            issueType: issueType,
            epicName: (0, $kBmd7.EpicName).FEATURES,
            assignee: (0, $kBmd7.Assignee).ALVIN,
            priority: (0, $kBmd7.Priority).HIGH
        }, props.card), {
            id: id
        });
    }, [
        id,
        issueType,
        messages.animatedCardHeading,
        props.card
    ]);
    const issueTypeElement = (0, $lUW15.getAssetOptionsForIssueType)(cardDetails.issueType, messages, true);
    (0, $1oC0p.useEffect)(()=>{
        setTimeout(()=>{
            nextAnimationStep();
            animateIssue(cardDetails);
        }, 4200);
    }, [
        animateIssue,
        cardDetails,
        nextAnimationStep
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "aria-describedby": id,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1yb4 _syaz10fz _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _2rko19bv _11q7cd5j _1bsbdgin _4t3iuuw1 _16qs1ie2 _1reo15vq _18m915vq",
            "_y44vyt1s"
        ]),
        style: {
            "--_1vqiml3": (0, $6ZVlx.default)((0, $hqndQ.colors).text),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1ns9"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    id: id,
                    className: (0, $2jatx.default)([
                        "_syaz1765 _1wyb1tcg _zg8l4jg8 _k48pni7l _1bsb1osq _vwz41wqb _1reo15vq _18m915vq _t51zuaqw _o5721q9c _y44vn48t"
                    ]),
                    style: {
                        "--_1jttx64": (0, $6ZVlx.default)((0, $hqndQ.colors).black),
                        "--_1cyyhae": (0, $6ZVlx.default)((0, $hqndQ.colors).textSelected)
                    },
                    children: cardDetails.summary
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc",
                    "type-priority-assignee-row"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx2vrvc _4cvr1h6o _zulp14y2",
                        "issue-type-container"
                    ]),
                    children: issueTypeElement
                })
            })
        ]
    });
};

});
parcelRegister("kBmd7", function(module, exports) {
$parcel$export(module.exports, "AnimationSteps", function () { return $1ab14393aeb9d856$export$34f7398b19a809cb; });
$parcel$export(module.exports, "IssueTypeName", function () { return $1ab14393aeb9d856$export$41bec0868bbe9664; });
$parcel$export(module.exports, "EpicName", function () { return $1ab14393aeb9d856$export$82af5b919cf981f7; });
$parcel$export(module.exports, "Assignee", function () { return $1ab14393aeb9d856$export$361f73eba39649ac; });
$parcel$export(module.exports, "Priority", function () { return $1ab14393aeb9d856$export$300334f671c43555; });
$parcel$export(module.exports, "stepsLength", function () { return $1ab14393aeb9d856$export$33096039fd990cf4; });
$parcel$export(module.exports, "ANIMATED_CARD_ID", function () { return $1ab14393aeb9d856$export$a04d920b5f45f5a4; });
var $1ab14393aeb9d856$export$34f7398b19a809cb = /*#__PURE__*/ function(AnimationSteps) {
    AnimationSteps[AnimationSteps["CARD_TYPING"] = 0] = "CARD_TYPING";
    AnimationSteps[AnimationSteps["TODO_COL"] = 1] = "TODO_COL";
    AnimationSteps[AnimationSteps["IN_PROG_COL"] = 2] = "IN_PROG_COL";
    AnimationSteps[AnimationSteps["DONE_COL"] = 3] = "DONE_COL";
    return AnimationSteps;
}({});
var $1ab14393aeb9d856$export$b6032183171af19f = /*#__PURE__*/ function(Project) {
    Project["TeamRocket"] = "team-rocket";
    return Project;
}({});
var $1ab14393aeb9d856$export$41bec0868bbe9664 = /*#__PURE__*/ function(IssueTypeName) {
    IssueTypeName["TASK"] = "task";
    IssueTypeName["STORY"] = "story";
    IssueTypeName["BUG"] = "bug";
    IssueTypeName["NO_ISSUE"] = "no-issue";
    return IssueTypeName;
}({});
var $1ab14393aeb9d856$export$82af5b919cf981f7 = /*#__PURE__*/ function(EpicName) {
    EpicName["FEATURES"] = "features";
    EpicName["ANALYTICS"] = "analytics";
    EpicName["PAYMENTS"] = "payments";
    EpicName["ASSETS"] = "assets";
    EpicName["STRATEGY"] = "strategy";
    EpicName["BUDGET"] = "budget";
    EpicName["Q1_CAMPAIGN"] = "q1 campaign";
    return EpicName;
}({});
var $1ab14393aeb9d856$export$361f73eba39649ac = /*#__PURE__*/ function(Assignee) {
    Assignee["ALVIN"] = "alvin";
    Assignee["JANE"] = "jane";
    Assignee["BLAKE"] = "blake";
    return Assignee;
}({});
var $1ab14393aeb9d856$export$300334f671c43555 = /*#__PURE__*/ function(Priority) {
    Priority["HIGH"] = "high";
    Priority["CRITICAL"] = "critical";
    Priority["BLOCKER"] = "blocker";
    Priority["MINOR"] = "minor";
    return Priority;
}({});
const $1ab14393aeb9d856$export$33096039fd990cf4 = Object.keys($1ab14393aeb9d856$export$34f7398b19a809cb).length / 2;
const $1ab14393aeb9d856$export$22aad1fd6cb58c70 = 255;
const $1ab14393aeb9d856$export$938f0a0c059b7000 = 3000;
const $1ab14393aeb9d856$export$a04d920b5f45f5a4 = "animated-card";

});

parcelRegister("b6pjw", function(module, exports) {
$parcel$export(module.exports, "colors", function () { return (parcelRequire("hqndQ")).colors; });
$parcel$export(module.exports, "getAssetForEpicLink", function () { return (parcelRequire("lUW15")).getAssetForEpicLink; });
$parcel$export(module.exports, "getAssetOptionsForAssignee", function () { return (parcelRequire("lUW15")).getAssetOptionsForAssignee; });
$parcel$export(module.exports, "getAssetOptionsForIssueType", function () { return (parcelRequire("lUW15")).getAssetOptionsForIssueType; });
$parcel$export(module.exports, "getAssetOptionsForPriority", function () { return (parcelRequire("lUW15")).getAssetOptionsForPriority; });
parcelRequire("hqndQ");
parcelRequire("lUW15");

});
parcelRegister("hqndQ", function(module, exports) {
$parcel$export(module.exports, "colors", function () { return $75d2912f8d2ad80e$export$8f45430ccf837300; });
/* eslint-disable local/ensure-wac-token-usage */ // custom colors that are not covered by wacToken
const $75d2912f8d2ad80e$export$8f45430ccf837300 = {
    black: "#000000",
    elevationSurfaceSunken: "#F7F8F9",
    text: "#172B4D",
    textSelected: "#0C66E4",
    textSubtle: "#44546F"
};

});

parcelRegister("lUW15", function(module, exports) {
$parcel$export(module.exports, "getAssetOptionsForIssueType", function () { return $12a7f239a660e5a9$export$d3e272371e479228; });
$parcel$export(module.exports, "getAssetOptionsForPriority", function () { return $12a7f239a660e5a9$export$5aec24a3628dae7c; });
$parcel$export(module.exports, "getAssetOptionsForAssignee", function () { return $12a7f239a660e5a9$export$d910478ee874e351; });
$parcel$export(module.exports, "getAssetForEpicLink", function () { return $12a7f239a660e5a9$export$2eeaca611ab4ba57; });
/* get-asset-options.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $hOmYB = parcelRequire("hOmYB");

var $7eewv = parcelRequire("7eewv");

var $40E4L = parcelRequire("40E4L");

var $20Gca = parcelRequire("20Gca");
parcelRequire("1yTnJ");
var $bH45K = parcelRequire("bH45K");
var $7cimc = parcelRequire("7cimc");
var $a82K6 = parcelRequire("a82K6");
var $iiNtx = parcelRequire("iiNtx");
var $51yZS = parcelRequire("51yZS");
var $e6xlA = parcelRequire("e6xlA");
var $gT217 = parcelRequire("gT217");

var $kBmd7 = parcelRequire("kBmd7");
const $12a7f239a660e5a9$var$issueText = null;
const $12a7f239a660e5a9$export$d3e272371e479228 = (value, messages, includeLabel)=>{
    const { createIssueModalIssueTypeAssetLabel1: createIssueModalIssueTypeAssetLabel1, createIssueModalIssueTypeAssetLabel2: createIssueModalIssueTypeAssetLabel2, createIssueModalIssueTypeAssetLabel3: createIssueModalIssueTypeAssetLabel3 } = includeLabel ? messages : {
        createIssueModalIssueTypeAssetLabel1: "",
        createIssueModalIssueTypeAssetLabel2: "",
        createIssueModalIssueTypeAssetLabel3: ""
    };
    switch(value){
        case (0, $kBmd7.IssueTypeName).TASK:
            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($40E4L))), {
                        label: createIssueModalIssueTypeAssetLabel1
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": true,
                        className: (0, $2jatx.default)([
                            "_1p1dangw _ahbq1y44 _1wyb1skh _zg8l4jg8 _k48p1fw0 _vwz47vkz"
                        ]),
                        children: messages.issueTypeTask
                    })
                ]
            });
        case (0, $kBmd7.IssueTypeName).STORY:
            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7eewv))), {
                        label: createIssueModalIssueTypeAssetLabel2
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": true,
                        className: (0, $2jatx.default)([
                            "_1p1dangw _ahbq1y44 _1wyb1skh _zg8l4jg8 _k48p1fw0 _vwz47vkz"
                        ]),
                        children: messages.issueTypeStory
                    })
                ]
            });
        case (0, $kBmd7.IssueTypeName).BUG:
            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hOmYB))), {
                        label: createIssueModalIssueTypeAssetLabel3
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "aria-hidden": true,
                        className: (0, $2jatx.default)([
                            "_1p1dangw _ahbq1y44 _1wyb1skh _zg8l4jg8 _k48p1fw0 _vwz47vkz"
                        ]),
                        children: messages.issueTypeBug
                    })
                ]
            });
        case (0, $kBmd7.IssueTypeName).NO_ISSUE:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {});
        default:
            console.warn(`Asset for issue type ${value} does not exist.`);
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($40E4L))), {
                label: createIssueModalIssueTypeAssetLabel1
            });
    }
};
const $12a7f239a660e5a9$export$5aec24a3628dae7c = (value, messages, includeLabel)=>{
    const { createIssueModalPriorityAssetLabel1: createIssueModalPriorityAssetLabel1, createIssueModalPriorityAssetLabel2: createIssueModalPriorityAssetLabel2, createIssueModalPriorityAssetLabel3: createIssueModalPriorityAssetLabel3, createIssueModalPriorityAssetLabel4: createIssueModalPriorityAssetLabel4 } = includeLabel ? messages : {
        createIssueModalPriorityAssetLabel1: "",
        createIssueModalPriorityAssetLabel2: "",
        createIssueModalPriorityAssetLabel3: "",
        createIssueModalPriorityAssetLabel4: ""
    };
    switch(value){
        case (0, $kBmd7.Priority).HIGH:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e6xlA.PriorityHigh16Icon), {
                label: createIssueModalPriorityAssetLabel1
            });
        case (0, $kBmd7.Priority).CRITICAL:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $51yZS.PriorityCritical24Icon), {
                label: createIssueModalPriorityAssetLabel2
            });
        case (0, $kBmd7.Priority).BLOCKER:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iiNtx.PriorityBlocker24Icon), {
                label: createIssueModalPriorityAssetLabel3
            });
        case (0, $kBmd7.Priority).MINOR:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gT217.PriorityMinor24Icon), {
                label: createIssueModalPriorityAssetLabel4
            });
        default:
            console.warn(`Asset for priority ${value} does not exist.`);
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gT217.PriorityMinor24Icon), {
                label: createIssueModalPriorityAssetLabel1
            });
    }
};
const $12a7f239a660e5a9$export$d910478ee874e351 = (value, messages, includeLabel)=>{
    const { createIssueModalAssigneeAssetLabel1: createIssueModalAssigneeAssetLabel1, createIssueModalAssigneeAssetLabel2: createIssueModalAssigneeAssetLabel2, createIssueModalAssigneeAssetLabel3: createIssueModalAssigneeAssetLabel3 } = includeLabel ? messages : {
        createIssueModalAssigneeAssetLabel1: "",
        createIssueModalAssigneeAssetLabel2: "",
        createIssueModalAssigneeAssetLabel3: ""
    };
    switch(value){
        case (0, $kBmd7.Assignee).ALVIN:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bH45K.AssigneeAlvin24Image), {
                alt: createIssueModalAssigneeAssetLabel1
            });
        case (0, $kBmd7.Assignee).JANE:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a82K6.AssigneeJane24Image), {
                alt: createIssueModalAssigneeAssetLabel2
            });
        case (0, $kBmd7.Assignee).BLAKE:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7cimc.AssigneeBlake24Image), {
                alt: createIssueModalAssigneeAssetLabel3
            });
        default:
            console.warn(`Asset for assignee ${value} does not exist.`);
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bH45K.AssigneeAlvin24Image), {
                alt: createIssueModalAssigneeAssetLabel1
            });
    }
};
const $12a7f239a660e5a9$export$2eeaca611ab4ba57 = (value, messages)=>{
    switch(value){
        case (0, $kBmd7.EpicName).FEATURES:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                appearance: "inprogress",
                isBold: true,
                children: messages.epicNameFeatures
            });
        case (0, $kBmd7.EpicName).ANALYTICS:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                appearance: "success",
                isBold: true,
                children: messages.epicNameAnalytics
            });
        case (0, $kBmd7.EpicName).PAYMENTS:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                appearance: "new",
                isBold: true,
                children: messages.epicNamePayments
            });
        case (0, $kBmd7.EpicName).ASSETS:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                appearance: "moved",
                isBold: true,
                children: messages.epicNameAssets
            });
        case (0, $kBmd7.EpicName).STRATEGY:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                appearance: "inprogress",
                isBold: true,
                children: messages.epicNameStrategy
            });
        case (0, $kBmd7.EpicName).BUDGET:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                appearance: "success",
                isBold: true,
                children: messages.epicNameBudget
            });
        case (0, $kBmd7.EpicName).Q1_CAMPAIGN:
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                appearance: "inprogress",
                isBold: true,
                children: messages.epicNameQ1Campaign
            });
        default:
            console.warn(`Asset for epic link ${value} does not exist.`);
            return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $20Gca.default), {
                appearance: "inprogress",
                isBold: true,
                children: value
            });
    }
};

});
parcelRegister("hOmYB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0358a8ff4a407f31$var$_react = $0358a8ff4a407f31$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $cBRzT = parcelRequire("cBRzT");
function $0358a8ff4a407f31$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0358a8ff4a407f31$var$Bug16Icon = (props)=>/*#__PURE__*/ $0358a8ff4a407f31$var$_react.default.createElement($cBRzT.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 12a4 4 0 100-8 4 4 0 000 8z"/></svg>`
    }, props, {
        size: "small"
    }));
$0358a8ff4a407f31$var$Bug16Icon.displayName = 'Bug16Icon';
var $0358a8ff4a407f31$var$_default = $0358a8ff4a407f31$var$Bug16Icon;
module.exports.default = $0358a8ff4a407f31$var$_default;

});

parcelRegister("40E4L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2eb63fb6ac66ecfc$var$_react = $2eb63fb6ac66ecfc$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $cBRzT = parcelRequire("cBRzT");
function $2eb63fb6ac66ecfc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2eb63fb6ac66ecfc$var$Task16Icon = (props)=>/*#__PURE__*/ $2eb63fb6ac66ecfc$var$_react.default.createElement($cBRzT.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0114.006 16H1.994A1.995 1.995 0 010 14.006V1.994zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3H4.667zM5 5v6h6V5H5z"/></svg>`
    }, props, {
        size: "small"
    }));
$2eb63fb6ac66ecfc$var$Task16Icon.displayName = 'Task16Icon';
var $2eb63fb6ac66ecfc$var$_default = $2eb63fb6ac66ecfc$var$Task16Icon;
module.exports.default = $2eb63fb6ac66ecfc$var$_default;

});

parcelRegister("1yTnJ", function(module, exports) {
$parcel$export(module.exports, "PriorityHigh16Icon", function () { return (parcelRequire("e6xlA")).PriorityHigh16Icon; });
$parcel$export(module.exports, "PriorityCritical24Icon", function () { return (parcelRequire("51yZS")).PriorityCritical24Icon; });
$parcel$export(module.exports, "PriorityBlocker24Icon", function () { return (parcelRequire("iiNtx")).PriorityBlocker24Icon; });
$parcel$export(module.exports, "PriorityMinor24Icon", function () { return (parcelRequire("gT217")).PriorityMinor24Icon; });
$parcel$export(module.exports, "AssigneeAlvin24Image", function () { return (parcelRequire("bH45K")).AssigneeAlvin24Image; });
$parcel$export(module.exports, "AssigneeJane24Image", function () { return (parcelRequire("a82K6")).AssigneeJane24Image; });
$parcel$export(module.exports, "AssigneeBlake24Image", function () { return (parcelRequire("7cimc")).AssigneeBlake24Image; });

var $e6xlA = parcelRequire("e6xlA");

var $51yZS = parcelRequire("51yZS");

var $iiNtx = parcelRequire("iiNtx");

var $gT217 = parcelRequire("gT217");

var $bH45K = parcelRequire("bH45K");

var $a82K6 = parcelRequire("a82K6");

var $7cimc = parcelRequire("7cimc");

});
parcelRegister("e6xlA", function(module, exports) {
$parcel$export(module.exports, "PriorityHigh16Icon", function () { return $325886629e40a140$export$dd6325c289ca803; });
/* icon-priority-high.tsx generated by @compiled/babel-plugin v0.28.8 */ // eslint-disable-next-line unused-imports/no-unused-imports

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $3c7rQ = parcelRequire("3c7rQ");
const $325886629e40a140$var$styles = {
    container: "_1e0c1o8l _1o9zidpf",
    svg: "_p12f1osq _c71l1osq _s7n4yfq0 _lcxvglyw"
};
const $325886629e40a140$export$dd6325c289ca803 = ({ label: label })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        role: "img",
        "aria-label": label,
        className: (0, $2jatx.default)([
            $325886629e40a140$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
            width: 17,
            height: 16,
            viewBox: "0 0 17 16",
            fill: "none",
            focusable: "false",
            xmlns: "http://www.w3.org/2000/svg",
            className: (0, $2jatx.default)([
                $325886629e40a140$var$styles.svg
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M9.34379 4.09779L9.41258 4.14609L12.7459 6.81275C13.0334 7.04276 13.08 7.46229 12.85 7.7498C12.6377 8.01519 12.2639 8.07532 11.9815 7.9021L11.913 7.85391L8.99612 5.52L6.07925 7.85391C5.81386 8.06623 5.43597 8.04284 5.1985 7.81185L5.14221 7.7498C4.92989 7.48441 4.95328 7.10652 5.18427 6.86905L5.24632 6.81275L8.57965 4.14609C8.801 3.96901 9.10705 3.95291 9.34379 4.09779Z",
                fill: (0, $3c7rQ.R300)
            })
        })
    });
};

});

parcelRegister("51yZS", function(module, exports) {
$parcel$export(module.exports, "PriorityCritical24Icon", function () { return $84ba360527c1138c$export$e8c8b58c821b2482; });
/* icon-priority-critical.tsx generated by @compiled/babel-plugin v0.28.8 */ // eslint-disable-next-line unused-imports/no-unused-imports

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $3c7rQ = parcelRequire("3c7rQ");
const $84ba360527c1138c$var$styles = {
    container: "_1e0c1o8l _1o9zidpf",
    svg: "_p12f1osq _c71l1osq _s7n4yfq0 _lcxvglyw"
};
const $84ba360527c1138c$export$e8c8b58c821b2482 = ({ label: label })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        role: "img",
        "aria-label": label,
        className: (0, $2jatx.default)([
            $84ba360527c1138c$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            fill: "none",
            focusable: "false",
            xmlns: "http://www.w3.org/2000/svg",
            className: (0, $2jatx.default)([
                $84ba360527c1138c$var$styles.svg
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M11.3753 4.21913L6.3753 8.21913C6.13809 8.4089 6 8.69622 6 9V19L6.00589 19.112C6.08752 19.8788 6.99969 20.2809 7.6247 19.7809L12 16.28L16.3753 19.7809C17.0301 20.3047 18 19.8385 18 19V9C18 8.69622 17.8619 8.4089 17.6247 8.21913L12.6247 4.21913C12.2595 3.92696 11.7405 3.92696 11.3753 4.21913Z",
                fill: (0, $3c7rQ.R300)
            })
        })
    });
};

});

parcelRegister("iiNtx", function(module, exports) {
$parcel$export(module.exports, "PriorityBlocker24Icon", function () { return $fde001e159fcfa32$export$13dfa89176f2d0ab; });
/* icon-priority-blocker.tsx generated by @compiled/babel-plugin v0.28.8 */ // eslint-disable-next-line unused-imports/no-unused-imports

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $3c7rQ = parcelRequire("3c7rQ");
const $fde001e159fcfa32$var$styles = {
    container: "_1e0c1o8l _1o9zidpf",
    svg: "_p12f1osq _c71l1osq _s7n4yfq0 _lcxvglyw"
};
const $fde001e159fcfa32$export$13dfa89176f2d0ab = ({ label: label })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        role: "img",
        "aria-label": label,
        className: (0, $2jatx.default)([
            $fde001e159fcfa32$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            fill: "none",
            focusable: "false",
            xmlns: "http://www.w3.org/2000/svg",
            className: (0, $2jatx.default)([
                $fde001e159fcfa32$var$styles.svg
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM7 11L6.88338 11.0067C6.38604 11.0645 6 11.4872 6 12C6 12.5523 6.44772 13 7 13H17L17.1166 12.9933C17.614 12.9355 18 12.5128 18 12C18 11.4477 17.5523 11 17 11H7Z",
                fill: (0, $3c7rQ.R300)
            })
        })
    });
};

});

parcelRegister("gT217", function(module, exports) {
$parcel$export(module.exports, "PriorityMinor24Icon", function () { return $25f70f969b862d64$export$7da8240bfa3b7af4; });
/* icon-priority-minor.tsx generated by @compiled/babel-plugin v0.28.8 */ // eslint-disable-next-line unused-imports/no-unused-imports

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $25f70f969b862d64$var$styles = {
    container: "_1e0c1o8l _1o9zidpf",
    svg: "_p12f1osq _c71l1osq _s7n4yfq0 _lcxvglyw"
};
const $25f70f969b862d64$export$7da8240bfa3b7af4 = ({ label: label })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
        role: "img",
        "aria-label": label,
        className: (0, $2jatx.default)([
            $25f70f969b862d64$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            fill: "none",
            focusable: "false",
            xmlns: "http://www.w3.org/2000/svg",
            className: (0, $2jatx.default)([
                $25f70f969b862d64$var$styles.svg
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M18.4491 14.975C18.6764 14.8427 18.9468 14.8054 19.2015 14.871C19.4563 14.9367 19.6749 15.1001 19.81 15.3258C19.9451 15.5516 19.9858 15.8214 19.9233 16.077C19.8608 16.3325 19.7001 16.5531 19.4761 16.691L12.5061 20.864C12.3503 20.9571 12.1722 21.0062 11.9908 21.0058C11.8093 21.0055 11.6314 20.9557 11.4761 20.862L4.57005 16.69C4.34303 16.5529 4.17977 16.3312 4.11619 16.0737C4.05262 15.8162 4.09393 15.544 4.23105 15.317C4.36817 15.09 4.58986 14.9267 4.84734 14.8631C5.10483 14.7996 5.37703 14.8409 5.60405 14.978L11.9951 18.84L18.4491 14.976V14.975Z",
                    fill: "#388BFF"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M11.9951 12.837L18.4491 8.97197C18.6764 8.83969 18.9468 8.80233 19.2015 8.868C19.4563 8.93367 19.6749 9.09707 19.81 9.3228C19.9451 9.54853 19.9858 9.8184 19.9233 10.0739C19.8608 10.3295 19.7001 10.5501 19.4761 10.688L12.5061 14.862C12.3503 14.9551 12.1722 15.0041 11.9908 15.0038C11.8093 15.0034 11.6314 14.9537 11.4761 14.86L4.57005 10.686C4.34303 10.5489 4.17977 10.3272 4.11619 10.0697C4.05262 9.81219 4.09393 9.54 4.23105 9.31297C4.36817 9.08595 4.58986 8.92269 4.84734 8.85911C5.10483 8.79554 5.37703 8.83685 5.60405 8.97397L11.9951 12.837Z",
                    fill: "#388BFF"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M11.9951 6.82306L18.4491 2.95806C18.5618 2.88868 18.6872 2.84237 18.8179 2.82182C18.9487 2.80127 19.0822 2.80688 19.2108 2.83833C19.3394 2.86978 19.4604 2.92644 19.5669 3.00503C19.6734 3.08362 19.7633 3.18257 19.8313 3.29615C19.8992 3.40973 19.944 3.53567 19.9629 3.66668C19.9818 3.79768 19.9746 3.93114 19.9415 4.05932C19.9085 4.18749 19.8503 4.30783 19.7704 4.41336C19.6905 4.51889 19.5905 4.6075 19.4761 4.67406L12.5061 8.84806C12.3503 8.9412 12.1722 8.99022 11.9908 8.98987C11.8093 8.98952 11.6314 8.93981 11.4761 8.84606L4.57005 4.67206C4.34303 4.53494 4.17977 4.31326 4.11619 4.05577C4.05262 3.79828 4.09393 3.52609 4.23105 3.29906C4.36817 3.07203 4.58986 2.90878 4.84734 2.8452C5.10483 2.78163 5.37703 2.82294 5.60405 2.96006L11.9951 6.82306Z",
                    fill: "#388BFF"
                })
            ]
        })
    });
};

});

parcelRegister("bH45K", function(module, exports) {
$parcel$export(module.exports, "AssigneeAlvin24Image", function () { return $a0040c514d1f7cdb$export$c9d73c94996ebdb; });

var $7VQPk = parcelRequire("7VQPk");

var $hnmMQ = parcelRequire("hnmMQ");
const $a0040c514d1f7cdb$export$c9d73c94996ebdb = (props)=>{
    const src = (0, $hnmMQ.extendBfldrCacheTime)("https://dam-cdn.atl.orangelogic.com/AssetLink/w3ew83t6fv2xk12878a62ut0qlbr50w8.svg");
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
        height: 24,
        width: 24,
        alt: props.alt,
        src: src,
        "data-testid": props["data-testid"],
        className: props.className
    }));
};

});

parcelRegister("a82K6", function(module, exports) {
$parcel$export(module.exports, "AssigneeJane24Image", function () { return $f9b674be0c4d5e4e$export$ba7e78c878adef6e; });

var $7VQPk = parcelRequire("7VQPk");

var $hnmMQ = parcelRequire("hnmMQ");
const $f9b674be0c4d5e4e$export$ba7e78c878adef6e = (props)=>{
    const src = (0, $hnmMQ.extendBfldrCacheTime)("https://dam-cdn.atl.orangelogic.com/AssetLink/6smlwl4eifdmx52le043b047ywb2js6v.svg");
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
        height: 24,
        width: 24,
        alt: props.alt,
        src: src,
        "data-testid": props["data-testid"],
        className: props.className
    }));
};

});

parcelRegister("7cimc", function(module, exports) {
$parcel$export(module.exports, "AssigneeBlake24Image", function () { return $a311a931ec44b510$export$6f4e8d70caa23820; });

var $7VQPk = parcelRequire("7VQPk");

var $hnmMQ = parcelRequire("hnmMQ");
const $a311a931ec44b510$export$6f4e8d70caa23820 = (props)=>{
    const src = (0, $hnmMQ.extendBfldrCacheTime)("https://dam-cdn.atl.orangelogic.com/AssetLink/gtou8x0538yr0283q5f5ph4a1qtx16c1.svg");
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
        height: 24,
        width: 24,
        alt: props.alt,
        src: src,
        "data-testid": props["data-testid"],
        className: props.className
    }));
};

});




parcelRegister("fECb5", function(module, exports) {
$parcel$export(module.exports, "useMessages", function () { return $1ac6468fd7b1031c$export$4d17e2d9c5348842; });
$parcel$export(module.exports, "useAnimatedJiraBoardStore", function () { return $1ac6468fd7b1031c$export$736729dc5e146045; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $cVxfO = parcelRequire("cVxfO");
var $dv8pz = parcelRequire("dv8pz");

var $9K41U = parcelRequire("9K41U");

var $kBmd7 = parcelRequire("kBmd7");
const $1ac6468fd7b1031c$var$initialState = {
    animationStep: (0, $kBmd7.AnimationSteps).CARD_TYPING,
    isCreateButtonFocused: false,
    todoCol: [],
    inProgressCol: [],
    doneCol: [],
    messages: (0, $9K41U.messages)
};
const $1ac6468fd7b1031c$var$genericRestartAction = ()=>({ setState: setState, getState: getState })=>{
        const { messages: messages } = getState();
        setState((0, $dPABA._)((0, $6ogO3._)({}, $1ac6468fd7b1031c$var$initialState), {
            messages: messages,
            isCreateButtonFocused: true
        }));
    };
const $1ac6468fd7b1031c$var$actions = {
    animateIssue: (animatedCardData)=>({ setState: setState, getState: getState })=>{
            const { todoCol: todoCol } = getState();
            const todoColAppend = todoCol.concat([
                animatedCardData
            ]);
            setState({
                todoCol: todoColAppend
            });
        },
    nextAnimationStep: ()=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { animationStep: animationStep } = getState();
            if (animationStep === (0, $kBmd7.stepsLength) - 1) {
                dispatch($1ac6468fd7b1031c$var$genericRestartAction());
                return;
            }
            setState({
                animationStep: animationStep + 1
            });
        },
    restartDemo: ()=>({ setState: setState, getState: getState })=>{
            const { messages: messages, inProgressCol: inProgressCol, doneCol: doneCol } = getState();
            setState((0, $dPABA._)((0, $6ogO3._)({}, $1ac6468fd7b1031c$var$initialState), {
                messages: messages,
                inProgressCol: inProgressCol,
                doneCol: doneCol,
                isCreateButtonFocused: true
            }));
        },
    setTodoCol: (colInfo)=>({ setState: setState })=>{
            setState({
                todoCol: colInfo
            });
        },
    setDoneCol: (colInfo)=>({ setState: setState })=>{
            setState({
                doneCol: colInfo
            });
        },
    setInProgressCol: (colInfo)=>({ setState: setState })=>{
            setState({
                inProgressCol: colInfo
            });
        },
    setMessages: (messages)=>({ setState: setState })=>{
            setState({
                messages: messages
            });
        },
    transitionToInProgress: ()=>({ setState: setState, getState: getState })=>{
            const { todoCol: todoCol, inProgressCol: inProgressCol } = getState();
            const todoColPop = todoCol.pop();
            const todoCopy = todoCol;
            if (todoColPop) {
                const inProgressAppend = inProgressCol.concat([
                    todoColPop
                ]);
                setState({
                    todoCol: todoCopy,
                    inProgressCol: inProgressAppend
                });
            }
        },
    transitionToDone: ()=>({ setState: setState, getState: getState })=>{
            const { inProgressCol: inProgressCol, doneCol: doneCol } = getState();
            const inProgColPop = inProgressCol.pop();
            const inProgCopy = inProgressCol;
            if (inProgColPop) {
                const doneColAppend = doneCol.concat([
                    inProgColPop
                ]);
                setState({
                    inProgressCol: inProgCopy,
                    doneCol: doneColAppend
                });
            }
        }
};
const $1ac6468fd7b1031c$var$InteractiveBoardStore = (0, $dv8pz.createStore)({
    initialState: $1ac6468fd7b1031c$var$initialState,
    actions: $1ac6468fd7b1031c$var$actions,
    name: "jsw-interactive-board-store"
});
const $1ac6468fd7b1031c$var$getMessages = (state)=>state.messages;
const $1ac6468fd7b1031c$export$4d17e2d9c5348842 = (0, $cVxfO.createHook)($1ac6468fd7b1031c$var$InteractiveBoardStore, {
    selector: $1ac6468fd7b1031c$var$getMessages
});
const $1ac6468fd7b1031c$export$736729dc5e146045 = (0, $cVxfO.createHook)($1ac6468fd7b1031c$var$InteractiveBoardStore);

});
parcelRegister("9K41U", function(module, exports) {
$parcel$export(module.exports, "messages", function () { return $db7619bd9b33642e$export$defe85febe8b728c; });
const $db7619bd9b33642e$export$defe85febe8b728c = {
    toDo: "To Do",
    inProgress: "In Progress",
    done: "Done",
    todoStaticLabel: "Design AI shopping suggestions for homepage",
    inProgStaticLabel1: "Create AI-generated shopping suggestions for homepage",
    inProgStaticLabel2: "Add advanced analytics tracking events",
    doneStaticLabel1: "Improve payment checkout time on mobile",
    doneStaticLabel2: "Define requirements to use new AI integrations",
    animatedCardHeading: "Design new billing API",
    createIssueModalIssueTypeAssetLabel1: "Issue type: Task",
    createIssueModalIssueTypeAssetLabel2: "Issue type: Story",
    createIssueModalIssueTypeAssetLabel3: "Issue type: Bug",
    createIssueModalPriorityAssetLabel1: "Priority: High",
    createIssueModalPriorityAssetLabel2: "Priority: Critical",
    createIssueModalPriorityAssetLabel3: "Priority: Blocker",
    createIssueModalPriorityAssetLabel4: "Priority: Minor",
    createIssueModalAssigneeAssetLabel1: "Assignee: Alvin",
    createIssueModalAssigneeAssetLabel2: "Assignee: Jane",
    createIssueModalAssigneeAssetLabel3: "Assignee: Blake",
    epicNameFeatures: "features",
    epicNameAnalytics: "analytics",
    epicNamePayments: "payments",
    epicNameAssets: "assets",
    epicNameStrategy: "strategy",
    epicNameBudget: "budget",
    epicNameQ1Campaign: "q1 campaign",
    priorityHigh: "high",
    priorityCritical: "critical",
    priorityMinor: "minor",
    priorityBlocker: "blocker",
    issueTypeBug: "bug",
    issueTypeStory: "story",
    issueTypeTask: "task"
};

});



parcelRegister("14aie", function(module, exports) {
$parcel$export(module.exports, "JswAnimatedBoard", function () { return $c7ae9ef94cb6aa27$export$d89965761ac203a5; });
/* jsw-animated-board.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kBmd7 = parcelRequire("kBmd7");

var $fECb5 = parcelRequire("fECb5");

var $kbpa7 = parcelRequire("kbpa7");

var $ad5e6 = parcelRequire("ad5e6");

var $bdh92 = parcelRequire("bdh92");
const $c7ae9ef94cb6aa27$var$rootContainerStyle = null;
const $c7ae9ef94cb6aa27$var$growBoard = null;
const $c7ae9ef94cb6aa27$var$shrinkBoard = null;
const $c7ae9ef94cb6aa27$var$fadeOut = null;
const $c7ae9ef94cb6aa27$var$fadeIn = null;
const $c7ae9ef94cb6aa27$var$animationBoardStyles = null;
const $c7ae9ef94cb6aa27$export$d89965761ac203a5 = (props)=>{
    const [{ messages: messages }, { setInProgressCol: setInProgressCol, setDoneCol: setDoneCol }] = (0, $fECb5.useAnimatedJiraBoardStore)();
    (0, $1oC0p.useState)(()=>{
        var _props_inProgressCardsOverride;
        setInProgressCol((_props_inProgressCardsOverride = props.inProgressCardsOverride) !== null && _props_inProgressCardsOverride !== void 0 ? _props_inProgressCardsOverride : [
            {
                id: "inProg1",
                summary: messages.inProgStaticLabel1,
                issueType: (0, $kBmd7.IssueTypeName).STORY,
                epicName: (0, $kBmd7.EpicName).FEATURES,
                assignee: (0, $kBmd7.Assignee).JANE,
                priority: (0, $kBmd7.Priority).BLOCKER
            },
            {
                id: "inProg2",
                summary: messages.inProgStaticLabel2,
                issueType: (0, $kBmd7.IssueTypeName).STORY,
                epicName: (0, $kBmd7.EpicName).ANALYTICS,
                assignee: (0, $kBmd7.Assignee).BLAKE,
                priority: (0, $kBmd7.Priority).HIGH
            }
        ]);
        var _props_doneCardsOverride;
        setDoneCol((_props_doneCardsOverride = props.doneCardsOverride) !== null && _props_doneCardsOverride !== void 0 ? _props_doneCardsOverride : [
            {
                id: "done1",
                summary: messages.doneStaticLabel1,
                issueType: (0, $kBmd7.IssueTypeName).BUG,
                epicName: (0, $kBmd7.EpicName).PAYMENTS,
                assignee: (0, $kBmd7.Assignee).ALVIN,
                priority: (0, $kBmd7.Priority).MINOR
            },
            {
                id: "done2",
                summary: messages.doneStaticLabel2,
                issueType: (0, $kBmd7.IssueTypeName).TASK,
                epicName: (0, $kBmd7.EpicName).FEATURES,
                assignee: (0, $kBmd7.Assignee).JANE,
                priority: (0, $kBmd7.Priority).CRITICAL
            }
        ]);
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_c71l1deq _p12f1c3h _1bsb1osq _bfhkcd5j _2rko19bv _ca0qftgi _u5f3ftgi _n3tdftgi _19bvftgi _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _zulp7vkz _16qs162a _1y8o1ogm",
            "_y44vmxuu"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bdh92.BoardHeader), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ad5e6.BoardBody), {})
        ]
    });
};
var $c7ae9ef94cb6aa27$export$2e2bcd8739ae039 = $c7ae9ef94cb6aa27$export$d89965761ac203a5;

});
parcelRegister("ad5e6", function(module, exports) {
$parcel$export(module.exports, "BoardBody", function () { return $f37db558e8dfc334$export$655dea6f92c41d9; });
/* board-body.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $aPuLC = parcelRequire("aPuLC");

var $kBmd7 = parcelRequire("kBmd7");

var $fECb5 = parcelRequire("fECb5");
const $f37db558e8dfc334$var$boardBodyStyle = null;
const $f37db558e8dfc334$var$columnContainerStyle = null;
const $f37db558e8dfc334$export$655dea6f92c41d9 = ()=>{
    const [{ messages: messages, todoCol: todoCol, inProgressCol: inProgressCol, doneCol: doneCol, animationStep: animationStep }, { transitionToInProgress: transitionToInProgress, transitionToDone: transitionToDone }] = (0, $fECb5.useAnimatedJiraBoardStore)();
    (0, $1oC0p.useEffect)(()=>{
        switch(animationStep){
            case (0, $kBmd7.AnimationSteps).IN_PROG_COL:
                transitionToInProgress();
                break;
            case (0, $kBmd7.AnimationSteps).DONE_COL:
                transitionToDone();
                break;
        }
    }, [
        animationStep
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_2rkoftgi _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _zulp1crf"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aPuLC.Column), {
                    title: messages.toDo,
                    cards: todoCol
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aPuLC.Column), {
                    title: messages.inProgress,
                    cards: inProgressCol
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aPuLC.Column), {
                    title: messages.done,
                    cards: doneCol
                })
            ]
        })
    });
};

});
parcelRegister("aPuLC", function(module, exports) {
$parcel$export(module.exports, "Column", function () { return $476035d6c3e5a9fd$export$816b5d811295e6bc; });
/* column.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $dSEv9 = parcelRequire("dSEv9");
parcelRequire("b6pjw");
var $hqndQ = parcelRequire("hqndQ");
const $476035d6c3e5a9fd$var$columnStyle = null;
const $476035d6c3e5a9fd$var$columnTitleStyle = null;
const $476035d6c3e5a9fd$var$listStyle = null;
const $476035d6c3e5a9fd$export$816b5d811295e6bc = ({ title: title, cards: cards })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_bfhkcnsw _2rkoftgi _16jlkb7n _1o9zkb7n _i0dlf1ug _bozg14y2 _y4ti14y2 _1tkeitct"
        ]),
        style: {
            "--_1li0dij": (0, $6ZVlx.default)((0, $hqndQ.colors).elevationSurfaceSunken)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_bfhkcnsw _syaz1h2j _1e0c1ule _1wyb1crf _k48pni7l _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1p1dangw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _vwz411ph"
                ]),
                style: {
                    "--_1li0dij": (0, $6ZVlx.default)((0, $hqndQ.colors).elevationSurfaceSunken),
                    "--_3qpi7d": (0, $6ZVlx.default)((0, $hqndQ.colors).textSubtle)
                },
                children: title
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "list",
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21sxn"
                ]),
                children: cards.map((card, i)=>{
                    return card.id && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dSEv9.Card), {
                        role: "listitem",
                        priority: card.priority,
                        epicName: card.epicName,
                        assignee: card.assignee,
                        issueType: card.issueType,
                        summary: card.summary,
                        id: card.id
                    }, i);
                })
            })
        ]
    });
};

});
parcelRegister("dSEv9", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return $b5f2b1c9dc340fa0$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");

var $kBmd7 = parcelRequire("kBmd7");
parcelRequire("b6pjw");
var $hqndQ = parcelRequire("hqndQ");
var $lUW15 = parcelRequire("lUW15");

var $fECb5 = parcelRequire("fECb5");
const $b5f2b1c9dc340fa0$export$60332b2344f7fe41 = ({ summary: summary, epicName: epicName, issueType: issueType, priority: priority, assignee: assignee, id: id, role: role })=>{
    const [isAnimatedCardId, setIsAnimatedCardId] = (0, $1oC0p.useState)(false);
    const [messages] = (0, $fECb5.useMessages)();
    const [, { nextAnimationStep: nextAnimationStep }] = (0, $fECb5.useAnimatedJiraBoardStore)();
    const epicLinkElement = (0, $lUW15.getAssetForEpicLink)(epicName, messages);
    const issueTypeElement = (0, $lUW15.getAssetOptionsForIssueType)(issueType, messages, true);
    (0, $1oC0p.useEffect)(()=>{
        if (id === (0, $kBmd7.ANIMATED_CARD_ID)) {
            setIsAnimatedCardId(true);
            setTimeout(()=>{
                nextAnimationStep();
            }, 4250);
        }
    }, [
        id,
        nextAnimationStep
    ]);
    const priorityElement = (0, $lUW15.getAssetOptionsForPriority)(priority, messages, true);
    const assigneeElement = (0, $lUW15.getAssetOptionsForAssignee)(assignee, messages, true);
    const cardStyles = null;
    const labelContainer = null;
    const epicLinkRow = null;
    const issueTypeContainer = null;
    const typePriorityAssigneeRow = null;
    const priorityAssigneeContainer = null;
    const animateCardonRender = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        "aria-describedby": id,
        role: role,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bah1yb4 _syaz10fz _19pk14y2 _2hwxidpf _otyr14y2 _18u0idpf _ca0q1crf _u5f31crf _n3td1crf _19bv1crf _2rko1y44 _11q7cd5j _16qs1drn _zulpftgi",
            isAnimatedCardId && "_c71lidpf _1reo15vq _18m915vq _o5721q9c _y44v4ib8 _ca0qidpf _u5f31crf _n3tdidpf _19bv1crf _16qs1trb"
        ]),
        style: {
            "--_1vqiml3": (0, $6ZVlx.default)((0, $hqndQ.colors).text),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1cyyhae": (0, $6ZVlx.default)((0, $hqndQ.colors).textSelected)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                id: id,
                className: (0, $2jatx.default)([
                    "_1wybdlk8 _zg8l4jg8 _k48p1nn1 _vwz4iio8 _1bsb1vuk"
                ]),
                children: summary
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc"
                ]),
                children: epicLinkElement
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx2vrvc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx2vrvc _4cvr1h6o _zulp14y2"
                        ]),
                        children: issueTypeElement
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx2vrvc _zulpftgi _ahbq1wug"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                children: priorityElement
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                children: assigneeElement
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("bdh92", function(module, exports) {
$parcel$export(module.exports, "BoardHeader", function () { return $ded6b79f1896df02$export$67b80e16fd3c69b6; });
/* board-header.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $ldzD5 = parcelRequire("ldzD5");
var $jwBtc = parcelRequire("jwBtc");
var $l5GWs = parcelRequire("l5GWs");
var $gdwBs = parcelRequire("gdwBs");
var $da25C = parcelRequire("da25C");
var $3T4xT = parcelRequire("3T4xT");
var $eI459 = parcelRequire("eI459");
var $lGRrf = parcelRequire("lGRrf");

var $4SA4u = parcelRequire("4SA4u");

var $6N4Iz = parcelRequire("6N4Iz");
var $7S9JL = parcelRequire("7S9JL");
const $ded6b79f1896df02$var$AtlassianProductHome = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $da25C.default), {
        icon: (0, $6N4Iz.JiraIcon),
        logo: (0, $7S9JL.JiraLogo)
    });
const $ded6b79f1896df02$var$greyLine = null;
const $ded6b79f1896df02$var$lineContainer = null;
const $ded6b79f1896df02$var$lineContainerWithBlueBackground = null;
const $ded6b79f1896df02$var$blueBackground = null;
const $ded6b79f1896df02$var$overlay = null;
const $ded6b79f1896df02$var$fakeProfile = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $3T4xT.Profile), {
        icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4SA4u.default), {
            size: "small"
        }),
        onClick: ()=>null,
        tooltip: "Your profile and settings"
    });
const $ded6b79f1896df02$var$fakeSearch = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eI459.Search), {
        onClick: ()=>null,
        placeholder: "Search...",
        tooltip: "Search",
        label: "Search",
        value: ""
    });
};
const $ded6b79f1896df02$var$fakeSettings = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $lGRrf.Settings), {
        tooltip: "Product settings"
    });
const $ded6b79f1896df02$var$fakeNotifications = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $gdwBs.Notifications), {
        badge: ()=>null,
        tooltip: "Notifications"
    });
const $ded6b79f1896df02$var$fakeAppSwitcher = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldzD5.AppSwitcher), {
        tooltip: "Switch between apps"
    });
const $ded6b79f1896df02$var$fakeHelp = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $l5GWs.Help), {
        tooltip: "Get help"
    });
const $ded6b79f1896df02$export$67b80e16fd3c69b6 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jwBtc.AtlassianNavigation), {
            label: "site",
            renderProductHome: $ded6b79f1896df02$var$AtlassianProductHome,
            primaryItems: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4t3i1y44 _2rkomt0u _11q7b7m8 _1bsb8ved _12l2ftgi _ahbqftgi"
                        ])
                    })
                }, "fake1"),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4t3i1y44 _2rkomt0u _11q7b7m8 _1bsb8ved _12l2ftgi _ahbqftgi"
                        ])
                    })
                }, "fake2"),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4t3i1y44 _2rkomt0u _11q7b7m8 _1bsb8ved _12l2ftgi _ahbqftgi"
                        ])
                    })
                }, "fake3"),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _1bah1h6o",
                        "_ca0q19bv _u5f319bv _n3td19bv _19bv19bv"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_2rkomt0u _11q73wju _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_4t3i1y44 _2rkomt0u _11q7b7m8 _1bsb8ved _12l2ftgi _ahbqftgi"
                            ])
                        })
                    })
                }, "fake4")
            ],
            renderSearch: $ded6b79f1896df02$var$fakeSearch,
            renderProfile: $ded6b79f1896df02$var$fakeProfile,
            renderSettings: $ded6b79f1896df02$var$fakeSettings,
            renderNotifications: $ded6b79f1896df02$var$fakeNotifications,
            renderAppSwitcher: $ded6b79f1896df02$var$fakeAppSwitcher,
            renderHelp: $ded6b79f1896df02$var$fakeHelp
        })
    });
};

});
parcelRegister("ldzD5", function(module, exports) {
$parcel$export(module.exports, "AppSwitcher", function () { return $f726731bf9b11391$export$9923361bd43fa030; });

var $dX2dk = parcelRequire("dX2dk");

var $faFp0 = parcelRequire("faFp0");

var $1oC0p = parcelRequire("1oC0p");

var $f4tHr = parcelRequire("f4tHr");

var $dzMzP = parcelRequire("dzMzP");
var $f726731bf9b11391$var$_excluded = [
    "tooltip"
];
var $f726731bf9b11391$export$9923361bd43fa030 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var tooltip = props.tooltip, iconButtonProps = (0, $faFp0.default)(props, $f726731bf9b11391$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $dzMzP.IconButton), (0, $dX2dk.default)({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f4tHr))), {
            label: typeof tooltip === 'string' ? tooltip : 'Appswitcher Icon'
        }),
        tooltip: tooltip,
        ref: ref
    }, iconButtonProps));
});
var // exists only to extract props
// eslint-disable-next-line @repo/internal/react/use-noop
$f726731bf9b11391$export$2e2bcd8739ae039 = function(props) {};

});
parcelRegister("dX2dk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a28280acba3eaaeb$export$2e2bcd8739ae039; });
function $a28280acba3eaaeb$export$2e2bcd8739ae039() {
    return $a28280acba3eaaeb$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a28280acba3eaaeb$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("faFp0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b0b7e7d93572a05f$export$2e2bcd8739ae039; });

var $cJNnP = parcelRequire("cJNnP");
function $b0b7e7d93572a05f$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $cJNnP.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("cJNnP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $945ffe82a7be2211$export$2e2bcd8739ae039; });
function $945ffe82a7be2211$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("f4tHr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af8e4472ffe68be9$var$_react = $af8e4472ffe68be9$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $rRAiF = parcelRequire("rRAiF");
function $af8e4472ffe68be9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $af8e4472ffe68be9$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $af8e4472ffe68be9$var$_react.default.createElement($rRAiF.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99v-1.98zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99v-1.98zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98z"/></svg>`
    }, props));
$af8e4472ffe68be9$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $af8e4472ffe68be9$var$_default = $af8e4472ffe68be9$var$AppSwitcherIcon;
module.exports.default = $af8e4472ffe68be9$var$_default;

});
parcelRegister("rRAiF", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $053c167e4e5324f5$export$f04a61298a47a40f; });

var $dX2dk = parcelRequire("dX2dk");

var $eYHx9 = parcelRequire("eYHx9");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $giBGP = parcelRequire("giBGP");

var $213ly = parcelRequire("213ly");
function $053c167e4e5324f5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $053c167e4e5324f5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $053c167e4e5324f5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eYHx9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $053c167e4e5324f5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $053c167e4e5324f5$var$iconStyles = (0, $3dJ4i.css)({
    display: 'inline-block',
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '> svg': $053c167e4e5324f5$var$_objectSpread($053c167e4e5324f5$var$_objectSpread({}, (0, $213ly.commonSVGStyles)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $053c167e4e5324f5$var$baseHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $053c167e4e5324f5$var$primaryEqualsSecondaryHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $053c167e4e5324f5$var$secondaryTransparentHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $053c167e4e5324f5$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $3dJ4i.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $213ly.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $3dJ4i.jsx)("span", (0, $dX2dk.default)({
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            '--icon-secondary-color': secondaryColor || (0, $giBGP.getBackground)()
        }
    }, glyphProps, {
        css: [
            $053c167e4e5324f5$var$iconStyles,
            $053c167e4e5324f5$var$baseHcmStyles,
            primaryColor === secondaryColor && $053c167e4e5324f5$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $053c167e4e5324f5$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $3dJ4i.css)({
                width: dimensions.width,
                height: dimensions.height,
                '> svg': dimensions
            })
        ]
    }));
});
var $053c167e4e5324f5$export$2e2bcd8739ae039 = $053c167e4e5324f5$export$f04a61298a47a40f;

});
parcelRegister("eYHx9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ae787029a31cbaa6$export$2e2bcd8739ae039; });

var $abldJ = parcelRequire("abldJ");
function $ae787029a31cbaa6$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $abldJ.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("abldJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $769b6467584971c5$export$2e2bcd8739ae039; });

var $5gJEo = parcelRequire("5gJEo");

var $9cHzA = parcelRequire("9cHzA");
function $769b6467584971c5$export$2e2bcd8739ae039(t) {
    var i = (0, $9cHzA.default)(t, "string");
    return "symbol" == (0, $5gJEo.default)(i) ? i : i + "";
}

});
parcelRegister("5gJEo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3d61dba20aac82cb$export$2e2bcd8739ae039; });
function $3d61dba20aac82cb$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $3d61dba20aac82cb$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3d61dba20aac82cb$export$2e2bcd8739ae039(o);
}

});

parcelRegister("9cHzA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6b3708bcd9f669af$export$2e2bcd8739ae039; });

var $5gJEo = parcelRequire("5gJEo");
function $6b3708bcd9f669af$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $5gJEo.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $5gJEo.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("giBGP", function(module, exports) {
$parcel$export(module.exports, "getBackground", function () { return $bddb9034b937f88a$export$18cb9425622d4e06; });
var $bddb9034b937f88a$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});

parcelRegister("213ly", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", function () { return $177e455dc0623e01$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $177e455dc0623e01$export$3eb7d6130acfda37; });

var $5hxro = parcelRequire("5hxro");

var $3dJ4i = parcelRequire("3dJ4i");
var $177e455dc0623e01$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
var $177e455dc0623e01$var$smallStyles = (0, $3dJ4i.css)((0, $5hxro.dimensions).small);
var $177e455dc0623e01$var$mediumStyles = (0, $3dJ4i.css)((0, $5hxro.dimensions).medium);
var $177e455dc0623e01$var$largeStyles = (0, $3dJ4i.css)((0, $5hxro.dimensions).large);
var $177e455dc0623e01$var$xlargeStyles = (0, $3dJ4i.css)((0, $5hxro.dimensions).xlarge);
var $177e455dc0623e01$export$ef0ad74202575b64 = {
    small: $177e455dc0623e01$var$smallStyles,
    medium: $177e455dc0623e01$var$mediumStyles,
    large: $177e455dc0623e01$var$largeStyles,
    xlarge: $177e455dc0623e01$var$xlargeStyles
};
var $177e455dc0623e01$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $5hxro.dimensions)[size];
    return undefined;
};

});
parcelRegister("5hxro", function(module, exports) {
$parcel$export(module.exports, "dimensions", function () { return $3d887af3f426f401$export$62ad7b0c781000e9; });
var $3d887af3f426f401$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $3d887af3f426f401$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $3d887af3f426f401$export$62ad7b0c781000e9 = {
    small: {
        width: $3d887af3f426f401$export$c647cb0ee6e282fe.small,
        height: $3d887af3f426f401$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $3d887af3f426f401$export$c647cb0ee6e282fe.medium,
        height: $3d887af3f426f401$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $3d887af3f426f401$export$c647cb0ee6e282fe.large,
        height: $3d887af3f426f401$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $3d887af3f426f401$export$c647cb0ee6e282fe.xlarge,
        height: $3d887af3f426f401$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("dzMzP", function(module, exports) {
$parcel$export(module.exports, "IconButton", function () { return $9e24399b5ff50fa9$export$c25acd513dcc8062; });

var $dX2dk = parcelRequire("dX2dk");

var $faFp0 = parcelRequire("faFp0");

var $1oC0p = parcelRequire("1oC0p");

var $cKOdq = parcelRequire("cKOdq");

var $hLJF4 = parcelRequire("hLJF4");

var $2zyTy = parcelRequire("2zyTy");

var $dPseJ = parcelRequire("dPseJ");
var $9e24399b5ff50fa9$var$_excluded = [
    "icon",
    "label",
    "testId",
    "tooltip"
];
var $9e24399b5ff50fa9$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var icon = props.icon, label = props.label, testId = props.testId, tooltip = props.tooltip, buttonProps = (0, $faFp0.default)(props, $9e24399b5ff50fa9$var$_excluded);
    var theme = (0, $2zyTy.useTheme)();
    var button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $cKOdq.default), (0, $dX2dk.default)({
        appearance: "primary",
        "aria-label": label,
        testId: testId,
        iconBefore: icon,
        ref: ref,
        theme: (0, $dPseJ.getIconButtonTheme)(theme)
    }, buttonProps));
    if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $hLJF4.default), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});

});
parcelRegister("cKOdq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9490bba7923d890b$export$2e2bcd8739ae039; });

var $dX2dk = parcelRequire("dX2dk");

var $4qhbp = parcelRequire("4qhbp");

var $eYHx9 = parcelRequire("eYHx9");

var $faFp0 = parcelRequire("faFp0");

var $1oC0p = parcelRequire("1oC0p");

var $2SIvA = parcelRequire("2SIvA");

var $43Jaz = parcelRequire("43Jaz");

var $1p6zS = parcelRequire("1p6zS");

var $8Zlix = parcelRequire("8Zlix");

var $5P4hh = parcelRequire("5P4hh");
var $9490bba7923d890b$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $9490bba7923d890b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9490bba7923d890b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9490bba7923d890b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eYHx9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9490bba7923d890b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9490bba7923d890b$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
var $9490bba7923d890b$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $9490bba7923d890b$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $5P4hh.defaultThemeFn) : _ref2$theme, rest = (0, $faFp0.default)(_ref2, $9490bba7923d890b$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $9490bba7923d890b$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $1oC0p.useState)($9490bba7923d890b$var$initial), _useState2 = (0, $4qhbp.default)(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $1oC0p.useCallback)(function(event) {
        setState(function(current) {
            return $9490bba7923d890b$var$_objectSpread($9490bba7923d890b$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $1oC0p.useCallback)(function(event) {
        setState(function(current) {
            return $9490bba7923d890b$var$_objectSpread($9490bba7923d890b$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $1oC0p.useCallback)(function(event) {
        setState(function(current) {
            return $9490bba7923d890b$var$_objectSpread($9490bba7923d890b$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $1oC0p.useCallback)(function(event) {
        setState(function(current) {
            return $9490bba7923d890b$var$_objectSpread($9490bba7923d890b$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $1oC0p.useCallback)(function(event) {
        setState(function(current) {
            return $9490bba7923d890b$var$_objectSpread($9490bba7923d890b$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $1oC0p.useCallback)(function(event) {
        setState(function(current) {
            return $9490bba7923d890b$var$_objectSpread($9490bba7923d890b$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $5P4hh.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $2SIvA.default).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $5P4hh.default).Consumer, (0, $dX2dk.default)({
            mode: mode,
            state: $9490bba7923d890b$var$getInteractionState($9490bba7923d890b$var$_objectSpread($9490bba7923d890b$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $1p6zS.default)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $43Jaz.default), (0, $dX2dk.default)({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8Zlix.default), restProps) : null,
                "aria-disabled": isLoading || restProps['aria-disabled'],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $5P4hh.getSpecifiers)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$9490bba7923d890b$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $9490bba7923d890b$export$2e2bcd8739ae039 = $9490bba7923d890b$var$CustomThemeButton;

});
parcelRegister("4qhbp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3386eb541ff1e471$export$2e2bcd8739ae039; });

var $ltC5T = parcelRequire("ltC5T");

var $6yN4V = parcelRequire("6yN4V");

var $4T47s = parcelRequire("4T47s");

var $aKujA = parcelRequire("aKujA");
function $3386eb541ff1e471$export$2e2bcd8739ae039(r, e) {
    return (0, $ltC5T.default)(r) || (0, $6yN4V.default)(r, e) || (0, $4T47s.default)(r, e) || (0, $aKujA.default)();
}

});
parcelRegister("ltC5T", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fa29db1d5de79615$export$2e2bcd8739ae039; });
function $fa29db1d5de79615$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("6yN4V", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4c6bfd0065e7b941$export$2e2bcd8739ae039; });
function $4c6bfd0065e7b941$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("4T47s", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $38ef7e7dbe3d8db9$export$2e2bcd8739ae039; });

var $eri1a = parcelRequire("eri1a");
function $38ef7e7dbe3d8db9$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $eri1a.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $eri1a.default)(r, a) : void 0;
    }
}

});
parcelRegister("eri1a", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a8319045731b559f$export$2e2bcd8739ae039; });
function $a8319045731b559f$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("aKujA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7d35b72fa893c2ed$export$2e2bcd8739ae039; });
function $7d35b72fa893c2ed$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("2SIvA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $219326649b28bebe$export$2e2bcd8739ae039; });

var $cUPup = parcelRequire("cUPup");
// Create default global light theme
var $219326649b28bebe$var$_createTheme = (0, $cUPup.createTheme)(function() {
    return {
        mode: 'light'
    };
}), $219326649b28bebe$var$Provider = $219326649b28bebe$var$_createTheme.Provider, $219326649b28bebe$var$Consumer = $219326649b28bebe$var$_createTheme.Consumer, $219326649b28bebe$export$7692396083754928 = $219326649b28bebe$var$_createTheme.useTheme;
var $219326649b28bebe$export$2e2bcd8739ae039 = {
    Provider: $219326649b28bebe$var$Provider,
    Consumer: $219326649b28bebe$var$Consumer
};

});
parcelRegister("cUPup", function(module, exports) {
$parcel$export(module.exports, "createTheme", function () { return $9672a7bf03434633$export$25d302a5b900a763; });

var $faFp0 = parcelRequire("faFp0");

var $1oC0p = parcelRequire("1oC0p");
var $9672a7bf03434633$var$_excluded = [
    "children"
];
function $9672a7bf03434633$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $1oC0p.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $1oC0p.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $faFp0.default)(props, $9672a7bf03434633$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $1oC0p.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $1oC0p.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("43Jaz", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2f4a7af1c14a868c$export$2e2bcd8739ae039; });

var $dX2dk = parcelRequire("dX2dk");

var $faFp0 = parcelRequire("faFp0");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $5MAze = parcelRequire("5MAze");

var $DDWSY = parcelRequire("DDWSY");

var $h049M = parcelRequire("h049M");

var $dNwLk = parcelRequire("dNwLk");

var $1svAK = parcelRequire("1svAK");

var $cSbsP = parcelRequire("cSbsP");

var $hlwOc = parcelRequire("hlwOc");

var $aoFFt = parcelRequire("aoFFt");

var $9kk7t = parcelRequire("9kk7t");
var $2f4a7af1c14a868c$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $2f4a7af1c14a868c$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
var $2f4a7af1c14a868c$var$iconBeforeSpacingFixStyle = (0, $3dJ4i.css)({
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $2f4a7af1c14a868c$var$iconAfterSpacingFixStyle = (0, $3dJ4i.css)({
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $2f4a7af1c14a868c$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $9kk7t.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $2f4a7af1c14a868c$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $9kk7t.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $3dJ4i.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $2f4a7af1c14a868c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $DDWSY.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $DDWSY.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, $faFp0.default)(props, $2f4a7af1c14a868c$var$_excluded);
    var ourRef = (0, $1oC0p.useRef)();
    var setRef = (0, $1oC0p.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $h049M.default)(ourRef, autoFocus);
    var interactionContext = (0, $1oC0p.useContext)((0, $1svAK.default));
    var handleClick = (0, $1oC0p.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $5MAze.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "17.14.2",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $1oC0p.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $1oC0p.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    var fadeStyles = (0, $3dJ4i.css)((0, $aoFFt.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $cSbsP.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $cSbsP.N500), ")"), " !important")
        }
    };
    return (0, $3dJ4i.jsx)((0, $dNwLk.default), null, (0, $3dJ4i.jsx)(Component, (0, $dX2dk.default)({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $2f4a7af1c14a868c$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $hlwOc.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $3dJ4i.jsx)("span", {
        css: [
            fadeStyles,
            (0, $aoFFt.getIconStyle)({
                spacing: spacing
            }),
            $2f4a7af1c14a868c$var$getSpacingFix(children, $2f4a7af1c14a868c$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $2f4a7af1c14a868c$var$getChildren(children, [
        fadeStyles,
        (0, $aoFFt.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $3dJ4i.jsx)("span", {
        css: [
            fadeStyles,
            (0, $aoFFt.getIconStyle)({
                spacing: spacing
            }),
            $2f4a7af1c14a868c$var$getSpacingFix(children, $2f4a7af1c14a868c$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $3dJ4i.jsx)("span", {
        css: [
            (0, $aoFFt.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});

});
parcelRegister("5MAze", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $435dccef21a2f168$export$a4687b0234b40e28; });

var $eYHx9 = parcelRequire("eYHx9");

var $1oC0p = parcelRequire("1oC0p");

var $bxK5o = parcelRequire("bxK5o");

var $hsLP5 = parcelRequire("hsLP5");
function $435dccef21a2f168$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $435dccef21a2f168$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $435dccef21a2f168$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eYHx9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $435dccef21a2f168$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $435dccef21a2f168$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $bxK5o.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $hsLP5.useTrackedRef)(analyticsData);
    var fnRef = (0, $hsLP5.useTrackedRef)(fn);
    var handler = (0, $1oC0p.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $435dccef21a2f168$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("bxK5o", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", function () { return $8676867e5d0351dd$export$5bf35293e545f20c; });

var $hcVab = parcelRequire("hcVab");

var $f93R4 = parcelRequire("f93R4");

var $eoQNl = parcelRequire("eoQNl");
function $8676867e5d0351dd$export$5bf35293e545f20c() {
    var analyticsContext = (0, $eoQNl.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $hcVab.useCallbackOne)(function(payload) {
        return new (0, $f93R4.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("f93R4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b06aafce8a2bfc4e$export$2e2bcd8739ae039; });

var $eT6dr = parcelRequire("eT6dr");

var $eL3cn = parcelRequire("eL3cn");

var $gwwR2 = parcelRequire("gwwR2");

var $cFBFP = parcelRequire("cFBFP");

var $4b0zj = parcelRequire("4b0zj");

var $4abMX = parcelRequire("4abMX");

var $lPcY5 = parcelRequire("lPcY5");

var $6NPrH = parcelRequire("6NPrH");

var $eYHx9 = parcelRequire("eYHx9");

var $a7P2x = parcelRequire("a7P2x");
function $b06aafce8a2bfc4e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b06aafce8a2bfc4e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $6NPrH.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $6NPrH.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $lPcY5.default)(this, result);
    };
}
function $b06aafce8a2bfc4e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b06aafce8a2bfc4e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $b06aafce8a2bfc4e$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $b06aafce8a2bfc4e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $b06aafce8a2bfc4e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, $4abMX.default)(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $b06aafce8a2bfc4e$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $eL3cn.default)(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, $eYHx9.default)((0, $cFBFP.default)(_this), "_isUIAnalyticsEvent", true);
        (0, $eYHx9.default)((0, $cFBFP.default)(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $eT6dr.default)(_this.context);
            var handlers = (0, $eT6dr.default)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $eYHx9.default)((0, $cFBFP.default)(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, $cFBFP.default)(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $gwwR2.default)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, $4b0zj.default)((0, $6NPrH.default)(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $a7P2x.default));

});
parcelRegister("eT6dr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ad6b060f2b5fe87b$export$2e2bcd8739ae039; });

var $a4wd5 = parcelRequire("a4wd5");

var $3Me98 = parcelRequire("3Me98");

var $4T47s = parcelRequire("4T47s");

var $8v6pS = parcelRequire("8v6pS");
function $ad6b060f2b5fe87b$export$2e2bcd8739ae039(r) {
    return (0, $a4wd5.default)(r) || (0, $3Me98.default)(r) || (0, $4T47s.default)(r) || (0, $8v6pS.default)();
}

});
parcelRegister("a4wd5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7553435db000abf1$export$2e2bcd8739ae039; });

var $eri1a = parcelRequire("eri1a");
function $7553435db000abf1$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $eri1a.default)(r);
}

});

parcelRegister("3Me98", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2c00d3ef55efcf02$export$2e2bcd8739ae039; });
function $2c00d3ef55efcf02$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("8v6pS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $630632275b091e58$export$2e2bcd8739ae039; });
function $630632275b091e58$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("eL3cn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $abe7efa71972ecca$export$2e2bcd8739ae039; });
function $abe7efa71972ecca$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("gwwR2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c0791eb29f17b297$export$2e2bcd8739ae039; });

var $abldJ = parcelRequire("abldJ");
function $c0791eb29f17b297$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $abldJ.default)(o.key), o);
    }
}
function $c0791eb29f17b297$export$2e2bcd8739ae039(e, r, t) {
    return r && $c0791eb29f17b297$var$_defineProperties(e.prototype, r), t && $c0791eb29f17b297$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("cFBFP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9396899650770269$export$2e2bcd8739ae039; });
function $9396899650770269$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("4b0zj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $30a8a16ae558310c$export$2e2bcd8739ae039; });

var $5ajvo = parcelRequire("5ajvo");
function $30a8a16ae558310c$export$2e2bcd8739ae039() {
    return $30a8a16ae558310c$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $5ajvo.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $30a8a16ae558310c$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("5ajvo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3c2d0445e95ea329$export$2e2bcd8739ae039; });

var $6NPrH = parcelRequire("6NPrH");
function $3c2d0445e95ea329$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $6NPrH.default)(t)););
    return t;
}

});
parcelRegister("6NPrH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4f3f39ba1915dea9$export$2e2bcd8739ae039; });
function $4f3f39ba1915dea9$export$2e2bcd8739ae039(t) {
    return $4f3f39ba1915dea9$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $4f3f39ba1915dea9$export$2e2bcd8739ae039(t);
}

});



parcelRegister("4abMX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $30813d8fef8ae818$export$2e2bcd8739ae039; });

var $8eKbH = parcelRequire("8eKbH");
function $30813d8fef8ae818$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $8eKbH.default)(t, e);
}

});
parcelRegister("8eKbH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5ff3757708696ee1$export$2e2bcd8739ae039; });
function $5ff3757708696ee1$export$2e2bcd8739ae039(t, e) {
    return $5ff3757708696ee1$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $5ff3757708696ee1$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("lPcY5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fe386b9215009633$export$2e2bcd8739ae039; });

var $5gJEo = parcelRequire("5gJEo");

var $cFBFP = parcelRequire("cFBFP");
function $fe386b9215009633$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5gJEo.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cFBFP.default)(t);
}

});

parcelRegister("a7P2x", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $75f2264df1a7300a$export$2e2bcd8739ae039; });

var $5gJEo = parcelRequire("5gJEo");

var $eL3cn = parcelRequire("eL3cn");

var $gwwR2 = parcelRequire("gwwR2");

var $eYHx9 = parcelRequire("eYHx9");
function $75f2264df1a7300a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $75f2264df1a7300a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $75f2264df1a7300a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eYHx9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $75f2264df1a7300a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $75f2264df1a7300a$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $75f2264df1a7300a$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $75f2264df1a7300a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $eL3cn.default)(this, AnalyticsEvent);
        (0, $eYHx9.default)(this, "_isAnalyticsEvent", true);
        (0, $eYHx9.default)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $75f2264df1a7300a$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, $gwwR2.default)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, $5gJEo.default)(updater) === 'object') this.payload = $75f2264df1a7300a$var$_objectSpread($75f2264df1a7300a$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("eoQNl", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", function () { return $a7bc4290ccbaaf47$export$d1f587f82ad51c4; });

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");
var $a7bc4290ccbaaf47$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $1oC0p.useContext)((0, $bEiDG.default));
};

});


parcelRegister("hsLP5", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", function () { return $cb6a25d5a5883ffc$export$1d27a74659855e44; });

var $1oC0p = parcelRequire("1oC0p");
var $cb6a25d5a5883ffc$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $1oC0p.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("DDWSY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0772a1a062172024$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $0772a1a062172024$export$2e2bcd8739ae039() {}

});

parcelRegister("h049M", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c605a93555b19892$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
function $c605a93555b19892$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("dNwLk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a0b943e0b07f633a$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");
var $a0b943e0b07f633a$var$BORDER_WIDTH = 2;
var $a0b943e0b07f633a$var$baseFocusOutsideStyles = (0, $3dJ4i.css)({
    outline: "".concat($a0b943e0b07f633a$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $a0b943e0b07f633a$var$BORDER_WIDTH
});
var $a0b943e0b07f633a$var$baseInsetStyles = (0, $3dJ4i.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    outlineOffset: -$a0b943e0b07f633a$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $a0b943e0b07f633a$var$focusRingStyles = (0, $3dJ4i.css)({
    '&:focus-visible': $a0b943e0b07f633a$var$baseFocusOutsideStyles,
    '@supports not selector(*:focus-visible)': {
        '&:focus': $a0b943e0b07f633a$var$baseFocusOutsideStyles
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $a0b943e0b07f633a$var$insetFocusRingStyles = (0, $3dJ4i.css)({
    '&:focus-visible': $a0b943e0b07f633a$var$baseInsetStyles,
    '@supports not selector(*:focus-visible)': {
        '&:focus': $a0b943e0b07f633a$var$baseInsetStyles
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $a0b943e0b07f633a$var$FocusRing = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $a0b943e0b07f633a$var$baseInsetStyles : $a0b943e0b07f633a$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $a0b943e0b07f633a$var$insetFocusRingStyles : $a0b943e0b07f633a$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $3dJ4i.jsx)((0, $3dJ4i.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $1oC0p.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $1oC0p.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$a0b943e0b07f633a$var$FocusRing.displayName = 'FocusRing';
var $a0b943e0b07f633a$export$2e2bcd8739ae039 = $a0b943e0b07f633a$var$FocusRing;

});

parcelRegister("1svAK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1100e96d3f2aea0d$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $1100e96d3f2aea0d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);

});

parcelRegister("cSbsP", function(module, exports) {
$parcel$export(module.exports, "R300", function () { return $95f36bb4e1aa1540$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $95f36bb4e1aa1540$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $95f36bb4e1aa1540$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y200", function () { return $95f36bb4e1aa1540$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $95f36bb4e1aa1540$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $95f36bb4e1aa1540$export$59619663aa6500fb; });
$parcel$export(module.exports, "B50", function () { return $95f36bb4e1aa1540$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $95f36bb4e1aa1540$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $95f36bb4e1aa1540$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $95f36bb4e1aa1540$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $95f36bb4e1aa1540$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $95f36bb4e1aa1540$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $95f36bb4e1aa1540$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N0", function () { return $95f36bb4e1aa1540$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $95f36bb4e1aa1540$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $95f36bb4e1aa1540$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N70", function () { return $95f36bb4e1aa1540$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $95f36bb4e1aa1540$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N100", function () { return $95f36bb4e1aa1540$export$d6447c357493214f; });
$parcel$export(module.exports, "N200", function () { return $95f36bb4e1aa1540$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $95f36bb4e1aa1540$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $95f36bb4e1aa1540$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N600", function () { return $95f36bb4e1aa1540$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N700", function () { return $95f36bb4e1aa1540$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $95f36bb4e1aa1540$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $95f36bb4e1aa1540$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $95f36bb4e1aa1540$export$920c0d5c49070351; });
$parcel$export(module.exports, "N50A", function () { return $95f36bb4e1aa1540$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $95f36bb4e1aa1540$export$d2d3bedfb276cac0; });
$parcel$export(module.exports, "DN400", function () { return $95f36bb4e1aa1540$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $95f36bb4e1aa1540$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $95f36bb4e1aa1540$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $95f36bb4e1aa1540$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $95f36bb4e1aa1540$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $95f36bb4e1aa1540$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $95f36bb4e1aa1540$export$3d4f271a500072a; });
$parcel$export(module.exports, "skeleton", function () { return $95f36bb4e1aa1540$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $gkJ2v = parcelRequire("gkJ2v");
var $95f36bb4e1aa1540$export$4b84fd0e2c617bd = '#FFEBE6';
var $95f36bb4e1aa1540$export$b34b069eff244586 = '#FFBDAD';
var $95f36bb4e1aa1540$export$be802dd0d8b57f35 = '#FF8F73';
var $95f36bb4e1aa1540$export$60847d42f9da92a6 = '#FF7452';
var $95f36bb4e1aa1540$export$4a7404f376229999 = '#FF5630';
var $95f36bb4e1aa1540$export$2010d0fb4295b346 = '#DE350B';
var $95f36bb4e1aa1540$export$2837b5a1a71d5c02 = '#BF2600';
var $95f36bb4e1aa1540$export$8d9596b529bbb9cf = '#FFFAE6';
var $95f36bb4e1aa1540$export$41060a744ab0b7ae = '#FFF0B3';
var $95f36bb4e1aa1540$export$1cc05bbbf340e559 = '#FFE380';
var $95f36bb4e1aa1540$export$5aae31392d72caaa = '#FFC400';
var $95f36bb4e1aa1540$export$c6930421db9fa514 = '#FFAB00';
var $95f36bb4e1aa1540$export$59619663aa6500fb = '#FF991F';
var $95f36bb4e1aa1540$export$874739ea9e379ab6 = '#FF8B00';
var $95f36bb4e1aa1540$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $95f36bb4e1aa1540$export$69a3bf21b9686c2b = '#ABF5D1';
var $95f36bb4e1aa1540$export$afbce1382ec95f73 = '#79F2C0';
var $95f36bb4e1aa1540$export$747d86715d4175de = '#57D9A3';
var $95f36bb4e1aa1540$export$940e1f69e873f202 = '#36B37E';
var $95f36bb4e1aa1540$export$a49394138f7b8e85 = '#00875A';
var $95f36bb4e1aa1540$export$6fa04827ac68a4fb = '#006644';
var $95f36bb4e1aa1540$export$226de0355ed012f8 = '#DEEBFF';
var $95f36bb4e1aa1540$export$8c13c2ee36917869 = '#B3D4FF';
var $95f36bb4e1aa1540$export$ecfc1dff386a3e7a = '#4C9AFF';
var $95f36bb4e1aa1540$export$215b7063051591f1 = '#2684FF';
var $95f36bb4e1aa1540$export$e62e8919cca44969 = '#0065FF';
var $95f36bb4e1aa1540$export$b3de0ae08da2ce64 = '#0052CC';
var $95f36bb4e1aa1540$export$a6ee3d71bc067634 = '#0747A6';
var $95f36bb4e1aa1540$export$363e4475840015bb = '#EAE6FF';
var $95f36bb4e1aa1540$export$4b0a4417ed59760f = '#C0B6F2';
var $95f36bb4e1aa1540$export$6011520a64d9a187 = '#998DD9';
var $95f36bb4e1aa1540$export$a7175d4e9206bc80 = '#8777D9';
var $95f36bb4e1aa1540$export$b48405b95304b5a1 = '#6554C0';
var $95f36bb4e1aa1540$export$c71e4279dd54a18d = '#5243AA';
var $95f36bb4e1aa1540$export$147899de772240ec = '#403294';
var $95f36bb4e1aa1540$export$2cf711fe14c66f06 = '#E6FCFF';
var $95f36bb4e1aa1540$export$7a8f4d33f6f9772c = '#B3F5FF';
var $95f36bb4e1aa1540$export$776c9c497ef08533 = '#79E2F2';
var $95f36bb4e1aa1540$export$69cb3ca10c1e330e = '#00C7E6';
var $95f36bb4e1aa1540$export$9dc1ef0f3f48059b = '#00B8D9';
var $95f36bb4e1aa1540$export$7c835c78b6fcdef8 = '#00A3BF';
var $95f36bb4e1aa1540$export$6036577f95c3877e = '#008DA6';
var $95f36bb4e1aa1540$export$29a4f05edc054374 = '#FFFFFF';
var $95f36bb4e1aa1540$export$e655ef011c4aa1a2 = '#FAFBFC';
var $95f36bb4e1aa1540$export$9fdfb749e33cdf97 = '#F4F5F7';
var $95f36bb4e1aa1540$export$3e51e8f1440314ba = '#EBECF0';
var $95f36bb4e1aa1540$export$1ce2d1575d444ceb = '#DFE1E6';
var $95f36bb4e1aa1540$export$8754fc7e6d8b3000 = '#C1C7D0';
var $95f36bb4e1aa1540$export$c2e91cbeada39b8b = '#B3BAC5';
var $95f36bb4e1aa1540$export$5f71e19f3a7ad9de = '#A5ADBA';
var $95f36bb4e1aa1540$export$eaa8c8a70ac22806 = '#97A0AF';
var $95f36bb4e1aa1540$export$7c87d337fb91a97d = '#8993A4';
var $95f36bb4e1aa1540$export$d6447c357493214f = '#7A869A';
var $95f36bb4e1aa1540$export$f563ee71e9ee74cd = '#6B778C';
var $95f36bb4e1aa1540$export$e2ef2124cf4024b1 = '#5E6C84';
var $95f36bb4e1aa1540$export$eece5f492e429f08 = '#505F79';
var $95f36bb4e1aa1540$export$c39c0fe0f26207ae = '#42526E';
var $95f36bb4e1aa1540$export$7090862dc3038a9f = '#344563';
var $95f36bb4e1aa1540$export$ad0bacf983b7ddaa = '#253858';
var $95f36bb4e1aa1540$export$7d61b15e0da132af = '#172B4D';
var $95f36bb4e1aa1540$export$fbda843f0a27fe96 = '#091E42';
var $95f36bb4e1aa1540$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $95f36bb4e1aa1540$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $95f36bb4e1aa1540$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $95f36bb4e1aa1540$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $95f36bb4e1aa1540$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $95f36bb4e1aa1540$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $95f36bb4e1aa1540$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $95f36bb4e1aa1540$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $95f36bb4e1aa1540$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $95f36bb4e1aa1540$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $95f36bb4e1aa1540$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $95f36bb4e1aa1540$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $95f36bb4e1aa1540$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $95f36bb4e1aa1540$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $95f36bb4e1aa1540$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $95f36bb4e1aa1540$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $95f36bb4e1aa1540$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $95f36bb4e1aa1540$export$2f6319cf7d736c2a = '#E6EDFA';
var $95f36bb4e1aa1540$export$95126bc8884d6634 = '#DCE5F5';
var $95f36bb4e1aa1540$export$8338d8c35d44ff1 = '#CED9EB';
var $95f36bb4e1aa1540$export$5368d76ae4fbbda7 = '#B8C7E0';
var $95f36bb4e1aa1540$export$9f0a771d16ec8d36 = '#ABBBD6';
var $95f36bb4e1aa1540$export$abcf8c38338b4aa5 = '#9FB0CC';
var $95f36bb4e1aa1540$export$97e81faa16a182c7 = '#8C9CB8';
var $95f36bb4e1aa1540$export$bfe21c59123ecf33 = '#7988A3';
var $95f36bb4e1aa1540$export$ee82aa2ea6a1558 = '#67758F';
var $95f36bb4e1aa1540$export$682927c6ed76be02 = '#56637A';
var $95f36bb4e1aa1540$export$91fd9994c5be9757 = '#455166';
var $95f36bb4e1aa1540$export$d281fbfe3cff2df6 = '#3B475C';
var $95f36bb4e1aa1540$export$3902c91d8b98a753 = '#313D52';
var $95f36bb4e1aa1540$export$8e8133c1ba5845b5 = '#283447';
var $95f36bb4e1aa1540$export$33ff357f6620b39 = '#202B3D';
var $95f36bb4e1aa1540$export$633847cf062b69e0 = '#1B2638';
var $95f36bb4e1aa1540$export$9776a6e503bdbf76 = '#121A29';
var $95f36bb4e1aa1540$export$6c813d5160dff5db = '#0E1624';
var $95f36bb4e1aa1540$export$3d4f271a500072a = '#0D1424';
var $95f36bb4e1aa1540$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $95f36bb4e1aa1540$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $95f36bb4e1aa1540$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $95f36bb4e1aa1540$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $95f36bb4e1aa1540$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $95f36bb4e1aa1540$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $95f36bb4e1aa1540$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $95f36bb4e1aa1540$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $95f36bb4e1aa1540$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $95f36bb4e1aa1540$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $95f36bb4e1aa1540$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $95f36bb4e1aa1540$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $95f36bb4e1aa1540$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $95f36bb4e1aa1540$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $95f36bb4e1aa1540$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $95f36bb4e1aa1540$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $95f36bb4e1aa1540$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $95f36bb4e1aa1540$export$8ce1fd94bee2f412 = (0, $gkJ2v.default)({
    light: "var(--ds-surface, ".concat($95f36bb4e1aa1540$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($95f36bb4e1aa1540$export$633847cf062b69e0, ")")
});
var $95f36bb4e1aa1540$export$b861914ea877b580 = (0, $gkJ2v.default)({
    light: "var(--ds-background-selected, ".concat($95f36bb4e1aa1540$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($95f36bb4e1aa1540$export$8c13c2ee36917869, ")")
});
var $95f36bb4e1aa1540$export$3f1b020df94387af = (0, $gkJ2v.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($95f36bb4e1aa1540$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($95f36bb4e1aa1540$export$d281fbfe3cff2df6, ")")
});
var $95f36bb4e1aa1540$export$c0183dbab98ca63e = (0, $gkJ2v.default)({
    light: "var(--ds-surface-overlay, ".concat($95f36bb4e1aa1540$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($95f36bb4e1aa1540$export$8e8133c1ba5845b5, ")")
});
var $95f36bb4e1aa1540$export$6f093cfa640b7166 = (0, $gkJ2v.default)({
    light: "var(--ds-text, ".concat($95f36bb4e1aa1540$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($95f36bb4e1aa1540$export$5368d76ae4fbbda7, ")")
});
var $95f36bb4e1aa1540$export$42f8e9c698766e7a = (0, $gkJ2v.default)({
    light: "var(--ds-text, ".concat($95f36bb4e1aa1540$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($95f36bb4e1aa1540$export$5368d76ae4fbbda7, ")")
});
var $95f36bb4e1aa1540$export$c2d157ca1c34b6e3 = (0, $gkJ2v.default)({
    light: "var(--ds-text-selected, ".concat($95f36bb4e1aa1540$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($95f36bb4e1aa1540$export$b3de0ae08da2ce64, ")")
});
var $95f36bb4e1aa1540$export$1905ba28d7cf066f = (0, $gkJ2v.default)({
    light: "var(--ds-text-subtlest, ".concat($95f36bb4e1aa1540$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($95f36bb4e1aa1540$export$97e81faa16a182c7, ")")
});
var $95f36bb4e1aa1540$export$bd9002130d306d39 = (0, $gkJ2v.default)({
    light: "var(--ds-text-subtlest, ".concat($95f36bb4e1aa1540$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($95f36bb4e1aa1540$export$bfe21c59123ecf33, ")")
});
var $95f36bb4e1aa1540$export$46e4a324ac90507f = (0, $gkJ2v.default)({
    light: "var(--ds-text, ".concat($95f36bb4e1aa1540$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($95f36bb4e1aa1540$export$5368d76ae4fbbda7, ")")
});
var $95f36bb4e1aa1540$export$79f3f2b82beb0d36 = (0, $gkJ2v.default)({
    light: "var(--ds-text-subtlest, ".concat($95f36bb4e1aa1540$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($95f36bb4e1aa1540$export$97e81faa16a182c7, ")")
});
var $95f36bb4e1aa1540$export$7bb0d5c671655cc4 = (0, $gkJ2v.default)({
    light: $95f36bb4e1aa1540$export$9fdfb749e33cdf97,
    dark: $95f36bb4e1aa1540$export$8e8133c1ba5845b5
});
var $95f36bb4e1aa1540$export$9c30223ca0a664fb = (0, $gkJ2v.default)({
    light: "var(--ds-link, ".concat($95f36bb4e1aa1540$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($95f36bb4e1aa1540$export$ecfc1dff386a3e7a, ")")
});
var $95f36bb4e1aa1540$export$7ed258b0728b004b = (0, $gkJ2v.default)({
    light: "var(--ds-link-pressed, ".concat($95f36bb4e1aa1540$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($95f36bb4e1aa1540$export$215b7063051591f1, ")")
});
var $95f36bb4e1aa1540$export$dfa920d8decc8a59 = (0, $gkJ2v.default)({
    light: "var(--ds-link-pressed, ".concat($95f36bb4e1aa1540$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($95f36bb4e1aa1540$export$ecfc1dff386a3e7a, ")")
});
var $95f36bb4e1aa1540$export$6069e6ad5c78f632 = (0, $gkJ2v.default)({
    light: "var(--ds-border-focused, ".concat($95f36bb4e1aa1540$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($95f36bb4e1aa1540$export$215b7063051591f1, ")")
});
var $95f36bb4e1aa1540$export$9ad721cf3b3debe0 = (0, $gkJ2v.default)({
    light: "var(--ds-background-brand-bold, ".concat($95f36bb4e1aa1540$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($95f36bb4e1aa1540$export$ecfc1dff386a3e7a, ")")
});
var $95f36bb4e1aa1540$export$2aa0182783e7e9de = (0, $gkJ2v.default)({
    light: $95f36bb4e1aa1540$export$b3de0ae08da2ce64,
    dark: $95f36bb4e1aa1540$export$ecfc1dff386a3e7a
});
var $95f36bb4e1aa1540$export$8bf7dff220b82b4a = (0, $gkJ2v.default)({
    light: $95f36bb4e1aa1540$export$9dc1ef0f3f48059b,
    dark: $95f36bb4e1aa1540$export$69cb3ca10c1e330e
});
var $95f36bb4e1aa1540$export$e13cce2a2d16a9d4 = (0, $gkJ2v.default)({
    light: $95f36bb4e1aa1540$export$b48405b95304b5a1,
    dark: $95f36bb4e1aa1540$export$6011520a64d9a187
});
var $95f36bb4e1aa1540$export$a90204d1394caf30 = (0, $gkJ2v.default)({
    light: $95f36bb4e1aa1540$export$4a7404f376229999,
    dark: $95f36bb4e1aa1540$export$4a7404f376229999
});
var $95f36bb4e1aa1540$export$594c5a8758200c32 = (0, $gkJ2v.default)({
    light: $95f36bb4e1aa1540$export$c6930421db9fa514,
    dark: $95f36bb4e1aa1540$export$c6930421db9fa514
});
var $95f36bb4e1aa1540$export$955a2ebd2fb142ae = (0, $gkJ2v.default)({
    light: $95f36bb4e1aa1540$export$940e1f69e873f202,
    dark: $95f36bb4e1aa1540$export$940e1f69e873f202
});
var $95f36bb4e1aa1540$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($95f36bb4e1aa1540$export$8d43898f60b96a82, ")");
};

});
parcelRegister("gkJ2v", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $be41737f3ed2920e$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $lo9EM = parcelRequire("lo9EM");
// Unpack custom variants, and get correct value for the current theme
function $be41737f3ed2920e$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $lo9EM.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $be41737f3ed2920e$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $be41737f3ed2920e$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $lo9EM.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}

});
parcelRegister("lo9EM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f923547c4e1ae36f$export$2e2bcd8739ae039; });

var $1Fk7u = parcelRequire("1Fk7u");
function $f923547c4e1ae36f$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $1Fk7u.CHANNEL) in props.theme) return props.theme[0, $1Fk7u.CHANNEL];
        else if ('mode' in props.theme && (0, $1Fk7u.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $1Fk7u.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("1Fk7u", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", function () { return $13693a2d5691cabd$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $13693a2d5691cabd$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $13693a2d5691cabd$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "gridSize", function () { return $13693a2d5691cabd$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $13693a2d5691cabd$export$85e3c3ca0c6fb93; });
$parcel$export(module.exports, "layers", function () { return $13693a2d5691cabd$export$7be255094ccdc533; });

var $eU0vm = parcelRequire("eU0vm");

var $cSbsP = parcelRequire("cSbsP");
var $13693a2d5691cabd$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $13693a2d5691cabd$export$c93026a968943f95 = 'light';
var $13693a2d5691cabd$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $13693a2d5691cabd$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $13693a2d5691cabd$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $13693a2d5691cabd$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $13693a2d5691cabd$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $13693a2d5691cabd$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $13693a2d5691cabd$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $13693a2d5691cabd$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $cSbsP.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $13693a2d5691cabd$export$6d8204c2cb2e06b8() / 4;
    (0, $eU0vm.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $13693a2d5691cabd$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $13693a2d5691cabd$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $13693a2d5691cabd$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $eU0vm.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $13693a2d5691cabd$export$ba1d834b86d72a09 = $13693a2d5691cabd$export$a1b3edb637fb4f35;
var $13693a2d5691cabd$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $cSbsP.skeleton)(), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $cSbsP.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $cSbsP.N30A), ")")
            }
        }
    };
};

});
parcelRegister("eU0vm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ad96afe1cd963221$export$2e2bcd8739ae039; });

var $ok2hF = parcelRequire("ok2hF");

var $7t0tI = parcelRequire("7t0tI");
function $ad96afe1cd963221$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $ok2hF.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $ad96afe1cd963221$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $7t0tI;
}

});
parcelRegister("ok2hF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0491c8b49b6fd4e2$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $0491c8b49b6fd4e2$var$printed = {};
function $0491c8b49b6fd4e2$export$2e2bcd8739ae039(message) {
    if ($0491c8b49b6fd4e2$var$printed[message]) return;
    $0491c8b49b6fd4e2$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});






parcelRegister("hlwOc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ca0dd8ee4a2e4814$export$2e2bcd8739ae039; });
function $ca0dd8ee4a2e4814$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $ca0dd8ee4a2e4814$var$tabKeyCode = 9;
function $ca0dd8ee4a2e4814$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $ca0dd8ee4a2e4814$var$tabKeyCode) return;
    $ca0dd8ee4a2e4814$var$abort(event);
}
var $ca0dd8ee4a2e4814$var$block = {
    onMouseDownCapture: $ca0dd8ee4a2e4814$var$abort,
    onMouseUpCapture: $ca0dd8ee4a2e4814$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $ca0dd8ee4a2e4814$var$onKey,
    onKeyUpCapture: $ca0dd8ee4a2e4814$var$onKey,
    onTouchStartCapture: $ca0dd8ee4a2e4814$var$abort,
    onTouchEndCapture: $ca0dd8ee4a2e4814$var$abort,
    onPointerDownCapture: $ca0dd8ee4a2e4814$var$abort,
    onPointerUpCapture: $ca0dd8ee4a2e4814$var$abort,
    onClickCapture: $ca0dd8ee4a2e4814$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $ca0dd8ee4a2e4814$var$abort
};
var $ca0dd8ee4a2e4814$var$doNotBlock = {};
function $ca0dd8ee4a2e4814$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $ca0dd8ee4a2e4814$var$doNotBlock : $ca0dd8ee4a2e4814$var$block;
}

});

parcelRegister("aoFFt", function(module, exports) {
$parcel$export(module.exports, "getCss", function () { return $791c77aaddab3c3c$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $791c77aaddab3c3c$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $791c77aaddab3c3c$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $791c77aaddab3c3c$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $791c77aaddab3c3c$export$1a9fe1b84c876bb5; });

var $eYHx9 = parcelRequire("eYHx9");

var $3dJ4i = parcelRequire("3dJ4i");

var $1Fk7u = parcelRequire("1Fk7u");

var $dxvmo = parcelRequire("dxvmo");
function $791c77aaddab3c3c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $791c77aaddab3c3c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $791c77aaddab3c3c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eYHx9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $791c77aaddab3c3c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $791c77aaddab3c3c$var$gridSize = (0, $1Fk7u.gridSize)();
var $791c77aaddab3c3c$var$fontSize = (0, $1Fk7u.fontSize)();
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $791c77aaddab3c3c$var$heights = {
    default: "".concat($791c77aaddab3c3c$var$gridSize * 4 / $791c77aaddab3c3c$var$fontSize, "em"),
    // 32px
    compact: "".concat($791c77aaddab3c3c$var$gridSize * 3 / $791c77aaddab3c3c$var$fontSize, "em"),
    none: 'auto'
};
var $791c77aaddab3c3c$var$lineHeights = {
    default: $791c77aaddab3c3c$var$heights.default,
    compact: $791c77aaddab3c3c$var$heights.compact,
    none: 'inherit'
};
var $791c77aaddab3c3c$var$padding = {
    // 10px gutter
    default: "0 ".concat($791c77aaddab3c3c$var$gridSize + $791c77aaddab3c3c$var$gridSize / 4, "px"),
    compact: "0 ".concat($791c77aaddab3c3c$var$gridSize + $791c77aaddab3c3c$var$gridSize / 4, "px"),
    none: '0'
};
var $791c77aaddab3c3c$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($791c77aaddab3c3c$var$gridSize / 4, "px"),
    default: "0 ".concat($791c77aaddab3c3c$var$gridSize / 4, "px"),
    none: '0'
};
var $791c77aaddab3c3c$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $791c77aaddab3c3c$var$innerMargin = {
    content: "0 ".concat($791c77aaddab3c3c$var$gridSize / 4, "px"),
    icon: "0 ".concat($791c77aaddab3c3c$var$gridSize / 4, "px")
};
function $791c77aaddab3c3c$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $791c77aaddab3c3c$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $791c77aaddab3c3c$var$getColor({
            group: (0, $dxvmo.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($791c77aaddab3c3c$var$getColor({
            group: (0, $dxvmo.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $791c77aaddab3c3c$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $791c77aaddab3c3c$var$getColors({
        appearance: appearance,
        key: isSelected ? 'selected' : 'default',
        mode: mode
    });
    return $791c77aaddab3c3c$var$_objectSpread($791c77aaddab3c3c$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap'
    }, baseColors), {}, {
        cursor: 'pointer',
        height: $791c77aaddab3c3c$var$heights[spacing],
        lineHeight: $791c77aaddab3c3c$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $791c77aaddab3c3c$var$singleIconPadding[spacing] : $791c77aaddab3c3c$var$padding[spacing],
        verticalAlign: $791c77aaddab3c3c$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        // Disabling visited styles (just using the base colors)
        '&:visited': $791c77aaddab3c3c$var$_objectSpread({}, baseColors),
        '&:hover': $791c77aaddab3c3c$var$_objectSpread($791c77aaddab3c3c$var$_objectSpread({}, $791c77aaddab3c3c$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'hover',
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? 'underline' : 'inherit',
            // background, box-shadow
            transitionDuration: '0s, 0.15s'
        }),
        // giving active styles preference by listing them after focus
        '&:active': $791c77aaddab3c3c$var$_objectSpread($791c77aaddab3c3c$var$_objectSpread({}, $791c77aaddab3c3c$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $791c77aaddab3c3c$var$_objectSpread($791c77aaddab3c3c$var$_objectSpread({}, $791c77aaddab3c3c$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        '&[disabled]': $791c77aaddab3c3c$var$_objectSpread($791c77aaddab3c3c$var$_objectSpread({}, $791c77aaddab3c3c$var$getColors({
            appearance: appearance,
            key: 'disabled',
            mode: mode
        })), {}, {
            cursor: 'not-allowed',
            textDecoration: 'none'
        }),
        '&[data-has-overlay="true"]': {
            cursor: 'default',
            textDecoration: 'none'
        },
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $791c77aaddab3c3c$var$_objectSpread({}, $791c77aaddab3c3c$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'default',
            mode: mode
        })),
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $791c77aaddab3c3c$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $3dJ4i.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === 'none' ? 0 : $791c77aaddab3c3c$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        fontSize: 0,
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $791c77aaddab3c3c$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $3dJ4i.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === 'none' ? 0 : $791c77aaddab3c3c$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $791c77aaddab3c3c$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $3dJ4i.css)({
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
var $791c77aaddab3c3c$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});
parcelRegister("dxvmo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9db6aee60bfae84b$export$2e2bcd8739ae039; });

var $cSbsP = parcelRequire("cSbsP");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $9db6aee60bfae84b$var$fadedB75 = 'rgba(179, 212, 255, 0.6)';
var $9db6aee60bfae84b$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($cSbsP.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($cSbsP.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($cSbsP.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($cSbsP.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($9db6aee60bfae84b$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($cSbsP.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($cSbsP.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($cSbsP.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cSbsP.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cSbsP.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cSbsP.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cSbsP.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($cSbsP.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($cSbsP.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($cSbsP.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($cSbsP.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($cSbsP.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($cSbsP.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($cSbsP.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($cSbsP.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cSbsP.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cSbsP.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cSbsP.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cSbsP.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($cSbsP.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($cSbsP.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($cSbsP.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($cSbsP.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($cSbsP.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($cSbsP.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($cSbsP.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($cSbsP.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cSbsP.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($cSbsP.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cSbsP.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($cSbsP.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($cSbsP.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($cSbsP.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($cSbsP.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($cSbsP.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($cSbsP.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($cSbsP.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($cSbsP.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($cSbsP.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cSbsP.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($cSbsP.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cSbsP.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($cSbsP.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cSbsP.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cSbsP.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cSbsP.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cSbsP.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($cSbsP.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($cSbsP.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($9db6aee60bfae84b$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($cSbsP.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cSbsP.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cSbsP.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cSbsP.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cSbsP.DN0, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($cSbsP.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cSbsP.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($cSbsP.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($cSbsP.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($cSbsP.N500, ")"),
                dark: "var(--ds-text, ".concat($cSbsP.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($cSbsP.B400, ")"),
                dark: "var(--ds-text, ".concat($cSbsP.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cSbsP.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cSbsP.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cSbsP.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cSbsP.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cSbsP.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cSbsP.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($cSbsP.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($cSbsP.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cSbsP.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cSbsP.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cSbsP.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cSbsP.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cSbsP.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cSbsP.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($cSbsP.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($cSbsP.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cSbsP.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cSbsP.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cSbsP.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($cSbsP.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cSbsP.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($cSbsP.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($cSbsP.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($cSbsP.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cSbsP.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cSbsP.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cSbsP.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($cSbsP.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cSbsP.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($cSbsP.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($cSbsP.B400, ")"),
                dark: "var(--ds-link, ".concat($cSbsP.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($cSbsP.B300, ")"),
                dark: "var(--ds-link, ".concat($cSbsP.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($cSbsP.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($cSbsP.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cSbsP.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cSbsP.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cSbsP.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cSbsP.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cSbsP.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cSbsP.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($cSbsP.N500, ")"),
                dark: "var(--ds-text, ".concat($cSbsP.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($cSbsP.B400, ")"),
                dark: "var(--ds-text, ".concat($cSbsP.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cSbsP.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cSbsP.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cSbsP.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cSbsP.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cSbsP.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cSbsP.DN400, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-text-subtle, ".concat($cSbsP.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($cSbsP.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($cSbsP.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($cSbsP.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($cSbsP.N400, ")"),
                dark: "var(--ds-text, ".concat($cSbsP.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($cSbsP.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($cSbsP.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($cSbsP.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cSbsP.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($cSbsP.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($cSbsP.DN400, ")")
            }
        }
    }
};
var $9db6aee60bfae84b$export$2e2bcd8739ae039 = $9db6aee60bfae84b$var$values;

});


parcelRegister("9kk7t", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $6ca596a4f94ff8aa$export$20bbd2efb0d734c4; });

var $1oC0p = parcelRequire("1oC0p");

var $eYsH0 = parcelRequire("eYsH0");
var $6ca596a4f94ff8aa$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $1oC0p.isValidElement)(children) && children.type === (0, $eYsH0.default);
};

});
parcelRegister("eYsH0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ae6ced0feef370a3$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
var $ae6ced0feef370a3$var$visuallyHiddenStyles = (0, $3dJ4i.css)({
    width: '1px',
    height: '1px',
    padding: '0',
    position: 'absolute',
    border: '0',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $ae6ced0feef370a3$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return (0, $3dJ4i.jsx)("span", {
        id: id,
        "data-testid": testId,
        css: $ae6ced0feef370a3$var$visuallyHiddenStyles,
        role: role
    }, children);
};
var $ae6ced0feef370a3$export$2e2bcd8739ae039 = $ae6ced0feef370a3$var$VisuallyHidden;

});



parcelRegister("1p6zS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $105d3a71c5a8bd78$export$2e2bcd8739ae039; });

var $9kk7t = parcelRequire("9kk7t");
function $105d3a71c5a8bd78$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $9kk7t.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});

parcelRegister("8Zlix", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $68b48a9192d3f03a$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $11idE = parcelRequire("11idE");
function $68b48a9192d3f03a$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $68b48a9192d3f03a$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing;
    var size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $11idE.default), {
        size: size,
        label: ", Loading",
        appearance: $68b48a9192d3f03a$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("11idE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0be404629c4f2587$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $1svAK = parcelRequire("1svAK");

var $cSbsP = parcelRequire("cSbsP");

var $jRlQ9 = parcelRequire("jRlQ9");
/**
 * Returns the appropriate circle stroke color.
 */ function $0be404629c4f2587$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $cSbsP.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $cSbsP.N0), ")");
}
var $0be404629c4f2587$var$rotate = (0, $3dJ4i.keyframes)({
    to: {
        transform: 'rotate(360deg)'
    }
});
var $0be404629c4f2587$var$rotateStyles = (0, $3dJ4i.css)({
    animation: "".concat($0be404629c4f2587$var$rotate, " 0.86s infinite"),
    animationTimingFunction: 'cubic-bezier(0.4, 0.15, 0.6, 0.85)',
    transformOrigin: 'center'
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $0be404629c4f2587$var$loadIn = (0, $3dJ4i.keyframes)({
    from: {
        transform: 'rotate(50deg)',
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: 'rotate(230deg)',
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $0be404629c4f2587$var$loadInStyles = (0, $3dJ4i.css)({
    animation: "".concat($0be404629c4f2587$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: 'forwards',
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $0be404629c4f2587$var$wrapperStyles = (0, $3dJ4i.css)({
    display: 'inline-flex',
    /**
   * Align better inline with text.
   */ verticalAlign: 'middle'
});
var $0be404629c4f2587$var$circleStyles = (0, $3dJ4i.css)({
    fill: 'none',
    strokeDasharray: 60,
    strokeDashoffset: 'inherit',
    strokeLinecap: 'round',
    strokeWidth: 1.5,
    '@media screen and (forced-colors: active)': {
        filter: 'grayscale(100%)',
        stroke: 'CanvasText'
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $0be404629c4f2587$var$useLayoutEffect = typeof window === 'undefined' ? (0, $1oC0p.useEffect) : (0, $1oC0p.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/{spinner}/examples)
 * - [Code](https://atlassian.design/components/{spinner}/code)
 * - [Usage](https://atlassian.design/components/{spinner}/usage)
 */ var $0be404629c4f2587$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $jRlQ9.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $0be404629c4f2587$var$getStrokeColor(appearance);
    var context = (0, $1oC0p.useContext)((0, $1svAK.default));
    $0be404629c4f2587$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $3dJ4i.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $0be404629c4f2587$var$wrapperStyles,
            $0be404629c4f2587$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $3dJ4i.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $0be404629c4f2587$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none'
    }, (0, $3dJ4i.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $0be404629c4f2587$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $0be404629c4f2587$export$2e2bcd8739ae039 = $0be404629c4f2587$var$Spinner;

});
parcelRegister("jRlQ9", function(module, exports) {
$parcel$export(module.exports, "presetSizes", function () { return $e753e88d3b455b6e$export$4e9f1640bbe7a1a8; });
var $e753e88d3b455b6e$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("5P4hh", function(module, exports) {
$parcel$export(module.exports, "getSpecifiers", function () { return $43d508a4aa96c7ef$export$643db0b8d8778e; });
$parcel$export(module.exports, "defaultThemeFn", function () { return $43d508a4aa96c7ef$export$437a7f77d13d7916; });
$parcel$export(module.exports, "default", function () { return $43d508a4aa96c7ef$export$2e2bcd8739ae039; });

var $eYHx9 = parcelRequire("eYHx9");

var $cUPup = parcelRequire("cUPup");

var $aoFFt = parcelRequire("aoFFt");
function $43d508a4aa96c7ef$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $43d508a4aa96c7ef$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $43d508a4aa96c7ef$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eYHx9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $43d508a4aa96c7ef$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $43d508a4aa96c7ef$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $43d508a4aa96c7ef$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? 'light' : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $aoFFt.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    var selector = $43d508a4aa96c7ef$var$stateToSelectorMap[state];
    if (selector) result = $43d508a4aa96c7ef$var$_objectSpread($43d508a4aa96c7ef$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $43d508a4aa96c7ef$var$_objectSpread($43d508a4aa96c7ef$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}
function $43d508a4aa96c7ef$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}
function $43d508a4aa96c7ef$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $43d508a4aa96c7ef$var$Theme = (0, $cUPup.createTheme)(function(themeProps) {
    return {
        buttonStyles: $43d508a4aa96c7ef$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43d508a4aa96c7ef$export$2e2bcd8739ae039 = $43d508a4aa96c7ef$var$Theme;

});


parcelRegister("2zyTy", function(module, exports) {
$parcel$export(module.exports, "useTheme", function () { return $1df9eb13c39afcb2$export$93d4e7f90805808f; });

var $1oC0p = parcelRequire("1oC0p");

var $9Q6kO = parcelRequire("9Q6kO");
var $1df9eb13c39afcb2$export$93d4e7f90805808f = function useTheme() {
    return (0, $1oC0p.useContext)((0, $9Q6kO.ThemeContext));
};

});
parcelRegister("9Q6kO", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", function () { return $729de24c493c0fa3$export$2c657da244d00bd6; });
$parcel$export(module.exports, "ThemeProvider", function () { return $729de24c493c0fa3$export$d8964aec282183a3; });

var $1oC0p = parcelRequire("1oC0p");

var $2Lx06 = parcelRequire("2Lx06");
var $729de24c493c0fa3$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $1oC0p.createContext)((0, $2Lx06.defaultTheme));
var $729de24c493c0fa3$export$d8964aec282183a3 = $729de24c493c0fa3$export$2c657da244d00bd6.Provider;

});
parcelRegister("2Lx06", function(module, exports) {
$parcel$export(module.exports, "defaultTheme", function () { return $203991c8dab7bf51$export$164de7ab8df77ef0; });

var $cSbsP = parcelRequire("cSbsP");

var $5vDdY = parcelRequire("5vDdY");

var $RRooL = parcelRequire("RRooL");
var $203991c8dab7bf51$export$eeee8619e1b91cb0 = (0, $RRooL.generateTheme)({
    name: (0, $5vDdY.DEFAULT_THEME_NAME),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: (0, $cSbsP.N0),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    highlightColor: (0, $cSbsP.B400)
});
var $203991c8dab7bf51$export$164de7ab8df77ef0 = $203991c8dab7bf51$export$eeee8619e1b91cb0;

});
parcelRegister("5vDdY", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_THEME_NAME", function () { return $402e462507315223$export$2491e13b198e597d; });
$parcel$export(module.exports, "default", function () { return $402e462507315223$export$2e2bcd8739ae039; });

var $6DIEl = parcelRequire("6DIEl");

var $cSbsP = parcelRequire("cSbsP");

var $2e5IK = parcelRequire("2e5IK");
var $402e462507315223$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, ".concat((0, $cSbsP.N0), ")"),
                backgroundColor: "var(--ds-background-brand-bold-pressed, ".concat((0, $2e5IK.hexToRGBA)((0, $cSbsP.B400), 0.8), ")"),
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, ".concat((0, $cSbsP.N0), ")"),
                backgroundColor: "var(--ds-background-brand-bold, ".concat((0, $cSbsP.B400), ")"),
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, ".concat((0, $cSbsP.N0), ")"),
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, ".concat((0, $cSbsP.N0), ")"),
                backgroundColor: "var(--ds-background-brand-bold-hovered, ".concat((0, $2e5IK.hexToRGBA)((0, $cSbsP.B400), 0.9), ")"),
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, ".concat((0, $cSbsP.B400), ")"),
                backgroundColor: "var(--ds-background-neutral-pressed, ".concat((0, $2e5IK.hexToRGBA)((0, $cSbsP.B50), 0.6), ")"),
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, ".concat((0, $cSbsP.N600), ")"),
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, ".concat((0, $cSbsP.N600), ")"),
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, ".concat((0, $cSbsP.B400), ")"),
                backgroundColor: "var(--ds-background-neutral-hovered, ".concat((0, $2e5IK.hexToRGBA)((0, $cSbsP.B50), 0.9), ")"),
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, ".concat((0, $cSbsP.B400), ")"),
                backgroundColor: "var(--ds-background-selected, ".concat((0, $2e5IK.hexToRGBA)((0, $cSbsP.B50), 0.6), ")"),
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, ".concat((0, $cSbsP.B400), ")"),
                backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $2e5IK.hexToRGBA)((0, $cSbsP.B50), 0.6), ")"),
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, ".concat((0, $cSbsP.N0), ")"),
            color: "var(--ds-text-subtlest, ".concat((0, $cSbsP.N200), ")")
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, ".concat((0, $cSbsP.B400), ")"),
            color: "var(--ds-text, ".concat((0, $cSbsP.N700), ")"),
            borderRight: "1px solid ".concat("var(--ds-border, ".concat((0, $2e5IK.hexToRGBA)((0, $cSbsP.N200), 0.3), ")")),
            // TODO: (DSP-1256) These colors should be moved into the Logo package
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconGradientStart: (0, $cSbsP.B400),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconGradientStop: (0, $cSbsP.B200),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconColor: (0, $6DIEl.getBooleanFF)('platform.design-system-team.brand-refresh-update-product-logos_q7coo') ? '#357DE8' : (0, $cSbsP.B200)
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, ".concat((0, $cSbsP.B400), ")"),
                backgroundColor: "var(--ds-background-neutral-pressed, ".concat((0, $2e5IK.hexToRGBA)((0, $cSbsP.B50), 0.7), ")"),
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, ".concat((0, $cSbsP.N600), ")"),
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, ".concat((0, $cSbsP.N600), ")"),
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, ".concat((0, $cSbsP.B400), ")"),
                backgroundColor: "var(--ds-background-neutral-hovered, ".concat((0, $2e5IK.hexToRGBA)((0, $cSbsP.B50), 0.9), ")"),
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, ".concat((0, $cSbsP.B400), ")"),
                backgroundColor: "var(--ds-background-selected, ".concat((0, $2e5IK.hexToRGBA)((0, $cSbsP.B50), 0.7), ")"),
                boxShadow: '',
                borderColor: "var(--ds-border-selected, ".concat((0, $cSbsP.B400), ")")
            },
            selectedHover: {
                color: "var(--ds-text-selected, ".concat((0, $cSbsP.B400), ")"),
                backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $2e5IK.hexToRGBA)((0, $cSbsP.B50), 0.6), ")"),
                boxShadow: '',
                borderColor: "var(--ds-border-selected, ".concat((0, $cSbsP.B400), ")")
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, ".concat((0, $cSbsP.N0), ")"),
                color: "var(--ds-text-subtlest, ".concat((0, $cSbsP.N200), ")"),
                borderColor: "var(--ds-border-input, ".concat((0, $cSbsP.N100), ")")
            },
            focus: {
                borderColor: "var(--ds-border-focused, ".concat((0, $cSbsP.B200), ")")
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, ".concat((0, $cSbsP.N0), ")")
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, ".concat((0, $cSbsP.N20), ")"),
            opacity: 1
        }
    }
};
var $402e462507315223$export$2491e13b198e597d = 'atlassian';
var $402e462507315223$export$2e2bcd8739ae039 = $402e462507315223$var$defaultTheme;

});
parcelRegister("6DIEl", function(module, exports) {
$parcel$export(module.exports, "getBooleanFF", function () { return $4d59051c0235f55f$export$470e5c2be1411c89; });

var $bQXWX = parcelRequire("bQXWX");
function $4d59051c0235f55f$export$ba05d765b8392e5e(flagResolver) {
    (0, $bQXWX.setBooleanResolver)(flagResolver);
}
function $4d59051c0235f55f$export$470e5c2be1411c89(name) {
    return (0, $bQXWX.resolveBooleanFlag)(name);
}

});
parcelRegister("bQXWX", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", function () { return $8a130dd720bf79e7$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $8a130dd720bf79e7$export$6333b6aff9fc6275; });

var $7P6Hx = parcelRequire("7P6Hx");

var $7t0tI = parcelRequire("7t0tI");
var $8a130dd720bf79e7$var$pkgName = '@atlaskit/platform-feature-flags';
var $8a130dd720bf79e7$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $8a130dd720bf79e7$var$hasProcessEnv = typeof $7t0tI !== 'undefined' && typeof $7t0tI.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $8a130dd720bf79e7$var$ENV_ENABLE_PLATFORM_FF = $8a130dd720bf79e7$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $8a130dd720bf79e7$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $8a130dd720bf79e7$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $8a130dd720bf79e7$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $8a130dd720bf79e7$var$ENV_ENABLE_PLATFORM_FF || $8a130dd720bf79e7$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $8a130dd720bf79e7$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $8a130dd720bf79e7$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$8a130dd720bf79e7$var$globalVar[$8a130dd720bf79e7$export$7e41b1b2bdee3f98] = $8a130dd720bf79e7$var$globalVar[$8a130dd720bf79e7$export$7e41b1b2bdee3f98] || $8a130dd720bf79e7$var$DEFAULT_PFF_GLOBAL;
function $8a130dd720bf79e7$export$f2b591175b3e424c(resolver) {
    $8a130dd720bf79e7$var$globalVar[$8a130dd720bf79e7$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2;
}
function $8a130dd720bf79e7$export$6333b6aff9fc6275(flagKey) {
    if ($8a130dd720bf79e7$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $7P6Hx.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $8a130dd720bf79e7$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL3;
        var result = (_globalVar$PFF_GLOBAL3 = $8a130dd720bf79e7$var$globalVar[$8a130dd720bf79e7$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("7P6Hx", function(module, exports) {
$parcel$export(module.exports, "debug", function () { return $5b227e8d4bcf397b$export$1c9f709888824e05; });
var $5b227e8d4bcf397b$var$_ref, $5b227e8d4bcf397b$var$_globalThis$process, $5b227e8d4bcf397b$var$_globalThis$process$e, $5b227e8d4bcf397b$var$_globalThis$process2, $5b227e8d4bcf397b$var$_globalThis$process2$;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $5b227e8d4bcf397b$var$TESTS_MODE = ($5b227e8d4bcf397b$var$_ref = (globalThis === null || globalThis === void 0 ? void 0 : ($5b227e8d4bcf397b$var$_globalThis$process = globalThis.process) === null || $5b227e8d4bcf397b$var$_globalThis$process === void 0 ? void 0 : ($5b227e8d4bcf397b$var$_globalThis$process$e = $5b227e8d4bcf397b$var$_globalThis$process.env) === null || $5b227e8d4bcf397b$var$_globalThis$process$e === void 0 ? void 0 : $5b227e8d4bcf397b$var$_globalThis$process$e.JEST_WORKER_ID) !== undefined, $5b227e8d4bcf397b$var$_ref !== void 0) ? $5b227e8d4bcf397b$var$_ref : false;
var $5b227e8d4bcf397b$var$DEBUG_MODE = !$5b227e8d4bcf397b$var$TESTS_MODE && (globalThis === null || globalThis === void 0 ? void 0 : ($5b227e8d4bcf397b$var$_globalThis$process2 = globalThis.process) === null || $5b227e8d4bcf397b$var$_globalThis$process2 === void 0 ? void 0 : ($5b227e8d4bcf397b$var$_globalThis$process2$ = $5b227e8d4bcf397b$var$_globalThis$process2.env) === null || $5b227e8d4bcf397b$var$_globalThis$process2$ === void 0 ? void 0 : $5b227e8d4bcf397b$var$_globalThis$process2$.NODE_ENV) !== 'production';
var $5b227e8d4bcf397b$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$5b227e8d4bcf397b$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("2e5IK", function(module, exports) {
$parcel$export(module.exports, "hexToRGBA", function () { return $19f1539f6edf2fe8$export$7229be6d7219ee6a; });
$parcel$export(module.exports, "getBoxShadow", function () { return $19f1539f6edf2fe8$export$bba5a971afe05444; });
$parcel$export(module.exports, "generateTextColor", function () { return $19f1539f6edf2fe8$export$10a10e7cd1193377; });
$parcel$export(module.exports, "getContrastColor", function () { return $19f1539f6edf2fe8$export$77a1051494882576; });

var $eT6dr = parcelRequire("eT6dr");

var $eYHx9 = parcelRequire("eYHx9");

var $2Pq7Y = parcelRequire("2Pq7Y");
function $19f1539f6edf2fe8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $19f1539f6edf2fe8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $19f1539f6edf2fe8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eYHx9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $19f1539f6edf2fe8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $19f1539f6edf2fe8$export$7229be6d7219ee6a = function hexToRGBA(hex) {
    var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var rgba = $19f1539f6edf2fe8$var$_objectSpread($19f1539f6edf2fe8$var$_objectSpread({}, (0, $2Pq7Y.default).convert(hex).rgb), {
        a: opacity
    });
    return "rgba(".concat(Object.values(rgba).join(', '), ")");
};
var $19f1539f6edf2fe8$export$bba5a971afe05444 = function getBoxShadow(color) {
    return "0 0 0 2px ".concat(color);
};
var $19f1539f6edf2fe8$var$hex = '[a-z0-9]';
var $19f1539f6edf2fe8$var$shortHandHexColorPattern = new RegExp("#(".concat($19f1539f6edf2fe8$var$hex, ")(").concat($19f1539f6edf2fe8$var$hex, ")(").concat($19f1539f6edf2fe8$var$hex, ")"), 'i');
var $19f1539f6edf2fe8$var$repeat = function repeat(str, times) {
    return (0, $eT6dr.default)(Array(times)).map(function() {
        return str;
    }).join('');
};
var $19f1539f6edf2fe8$var$isShortHexColor = function isShortHexColor(color) {
    return color && color.length === 4;
};
var $19f1539f6edf2fe8$var$completeHexColor = function completeHexColor(colors) {
    var hex = colors.map(function(color) {
        return $19f1539f6edf2fe8$var$repeat(color, 2);
    }).join('');
    return "#".concat(hex);
};
var $19f1539f6edf2fe8$var$completeTriplet = function completeTriplet(colors) {
    return "#".concat($19f1539f6edf2fe8$var$repeat(colors[1], 6));
};
var $19f1539f6edf2fe8$var$isTriplet = function isTriplet(colors) {
    return colors[0] === colors[1] && colors[1] === colors[2];
};
var $19f1539f6edf2fe8$export$db8d2130677f868c = function convertHexShorthand(color) {
    if ($19f1539f6edf2fe8$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        var matches = color.match($19f1539f6edf2fe8$var$shortHandHexColorPattern);
        if (matches) {
            var colors = matches.slice(1, 4);
            if ($19f1539f6edf2fe8$var$isTriplet(colors)) return $19f1539f6edf2fe8$var$completeTriplet(colors);
            else return $19f1539f6edf2fe8$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
var $19f1539f6edf2fe8$export$10a10e7cd1193377 = function generateTextColor(color) {
    var converted = $19f1539f6edf2fe8$export$db8d2130677f868c(color);
    return (0, $2Pq7Y.default).contrastRatio(converted).hex;
};
var $19f1539f6edf2fe8$export$77a1051494882576 = function getContrastColor(contrastValue, opacityValue, color) {
    return $19f1539f6edf2fe8$export$7229be6d7219ee6a((0, $2Pq7Y.default).contrast(contrastValue, color).hex, opacityValue);
};

});
parcelRegister("2Pq7Y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $20f49c9d1818c473$export$2e2bcd8739ae039; });
function $20f49c9d1818c473$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $20f49c9d1818c473$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $20f49c9d1818c473$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $20f49c9d1818c473$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $20f49c9d1818c473$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $20f49c9d1818c473$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $20f49c9d1818c473$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $20f49c9d1818c473$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $20f49c9d1818c473$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $20f49c9d1818c473$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $20f49c9d1818c473$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $20f49c9d1818c473$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $20f49c9d1818c473$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $20f49c9d1818c473$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $20f49c9d1818c473$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $20f49c9d1818c473$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $20f49c9d1818c473$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $20f49c9d1818c473$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $20f49c9d1818c473$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $20f49c9d1818c473$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $20f49c9d1818c473$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $20f49c9d1818c473$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $20f49c9d1818c473$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $20f49c9d1818c473$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $20f49c9d1818c473$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $20f49c9d1818c473$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $20f49c9d1818c473$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $20f49c9d1818c473$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $20f49c9d1818c473$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $20f49c9d1818c473$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $20f49c9d1818c473$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $20f49c9d1818c473$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $20f49c9d1818c473$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $20f49c9d1818c473$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $20f49c9d1818c473$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $20f49c9d1818c473$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $20f49c9d1818c473$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $20f49c9d1818c473$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $20f49c9d1818c473$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $20f49c9d1818c473$var$fromHex_1 = $20f49c9d1818c473$var$fromHex, $20f49c9d1818c473$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $20f49c9d1818c473$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $20f49c9d1818c473$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $20f49c9d1818c473$var$fromRgb_1 = $20f49c9d1818c473$var$fromRgb, $20f49c9d1818c473$var$fromCssRgb_1 = $20f49c9d1818c473$var$fromCssRgb, $20f49c9d1818c473$var$fromHsl_1 = $20f49c9d1818c473$var$fromHsl, $20f49c9d1818c473$var$fromCssHsl_1 = $20f49c9d1818c473$var$fromCssHsl, $20f49c9d1818c473$var$fromHsv_1 = $20f49c9d1818c473$var$fromHsv, $20f49c9d1818c473$var$fromCmyk_1 = $20f49c9d1818c473$var$fromCmyk, $20f49c9d1818c473$var$fromYiq_1 = $20f49c9d1818c473$var$fromYiq, $20f49c9d1818c473$var$fromXYZ_1 = $20f49c9d1818c473$var$fromXYZ, $20f49c9d1818c473$var$fromxyY_1 = $20f49c9d1818c473$var$fromxyY, $20f49c9d1818c473$var$fromLms_1 = $20f49c9d1818c473$var$fromLms, $20f49c9d1818c473$var$fromCieLab_1 = $20f49c9d1818c473$var$fromCieLab, $20f49c9d1818c473$var$fromCieLuv_1 = $20f49c9d1818c473$var$fromCieLuv, $20f49c9d1818c473$var$fromCieLch_1 = $20f49c9d1818c473$var$fromCieLch, $20f49c9d1818c473$var$fromHsluv = $20f49c9d1818c473$var$fromCieLch$1, $20f49c9d1818c473$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $20f49c9d1818c473$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $20f49c9d1818c473$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $20f49c9d1818c473$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $20f49c9d1818c473$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $20f49c9d1818c473$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $20f49c9d1818c473$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $20f49c9d1818c473$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $20f49c9d1818c473$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $20f49c9d1818c473$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $20f49c9d1818c473$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $20f49c9d1818c473$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $20f49c9d1818c473$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $20f49c9d1818c473$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $20f49c9d1818c473$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $20f49c9d1818c473$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $20f49c9d1818c473$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $20f49c9d1818c473$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $20f49c9d1818c473$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $20f49c9d1818c473$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $20f49c9d1818c473$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $20f49c9d1818c473$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $20f49c9d1818c473$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $20f49c9d1818c473$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $20f49c9d1818c473$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $20f49c9d1818c473$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $20f49c9d1818c473$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $20f49c9d1818c473$var$fromHsluv
    }
}, $20f49c9d1818c473$var$adapt_1 = $20f49c9d1818c473$var$adapt, $20f49c9d1818c473$var$adjacent_1 = $20f49c9d1818c473$var$adjacent, $20f49c9d1818c473$var$brightness_1 = $20f49c9d1818c473$var$brightness, $20f49c9d1818c473$var$complementary_1 = $20f49c9d1818c473$var$complementary, $20f49c9d1818c473$var$contrast_1 = $20f49c9d1818c473$var$contrast, $20f49c9d1818c473$var$contrastRatio_1 = $20f49c9d1818c473$var$contrastRatio, $20f49c9d1818c473$var$convert_1 = $20f49c9d1818c473$var$convert, $20f49c9d1818c473$var$difference_1 = $20f49c9d1818c473$var$difference, $20f49c9d1818c473$var$fade_1 = $20f49c9d1818c473$var$fade, $20f49c9d1818c473$var$greyscale_1 = $20f49c9d1818c473$var$greyscale, $20f49c9d1818c473$var$hue_1 = $20f49c9d1818c473$var$hue, $20f49c9d1818c473$var$invert_1 = $20f49c9d1818c473$var$invert, $20f49c9d1818c473$var$invertLightness_1 = $20f49c9d1818c473$var$invertLightness, $20f49c9d1818c473$var$mid_1 = $20f49c9d1818c473$var$mid, $20f49c9d1818c473$var$multiply_1 = $20f49c9d1818c473$var$multiply, $20f49c9d1818c473$var$saturation_1 = $20f49c9d1818c473$var$saturation, $20f49c9d1818c473$var$sepia_1 = $20f49c9d1818c473$var$sepia, $20f49c9d1818c473$var$shade_1 = $20f49c9d1818c473$var$shade, $20f49c9d1818c473$var$temperature_1 = $20f49c9d1818c473$var$temperature, $20f49c9d1818c473$var$tetrad_1 = $20f49c9d1818c473$var$tetrad, $20f49c9d1818c473$var$triad_1 = $20f49c9d1818c473$var$triad, $20f49c9d1818c473$var$index$2 = {
    adapt: $20f49c9d1818c473$var$adapt_1,
    adjacent: $20f49c9d1818c473$var$adjacent_1,
    brightness: $20f49c9d1818c473$var$brightness_1,
    complementary: $20f49c9d1818c473$var$complementary_1,
    contrast: $20f49c9d1818c473$var$contrast_1,
    contrastRatio: $20f49c9d1818c473$var$contrastRatio_1,
    convert: $20f49c9d1818c473$var$convert_1,
    difference: $20f49c9d1818c473$var$difference_1,
    fade: $20f49c9d1818c473$var$fade_1,
    greyscale: $20f49c9d1818c473$var$greyscale_1,
    hue: $20f49c9d1818c473$var$hue_1,
    invert: $20f49c9d1818c473$var$invert_1,
    invertLightness: $20f49c9d1818c473$var$invertLightness_1,
    mid: $20f49c9d1818c473$var$mid_1,
    multiply: $20f49c9d1818c473$var$multiply_1,
    saturation: $20f49c9d1818c473$var$saturation_1,
    sepia: $20f49c9d1818c473$var$sepia_1,
    shade: $20f49c9d1818c473$var$shade_1,
    temperature: $20f49c9d1818c473$var$temperature_1,
    tetrad: $20f49c9d1818c473$var$tetrad_1,
    triad: $20f49c9d1818c473$var$triad_1
}, $20f49c9d1818c473$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $20f49c9d1818c473$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $20f49c9d1818c473$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($20f49c9d1818c473$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $20f49c9d1818c473$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($20f49c9d1818c473$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $20f49c9d1818c473$var$api_1 = $20f49c9d1818c473$var$api, $20f49c9d1818c473$var$helpers = {
    getIlluminant: function(r) {
        return $20f49c9d1818c473$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $20f49c9d1818c473$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $20f49c9d1818c473$var$index)if ($20f49c9d1818c473$var$index.hasOwnProperty(e) && $20f49c9d1818c473$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $20f49c9d1818c473$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $20f49c9d1818c473$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $20f49c9d1818c473$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $20f49c9d1818c473$var$constants, s));
            default:
                return null;
        }
    }
}, $20f49c9d1818c473$var$helpers_1 = $20f49c9d1818c473$var$helpers, $20f49c9d1818c473$var$dependencies = {
    conversions: $20f49c9d1818c473$var$index,
    operations: $20f49c9d1818c473$var$index$2,
    helpers: $20f49c9d1818c473$var$helpers_1
}, $20f49c9d1818c473$var$entry = $20f49c9d1818c473$var$api_1($20f49c9d1818c473$var$dependencies, $20f49c9d1818c473$var$constants);
var $20f49c9d1818c473$export$2e2bcd8739ae039 = $20f49c9d1818c473$var$entry;

});



parcelRegister("RRooL", function(module, exports) {
$parcel$export(module.exports, "generateTheme", function () { return $0a1e5dfe9f42ed18$export$2e4ecffaca289a18; });

var $eYHx9 = parcelRequire("eYHx9");

var $5vDdY = parcelRequire("5vDdY");

var $2e5IK = parcelRequire("2e5IK");
function $0a1e5dfe9f42ed18$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a1e5dfe9f42ed18$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a1e5dfe9f42ed18$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eYHx9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a1e5dfe9f42ed18$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0a1e5dfe9f42ed18$var$generateOpacityValue = function generateOpacityValue(color) {
    return color === '#000000' ? 0.3 : 0.6;
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $0a1e5dfe9f42ed18$var$generateButtonCSSStates = function generateButtonCSSStates(colors, buttonType) {
    var backgroundColor = colors.backgroundColor, color = colors.color, highlightColor = colors.highlightColor;
    // Add less opacity for white text so it is still legible.
    var opacityValue = $0a1e5dfe9f42ed18$var$generateOpacityValue(color);
    var isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $2e5IK.hexToRGBA)(backgroundColor, 0.65) : (0, $2e5IK.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $2e5IK.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $2e5IK.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $2e5IK.hexToRGBA)(backgroundColor, 0.8) : (0, $2e5IK.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $2e5IK.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $2e5IK.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $2e5IK.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $2e5IK.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $2e5IK.getBoxShadow)('transparent')
        }
    };
};
var $0a1e5dfe9f42ed18$var$generateCreateButtonColors = function generateCreateButtonColors(themeBackground, themeHighlight) {
    return {
        backgroundColor: themeHighlight,
        color: (0, $2e5IK.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    };
};
var $0a1e5dfe9f42ed18$export$2e4ecffaca289a18 = function generateTheme(themeColors) {
    var backgroundColor = themeColors.backgroundColor, highlightColor = themeColors.highlightColor, name = themeColors.name;
    var color = (0, $2e5IK.generateTextColor)(backgroundColor);
    var colors = $0a1e5dfe9f42ed18$var$_objectSpread($0a1e5dfe9f42ed18$var$_objectSpread({}, themeColors), {}, {
        color: color
    });
    if (name === (0, $5vDdY.DEFAULT_THEME_NAME)) return 0, $5vDdY.default;
    return {
        mode: {
            create: $0a1e5dfe9f42ed18$var$generateButtonCSSStates($0a1e5dfe9f42ed18$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $0a1e5dfe9f42ed18$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $0a1e5dfe9f42ed18$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                backgroundColor: highlightColor,
                borderRight: "1px solid ".concat((0, $2e5IK.hexToRGBA)(color, 0.5))
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $2e5IK.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $2e5IK.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $2e5IK.getBoxShadow)((0, $2e5IK.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $2e5IK.getContrastColor)(0.1, $0a1e5dfe9f42ed18$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};
var $0a1e5dfe9f42ed18$export$2e2bcd8739ae039 = $0a1e5dfe9f42ed18$export$2e4ecffaca289a18;

});




parcelRegister("dPseJ", function(module, exports) {
$parcel$export(module.exports, "getIconButtonTheme", function () { return $029920ca30c0f22c$export$f32bddcb857301f3; });

var $eYHx9 = parcelRequire("eYHx9");
function $029920ca30c0f22c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $029920ca30c0f22c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $029920ca30c0f22c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eYHx9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $029920ca30c0f22c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $029920ca30c0f22c$export$f32bddcb857301f3 = function getIconButtonTheme(_ref) {
    var iconButton = _ref.mode.iconButton;
    return function(current, props) {
        var _current = current(props), buttonStyles = _current.buttonStyles, spinnerStyles = _current.spinnerStyles;
        return {
            buttonStyles: $029920ca30c0f22c$var$_objectSpread($029920ca30c0f22c$var$_objectSpread($029920ca30c0f22c$var$_objectSpread($029920ca30c0f22c$var$_objectSpread({}, buttonStyles), {}, {
                borderRadius: "var(--ds-border-radius-circle, 100%)",
                display: 'flex',
                margin: "0 ".concat("var(--ds-space-025, 2px)"),
                // TODO Delete this comment after verifying space token -> previous value `4`
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)"
            }, iconButton.default), {}, {
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': $029920ca30c0f22c$var$_objectSpread({}, props.state === 'active' && iconButton.active)
            }, props.state === 'selected' && iconButton.selected), {}, {
                '> span': {
                    margin: 0
                }
            }),
            spinnerStyles: spinnerStyles
        };
    };
};

});



parcelRegister("jwBtc", function(module, exports) {
$parcel$export(module.exports, "AtlassianNavigation", function () { return $e36e123bb9633bad$export$f66ccb39f60980e5; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");
parcelRequire("3BSHr");
var $eCoFE = parcelRequire("eCoFE");

var $6DIEl = parcelRequire("6DIEl");

var $cSbsP = parcelRequire("cSbsP");

var $4eREm = parcelRequire("4eREm");

var $2Lx06 = parcelRequire("2Lx06");
var $9Q6kO = parcelRequire("9Q6kO");

var $hf5fJ = parcelRequire("hf5fJ");

var $fwsq8 = parcelRequire("fwsq8");
var $e36e123bb9633bad$var$containerStyles = (0, $3dJ4i.css)({
    display: 'flex',
    boxSizing: 'border-box',
    height: (0, $4eREm.HORIZONTAL_GLOBAL_NAV_HEIGHT),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: "1px solid ".concat("var(--ds-border, ".concat((0, $cSbsP.N30), ")")),
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
var $e36e123bb9633bad$var$leftStyles = (0, $3dJ4i.css)({
    display: 'flex',
    minWidth: 0,
    height: 'inherit',
    alignItems: 'center',
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > *': {
        flexShrink: 0
    }
});
var $e36e123bb9633bad$var$rightStyles = (0, $3dJ4i.css)({
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > *': {
        flexShrink: 0,
        marginInlineEnd: "var(--ds-space-050, 4px)"
    }
});
var $e36e123bb9633bad$var$noRightMarginStyles = (0, $3dJ4i.css)({
    marginInlineEnd: 0
});
var $e36e123bb9633bad$var$analyticsData = {
    attributes: {
        navigationLayer: 'global'
    },
    componentName: 'atlassianNavigation'
};
var $e36e123bb9633bad$export$f66ccb39f60980e5 = function AtlassianNavigation(props) {
    var label = props.label, _props$primaryItems = props.primaryItems, primaryItems = _props$primaryItems === void 0 ? [] : _props$primaryItems, AppSwitcher = props.renderAppSwitcher, create = props.renderCreate, Help = props.renderHelp, Notifications = props.renderNotifications, ProductHome = props.renderProductHome, Profile = props.renderProfile, Search = props.renderSearch, SignIn = props.renderSignIn, Settings = props.renderSettings, _props$moreLabel = props.moreLabel, moreLabel = _props$moreLabel === void 0 ? "\u2026" : _props$moreLabel, _props$theme = props.theme, theme = _props$theme === void 0 ? (0, $2Lx06.defaultTheme) : _props$theme, testId = props.testId;
    return (0, $3dJ4i.jsx)((0, $9Q6kO.ThemeProvider), {
        value: theme
    }, (0, $3dJ4i.jsx)((0, $eCoFE.NavigationAnalyticsContext), {
        data: $e36e123bb9633bad$var$analyticsData
    }, (0, $3dJ4i.jsx)("header", {
        style: theme.mode.navigation,
        css: $e36e123bb9633bad$var$containerStyles,
        "data-testid": testId && "".concat(testId, "-header"),
        role: "banner"
    }, (0, $3dJ4i.jsx)("nav", {
        css: $e36e123bb9633bad$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && (0, $3dJ4i.jsx)(AppSwitcher, null), ProductHome && (0, $3dJ4i.jsx)(ProductHome, null), (0, $6DIEl.getBooleanFF)('platform.design-system-team.navigation-v2-no-jank_5yhbd') ? (0, $3dJ4i.jsx)((0, $fwsq8.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        theme: theme
    }) : (0, $3dJ4i.jsx)((0, $hf5fJ.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        theme: theme
    })), (0, $3dJ4i.jsx)("div", {
        css: $e36e123bb9633bad$var$rightStyles,
        "data-testid": testId && "".concat(testId, "-secondary-actions")
    }, Search && (0, $3dJ4i.jsx)(Search, null), (0, $3dJ4i.jsx)("div", {
        role: "list",
        css: [
            $e36e123bb9633bad$var$rightStyles,
            $e36e123bb9633bad$var$noRightMarginStyles
        ]
    }, Notifications && (0, $3dJ4i.jsx)(Notifications, null), Help && (0, $3dJ4i.jsx)(Help, null), Settings && (0, $3dJ4i.jsx)(Settings, null), SignIn && (0, $3dJ4i.jsx)(SignIn, null), Profile && (0, $3dJ4i.jsx)(Profile, null))))));
};
var $e36e123bb9633bad$export$2e2bcd8739ae039 = $e36e123bb9633bad$export$f66ccb39f60980e5;

});
parcelRegister("3BSHr", function(module, exports) {
$parcel$export(module.exports, "NavigationAnalyticsContext", function () { return (parcelRequire("eCoFE")).NavigationAnalyticsContext; });

var $5cADU = parcelRequire("5cADU");

var $eCoFE = parcelRequire("eCoFE");

var $1TKr6 = parcelRequire("1TKr6");

var $aEQqJ = parcelRequire("aEQqJ");

var $bPOdm = parcelRequire("bPOdm");

var $7Shvj = parcelRequire("7Shvj");

var $dbN4m = parcelRequire("dbN4m");

var $2JHeH = parcelRequire("2JHeH");

var $5kTYx = parcelRequire("5kTYx");

var $3ZL4C = parcelRequire("3ZL4C");

var $9dOYV = parcelRequire("9dOYV");

});
parcelRegister("5cADU", function(module, exports) {

var $kcL6f = parcelRequire("kcL6f");
var $3c9a7f391198178c$export$80450e0a84a5ede9 = 'fabricElementsCtx';
var $3c9a7f391198178c$export$3fe25500478a635c = (0, $kcL6f.default)($3c9a7f391198178c$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');

});
parcelRegister("kcL6f", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eb5976a6e54b0961$export$2e2bcd8739ae039; });

var $eYHx9 = parcelRequire("eYHx9");

var $1oC0p = parcelRequire("1oC0p");

var $j9BEl = parcelRequire("j9BEl");
var $eb5976a6e54b0961$var$createNamespaceContext = function createNamespaceContext(namespace) {
    var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'NamespacedContext';
    var Component = function Component(props) {
        var newData = (0, $eYHx9.default)({}, namespace, props.data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $j9BEl.default), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $eb5976a6e54b0961$export$2e2bcd8739ae039 = $eb5976a6e54b0961$var$createNamespaceContext;

});


parcelRegister("eCoFE", function(module, exports) {
$parcel$export(module.exports, "NavigationAnalyticsContext", function () { return $aa47c06905cbad94$export$d0a82da1a0b94929; });

var $kcL6f = parcelRequire("kcL6f");
var $aa47c06905cbad94$export$1fd3aad76a7c6788 = 'navigationCtx';
var $aa47c06905cbad94$export$d0a82da1a0b94929 = (0, $kcL6f.default)($aa47c06905cbad94$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');

});

parcelRegister("1TKr6", function(module, exports) {

var $kcL6f = parcelRequire("kcL6f");
var $161ef2bb9f4428cd$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $161ef2bb9f4428cd$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
var $161ef2bb9f4428cd$export$629cada6c5e621e1 = (0, $kcL6f.default)($161ef2bb9f4428cd$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');

});

parcelRegister("aEQqJ", function(module, exports) {
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
var $7c264f573d0cfd2f$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

});

parcelRegister("bPOdm", function(module, exports) {

var $kcL6f = parcelRequire("kcL6f");
var $89db68b4dca61043$export$b326383bee6cb993 = 'peopleTeamsCtx';
var $89db68b4dca61043$export$4119ddb38ccbfb87 = (0, $kcL6f.default)($89db68b4dca61043$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');

});

parcelRegister("7Shvj", function(module, exports) {

var $kcL6f = parcelRequire("kcL6f");
var $5bbb278069d4459e$export$da1befb791e93c7e = 'NotificationsCtx';
var $5bbb278069d4459e$export$6f8e7ff1e3feafd7 = (0, $kcL6f.default)($5bbb278069d4459e$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');

});

parcelRegister("dbN4m", function(module, exports) {

var $kcL6f = parcelRequire("kcL6f");
var $027a5c5935691932$export$fc7a65795610cb71 = 'RecentWorkCtx';
var $027a5c5935691932$export$745926731087ebe2 = (0, $kcL6f.default)($027a5c5935691932$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');

});

parcelRegister("2JHeH", function(module, exports) {

var $kcL6f = parcelRequire("kcL6f");
var $1fe152850498c370$export$4906017439f33fc0 = 'atlasCtx';
var $1fe152850498c370$export$43ebbe41370d4543 = (0, $kcL6f.default)($1fe152850498c370$export$4906017439f33fc0, 'AtlasAnalyticsContext');

});

parcelRegister("5kTYx", function(module, exports) {

var $kcL6f = parcelRequire("kcL6f");
var $3e2a3d8b1a744987$export$3240443bf2b83834 = 'linkingPlatformCtx';
var $3e2a3d8b1a744987$export$6d568da622ce0a08 = (0, $kcL6f.default)($3e2a3d8b1a744987$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');

});

parcelRegister("3ZL4C", function(module, exports) {

var $kcL6f = parcelRequire("kcL6f");
var $2e8b956efaa4fee3$export$ef0c05448f0f8f9 = 'postOfficeCtx';
var $2e8b956efaa4fee3$export$dcd232f3be312f94 = (0, $kcL6f.default)($2e8b956efaa4fee3$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');

});

parcelRegister("9dOYV", function(module, exports) {

var $kcL6f = parcelRequire("kcL6f");
var $6b6cdfdc0374fdb2$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
var $6b6cdfdc0374fdb2$export$de3826c30468da26 = (0, $kcL6f.default)($6b6cdfdc0374fdb2$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');

});


parcelRegister("4eREm", function(module, exports) {
$parcel$export(module.exports, "HORIZONTAL_GLOBAL_NAV_HEIGHT", function () { return $316215fd8c8843a4$export$30fa7cc5f2690a43; });
$parcel$export(module.exports, "PRODUCT_HOME_BREAKPOINT", function () { return $316215fd8c8843a4$export$4033a111ca79977d; });
$parcel$export(module.exports, "CREATE_BREAKPOINT", function () { return $316215fd8c8843a4$export$24ec62cee78b7042; });
$parcel$export(module.exports, "varSearchFocusBorderColor", function () { return $316215fd8c8843a4$export$d8bde68ac946124f; });
$parcel$export(module.exports, "varSearchHoverBackgroundColor", function () { return $316215fd8c8843a4$export$73e44f54603a0964; });
$parcel$export(module.exports, "varSearchBackgroundColor", function () { return $316215fd8c8843a4$export$13f8aa8f663f4c99; });
$parcel$export(module.exports, "varSearchColor", function () { return $316215fd8c8843a4$export$d81606c1fc5119bc; });
$parcel$export(module.exports, "varSearchBorderColor", function () { return $316215fd8c8843a4$export$65f656ad520ea71; });
var $316215fd8c8843a4$export$30fa7cc5f2690a43 = 56;
var $316215fd8c8843a4$export$4033a111ca79977d = 1280;
var $316215fd8c8843a4$export$24ec62cee78b7042 = 1130;
var $316215fd8c8843a4$export$d8bde68ac946124f = '--ds--ans--fbc';
var $316215fd8c8843a4$export$73e44f54603a0964 = '--ds--ans--hbgc';
var $316215fd8c8843a4$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
var $316215fd8c8843a4$export$d81606c1fc5119bc = '--ds--ans--c';
var $316215fd8c8843a4$export$65f656ad520ea71 = '--ds--ans--bc';

});

parcelRegister("hf5fJ", function(module, exports) {
$parcel$export(module.exports, "PrimaryItemsContainer", function () { return $c8d7e973a07bf6a2$export$43e704064d596a9e; });

var $dX2dk = parcelRequire("dX2dk");

var $4qhbp = parcelRequire("4qhbp");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $aeVS3 = parcelRequire("aeVS3");

var $cSbsP = parcelRequire("cSbsP");

var $1X0st = parcelRequire("1X0st");

var $7JYQt = parcelRequire("7JYQt");

var $8Qw9J = parcelRequire("8Qw9J");
var $c8d7e973a07bf6a2$var$containerStyles = (0, $3dJ4i.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'stretch',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > *': {
        margin: "0 ".concat("var(--ds-space-050, 4px)"),
        flexShrink: 0
    }
});
var $c8d7e973a07bf6a2$var$widthObserverContainerStyles = (0, $3dJ4i.css)({
    width: '100%',
    minWidth: '1px',
    margin: '0px',
    position: 'relative',
    flexShrink: 1
});
var $c8d7e973a07bf6a2$var$overflowItemsStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text, ".concat((0, $cSbsP.N700), ")")
});
var $c8d7e973a07bf6a2$export$43e704064d596a9e = function PrimaryItemsContainer(_ref) {
    var moreLabel = _ref.moreLabel, items = _ref.items, Create = _ref.create, theme = _ref.theme, testId = _ref.testId;
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $4qhbp.default)(_useState, 2), isMoreOpen = _useState2[0], setIsMoreOpen = _useState2[1];
    var _useOverflowControlle = (0, $7JYQt.useOverflowController)(items), updateWidth = _useOverflowControlle.updateWidth, visibleItems = _useOverflowControlle.visibleItems, overflowItems = _useOverflowControlle.overflowItems;
    var onMoreClick = (0, $1oC0p.useCallback)(function() {
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    var onMoreClose = (0, $1oC0p.useCallback)(function() {
        setIsMoreOpen(false);
    }, []);
    var openOverflowMenu = (0, $1oC0p.useCallback)(function() {
        setIsMoreOpen(true);
    }, []);
    var trigger = (0, $1oC0p.useCallback)(function(triggerProps) {
        return (0, $3dJ4i.jsx)((0, $8Qw9J.PrimaryDropdownButton), (0, $dX2dk.default)({
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? "".concat(testId, "-overflow-menu-trigger") : 'overflow-menu-trigger'
        }, triggerProps), moreLabel);
    }, [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    var content = (0, $1oC0p.useCallback)(function() {
        return (0, $3dJ4i.jsx)((0, $7JYQt.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, (0, $3dJ4i.jsx)("div", {
            css: $c8d7e973a07bf6a2$var$overflowItemsStyles
        }, overflowItems));
    }, // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return (0, $3dJ4i.jsx)("div", {
        css: $c8d7e973a07bf6a2$var$containerStyles,
        "data-testid": testId && "".concat(testId, "-primary-actions"),
        role: "list"
    }, (0, $3dJ4i.jsx)((0, $7JYQt.OverflowProvider), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && (0, $3dJ4i.jsx)((0, $aeVS3.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? "".concat(testId, "-overflow-menu-popup") : 'overflow-menu-popup'
    }), Create && (0, $3dJ4i.jsx)(Create, null), (0, $3dJ4i.jsx)("div", {
        css: $c8d7e973a07bf6a2$var$widthObserverContainerStyles
    }, (0, $3dJ4i.jsx)((0, $1X0st.WidthObserver), {
        offscreen: true,
        setWidth: updateWidth
    })));
};

});
parcelRegister("aeVS3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $77481a1eff6c12f5$export$2e2bcd8739ae039; });

var $7vMYr = parcelRequire("7vMYr");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$77481a1eff6c12f5$export$2e2bcd8739ae039 = (0, $7vMYr.Popup);

});
parcelRegister("7vMYr", function(module, exports) {
$parcel$export(module.exports, "Popup", function () { return $57816adbeb82fce1$export$129a32eedafa97c5; });

var $4qhbp = parcelRequire("4qhbp");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $jIxfO = parcelRequire("jIxfO");

var $1DOlV = parcelRequire("1DOlV");
var $3z0jF = parcelRequire("3z0jF");

var $dGpYu = parcelRequire("dGpYu");

var $1Fk7u = parcelRequire("1Fk7u");

var $4gHLN = parcelRequire("4gHLN");

var $T3blm = parcelRequire("T3blm");
var $57816adbeb82fce1$var$defaultLayer = (0, $1Fk7u.layers).layer();
var $57816adbeb82fce1$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref) {
    var isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? 'viewport' : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $57816adbeb82fce1$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $4qhbp.default)(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $T3blm.useGetMemoizedMergedTriggerRef)();
    var renderPopperWrapper = (0, $3dJ4i.jsx)((0, $jIxfO.UNSAFE_LAYERING), {
        isDisabled: false
    }, (0, $3dJ4i.jsx)((0, $4gHLN.default), {
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent,
        shouldDisableFocusLock: shouldDisableFocusLock,
        triggerRef: triggerRef,
        strategy: strategy,
        role: role,
        label: label,
        titleId: titleId
    }));
    return (0, $3dJ4i.jsx)((0, $1DOlV.Manager), null, (0, $3dJ4i.jsx)((0, $3z0jF.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: getMergedTriggerRef(ref, setTriggerRef, isOpen),
            'aria-controls': id,
            'aria-expanded': isOpen,
            'aria-haspopup': true
        });
    }), isOpen && (shouldRenderToParent ? renderPopperWrapper : (0, $3dJ4i.jsx)((0, $dGpYu.default), {
        zIndex: zIndex
    }, renderPopperWrapper)));
});
var $57816adbeb82fce1$export$2e2bcd8739ae039 = $57816adbeb82fce1$export$129a32eedafa97c5;

});
parcelRegister("jIxfO", function(module, exports) {
$parcel$export(module.exports, "LevelContext", function () { return $e5abebec880be02d$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "TopLevelContext", function () { return $e5abebec880be02d$export$48b383b280e20440; });
$parcel$export(module.exports, "UNSAFE_LAYERING", function () { return $e5abebec880be02d$export$a183686c3f6f4ea8; });

var $1oC0p = parcelRequire("1oC0p");

var $DDWSY = parcelRequire("DDWSY");
var $e5abebec880be02d$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $1oC0p.createContext)(0);
var $e5abebec880be02d$export$48b383b280e20440 = /*#__PURE__*/ (0, $1oC0p.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $DDWSY.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $e5abebec880be02d$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $1oC0p.useContext)($e5abebec880be02d$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel;
    setTopLevel(currentLevel);
    (0, $1oC0p.useEffect)(function() {
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return function() {
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($e5abebec880be02d$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $e5abebec880be02d$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $1oC0p.useRef)(0);
    var value = (0, $1oC0p.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($e5abebec880be02d$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $e5abebec880be02d$export$a183686c3f6f4ea8 = function UNSAFE_LAYERING(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $1oC0p.useContext)($e5abebec880be02d$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($e5abebec880be02d$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($e5abebec880be02d$var$LayeringProvider, null, content);
};

});

parcelRegister("1DOlV", function(module, exports) {
$parcel$export(module.exports, "ManagerReferenceNodeContext", function () { return $13207deeacc84340$export$3dbd3405086fec7b; });
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", function () { return $13207deeacc84340$export$cbabb21c2529b130; });
$parcel$export(module.exports, "Manager", function () { return $13207deeacc84340$export$d0d38e7dec7a1a61; });

var $1oC0p = parcelRequire("1oC0p");
var $13207deeacc84340$export$3dbd3405086fec7b = $1oC0p.createContext();
var $13207deeacc84340$export$cbabb21c2529b130 = $1oC0p.createContext();
function $13207deeacc84340$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $1oC0p.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $1oC0p.useRef(false);
    $1oC0p.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $1oC0p.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $1oC0p.createElement($13207deeacc84340$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $1oC0p.createElement($13207deeacc84340$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("3z0jF", function(module, exports) {
$parcel$export(module.exports, "Reference", function () { return $2984e2c2e8e6334b$export$e0be378c32fb70a7; });

var $1oC0p = parcelRequire("1oC0p");

var $at85i = parcelRequire("at85i");

var $1DOlV = parcelRequire("1DOlV");

var $dKuVz = parcelRequire("dKuVz");
function $2984e2c2e8e6334b$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $1oC0p.useContext((0, $1DOlV.ManagerReferenceNodeSetterContext));
    var refHandler = $1oC0p.useCallback(function(node) {
        (0, $dKuVz.setRef)(innerRef, node);
        (0, $dKuVz.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $1oC0p.useEffect(function() {
        return function() {
            return (0, $dKuVz.setRef)(innerRef, null);
        };
    }, []);
    $1oC0p.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($at85i)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $dKuVz.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("dKuVz", function(module, exports) {
$parcel$export(module.exports, "unwrapArray", function () { return $a0278fd322ac1803$export$f52c55943429c8b6; });
$parcel$export(module.exports, "safeInvoke", function () { return $a0278fd322ac1803$export$3dfa7c28635fe028; });
$parcel$export(module.exports, "setRef", function () { return $a0278fd322ac1803$export$4bb192c7cacf928f; });
$parcel$export(module.exports, "fromEntries", function () { return $a0278fd322ac1803$export$5150077fc2e7c662; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $a0278fd322ac1803$export$700979bc83e7db82; });

var $1oC0p = parcelRequire("1oC0p");
var $a0278fd322ac1803$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $a0278fd322ac1803$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $a0278fd322ac1803$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $a0278fd322ac1803$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $a0278fd322ac1803$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $a0278fd322ac1803$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $1oC0p.useLayoutEffect : $1oC0p.useEffect;

});


parcelRegister("dGpYu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9f6358a52aae9e3d$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $i0edA = parcelRequire("i0edA");

var $jV63J = parcelRequire("jV63J");

var $anmwb = parcelRequire("anmwb");
function $9f6358a52aae9e3d$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $jV63J.default)(mountStrategy);
    (0, $anmwb.default)(zIndex);
    return isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $i0edA.default), {
        zIndex: zIndex
    }, children) : null;
}

});
parcelRegister("i0edA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d1b34181030b33f6$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $gdaW9 = parcelRequire("gdaW9");
function $d1b34181030b33f6$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $1oC0p.useMemo)(function() {
        return (0, $gdaW9.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $gdaW9.appendPortalContainerIfNotAppended)(container);
    (0, $1oC0p.useEffect)(function() {
        return function() {
            (0, $gdaW9.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $gUjjH.createPortal)(children, container);
}

});
parcelRegister("gdaW9", function(module, exports) {
$parcel$export(module.exports, "createContainer", function () { return $bcd658191c672802$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $bcd658191c672802$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $bcd658191c672802$export$c582005add11e141; });

var $1nmjm = parcelRequire("1nmjm");
var $bcd658191c672802$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $1nmjm.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $bcd658191c672802$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $bcd658191c672802$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $1nmjm.portalParentSelector));
    if (!parentElement) {
        var parent = document.createElement('div');
        parent.className = (0, $1nmjm.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        $bcd658191c672802$var$getBody().appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $bcd658191c672802$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $bcd658191c672802$var$getPortalParent().removeChild(container);
};
var $bcd658191c672802$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $bcd658191c672802$var$getPortalParent().appendChild(container);
};

});
parcelRegister("1nmjm", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", function () { return $10093ef56466469d$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $10093ef56466469d$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $10093ef56466469d$export$13f57c02915787b3; });
var $10093ef56466469d$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $10093ef56466469d$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $10093ef56466469d$export$13f57c02915787b3 = 'atlaskit-portal';

});



parcelRegister("jV63J", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e8080a6d99682076$export$2e2bcd8739ae039; });

var $4qhbp = parcelRequire("4qhbp");

var $1oC0p = parcelRequire("1oC0p");

var $4Y4UF = parcelRequire("4Y4UF");
var $e8080a6d99682076$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $4qhbp.default)(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $4Y4UF.useIsomorphicLayoutEffect) : (0, $1oC0p.useEffect);
    }), _useState4 = (0, $4qhbp.default)(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $e8080a6d99682076$export$2e2bcd8739ae039 = $e8080a6d99682076$var$useIsSubsequentRender;

});
parcelRegister("4Y4UF", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $39e093a17365b70e$export$700979bc83e7db82; });

var $1oC0p = parcelRequire("1oC0p");
var $39e093a17365b70e$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $1oC0p.useLayoutEffect) : (0, $1oC0p.useEffect);

});


parcelRegister("anmwb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $78dd84fb7009da2a$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $cDhtP = parcelRequire("cDhtP");

var $7cjLp = parcelRequire("7cjLp");
var $78dd84fb7009da2a$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $1oC0p.useEffect)(function() {
        (0, $7cjLp.default)((0, $cDhtP.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $7cjLp.default)((0, $cDhtP.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $78dd84fb7009da2a$export$2e2bcd8739ae039 = $78dd84fb7009da2a$var$useFirePortalEvent;

});
parcelRegister("cDhtP", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $9326afbaba846c5c$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $9326afbaba846c5c$export$80816bd900e5bd00; });
var $9326afbaba846c5c$export$ed5835cc67e87f72 = 'akPortalMount';
var $9326afbaba846c5c$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("7cjLp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $53d8fc0528fa968c$export$2e2bcd8739ae039; });
var $53d8fc0528fa968c$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $53d8fc0528fa968c$var$getLayerName = function getLayerName(zIndex) {
    return $53d8fc0528fa968c$var$zIndexToName.hasOwnProperty(zIndex) ? $53d8fc0528fa968c$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $53d8fc0528fa968c$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $53d8fc0528fa968c$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $53d8fc0528fa968c$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $53d8fc0528fa968c$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("4gHLN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $31ba9bd684777000$export$2e2bcd8739ae039; });

var $4qhbp = parcelRequire("4qhbp");

var $dX2dk = parcelRequire("dX2dk");

var $faFp0 = parcelRequire("faFp0");

var $eYHx9 = parcelRequire("eYHx9");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $hZokc = parcelRequire("hZokc");

var $6DIEl = parcelRequire("6DIEl");

var $3wlx0 = parcelRequire("3wlx0");

var $cSbsP = parcelRequire("cSbsP");

var $1Fk7u = parcelRequire("1Fk7u");

var $ddcbt = parcelRequire("ddcbt");

var $2ddNe = parcelRequire("2ddNe");

var $au2Jw = parcelRequire("au2Jw");

var $769PS = parcelRequire("769PS");
var $31ba9bd684777000$var$_excluded = [
    "shouldRenderToParent",
    "children"
];
var $31ba9bd684777000$var$_css;
var $31ba9bd684777000$var$popupStyles = (0, $3dJ4i.css)(($31ba9bd684777000$var$_css = {
    display: 'block',
    boxSizing: 'border-box',
    zIndex: (0, $1Fk7u.layers).layer(),
    flex: '1 1 auto',
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $cSbsP.N0), ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $cSbsP.N50A), ", 0 0 1px ").concat((0, $cSbsP.N60A)), ")")
}, (0, $eYHx9.default)($31ba9bd684777000$var$_css, (0, $ddcbt.CURRENT_SURFACE_CSS_VAR), "var(--ds-surface-overlay, ".concat((0, $cSbsP.N0), ")")), (0, $eYHx9.default)($31ba9bd684777000$var$_css, ':focus', {
    outline: 'none'
}), $31ba9bd684777000$var$_css));
var $31ba9bd684777000$var$popupOverflowStyles = (0, $3dJ4i.css)({
    overflow: 'auto'
});
// disables iframe pointer events while popup is open, except if iframe is nested inside popup
// solves an issue of popup not being closed on iframe click
var $31ba9bd684777000$var$blockPointerEventsOnExternalIframeStyles = (0, $3dJ4i.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    'iframe:not([data-ds--level] iframe)': {
        pointerEvents: 'none'
    }
});
var $31ba9bd684777000$var$DefaultPopupComponent = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, children = props.children, htmlAttributes = (0, $faFp0.default)(props, $31ba9bd684777000$var$_excluded);
    return (0, $3dJ4i.jsx)("div", (0, $dX2dk.default)({
        css: [
            $31ba9bd684777000$var$popupStyles,
            !shouldRenderToParent && $31ba9bd684777000$var$popupOverflowStyles
        ]
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $31ba9bd684777000$var$PopperWrapper(_ref) {
    var isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $31ba9bd684777000$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldDisableFocusLock = _ref.shouldDisableFocusLock, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId;
    var _useState = (0, $1oC0p.useState)(null), _useState2 = (0, $4qhbp.default)(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(null), _useState4 = (0, $4qhbp.default)(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases when we need to prohibit focus locking
    // e.g. in DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    (0, $769PS.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab
    });
    (0, $au2Jw.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab
    });
    var _UNSAFE_useLayering = (0, $hZokc.UNSAFE_useLayering)(), currentLevel = _UNSAFE_useLayering.currentLevel;
    var modifiers = (0, $1oC0p.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ];
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements
    ]);
    return (0, $3dJ4i.jsx)((0, $3wlx0.Popper), {
        placement: placement,
        offset: offset,
        modifiers: modifiers,
        strategy: strategy
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update;
        return (0, $3dJ4i.jsx)(PopupContainer, {
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent
        }, (0, $6DIEl.getBooleanFF)('platform.design-system-team.iframe_gojiv') && (0, $3dJ4i.jsx)((0, $3dJ4i.Global), {
            styles: $31ba9bd684777000$var$blockPointerEventsOnExternalIframeStyles
        }), (0, $3dJ4i.jsx)((0, $2ddNe.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$31ba9bd684777000$export$2e2bcd8739ae039 = $31ba9bd684777000$var$PopperWrapper;

});
parcelRegister("hZokc", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useLayering", function () { return $d18b0097496e4c18$export$cec37b93989366d4; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $jIxfO = parcelRequire("jIxfO");
var $d18b0097496e4c18$var$ESCAPE = 'Escape';
function $d18b0097496e4c18$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $1oC0p.useRef)(false);
    var _UNSAFE_useLayering = $d18b0097496e4c18$export$cec37b93989366d4(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    var onKeyDown = (0, $1oC0p.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $d18b0097496e4c18$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $1oC0p.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $1oC0p.useEffect)(function() {
        return (0, $dH1HR.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $d18b0097496e4c18$export$cec37b93989366d4() {
    var currentLevel = (0, $1oC0p.useContext)((0, $jIxfO.LevelContext));
    var _useContext = (0, $1oC0p.useContext)((0, $jIxfO.TopLevelContext)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $1oC0p.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});

parcelRegister("3wlx0", function(module, exports) {
$parcel$export(module.exports, "Popper", function () { return $29050fe90457e690$export$badac9ada3a0bdf9; });

var $eT6dr = parcelRequire("eT6dr");

var $4qhbp = parcelRequire("4qhbp");

var $1oC0p = parcelRequire("1oC0p");

var $eDyD0 = parcelRequire("eDyD0");

// Export types from PopperJS / React Popper
var $29050fe90457e690$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: 5,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    },
    {
        name: 'preventOverflow',
        options: {
            padding: 5,
            rootBoundary: 'document'
        }
    }
];
function $29050fe90457e690$var$defaultChildrenFn() {
    return null;
}
var $29050fe90457e690$var$defaultOffset = [
    0,
    8
];
function $29050fe90457e690$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $29050fe90457e690$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $29050fe90457e690$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy;
    var _offset = (0, $4qhbp.default)(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $1oC0p.useMemo)(function() {
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($29050fe90457e690$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $1oC0p.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, $eT6dr.default)(internalModifiers), (0, $eT6dr.default)(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $eDyD0.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("eDyD0", function(module, exports) {
$parcel$export(module.exports, "Popper", function () { return $aa7f919d89b1faa4$export$badac9ada3a0bdf9; });

var $1oC0p = parcelRequire("1oC0p");

var $1DOlV = parcelRequire("1DOlV");

var $dKuVz = parcelRequire("dKuVz");

var $kMYaY = parcelRequire("kMYaY");
var $aa7f919d89b1faa4$var$NOOP = function NOOP() {
    return void 0;
};
var $aa7f919d89b1faa4$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $aa7f919d89b1faa4$var$EMPTY_MODIFIERS = [];
function $aa7f919d89b1faa4$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $aa7f919d89b1faa4$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $1oC0p.useContext((0, $1DOlV.ManagerReferenceNodeContext));
    var _React$useState = $1oC0p.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $1oC0p.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $1oC0p.useEffect(function() {
        (0, $dKuVz.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $1oC0p.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $kMYaY.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $1oC0p.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $aa7f919d89b1faa4$var$NOOP,
            update: update || $aa7f919d89b1faa4$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $dKuVz.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("kMYaY", function(module, exports) {
$parcel$export(module.exports, "usePopper", function () { return $f226f80df3f599a7$export$f4d5bf230a36dd6e; });

var $1oC0p = parcelRequire("1oC0p");

var $gUjjH = parcelRequire("gUjjH");

var $fUAG0 = parcelRequire("fUAG0");

var $6prbz = parcelRequire("6prbz");

var $dKuVz = parcelRequire("dKuVz");
var $f226f80df3f599a7$var$EMPTY_MODIFIERS = [];
var $f226f80df3f599a7$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $1oC0p.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $f226f80df3f599a7$var$EMPTY_MODIFIERS
    };
    var _React$useState = $1oC0p.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $1oC0p.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $gUjjH.flushSync(function() {
                    setState({
                        styles: (0, $dKuVz.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $dKuVz.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $1oC0p.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6prbz)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $1oC0p.useRef();
    (0, $dKuVz.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $dKuVz.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $fUAG0.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("fUAG0", function(module, exports) {
$parcel$export(module.exports, "createPopper", function () { return $b9588927f4cc7d84$export$8f7491d57c8f97a9; });

var $faFSX = parcelRequire("faFSX");

var $7AhLS = parcelRequire("7AhLS");

var $gjnhj = parcelRequire("gjnhj");

var $1XfhC = parcelRequire("1XfhC");

var $7nOmT = parcelRequire("7nOmT");

var $8byWx = parcelRequire("8byWx");

var $9WVZp = parcelRequire("9WVZp");

var $b5KSV = parcelRequire("b5KSV");

var $5UQcV = parcelRequire("5UQcV");

var $d7iA4 = parcelRequire("d7iA4");


var $b9588927f4cc7d84$export$d34966752335dd47 = [
    (0, $7AhLS.default),
    (0, $gjnhj.default),
    (0, $1XfhC.default),
    (0, $7nOmT.default),
    (0, $8byWx.default),
    (0, $9WVZp.default),
    (0, $b5KSV.default),
    (0, $5UQcV.default),
    (0, $d7iA4.default)
];
var $b9588927f4cc7d84$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $faFSX.popperGenerator)({
    defaultModifiers: $b9588927f4cc7d84$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("faFSX", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", function () { return $02d9ae9399f9ea91$export$ed5e13716264f202; });

var $63yBW = parcelRequire("63yBW");

var $5OOkA = parcelRequire("5OOkA");

var $7XaUi = parcelRequire("7XaUi");

var $7knkd = parcelRequire("7knkd");

var $hestY = parcelRequire("hestY");

var $3VhxH = parcelRequire("3VhxH");

var $gOu4Q = parcelRequire("gOu4Q");


var $fsXJY = parcelRequire("fsXJY");
var $02d9ae9399f9ea91$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $02d9ae9399f9ea91$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $02d9ae9399f9ea91$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $02d9ae9399f9ea91$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $02d9ae9399f9ea91$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $fsXJY.isElement)(reference) ? (0, $7XaUi.default)(reference) : reference.contextElement ? (0, $7XaUi.default)(reference.contextElement) : [],
                    popper: (0, $7XaUi.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $hestY.default)((0, $gOu4Q.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$02d9ae9399f9ea91$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $63yBW.default)(reference, (0, $7knkd.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $5OOkA.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $3VhxH.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$02d9ae9399f9ea91$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $02d9ae9399f9ea91$export$8f7491d57c8f97a9 = /*#__PURE__*/ $02d9ae9399f9ea91$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("63yBW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $468ddeea610d08dd$export$2e2bcd8739ae039; });

var $gocgq = parcelRequire("gocgq");

var $3ZdAD = parcelRequire("3ZdAD");

var $dnqsa = parcelRequire("dnqsa");

var $fsXJY = parcelRequire("fsXJY");

var $7en0k = parcelRequire("7en0k");

var $j5Jdb = parcelRequire("j5Jdb");

var $ee308 = parcelRequire("ee308");

var $gTg95 = parcelRequire("gTg95");
function $468ddeea610d08dd$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $gTg95.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $gTg95.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $468ddeea610d08dd$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $fsXJY.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $fsXJY.isHTMLElement)(offsetParent) && $468ddeea610d08dd$var$isElementScaled(offsetParent);
    var documentElement = (0, $j5Jdb.default)(offsetParent);
    var rect = (0, $gocgq.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $dnqsa.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $ee308.default)(documentElement)) scroll = (0, $3ZdAD.default)(offsetParent);
        if ((0, $fsXJY.isHTMLElement)(offsetParent)) {
            offsets = (0, $gocgq.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $7en0k.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("gocgq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bee866950ebe1e59$export$2e2bcd8739ae039; });

var $fsXJY = parcelRequire("fsXJY");

var $gTg95 = parcelRequire("gTg95");

var $k6EFu = parcelRequire("k6EFu");

var $PBhbr = parcelRequire("PBhbr");
function $bee866950ebe1e59$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $fsXJY.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $gTg95.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $gTg95.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $fsXJY.isElement)(element) ? (0, $k6EFu.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $PBhbr.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("fsXJY", function(module, exports) {
$parcel$export(module.exports, "isElement", function () { return $b427cfc68430170d$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $b427cfc68430170d$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $b427cfc68430170d$export$af51f0f06c0f328a; });

var $k6EFu = parcelRequire("k6EFu");
function $b427cfc68430170d$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $k6EFu.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $b427cfc68430170d$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $k6EFu.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $b427cfc68430170d$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $k6EFu.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("k6EFu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ea33ea10fdd99f2a$export$2e2bcd8739ae039; });
function $ea33ea10fdd99f2a$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("gTg95", function(module, exports) {
$parcel$export(module.exports, "max", function () { return $c4be4e95d29828cf$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $c4be4e95d29828cf$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $c4be4e95d29828cf$export$2077e0241d6afd3c; });
var $c4be4e95d29828cf$export$8960430cfd85939f = Math.max;
var $c4be4e95d29828cf$export$96ec731ed4dcb222 = Math.min;
var $c4be4e95d29828cf$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("PBhbr", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $09b1adcd605a7e9d$export$2e2bcd8739ae039; });

var $bMsMl = parcelRequire("bMsMl");
function $09b1adcd605a7e9d$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $bMsMl.default)());
}

});
parcelRegister("bMsMl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $893a8045004381c9$export$2e2bcd8739ae039; });
function $893a8045004381c9$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("3ZdAD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2e719c4857b980e2$export$2e2bcd8739ae039; });

var $1irp5 = parcelRequire("1irp5");

var $k6EFu = parcelRequire("k6EFu");

var $fsXJY = parcelRequire("fsXJY");

var $bv8a4 = parcelRequire("bv8a4");
function $2e719c4857b980e2$export$2e2bcd8739ae039(node) {
    if (node === (0, $k6EFu.default)(node) || !(0, $fsXJY.isHTMLElement)(node)) return (0, $1irp5.default)(node);
    else return (0, $bv8a4.default)(node);
}

});
parcelRegister("1irp5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0f1cbab23df141c1$export$2e2bcd8739ae039; });

var $k6EFu = parcelRequire("k6EFu");
function $0f1cbab23df141c1$export$2e2bcd8739ae039(node) {
    var win = (0, $k6EFu.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("bv8a4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $85f8eba4fa30bb73$export$2e2bcd8739ae039; });
function $85f8eba4fa30bb73$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("dnqsa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9bd1f16ac810fde4$export$2e2bcd8739ae039; });
function $9bd1f16ac810fde4$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("7en0k", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $543baf5fbbd4857a$export$2e2bcd8739ae039; });

var $gocgq = parcelRequire("gocgq");

var $j5Jdb = parcelRequire("j5Jdb");

var $1irp5 = parcelRequire("1irp5");
function $543baf5fbbd4857a$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $gocgq.default)((0, $j5Jdb.default)(element)).left + (0, $1irp5.default)(element).scrollLeft;
}

});
parcelRegister("j5Jdb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $de618e0f66c41582$export$2e2bcd8739ae039; });

var $fsXJY = parcelRequire("fsXJY");
function $de618e0f66c41582$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $fsXJY.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("ee308", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a5b4b375d5f71381$export$2e2bcd8739ae039; });

var $2B9xV = parcelRequire("2B9xV");
function $a5b4b375d5f71381$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $2B9xV.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("2B9xV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1e46711f77301e30$export$2e2bcd8739ae039; });

var $k6EFu = parcelRequire("k6EFu");
function $1e46711f77301e30$export$2e2bcd8739ae039(element) {
    return (0, $k6EFu.default)(element).getComputedStyle(element);
}

});



parcelRegister("5OOkA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $43c8a9ef0be706f7$export$2e2bcd8739ae039; });

var $gocgq = parcelRequire("gocgq");
function $43c8a9ef0be706f7$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $gocgq.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("7XaUi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5ca680fa0a272b59$export$2e2bcd8739ae039; });

var $ko5Bm = parcelRequire("ko5Bm");

var $ciQdp = parcelRequire("ciQdp");

var $k6EFu = parcelRequire("k6EFu");

var $ee308 = parcelRequire("ee308");
function $5ca680fa0a272b59$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $ko5Bm.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $k6EFu.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $ee308.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($5ca680fa0a272b59$export$2e2bcd8739ae039((0, $ciQdp.default)(target)));
}

});
parcelRegister("ko5Bm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ed7a64e926f57a81$export$2e2bcd8739ae039; });

var $ciQdp = parcelRequire("ciQdp");

var $ee308 = parcelRequire("ee308");

var $dnqsa = parcelRequire("dnqsa");

var $fsXJY = parcelRequire("fsXJY");
function $ed7a64e926f57a81$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $dnqsa.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $fsXJY.isHTMLElement)(node) && (0, $ee308.default)(node)) return node;
    return $ed7a64e926f57a81$export$2e2bcd8739ae039((0, $ciQdp.default)(node));
}

});
parcelRegister("ciQdp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8f4fab570604fb63$export$2e2bcd8739ae039; });

var $dnqsa = parcelRequire("dnqsa");

var $j5Jdb = parcelRequire("j5Jdb");

var $fsXJY = parcelRequire("fsXJY");
function $8f4fab570604fb63$export$2e2bcd8739ae039(element) {
    if ((0, $dnqsa.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $fsXJY.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $j5Jdb.default)(element) // fallback
    );
}

});



parcelRegister("7knkd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $555c7e8bab249ef1$export$2e2bcd8739ae039; });

var $k6EFu = parcelRequire("k6EFu");

var $dnqsa = parcelRequire("dnqsa");

var $2B9xV = parcelRequire("2B9xV");

var $fsXJY = parcelRequire("fsXJY");

var $cy5G3 = parcelRequire("cy5G3");

var $ciQdp = parcelRequire("ciQdp");

var $bMsMl = parcelRequire("bMsMl");
function $555c7e8bab249ef1$var$getTrueOffsetParent(element) {
    if (!(0, $fsXJY.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $2B9xV.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $555c7e8bab249ef1$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $bMsMl.default)());
    var isIE = /Trident/i.test((0, $bMsMl.default)());
    if (isIE && (0, $fsXJY.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $2B9xV.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $ciQdp.default)(element);
    if ((0, $fsXJY.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $fsXJY.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $dnqsa.default)(currentNode)) < 0){
        var css = (0, $2B9xV.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $555c7e8bab249ef1$export$2e2bcd8739ae039(element) {
    var window = (0, $k6EFu.default)(element);
    var offsetParent = $555c7e8bab249ef1$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $cy5G3.default)(offsetParent) && (0, $2B9xV.default)(offsetParent).position === 'static')offsetParent = $555c7e8bab249ef1$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $dnqsa.default)(offsetParent) === 'html' || (0, $dnqsa.default)(offsetParent) === 'body' && (0, $2B9xV.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $555c7e8bab249ef1$var$getContainingBlock(element) || window;
}

});
parcelRegister("cy5G3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $922d10638addda5f$export$2e2bcd8739ae039; });

var $dnqsa = parcelRequire("dnqsa");
function $922d10638addda5f$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $dnqsa.default)(element)) >= 0;
}

});


parcelRegister("hestY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c8b9d685121ca9b7$export$2e2bcd8739ae039; });

var $ibU15 = parcelRequire("ibU15");
function $c8b9d685121ca9b7$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $c8b9d685121ca9b7$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $c8b9d685121ca9b7$var$order(modifiers); // order based on phase
    return (0, $ibU15.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("ibU15", function(module, exports) {
$parcel$export(module.exports, "top", function () { return $d3e4b4cb4d2446aa$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $d3e4b4cb4d2446aa$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $d3e4b4cb4d2446aa$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $d3e4b4cb4d2446aa$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $d3e4b4cb4d2446aa$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $d3e4b4cb4d2446aa$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $d3e4b4cb4d2446aa$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $d3e4b4cb4d2446aa$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $d3e4b4cb4d2446aa$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $d3e4b4cb4d2446aa$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $d3e4b4cb4d2446aa$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $d3e4b4cb4d2446aa$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $d3e4b4cb4d2446aa$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $d3e4b4cb4d2446aa$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $d3e4b4cb4d2446aa$export$d087d3878fdf71d5; });
var $d3e4b4cb4d2446aa$export$1e95b668f3b82d = 'top';
var $d3e4b4cb4d2446aa$export$40e543e69a8b3fbb = 'bottom';
var $d3e4b4cb4d2446aa$export$79ffe56a765070d2 = 'right';
var $d3e4b4cb4d2446aa$export$eabcd2c8791e7bf4 = 'left';
var $d3e4b4cb4d2446aa$export$dfb5619354ba860 = 'auto';
var $d3e4b4cb4d2446aa$export$aec2ce47c367b8c3 = [
    $d3e4b4cb4d2446aa$export$1e95b668f3b82d,
    $d3e4b4cb4d2446aa$export$40e543e69a8b3fbb,
    $d3e4b4cb4d2446aa$export$79ffe56a765070d2,
    $d3e4b4cb4d2446aa$export$eabcd2c8791e7bf4
];
var $d3e4b4cb4d2446aa$export$b3571188c770cc5a = 'start';
var $d3e4b4cb4d2446aa$export$bd5df0f255a350f8 = 'end';
var $d3e4b4cb4d2446aa$export$390fd549c5303b4d = 'clippingParents';
var $d3e4b4cb4d2446aa$export$d7b7311ec04a3e8f = 'viewport';
var $d3e4b4cb4d2446aa$export$ae5ab1c730825774 = 'popper';
var $d3e4b4cb4d2446aa$export$ca50aac9f3ba507f = 'reference';
var $d3e4b4cb4d2446aa$export$368f9a87e87fa4e1 = /*#__PURE__*/ $d3e4b4cb4d2446aa$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $d3e4b4cb4d2446aa$export$b3571188c770cc5a,
        placement + "-" + $d3e4b4cb4d2446aa$export$bd5df0f255a350f8
    ]);
}, []);
var $d3e4b4cb4d2446aa$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($d3e4b4cb4d2446aa$export$aec2ce47c367b8c3, [
    $d3e4b4cb4d2446aa$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $d3e4b4cb4d2446aa$export$b3571188c770cc5a,
        placement + "-" + $d3e4b4cb4d2446aa$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $d3e4b4cb4d2446aa$export$421679a7c3d56e = 'beforeRead';
var $d3e4b4cb4d2446aa$export$aafa59e2e03f2942 = 'read';
var $d3e4b4cb4d2446aa$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $d3e4b4cb4d2446aa$export$c65e99957a05207c = 'beforeMain';
var $d3e4b4cb4d2446aa$export$f22da7240b7add18 = 'main';
var $d3e4b4cb4d2446aa$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $d3e4b4cb4d2446aa$export$8d4d2d70e7d46032 = 'beforeWrite';
var $d3e4b4cb4d2446aa$export$68d8715fc104d294 = 'write';
var $d3e4b4cb4d2446aa$export$70a6e5159acce2e6 = 'afterWrite';
var $d3e4b4cb4d2446aa$export$d087d3878fdf71d5 = [
    $d3e4b4cb4d2446aa$export$421679a7c3d56e,
    $d3e4b4cb4d2446aa$export$aafa59e2e03f2942,
    $d3e4b4cb4d2446aa$export$6964f6c886723980,
    $d3e4b4cb4d2446aa$export$c65e99957a05207c,
    $d3e4b4cb4d2446aa$export$f22da7240b7add18,
    $d3e4b4cb4d2446aa$export$bab79516f2d662fe,
    $d3e4b4cb4d2446aa$export$8d4d2d70e7d46032,
    $d3e4b4cb4d2446aa$export$68d8715fc104d294,
    $d3e4b4cb4d2446aa$export$70a6e5159acce2e6
];

});


parcelRegister("3VhxH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2db44d87546ad926$export$2e2bcd8739ae039; });
function $2db44d87546ad926$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("gOu4Q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c3d8a59265969b22$export$2e2bcd8739ae039; });
function $c3d8a59265969b22$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("7AhLS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5859ae3021aab54f$export$2e2bcd8739ae039; });

var $k6EFu = parcelRequire("k6EFu");
var $5859ae3021aab54f$var$passive = {
    passive: true
};
function $5859ae3021aab54f$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $k6EFu.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $5859ae3021aab54f$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $5859ae3021aab54f$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $5859ae3021aab54f$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $5859ae3021aab54f$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $5859ae3021aab54f$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $5859ae3021aab54f$var$effect,
    data: {}
};

});

parcelRegister("gjnhj", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $be007a3f4ade62ec$export$2e2bcd8739ae039; });

var $1N34N = parcelRequire("1N34N");
function $be007a3f4ade62ec$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $1N34N.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $be007a3f4ade62ec$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $be007a3f4ade62ec$var$popperOffsets,
    data: {}
};

});
parcelRegister("1N34N", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $14dcc0efef6d57ad$export$2e2bcd8739ae039; });

var $eS16w = parcelRequire("eS16w");

var $dWXqw = parcelRequire("dWXqw");

var $23O97 = parcelRequire("23O97");

var $ibU15 = parcelRequire("ibU15");
function $14dcc0efef6d57ad$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $eS16w.default)(placement) : null;
    var variation = placement ? (0, $dWXqw.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $ibU15.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $ibU15.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $ibU15.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $ibU15.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $23O97.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $ibU15.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $ibU15.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("eS16w", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ad36f71c4bc1b364$export$2e2bcd8739ae039; });

function $ad36f71c4bc1b364$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("dWXqw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a27eca0a1b3a29bf$export$2e2bcd8739ae039; });
function $a27eca0a1b3a29bf$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("23O97", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1802c28f85dd4d56$export$2e2bcd8739ae039; });
function $1802c28f85dd4d56$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("1XfhC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $16c7280b70214726$export$2e2bcd8739ae039; });

var $ibU15 = parcelRequire("ibU15");

var $7knkd = parcelRequire("7knkd");

var $k6EFu = parcelRequire("k6EFu");

var $j5Jdb = parcelRequire("j5Jdb");

var $2B9xV = parcelRequire("2B9xV");

var $eS16w = parcelRequire("eS16w");

var $dWXqw = parcelRequire("dWXqw");

var $gTg95 = parcelRequire("gTg95");
var $16c7280b70214726$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $16c7280b70214726$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $gTg95.round)(x * dpr) / dpr || 0,
        y: (0, $gTg95.round)(y * dpr) / dpr || 0
    };
}
function $16c7280b70214726$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $ibU15.left);
    var sideY = (0, $ibU15.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $7knkd.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $k6EFu.default)(popper)) {
            offsetParent = (0, $j5Jdb.default)(popper);
            if ((0, $2B9xV.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $ibU15.top) || (placement === (0, $ibU15.left) || placement === (0, $ibU15.right)) && variation === (0, $ibU15.end)) {
            sideY = (0, $ibU15.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $ibU15.left) || (placement === (0, $ibU15.top) || placement === (0, $ibU15.bottom)) && variation === (0, $ibU15.end)) {
            sideX = (0, $ibU15.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $16c7280b70214726$var$unsetSides);
    var _ref4 = roundOffsets === true ? $16c7280b70214726$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $k6EFu.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $16c7280b70214726$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $eS16w.default)(state.placement),
        variation: (0, $dWXqw.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $16c7280b70214726$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $16c7280b70214726$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $16c7280b70214726$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $16c7280b70214726$var$computeStyles,
    data: {}
};

});

parcelRegister("7nOmT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5601c07d9ecf3713$export$2e2bcd8739ae039; });

var $dnqsa = parcelRequire("dnqsa");

var $fsXJY = parcelRequire("fsXJY");
// and applies them to the HTMLElements such as popper and arrow
function $5601c07d9ecf3713$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $fsXJY.isHTMLElement)(element) || !(0, $dnqsa.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $5601c07d9ecf3713$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $fsXJY.isHTMLElement)(element) || !(0, $dnqsa.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $5601c07d9ecf3713$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $5601c07d9ecf3713$var$applyStyles,
    effect: $5601c07d9ecf3713$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("8byWx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5f5a74d0c15233e7$export$2e2bcd8739ae039; });

var $eS16w = parcelRequire("eS16w");

var $ibU15 = parcelRequire("ibU15");
function $5f5a74d0c15233e7$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $eS16w.default)(placement);
    var invertDistance = [
        (0, $ibU15.left),
        (0, $ibU15.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $ibU15.left),
        (0, $ibU15.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $5f5a74d0c15233e7$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $ibU15.placements).reduce(function(acc, placement) {
        acc[placement] = $5f5a74d0c15233e7$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $5f5a74d0c15233e7$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $5f5a74d0c15233e7$var$offset
};

});

parcelRegister("9WVZp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $73e683524af4941b$export$2e2bcd8739ae039; });

var $esgz1 = parcelRequire("esgz1");

var $eS16w = parcelRequire("eS16w");

var $bH57c = parcelRequire("bH57c");

var $92FzN = parcelRequire("92FzN");

var $i7yjg = parcelRequire("i7yjg");

var $ibU15 = parcelRequire("ibU15");

var $dWXqw = parcelRequire("dWXqw");
function $73e683524af4941b$var$getExpandedFallbackPlacements(placement) {
    if ((0, $eS16w.default)(placement) === (0, $ibU15.auto)) return [];
    var oppositePlacement = (0, $esgz1.default)(placement);
    return [
        (0, $bH57c.default)(placement),
        oppositePlacement,
        (0, $bH57c.default)(oppositePlacement)
    ];
}
function $73e683524af4941b$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $eS16w.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $esgz1.default)(preferredPlacement)
    ] : $73e683524af4941b$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $eS16w.default)(placement) === (0, $ibU15.auto) ? (0, $i7yjg.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $eS16w.default)(placement);
        var isStartVariation = (0, $dWXqw.default)(placement) === (0, $ibU15.start);
        var isVertical = [
            (0, $ibU15.top),
            (0, $ibU15.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $92FzN.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $ibU15.right) : (0, $ibU15.left) : isStartVariation ? (0, $ibU15.bottom) : (0, $ibU15.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $esgz1.default)(mainVariationSide);
        var altVariationSide = (0, $esgz1.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $73e683524af4941b$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $73e683524af4941b$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("esgz1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a8608771b5956ec3$export$2e2bcd8739ae039; });
var $a8608771b5956ec3$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $a8608771b5956ec3$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $a8608771b5956ec3$var$hash[matched];
    });
}

});

parcelRegister("bH57c", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8837ada23dfb1c35$export$2e2bcd8739ae039; });
var $8837ada23dfb1c35$var$hash = {
    start: 'end',
    end: 'start'
};
function $8837ada23dfb1c35$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $8837ada23dfb1c35$var$hash[matched];
    });
}

});

parcelRegister("92FzN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $69548d2bf33811e9$export$2e2bcd8739ae039; });

var $k981Q = parcelRequire("k981Q");

var $j5Jdb = parcelRequire("j5Jdb");

var $gocgq = parcelRequire("gocgq");

var $1N34N = parcelRequire("1N34N");

var $6Lzfb = parcelRequire("6Lzfb");

var $ibU15 = parcelRequire("ibU15");

var $fsXJY = parcelRequire("fsXJY");

var $3Eg0e = parcelRequire("3Eg0e");

var $7botX = parcelRequire("7botX");
function $69548d2bf33811e9$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $ibU15.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $ibU15.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $ibU15.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $3Eg0e.default)(typeof padding !== 'number' ? padding : (0, $7botX.default)(padding, (0, $ibU15.basePlacements)));
    var altContext = elementContext === (0, $ibU15.popper) ? (0, $ibU15.reference) : (0, $ibU15.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $k981Q.default)((0, $fsXJY.isElement)(element) ? element : element.contextElement || (0, $j5Jdb.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $gocgq.default)(state.elements.reference);
    var popperOffsets = (0, $1N34N.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $6Lzfb.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $ibU15.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $ibU15.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $ibU15.right),
                (0, $ibU15.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $ibU15.top),
                (0, $ibU15.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("k981Q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eaaae043673cb6ac$export$2e2bcd8739ae039; });

var $ibU15 = parcelRequire("ibU15");

var $iAoqU = parcelRequire("iAoqU");

var $aVmrF = parcelRequire("aVmrF");

var $7XaUi = parcelRequire("7XaUi");

var $7knkd = parcelRequire("7knkd");

var $j5Jdb = parcelRequire("j5Jdb");

var $2B9xV = parcelRequire("2B9xV");

var $fsXJY = parcelRequire("fsXJY");

var $gocgq = parcelRequire("gocgq");

var $ciQdp = parcelRequire("ciQdp");

var $gPKrR = parcelRequire("gPKrR");

var $dnqsa = parcelRequire("dnqsa");

var $6Lzfb = parcelRequire("6Lzfb");

var $gTg95 = parcelRequire("gTg95");
function $eaaae043673cb6ac$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $gocgq.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $eaaae043673cb6ac$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $ibU15.viewport) ? (0, $6Lzfb.default)((0, $iAoqU.default)(element, strategy)) : (0, $fsXJY.isElement)(clippingParent) ? $eaaae043673cb6ac$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $6Lzfb.default)((0, $aVmrF.default)((0, $j5Jdb.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $eaaae043673cb6ac$var$getClippingParents(element) {
    var clippingParents = (0, $7XaUi.default)((0, $ciQdp.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $2B9xV.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $fsXJY.isHTMLElement)(element) ? (0, $7knkd.default)(element) : element;
    if (!(0, $fsXJY.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $fsXJY.isElement)(clippingParent) && (0, $gPKrR.default)(clippingParent, clipperElement) && (0, $dnqsa.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $eaaae043673cb6ac$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $eaaae043673cb6ac$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $eaaae043673cb6ac$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $gTg95.max)(rect.top, accRect.top);
        accRect.right = (0, $gTg95.min)(rect.right, accRect.right);
        accRect.bottom = (0, $gTg95.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $gTg95.max)(rect.left, accRect.left);
        return accRect;
    }, $eaaae043673cb6ac$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("iAoqU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d87e8aaa90f0481a$export$2e2bcd8739ae039; });

var $k6EFu = parcelRequire("k6EFu");

var $j5Jdb = parcelRequire("j5Jdb");

var $7en0k = parcelRequire("7en0k");

var $PBhbr = parcelRequire("PBhbr");
function $d87e8aaa90f0481a$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $k6EFu.default)(element);
    var html = (0, $j5Jdb.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $PBhbr.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $7en0k.default)(element),
        y: y
    };
}

});

parcelRegister("aVmrF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7f40a36ba1ec39ae$export$2e2bcd8739ae039; });

var $j5Jdb = parcelRequire("j5Jdb");

var $2B9xV = parcelRequire("2B9xV");

var $7en0k = parcelRequire("7en0k");

var $1irp5 = parcelRequire("1irp5");

var $gTg95 = parcelRequire("gTg95");
function $7f40a36ba1ec39ae$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $j5Jdb.default)(element);
    var winScroll = (0, $1irp5.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $gTg95.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $gTg95.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $7en0k.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $2B9xV.default)(body || html).direction === 'rtl') x += (0, $gTg95.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("gPKrR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c4157072b7a98e7c$export$2e2bcd8739ae039; });

var $fsXJY = parcelRequire("fsXJY");
function $c4157072b7a98e7c$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $fsXJY.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("6Lzfb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4ed27892f477574b$export$2e2bcd8739ae039; });
function $4ed27892f477574b$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("3Eg0e", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2a81855717ebff37$export$2e2bcd8739ae039; });

var $fixzu = parcelRequire("fixzu");
function $2a81855717ebff37$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $fixzu.default)(), paddingObject);
}

});
parcelRegister("fixzu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b23294085cc6359a$export$2e2bcd8739ae039; });
function $b23294085cc6359a$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("7botX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $53ac8d25661a4dc7$export$2e2bcd8739ae039; });
function $53ac8d25661a4dc7$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("i7yjg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d3137ea4e82c3678$export$2e2bcd8739ae039; });

var $dWXqw = parcelRequire("dWXqw");

var $ibU15 = parcelRequire("ibU15");

var $92FzN = parcelRequire("92FzN");

var $eS16w = parcelRequire("eS16w");
function $d3137ea4e82c3678$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $ibU15.placements) : _options$allowedAutoP;
    var variation = (0, $dWXqw.default)(placement);
    var placements = variation ? flipVariations ? (0, $ibU15.variationPlacements) : (0, $ibU15.variationPlacements).filter(function(placement) {
        return (0, $dWXqw.default)(placement) === variation;
    }) : (0, $ibU15.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $92FzN.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $eS16w.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("b5KSV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $813487b304da2728$export$2e2bcd8739ae039; });

var $ibU15 = parcelRequire("ibU15");

var $eS16w = parcelRequire("eS16w");

var $23O97 = parcelRequire("23O97");

var $jTQp3 = parcelRequire("jTQp3");

var $jpWwf = parcelRequire("jpWwf");

var $5OOkA = parcelRequire("5OOkA");

var $7knkd = parcelRequire("7knkd");

var $92FzN = parcelRequire("92FzN");

var $dWXqw = parcelRequire("dWXqw");

var $fixzu = parcelRequire("fixzu");

var $gTg95 = parcelRequire("gTg95");
function $813487b304da2728$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $92FzN.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $eS16w.default)(state.placement);
    var variation = (0, $dWXqw.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $23O97.default)(basePlacement);
    var altAxis = (0, $jTQp3.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $ibU15.top) : (0, $ibU15.left);
        var altSide = mainAxis === 'y' ? (0, $ibU15.bottom) : (0, $ibU15.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $ibU15.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $ibU15.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $5OOkA.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $fixzu.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $jpWwf.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $7knkd.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $jpWwf.within)(tether ? (0, $gTg95.min)(min, tetherMin) : min, offset, tether ? (0, $gTg95.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $ibU15.top) : (0, $ibU15.left);
        var _altSide = mainAxis === 'x' ? (0, $ibU15.bottom) : (0, $ibU15.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $ibU15.top),
            (0, $ibU15.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $jpWwf.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $jpWwf.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $813487b304da2728$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $813487b304da2728$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("jTQp3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e7cbcd87c02c1df6$export$2e2bcd8739ae039; });
function $e7cbcd87c02c1df6$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("jpWwf", function(module, exports) {
$parcel$export(module.exports, "within", function () { return $e22dbec948d2e1cb$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $e22dbec948d2e1cb$export$86c8af6d3ef0b4a; });

var $gTg95 = parcelRequire("gTg95");
function $e22dbec948d2e1cb$export$f28d906d67a997f3(min, value, max) {
    return (0, $gTg95.max)(min, (0, $gTg95.min)(value, max));
}
function $e22dbec948d2e1cb$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $e22dbec948d2e1cb$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("5UQcV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $44eaae0bd533a450$export$2e2bcd8739ae039; });

var $eS16w = parcelRequire("eS16w");

var $5OOkA = parcelRequire("5OOkA");

var $gPKrR = parcelRequire("gPKrR");

var $7knkd = parcelRequire("7knkd");

var $23O97 = parcelRequire("23O97");

var $jpWwf = parcelRequire("jpWwf");

var $3Eg0e = parcelRequire("3Eg0e");

var $7botX = parcelRequire("7botX");

var $ibU15 = parcelRequire("ibU15");
var $44eaae0bd533a450$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $3Eg0e.default)(typeof padding !== 'number' ? padding : (0, $7botX.default)(padding, (0, $ibU15.basePlacements)));
};
function $44eaae0bd533a450$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $eS16w.default)(state.placement);
    var axis = (0, $23O97.default)(basePlacement);
    var isVertical = [
        (0, $ibU15.left),
        (0, $ibU15.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $44eaae0bd533a450$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $5OOkA.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $ibU15.top) : (0, $ibU15.left);
    var maxProp = axis === 'y' ? (0, $ibU15.bottom) : (0, $ibU15.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $7knkd.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $jpWwf.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $44eaae0bd533a450$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $gPKrR.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $44eaae0bd533a450$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $44eaae0bd533a450$var$arrow,
    effect: $44eaae0bd533a450$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("d7iA4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $98ca578da677aabf$export$2e2bcd8739ae039; });

var $ibU15 = parcelRequire("ibU15");

var $92FzN = parcelRequire("92FzN");
function $98ca578da677aabf$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $98ca578da677aabf$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $ibU15.top),
        (0, $ibU15.right),
        (0, $ibU15.bottom),
        (0, $ibU15.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $98ca578da677aabf$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $92FzN.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $92FzN.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $98ca578da677aabf$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $98ca578da677aabf$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $98ca578da677aabf$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $98ca578da677aabf$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $98ca578da677aabf$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $98ca578da677aabf$var$hide
};

});





parcelRegister("ddcbt", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $99e5f0c1a0841abc$export$9d7b58831ae93caa; });
var $99e5f0c1a0841abc$export$4ef52930e33717cd = 'data-theme';
var $99e5f0c1a0841abc$export$a00eac3f8684bcd0 = 'data-color-mode';
var $99e5f0c1a0841abc$export$2112803007239c61 = 'data-contrast-mode';
var $99e5f0c1a0841abc$export$352e418ed5b6193a = 'data-custom-theme';
var $99e5f0c1a0841abc$export$2faeed762aac6741 = 'light';
var $99e5f0c1a0841abc$export$6f0c6fb8c80fcc92 = 'ds';
var $99e5f0c1a0841abc$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $99e5f0c1a0841abc$export$dddac1532e822863 = "--".concat($99e5f0c1a0841abc$export$6f0c6fb8c80fcc92, "-token-not-found");
var $99e5f0c1a0841abc$export$9d7b58831ae93caa = "--".concat($99e5f0c1a0841abc$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("2ddNe", function(module, exports) {
$parcel$export(module.exports, "RepositionOnUpdate", function () { return $19c77eacdbc27b20$export$51eddd7655ca235a; });

var $1oC0p = parcelRequire("1oC0p");
var $19c77eacdbc27b20$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $1oC0p.useRef)(true);
    (0, $1oC0p.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1oC0p.Fragment), null, children);
};

});

parcelRegister("au2Jw", function(module, exports) {
$parcel$export(module.exports, "useCloseManager", function () { return $7a1ed37bd36f0e46$export$92dae2778ae88f9d; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $DDWSY = parcelRequire("DDWSY");

var $hZokc = parcelRequire("hZokc");
var $7a1ed37bd36f0e46$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab;
    var _UNSAFE_useLayering = (0, $hZokc.UNSAFE_useLayering)(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    (0, $1oC0p.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $DDWSY.default;
        var closePopup = function closePopup(event) {
            if (onClose) onClose(event);
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) closePopup(event);
        };
        var onKeyDown = function onKeyDown(event) {
            if (isLayerDisabled()) return;
            var key = event.key;
            if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
        };
        var unbind = (0, $dH1HR.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            }
        ]);
        return unbind;
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        capture,
        isLayerDisabled,
        shouldCloseOnTab
    ]);
};

});

parcelRegister("769PS", function(module, exports) {
$parcel$export(module.exports, "useFocusManager", function () { return $52b0b92254d74b42$export$10c5169755ce7bd7; });

var $1oC0p = parcelRequire("1oC0p");

var $4b05t = parcelRequire("4b05t");

var $DDWSY = parcelRequire("DDWSY");
var $52b0b92254d74b42$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, shouldCloseOnTab = _ref.shouldCloseOnTab;
    (0, $1oC0p.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $DDWSY.default;
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: true
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($4b05t)))(popupRef, trapConfig);
        var frameId = null;
        // wait for the popup to reposition itself before we focus
        frameId = requestAnimationFrame(function() {
            frameId = null;
            focusTrap.activate();
        });
        return function() {
            if (frameId != null) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        initialFocusRef,
        shouldCloseOnTab
    ]);
};

});


parcelRegister("T3blm", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", function () { return $0a579b0a4c0d24f5$export$7cc5c058dd769dff; });

var $4qhbp = parcelRequire("4qhbp");

var $1oC0p = parcelRequire("1oC0p");

var $dWJ7u = parcelRequire("dWJ7u");
var $0a579b0a4c0d24f5$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $1oC0p.useState)(function() {
        return (0, $dWJ7u.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, $4qhbp.default)(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};

});



parcelRegister("1X0st", function(module, exports) {
$parcel$export(module.exports, "WidthObserver", function () { return $16bba822c61a61ab$export$b2ad68b9bc407b80; });

var $1oC0p = parcelRequire("1oC0p");

var $dpQxw = parcelRequire("dpQxw");
var $16bba822c61a61ab$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $dpQxw.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $16bba822c61a61ab$export$2e2bcd8739ae039 = $16bba822c61a61ab$export$b2ad68b9bc407b80;

});
parcelRegister("dpQxw", function(module, exports) {
$parcel$export(module.exports, "WidthDetectorObserver", function () { return $9c465d7915f0acf9$export$ff983d2a2b6112ea; });

var $4qhbp = parcelRequire("4qhbp");

var $1oC0p = parcelRequire("1oC0p");

var $iS2Px = parcelRequire("iS2Px");
var $9c465d7915f0acf9$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(function(_ref) {
    var setWidth = _ref.setWidth, offscreen = _ref.offscreen;
    var _useInView = (0, $iS2Px.useInView)({
        /* Optional options */ threshold: 0
    }), _useInView2 = (0, $4qhbp.default)(_useInView, 3), inViewRef = _useInView2[0], inView = _useInView2[1], target = _useInView2[2];
    var observer = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useRef(function() {
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver(function(entries) {
            if (!Array.isArray(entries) || !entries.length) return;
            var width = entries[0].contentRect.width;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useEffect(function() {
        var currentObserver = observer.current;
        var resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return function() {
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        style: {
            display: 'block',
            width: '100%',
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("iS2Px", function(module, exports) {
$parcel$export(module.exports, "useInView", function () { return $dbcf772fdb3d61a9$export$2f62ee6831462844; });

var $4qhbp = parcelRequire("4qhbp");

var $1oC0p = parcelRequire("1oC0p");
function $dbcf772fdb3d61a9$export$2f62ee6831462844() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useRef();
    var observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useRef();
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    }), _React$useState2 = (0, $4qhbp.default)(_React$useState, 2), state = _React$useState2[0], setState = _React$useState2[1];
    var threshold = options.threshold, root = options.root, rootMargin = options.rootMargin;
    var setRef = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useCallback(function(node) {
        observerInstance.current = new IntersectionObserver(function(entries) {
            if (entries && entries.length) {
                var intersection = entries[0];
                var isIntersecting = intersection.isIntersecting, intersectionRatio = intersection.intersectionRatio;
                if (intersectionRatio >= 0) {
                    var inView = intersectionRatio >= (threshold || 0);
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useEffect(function() {
        return function() {
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("7JYQt", function(module, exports) {
$parcel$export(module.exports, "OverflowProvider", function () { return $5a2bef0173d9e1f4$export$a3a2def3937905a0; });
$parcel$export(module.exports, "useOverflowController", function () { return $5a2bef0173d9e1f4$export$705aa66a39c35bf7; });

var $4qhbp = parcelRequire("4qhbp");

var $1oC0p = parcelRequire("1oC0p");

var $iyuye = parcelRequire("iyuye");

var $DDWSY = parcelRequire("DDWSY");
// Prevent width detector from triggering too many re-renders
var $5a2bef0173d9e1f4$var$THROTTLE_INTERVAL = 64;
// Approx min width of items (based of "More" size)
var $5a2bef0173d9e1f4$var$ITEM_APPROX_MINWIDTH = 70;
var $5a2bef0173d9e1f4$var$calculateHash = function calculateHash(w, n) {
    return w + '#' + n;
};
var $5a2bef0173d9e1f4$var$updateHashRef = function updateHashRef(currentRef, value) {
    currentRef.unshift(value);
    currentRef.length = 3;
};
var $5a2bef0173d9e1f4$var$OverflowContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $DDWSY.default),
    closeOverflowMenu: (0, $DDWSY.default)
});
var $5a2bef0173d9e1f4$export$a3a2def3937905a0 = function OverflowProvider(_ref) {
    var children = _ref.children, isVisible = _ref.isVisible, openOverflowMenu = _ref.openOverflowMenu, closeOverflowMenu = _ref.closeOverflowMenu;
    var Provider = $5a2bef0173d9e1f4$var$OverflowContext.Provider;
    var value = (0, $1oC0p.useMemo)(function() {
        return {
            isVisible: isVisible,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: closeOverflowMenu
        };
    }, [
        isVisible,
        openOverflowMenu,
        closeOverflowMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Provider, {
        value: value
    }, children);
};
var $5a2bef0173d9e1f4$export$3fcfc71fab3314f2 = function useOverflowStatus() {
    return (0, $1oC0p.useContext)($5a2bef0173d9e1f4$var$OverflowContext);
};
var $5a2bef0173d9e1f4$export$705aa66a39c35bf7 = function useOverflowController(nodes) {
    var items = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.toArray(nodes);
    var _useState = (0, $1oC0p.useState)(9999), _useState2 = (0, $4qhbp.default)(_useState, 2), width = _useState2[0], setWidth = _useState2[1];
    var _useState3 = (0, $1oC0p.useState)(items.length), _useState4 = (0, $4qhbp.default)(_useState3, 2), itemsLimit = _useState4[0], setItemsLimit = _useState4[1];
    var _useState5 = (0, $1oC0p.useState)({}), _useState6 = (0, $4qhbp.default)(_useState5, 2), forceEffectValue = _useState6[0], triggerForceEffect = _useState6[1];
    // Storing items approximate width so we can try expanding when there is enough room
    var itemsWidths = (0, $1oC0p.useRef)([]).current;
    // Storing a couple of width + items count in order to stabilize
    var hashRef = (0, $1oC0p.useRef)([]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var throttleSetWidth = (0, $1oC0p.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($iyuye)))(setWidth, $5a2bef0173d9e1f4$var$THROTTLE_INTERVAL), [
        setWidth
    ]);
    (0, $1oC0p.useEffect)(function() {
        var lastItemWidth = itemsWidths[itemsLimit] || 0;
        var wasJustLimited = lastItemWidth < 0;
        var currentHash = $5a2bef0173d9e1f4$var$calculateHash(width, itemsLimit);
        if (hashRef.current[0] === currentHash) {
            // After removing an item, if width has not changed yet we schedule a force update
            // to handle case where removing an item does not actually trigger width change
            var t = setTimeout(function() {
                $5a2bef0173d9e1f4$var$updateHashRef(hashRef.current, '');
                triggerForceEffect({});
            }, $5a2bef0173d9e1f4$var$THROTTLE_INTERVAL * 1.5);
            return function() {
                return clearTimeout(t);
            };
        }
        if (wasJustLimited) {
            // Width was updated either via resize or after changing the limit
            // we cap the width between ITEM_APPROX_MINWIDTH and 2*ITEM_APPROX_MINWIDTH
            // because width is throttled as when fast expanding/resizing partialWidth
            // will not be reliable (edge case)
            var partialWidth = Math.max(Math.min(width + lastItemWidth, $5a2bef0173d9e1f4$var$ITEM_APPROX_MINWIDTH * 2), $5a2bef0173d9e1f4$var$ITEM_APPROX_MINWIDTH);
            itemsWidths[itemsLimit] = partialWidth;
        }
        if (width < $5a2bef0173d9e1f4$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
            // If current width is less than an item approx width we remove an item
            // marking the width as negative so we will calculate it on width update
            // plus we set the hash to stabilise and not removing more than one element
            // until we are sure width was updated
            var nextHash = $5a2bef0173d9e1f4$var$calculateHash(width, itemsLimit - 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit - 1);
                itemsWidths[itemsLimit - 1] = -(width || 1);
                $5a2bef0173d9e1f4$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        /**
     * This is not necessarily equal to `lastItemWidth` because the
     * ```js
     * if (wasJustLimited) {}
     * ```
     * branch above modifies `itemsWidths`.
     *
     * Using `lastItemWidth` here can cause collapsing behavior to fail,
     * such as the issue reported in DSP-7329.
     */ var currentLastItemWidth = itemsWidths[itemsLimit] || 0;
        if (width - currentLastItemWidth > $5a2bef0173d9e1f4$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
            // If we have enough room to accomodate next item width we increase the limit
            // unless it has been recently removed
            var _nextHash = $5a2bef0173d9e1f4$var$calculateHash(width, itemsLimit + 1);
            if (hashRef.current.indexOf(_nextHash) === -1) {
                setItemsLimit(itemsLimit + 1);
                $5a2bef0173d9e1f4$var$updateHashRef(hashRef.current, _nextHash);
            }
            return;
        }
    }, [
        width,
        hashRef,
        itemsLimit,
        itemsWidths,
        forceEffectValue,
        items.length
    ]);
    return {
        visibleItems: items.slice(0, itemsLimit),
        overflowItems: items.slice(itemsLimit),
        updateWidth: throttleSetWidth
    };
};
var // Used to extract props for useOverflowStatus();
// eslint-disable-next-line @repo/internal/react/use-noop
$5a2bef0173d9e1f4$export$2e2bcd8739ae039 = function(props) {};

});

parcelRegister("8Qw9J", function(module, exports) {
$parcel$export(module.exports, "PrimaryDropdownButton", function () { return $670c1f909633900d$export$bb3af89fb196520d; });

var $dX2dk = parcelRequire("dX2dk");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $gnDho = parcelRequire("gnDho");

var $9JQuv = parcelRequire("9JQuv");
var $iMWKd = parcelRequire("iMWKd");

var $inX57 = parcelRequire("inX57");
var $670c1f909633900d$var$chevronIconStylesWithSpacingFixStyles = (0, $iMWKd.xcss)({
    marginInlineEnd: 'space.negative.050'
});
var $670c1f909633900d$export$bb3af89fb196520d = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    return (0, $3dJ4i.jsx)((0, $inX57.PrimaryButton), (0, $dX2dk.default)({
        iconAfter: (0, $3dJ4i.jsx)((0, $9JQuv.default), {
            xcss: $670c1f909633900d$var$chevronIconStylesWithSpacingFixStyles,
            inline: "space.100"
        }, (0, $3dJ4i.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gnDho))), {
            label: ""
        })),
        ref: ref
    }, props));
});
var $670c1f909633900d$export$2e2bcd8739ae039 = $670c1f909633900d$export$bb3af89fb196520d;

});
parcelRegister("gnDho", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $becd4371327ba0ed$var$_react = $becd4371327ba0ed$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $rRAiF = parcelRequire("rRAiF");
function $becd4371327ba0ed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $becd4371327ba0ed$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $becd4371327ba0ed$var$_react.default.createElement($rRAiF.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M8.292 10.293a1.009 1.009 0 000 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 000-1.419.987.987 0 00-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 00-1.406 0z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$becd4371327ba0ed$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $becd4371327ba0ed$var$_default = $becd4371327ba0ed$var$ChevronDownIcon;
module.exports.default = $becd4371327ba0ed$var$_default;

});

parcelRegister("9JQuv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $717108aa94ea51b6$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $iMWKd = parcelRequire("iMWKd");
var $717108aa94ea51b6$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box'
});
var $717108aa94ea51b6$var$blockBleedMap = {
    'space.025': (0, $3dJ4i.css)({
        marginBlock: "var(--ds-space-negative-025, -0.125rem)"
    }),
    'space.050': (0, $3dJ4i.css)({
        marginBlock: "var(--ds-space-negative-050, -0.25rem)"
    }),
    'space.100': (0, $3dJ4i.css)({
        marginBlock: "var(--ds-space-negative-100, -0.5rem)"
    }),
    'space.150': (0, $3dJ4i.css)({
        marginBlock: "var(--ds-space-negative-150, -0.75rem)"
    }),
    'space.200': (0, $3dJ4i.css)({
        marginBlock: "var(--ds-space-negative-200, -1rem)"
    })
};
var $717108aa94ea51b6$var$inlineBleedMap = {
    'space.025': (0, $3dJ4i.css)({
        marginInline: "var(--ds-space-negative-025, -0.125rem)"
    }),
    'space.050': (0, $3dJ4i.css)({
        marginInline: "var(--ds-space-negative-050, -0.25rem)"
    }),
    'space.100': (0, $3dJ4i.css)({
        marginInline: "var(--ds-space-negative-100, -0.5rem)"
    }),
    'space.150': (0, $3dJ4i.css)({
        marginInline: "var(--ds-space-negative-150, -0.75rem)"
    }),
    'space.200': (0, $3dJ4i.css)({
        marginInline: "var(--ds-space-negative-200, -1rem)"
    })
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ var $717108aa94ea51b6$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).memo(function(_ref) {
    var children = _ref.children, testId = _ref.testId, inline = _ref.inline, block = _ref.block, all = _ref.all, xcss = _ref.xcss;
    var resolvedStyles = (0, $iMWKd.parseXcss)(xcss);
    return (0, $3dJ4i.jsx)("div", {
        className: resolvedStyles.static,
        css: [
            $717108aa94ea51b6$var$baseStyles,
            (inline || all) && $717108aa94ea51b6$var$inlineBleedMap[inline || all],
            (block || all) && $717108aa94ea51b6$var$blockBleedMap[block || all],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
});
$717108aa94ea51b6$var$Bleed.displayName = 'Bleed';
var $717108aa94ea51b6$export$2e2bcd8739ae039 = $717108aa94ea51b6$var$Bleed;

});
parcelRegister("iMWKd", function(module, exports) {
$parcel$export(module.exports, "parseXcss", function () { return $dada471fe88f7fed$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $dada471fe88f7fed$export$f6c783d06584602c; });

var $eT6dr = parcelRequire("eT6dr");

var $eYHx9 = parcelRequire("eYHx9");

var $4qhbp = parcelRequire("4qhbp");

var $5gJEo = parcelRequire("5gJEo");

var $3dJ4i = parcelRequire("3dJ4i");

var $95P4l = parcelRequire("95P4l");

var $7t0tI = parcelRequire("7t0tI");
function $dada471fe88f7fed$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $dada471fe88f7fed$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $dada471fe88f7fed$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dada471fe88f7fed$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dada471fe88f7fed$var$_arrayLikeToArray(o, minLen);
}
function $dada471fe88f7fed$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $dada471fe88f7fed$export$9a199fbafee0014e = {
    backgroundColor: (0, $95P4l.backgroundColorMap),
    blockSize: (0, $95P4l.dimensionMap),
    borderBlockColor: (0, $95P4l.borderColorMap),
    borderBlockEndColor: (0, $95P4l.borderColorMap),
    borderBlockEndWidth: (0, $95P4l.borderWidthMap),
    borderBlockStartColor: (0, $95P4l.borderColorMap),
    borderBlockStartWidth: (0, $95P4l.borderWidthMap),
    borderBlockWidth: (0, $95P4l.borderWidthMap),
    borderBottomColor: (0, $95P4l.borderColorMap),
    borderBottomLeftRadius: (0, $95P4l.borderRadiusMap),
    borderBottomRightRadius: (0, $95P4l.borderRadiusMap),
    borderBottomWidth: (0, $95P4l.borderWidthMap),
    borderColor: (0, $95P4l.borderColorMap),
    borderEndEndRadius: (0, $95P4l.borderRadiusMap),
    borderEndStartRadius: (0, $95P4l.borderRadiusMap),
    borderInlineColor: (0, $95P4l.borderColorMap),
    borderInlineEndColor: (0, $95P4l.borderColorMap),
    borderInlineEndWidth: (0, $95P4l.borderWidthMap),
    borderInlineStartColor: (0, $95P4l.borderColorMap),
    borderInlineStartWidth: (0, $95P4l.borderWidthMap),
    borderInlineWidth: (0, $95P4l.borderWidthMap),
    borderLeftColor: (0, $95P4l.borderColorMap),
    borderLeftWidth: (0, $95P4l.borderWidthMap),
    borderRadius: (0, $95P4l.borderRadiusMap),
    borderRightColor: (0, $95P4l.borderColorMap),
    borderRightWidth: (0, $95P4l.borderWidthMap),
    borderStartEndRadius: (0, $95P4l.borderRadiusMap),
    borderStartStartRadius: (0, $95P4l.borderRadiusMap),
    borderTopColor: (0, $95P4l.borderColorMap),
    borderTopLeftRadius: (0, $95P4l.borderRadiusMap),
    borderTopRightRadius: (0, $95P4l.borderRadiusMap),
    borderTopWidth: (0, $95P4l.borderWidthMap),
    borderWidth: (0, $95P4l.borderWidthMap),
    bottom: (0, $95P4l.allSpaceMap),
    boxShadow: (0, $95P4l.shadowMap),
    color: (0, $95P4l.textColorMap),
    columnGap: (0, $95P4l.positiveSpaceMap),
    gap: (0, $95P4l.positiveSpaceMap),
    height: (0, $95P4l.dimensionMap),
    inlineSize: (0, $95P4l.dimensionMap),
    inset: (0, $95P4l.allSpaceMap),
    insetBlock: (0, $95P4l.allSpaceMap),
    insetBlockEnd: (0, $95P4l.allSpaceMap),
    insetBlockStart: (0, $95P4l.allSpaceMap),
    insetInline: (0, $95P4l.allSpaceMap),
    insetInlineEnd: (0, $95P4l.allSpaceMap),
    insetInlineStart: (0, $95P4l.allSpaceMap),
    left: (0, $95P4l.allSpaceMap),
    margin: (0, $95P4l.allSpaceMap),
    marginBlock: (0, $95P4l.allSpaceMap),
    marginBlockEnd: (0, $95P4l.allSpaceMap),
    marginBlockStart: (0, $95P4l.allSpaceMap),
    marginBottom: (0, $95P4l.allSpaceMap),
    marginInline: (0, $95P4l.allSpaceMap),
    marginInlineEnd: (0, $95P4l.allSpaceMap),
    marginInlineStart: (0, $95P4l.allSpaceMap),
    marginLeft: (0, $95P4l.allSpaceMap),
    marginRight: (0, $95P4l.allSpaceMap),
    marginTop: (0, $95P4l.allSpaceMap),
    maxBlockSize: (0, $95P4l.dimensionMap),
    maxHeight: (0, $95P4l.dimensionMap),
    maxInlineSize: (0, $95P4l.dimensionMap),
    maxWidth: (0, $95P4l.dimensionMap),
    minBlockSize: (0, $95P4l.dimensionMap),
    minHeight: (0, $95P4l.dimensionMap),
    minInlineSize: (0, $95P4l.dimensionMap),
    minWidth: (0, $95P4l.dimensionMap),
    opacity: (0, $95P4l.opacityMap),
    outlineColor: (0, $95P4l.borderColorMap),
    outlineOffset: (0, $95P4l.positiveSpaceMap),
    outlineWidth: (0, $95P4l.borderWidthMap),
    padding: (0, $95P4l.positiveSpaceMap),
    paddingBlock: (0, $95P4l.positiveSpaceMap),
    paddingBlockEnd: (0, $95P4l.positiveSpaceMap),
    paddingBlockStart: (0, $95P4l.positiveSpaceMap),
    paddingBottom: (0, $95P4l.positiveSpaceMap),
    paddingInline: (0, $95P4l.positiveSpaceMap),
    paddingInlineEnd: (0, $95P4l.positiveSpaceMap),
    paddingInlineStart: (0, $95P4l.positiveSpaceMap),
    paddingLeft: (0, $95P4l.positiveSpaceMap),
    paddingRight: (0, $95P4l.positiveSpaceMap),
    paddingTop: (0, $95P4l.positiveSpaceMap),
    right: (0, $95P4l.allSpaceMap),
    rowGap: (0, $95P4l.positiveSpaceMap),
    top: (0, $95P4l.allSpaceMap),
    width: (0, $95P4l.dimensionMap),
    zIndex: (0, $95P4l.layerMap)
};
var $dada471fe88f7fed$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $dada471fe88f7fed$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $7t0tI === "undefined" ? "undefined" : (0, $5gJEo.default)($7t0tI)) === 'object' && (0, $5gJEo.default)($7t0tI.env) === 'object' && false;
};
var $dada471fe88f7fed$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $dada471fe88f7fed$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $dada471fe88f7fed$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $5gJEo.default)(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $4qhbp.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $5gJEo.default)(value) === 'object' && $dada471fe88f7fed$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($dada471fe88f7fed$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($dada471fe88f7fed$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $dada471fe88f7fed$export$9a199fbafee0014e)) return;
        var tokenValue = $dada471fe88f7fed$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $dada471fe88f7fed$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $dada471fe88f7fed$var$transformStyles(style);
    return (0, $eYHx9.default)({}, $dada471fe88f7fed$var$uniqueSymbol, (0, $3dJ4i.css)(transformedStyles));
};
var $dada471fe88f7fed$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $dada471fe88f7fed$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, $eT6dr.default)(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$dada471fe88f7fed$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $dada471fe88f7fed$export$f6c783d06584602c(style) {
    return $dada471fe88f7fed$var$baseXcss(style);
}

});
parcelRegister("95P4l", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", function () { return $69ec31f4222fa8c8$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $69ec31f4222fa8c8$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $69ec31f4222fa8c8$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $69ec31f4222fa8c8$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $69ec31f4222fa8c8$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $69ec31f4222fa8c8$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $69ec31f4222fa8c8$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $69ec31f4222fa8c8$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $69ec31f4222fa8c8$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $69ec31f4222fa8c8$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $69ec31f4222fa8c8$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $69ec31f4222fa8c8$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $69ec31f4222fa8c8$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $69ec31f4222fa8c8$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $69ec31f4222fa8c8$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $69ec31f4222fa8c8$export$5e65a44e5b6ecadb; });

var $eYHx9 = parcelRequire("eYHx9");

var $3dJ4i = parcelRequire("3dJ4i");

var $ddcbt = parcelRequire("ddcbt");
function $69ec31f4222fa8c8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $69ec31f4222fa8c8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $69ec31f4222fa8c8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eYHx9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $69ec31f4222fa8c8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $69ec31f4222fa8c8$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $69ec31f4222fa8c8$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $69ec31f4222fa8c8$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $69ec31f4222fa8c8$export$632685d741f3dbbf = $69ec31f4222fa8c8$var$_objectSpread($69ec31f4222fa8c8$var$_objectSpread({}, $69ec31f4222fa8c8$export$958d0ae7f2977ae4), $69ec31f4222fa8c8$export$d2dc61f58390201c);
var $69ec31f4222fa8c8$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $69ec31f4222fa8c8$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $69ec31f4222fa8c8$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $69ec31f4222fa8c8$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $69ec31f4222fa8c8$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $69ec31f4222fa8c8$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $69ec31f4222fa8c8$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $69ec31f4222fa8c8$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $69ec31f4222fa8c8$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $69ec31f4222fa8c8$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $69ec31f4222fa8c8$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $69ec31f4222fa8c8$export$6cc560b4dedf3816 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $69ec31f4222fa8c8$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $69ec31f4222fa8c8$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $69ec31f4222fa8c8$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $69ec31f4222fa8c8$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $3dJ4i.css)((0, $eYHx9.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $69ec31f4222fa8c8$export$e615f061ca585a6c = $69ec31f4222fa8c8$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $69ec31f4222fa8c8$var$getSerializedStylesMap(spacingProperty, $69ec31f4222fa8c8$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $69ec31f4222fa8c8$export$bf46c3f9eeafc71f = $69ec31f4222fa8c8$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $69ec31f4222fa8c8$var$getSerializedStylesMap(spacingProperty, $69ec31f4222fa8c8$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $69ec31f4222fa8c8$export$e7af83bafe7f9e63 = $69ec31f4222fa8c8$var$getSerializedStylesMap('backgroundColor', $69ec31f4222fa8c8$export$d1d79bf68ac056bd);
var $69ec31f4222fa8c8$export$3a1bcba60b23d7f0 = $69ec31f4222fa8c8$var$getSerializedStylesMap('color', $69ec31f4222fa8c8$export$8473307aa00d6ea1);
var $69ec31f4222fa8c8$export$45f3f4fe16f9f7d5 = $69ec31f4222fa8c8$var$getSerializedStylesMap('fontWeight', $69ec31f4222fa8c8$export$303e322c6b1ed114);
var $69ec31f4222fa8c8$export$68cc305da27dbaa4 = $69ec31f4222fa8c8$var$getSerializedStylesMap('fontFamily', $69ec31f4222fa8c8$export$3c7e9587132614b4);
var $69ec31f4222fa8c8$export$128f10c238242f83 = $69ec31f4222fa8c8$var$getSerializedStylesMap('font', $69ec31f4222fa8c8$export$6cc560b4dedf3816);
var $69ec31f4222fa8c8$export$ff257d957d48c421 = $69ec31f4222fa8c8$var$getSerializedStylesMap((0, $ddcbt.CURRENT_SURFACE_CSS_VAR), $69ec31f4222fa8c8$export$41a358c9c2356760);
var $69ec31f4222fa8c8$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $69ec31f4222fa8c8$export$41a358c9c2356760[color] !== undefined;
};

});



parcelRegister("inX57", function(module, exports) {
$parcel$export(module.exports, "PrimaryButton", function () { return $d62834587cdb3872$export$ac16a6a04d9b7c84; });

var $dX2dk = parcelRequire("dX2dk");

var $eYHx9 = parcelRequire("eYHx9");

var $faFp0 = parcelRequire("faFp0");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $cKOdq = parcelRequire("cKOdq");

var $hLJF4 = parcelRequire("hLJF4");

var $2zyTy = parcelRequire("2zyTy");

var $hBIj4 = parcelRequire("hBIj4");
var $d62834587cdb3872$var$_excluded = [
    "children",
    "testId",
    "tooltip",
    "isSelected",
    "isHighlighted"
];
var $d62834587cdb3872$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
var $d62834587cdb3872$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
var $d62834587cdb3872$var$buttonBaseStyles = (0, $3dJ4i.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
});
var $d62834587cdb3872$var$buttonHighlightedStyles = (0, $3dJ4i.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '&& > *': {
        color: "var(".concat($d62834587cdb3872$var$VAR_BUTTON_SELECTED_COLOR, ")")
    },
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: "var(".concat($d62834587cdb3872$var$VAR_BUTTON_SELECTED_BORDER_COLOR, ")"),
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
var $d62834587cdb3872$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var _ref;
    var children = props.children, testId = props.testId, tooltip = props.tooltip, isSelected = props.isSelected, isHighlighted = props.isHighlighted, buttonProps = (0, $faFp0.default)(props, $d62834587cdb3872$var$_excluded);
    var theme = (0, $2zyTy.useTheme)();
    var button = (0, $3dJ4i.jsx)("div", {
        style: (_ref = {}, (0, $eYHx9.default)(_ref, $d62834587cdb3872$var$VAR_BUTTON_SELECTED_COLOR, theme.mode.primaryButton.selected.color), (0, $eYHx9.default)(_ref, $d62834587cdb3872$var$VAR_BUTTON_SELECTED_BORDER_COLOR, theme.mode.primaryButton.selected.borderColor), _ref),
        css: [
            $d62834587cdb3872$var$buttonBaseStyles,
            isHighlighted && $d62834587cdb3872$var$buttonHighlightedStyles
        ],
        role: "listitem"
    }, (0, $3dJ4i.jsx)((0, $cKOdq.default), (0, $dX2dk.default)({
        appearance: "primary",
        testId: testId,
        ref: ref,
        isSelected: isSelected,
        theme: (0, $hBIj4.getPrimaryButtonTheme)(theme)
    }, buttonProps), children));
    if (tooltip) return (0, $3dJ4i.jsx)((0, $hLJF4.default), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});
var $d62834587cdb3872$export$2e2bcd8739ae039 = $d62834587cdb3872$export$ac16a6a04d9b7c84;

});
parcelRegister("hBIj4", function(module, exports) {
$parcel$export(module.exports, "getPrimaryButtonTheme", function () { return $cd1842be42460b13$export$14dd6915caf431fe; });

var $eYHx9 = parcelRequire("eYHx9");
function $cd1842be42460b13$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd1842be42460b13$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd1842be42460b13$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eYHx9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd1842be42460b13$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cd1842be42460b13$export$14dd6915caf431fe = function getPrimaryButtonTheme(_ref) {
    var primaryButton = _ref.mode.primaryButton;
    return function(current, props) {
        var _current = current(props), buttonStyles = _current.buttonStyles, spinnerStyles = _current.spinnerStyles;
        return {
            buttonStyles: $cd1842be42460b13$var$_objectSpread($cd1842be42460b13$var$_objectSpread($cd1842be42460b13$var$_objectSpread($cd1842be42460b13$var$_objectSpread({}, buttonStyles), primaryButton.default), props.isSelected && primaryButton.selected), {}, {
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: "0 ".concat("var(--ds-space-050, 4px)"),
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': $cd1842be42460b13$var$_objectSpread({}, props.state === 'active' && primaryButton.active)
            }),
            spinnerStyles: spinnerStyles
        };
    };
};

});




parcelRegister("fwsq8", function(module, exports) {
$parcel$export(module.exports, "PrimaryItemsContainer", function () { return $b4cfe3e77b72a0da$export$43e704064d596a9e; });

var $dX2dk = parcelRequire("dX2dk");

var $4qhbp = parcelRequire("4qhbp");

var $eYHx9 = parcelRequire("eYHx9");

var $1oC0p = parcelRequire("1oC0p");

var $aeVS3 = parcelRequire("aeVS3");

var $9PG0d = parcelRequire("9PG0d");
var $hvWW5 = parcelRequire("hvWW5");
var $iMWKd = parcelRequire("iMWKd");

var $b1jzZ = parcelRequire("b1jzZ");
var $k9sjd = parcelRequire("k9sjd");

var $7JYQt = parcelRequire("7JYQt");

var $8Qw9J = parcelRequire("8Qw9J");
var $b4cfe3e77b72a0da$var$_xcss2;
var $b4cfe3e77b72a0da$var$containerWrapperStyles = (0, $iMWKd.xcss)({
    height: '100%'
});
var $b4cfe3e77b72a0da$var$sharedContainerStyles = (0, $iMWKd.xcss)({
    height: '100%',
    alignItems: 'stretch',
    paddingInlineEnd: 'space.050',
    gap: 'space.100'
});
var $b4cfe3e77b72a0da$var$smallContainerStyles = (0, $iMWKd.xcss)((0, $eYHx9.default)({}, (0, $b1jzZ.media).above.sm, {
    display: 'none'
}));
var $b4cfe3e77b72a0da$var$mediumContainerStyles = (0, $iMWKd.xcss)(($b4cfe3e77b72a0da$var$_xcss2 = {
    display: 'none'
}, (0, $eYHx9.default)($b4cfe3e77b72a0da$var$_xcss2, (0, $b1jzZ.media).above.sm, {
    display: 'flex'
}), (0, $eYHx9.default)($b4cfe3e77b72a0da$var$_xcss2, (0, $b1jzZ.media).above.lg, {
    display: 'none'
}), $b4cfe3e77b72a0da$var$_xcss2));
var $b4cfe3e77b72a0da$var$largeContainerStyles = (0, $iMWKd.xcss)((0, $eYHx9.default)({
    display: 'none'
}, (0, $b1jzZ.media).above.lg, {
    display: 'flex'
}));
var $b4cfe3e77b72a0da$var$overflowItemsStyles = (0, $iMWKd.xcss)({
    color: 'color.text'
});
var $b4cfe3e77b72a0da$var$MoreItemsPopup = function MoreItemsPopup(_ref) {
    var moreLabel = _ref.moreLabel, testId = _ref.testId, items = _ref.items;
    var _useState = (0, $1oC0p.useState)(false), _useState2 = (0, $4qhbp.default)(_useState, 2), isMoreOpen = _useState2[0], setIsMoreOpen = _useState2[1];
    var onMoreClose = (0, $1oC0p.useCallback)(function() {
        return setIsMoreOpen(false);
    }, []);
    var onMoreClick = (0, $1oC0p.useCallback)(function() {
        return setIsMoreOpen(function(current) {
            return !current;
        });
    }, []);
    var openOverflowMenu = (0, $1oC0p.useCallback)(function() {
        return setIsMoreOpen(true);
    }, []);
    var trigger = (0, $1oC0p.useCallback)(function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $8Qw9J.PrimaryDropdownButton), (0, $dX2dk.default)({
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? "".concat(testId, "-overflow-menu-trigger") : 'overflow-menu-trigger'
        }, triggerProps), moreLabel);
    }, [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    var content = (0, $1oC0p.useCallback)(function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $7JYQt.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9PG0d.default), {
            xcss: $b4cfe3e77b72a0da$var$overflowItemsStyles
        }, items));
    }, [
        items,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $aeVS3.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        content: content,
        testId: testId ? "".concat(testId, "-overflow-menu-popup") : 'overflow-menu-popup'
    });
};
var $b4cfe3e77b72a0da$export$43e704064d596a9e = /*#__PURE__*/ (0, $1oC0p.memo)(function(_ref2) {
    var moreLabel = _ref2.moreLabel, items = _ref2.items, Create = _ref2.create, theme = _ref2.theme, testId = _ref2.testId;
    // We render a CSS media query based nav at first to handle SSR, then use
    // our useMediaQuery hook once we are hydrated so there is only one set of nav items
    var _useState3 = (0, $1oC0p.useState)(false), _useState4 = (0, $4qhbp.default)(_useState3, 2), isClient = _useState4[0], setIsClient = _useState4[1];
    (0, $1oC0p.useEffect)(function() {
        setIsClient(true);
    }, []);
    // Setting up our media queries to use once app is hydrated
    var mqSm = (0, $k9sjd.UNSAFE_useMediaQuery)('above.sm', function(event) {
        return setIsAboveSm(event.matches);
    });
    var _useState5 = (0, $1oC0p.useState)(mqSm === null || mqSm === void 0 ? void 0 : mqSm.matches), _useState6 = (0, $4qhbp.default)(_useState5, 2), isAboveSm = _useState6[0], setIsAboveSm = _useState6[1];
    var mqLg = (0, $k9sjd.UNSAFE_useMediaQuery)('above.lg', function(event) {
        return setIsAboveLg(event.matches);
    });
    var _useState7 = (0, $1oC0p.useState)(mqLg === null || mqLg === void 0 ? void 0 : mqLg.matches), _useState8 = (0, $4qhbp.default)(_useState7, 2), isAboveLg = _useState8[0], setIsAboveLg = _useState8[1];
    // Filter out any falsy items passed in
    var filteredItems = (0, $1oC0p.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Children.toArray(items).filter(function(item) {
            return !!item;
        });
    }, [
        items
    ]);
    // NOTE: we could make these max items configurable in the future. For now
    // we are using sensible defaults. Anything over the max gets put in the
    // overflow menu for that screen size.
    // While it may be tempting to use more than 3 items for the medium nav when
    // you see the available space, you need to consider internationalistion.
    // 3 is the safe, defensive choice across many languages and scripts.
    var smallMaxItems = 0;
    var mediumMaxItems = 3;
    var largeMaxItems = 8;
    // We re-use this in both the CSS media query nav that loads in for SSR,
    // and the JS/hook media query nav that is used once hydrated
    var navItems = (0, $1oC0p.useMemo)(function() {
        return {
            small: {
                navBarItems: [],
                overflowItems: filteredItems
            },
            medium: {
                navBarItems: filteredItems.slice(0, mediumMaxItems),
                overflowItems: filteredItems.slice(mediumMaxItems, filteredItems.length)
            },
            large: {
                navBarItems: filteredItems.slice(0, largeMaxItems),
                overflowItems: filteredItems.slice(largeMaxItems, filteredItems.length)
            }
        };
    }, [
        filteredItems
    ]);
    var hydratedNavItems = (0, $1oC0p.useMemo)(function() {
        if (isAboveLg) return navItems.large;
        if (isAboveSm && !isAboveLg) return navItems.medium;
        return navItems.small;
    }, [
        isAboveLg,
        isAboveSm,
        navItems.large,
        navItems.medium,
        navItems.small
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, null, isClient ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9PG0d.default), {
        role: "list",
        xcss: $b4cfe3e77b72a0da$var$containerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $hvWW5.default), {
        testId: testId && "".concat(testId, "-primary-actions"),
        xcss: $b4cfe3e77b72a0da$var$sharedContainerStyles
    }, hydratedNavItems.navBarItems, hydratedNavItems.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($b4cfe3e77b72a0da$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        items: hydratedNavItems.overflowItems,
        testId: testId
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $9PG0d.default), {
        role: "list",
        xcss: $b4cfe3e77b72a0da$var$containerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $hvWW5.default), {
        xcss: [
            $b4cfe3e77b72a0da$var$sharedContainerStyles,
            $b4cfe3e77b72a0da$var$smallContainerStyles
        ]
    }, filteredItems.length > smallMaxItems && /*#__PURE__*/ // We don't need to pass items into popup, it won't be interactive (SSR only)
    (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($b4cfe3e77b72a0da$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $hvWW5.default), {
        xcss: [
            $b4cfe3e77b72a0da$var$sharedContainerStyles,
            $b4cfe3e77b72a0da$var$mediumContainerStyles
        ]
    }, navItems.medium.navBarItems, navItems.medium.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($b4cfe3e77b72a0da$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $hvWW5.default), {
        xcss: [
            $b4cfe3e77b72a0da$var$sharedContainerStyles,
            $b4cfe3e77b72a0da$var$largeContainerStyles
        ]
    }, navItems.large.navBarItems, navItems.large.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($b4cfe3e77b72a0da$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    }))), Create && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(Create, null));
});

});
parcelRegister("9PG0d", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7289754def8bb61c$export$2e2bcd8739ae039; });

var $dX2dk = parcelRequire("dX2dk");

var $faFp0 = parcelRequire("faFp0");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $95P4l = parcelRequire("95P4l");

var $iMWKd = parcelRequire("iMWKd");

var $ah0oL = parcelRequire("ah0oL");
var $7289754def8bb61c$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $7289754def8bb61c$var$_excluded2 = [
    "className"
];
var $7289754def8bb61c$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $faFp0.default)(_ref, $7289754def8bb61c$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $faFp0.default)(htmlAttributes, $7289754def8bb61c$var$_excluded2);
    var resolvedStyles = (0, $iMWKd.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $3dJ4i.jsx)(Component, (0, $dX2dk.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $7289754def8bb61c$var$baseStyles,
            backgroundColor && (0, $95P4l.backgroundColorStylesMap)[backgroundColor],
            (0, $95P4l.isSurfaceColorToken)(backgroundColor) && (0, $95P4l.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $95P4l.paddingStylesMap).padding[padding],
            paddingBlock && (0, $95P4l.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $95P4l.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $95P4l.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $95P4l.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $95P4l.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $95P4l.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $3dJ4i.jsx)((0, $ah0oL.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $7289754def8bb61c$export$2e2bcd8739ae039 = $7289754def8bb61c$export$e71c4d32a2263218;
var $7289754def8bb61c$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("ah0oL", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $77abcd0701d1c740$export$1ca2a26fecb070ae; });

var $1oC0p = parcelRequire("1oC0p");
var $77abcd0701d1c740$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $77abcd0701d1c740$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($77abcd0701d1c740$export$1ca2a26fecb070ae);
};
$77abcd0701d1c740$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("hvWW5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cc030c583b44aa50$export$2e2bcd8739ae039; });

var $eT6dr = parcelRequire("eT6dr");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $iMWKd = parcelRequire("iMWKd");

var $19rvH = parcelRequire("19rvH");
var $cc030c583b44aa50$var$flexGrowMap = {
    hug: (0, $iMWKd.xcss)({
        flexGrow: 0
    }),
    fill: (0, $iMWKd.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $cc030c583b44aa50$var$separatorStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $cc030c583b44aa50$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $3dJ4i.jsx)("span", {
        css: $cc030c583b44aa50$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $cc030c583b44aa50$var$Inline = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $3dJ4i.jsx)($cc030c583b44aa50$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $1oC0p.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $cc030c583b44aa50$var$flexGrowMap[grow]
    ].concat((0, $eT6dr.default)(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $3dJ4i.jsx)((0, $19rvH.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$cc030c583b44aa50$var$Inline.displayName = 'Inline';
var $cc030c583b44aa50$export$2e2bcd8739ae039 = $cc030c583b44aa50$var$Inline;

});
parcelRegister("19rvH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0d6bf8ab9f33b3a1$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $95P4l = parcelRequire("95P4l");

var $iMWKd = parcelRequire("iMWKd");
var $0d6bf8ab9f33b3a1$var$justifyContentMap = {
    start: (0, $3dJ4i.css)({
        justifyContent: 'start'
    }),
    center: (0, $3dJ4i.css)({
        justifyContent: 'center'
    }),
    end: (0, $3dJ4i.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $3dJ4i.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $3dJ4i.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $3dJ4i.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $3dJ4i.css)({
        justifyContent: 'stretch'
    })
};
var $0d6bf8ab9f33b3a1$var$flexDirectionMap = {
    column: (0, $3dJ4i.css)({
        flexDirection: 'column'
    }),
    row: (0, $3dJ4i.css)({
        flexDirection: 'row'
    })
};
var $0d6bf8ab9f33b3a1$var$flexWrapMap = {
    wrap: (0, $3dJ4i.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $3dJ4i.css)({
        flexWrap: 'nowrap'
    })
};
var $0d6bf8ab9f33b3a1$var$alignItemsMap = {
    start: (0, $3dJ4i.css)({
        alignItems: 'start'
    }),
    center: (0, $3dJ4i.css)({
        alignItems: 'center'
    }),
    baseline: (0, $3dJ4i.css)({
        alignItems: 'baseline'
    }),
    end: (0, $3dJ4i.css)({
        alignItems: 'end'
    }),
    stretch: (0, $3dJ4i.css)({
        alignItems: 'stretch'
    })
};
var $0d6bf8ab9f33b3a1$var$baseStyles = (0, $3dJ4i.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $0d6bf8ab9f33b3a1$var$Flex = /*#__PURE__*/ (0, $1oC0p.memo)(/*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $iMWKd.parseXcss)(xcss);
    return (0, $3dJ4i.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $0d6bf8ab9f33b3a1$var$baseStyles,
            gap && (0, $95P4l.spaceStylesMap).gap[gap],
            columnGap && (0, $95P4l.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $95P4l.spaceStylesMap).rowGap[rowGap],
            alignItems && $0d6bf8ab9f33b3a1$var$alignItemsMap[alignItems],
            direction && $0d6bf8ab9f33b3a1$var$flexDirectionMap[direction],
            justifyContent && $0d6bf8ab9f33b3a1$var$justifyContentMap[justifyContent],
            wrap && $0d6bf8ab9f33b3a1$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$0d6bf8ab9f33b3a1$var$Flex.displayName = 'Flex';
var $0d6bf8ab9f33b3a1$export$2e2bcd8739ae039 = $0d6bf8ab9f33b3a1$var$Flex;

});


parcelRegister("b1jzZ", function(module, exports) {
$parcel$export(module.exports, "media", function () { return $805ef9ca8e3346b8$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "UNSAFE_media", function () { return $805ef9ca8e3346b8$export$c881183ca713c214; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $805ef9ca8e3346b8$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 109.99rem)',
        xl: '@media (min-width: 110rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110rem)'
    }
};
var $805ef9ca8e3346b8$export$c881183ca713c214 = $805ef9ca8e3346b8$export$987d49ffe1b0900f;

});

parcelRegister("k9sjd", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", function () { return $eaba9b7b73caa2db$export$49e55ae2c03d6045; });

var $1oC0p = parcelRequire("1oC0p");

var $dH1HR = parcelRequire("dH1HR");

var $b1jzZ = parcelRequire("b1jzZ");
var $eaba9b7b73caa2db$var$_window, $eaba9b7b73caa2db$var$_window$matchMedia, $eaba9b7b73caa2db$var$_window2, $eaba9b7b73caa2db$var$_window2$matchMedia, $eaba9b7b73caa2db$var$_window3, $eaba9b7b73caa2db$var$_window3$matchMedia, $eaba9b7b73caa2db$var$_window4, $eaba9b7b73caa2db$var$_window4$matchMedia, $eaba9b7b73caa2db$var$_window5, $eaba9b7b73caa2db$var$_window5$matchMedia, $eaba9b7b73caa2db$var$_window6, $eaba9b7b73caa2db$var$_window6$matchMedia, $eaba9b7b73caa2db$var$_window7, $eaba9b7b73caa2db$var$_window7$matchMedia, $eaba9b7b73caa2db$var$_window8, $eaba9b7b73caa2db$var$_window8$matchMedia, $eaba9b7b73caa2db$var$_window9, $eaba9b7b73caa2db$var$_window9$matchMedia, $eaba9b7b73caa2db$var$_window10, $eaba9b7b73caa2db$var$_window10$matchMedia, $eaba9b7b73caa2db$var$_window11, $eaba9b7b73caa2db$var$_window11$matchMedia;
var $eaba9b7b73caa2db$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($eaba9b7b73caa2db$var$_window = window) === null || $eaba9b7b73caa2db$var$_window === void 0 || ($eaba9b7b73caa2db$var$_window$matchMedia = $eaba9b7b73caa2db$var$_window.matchMedia) === null || $eaba9b7b73caa2db$var$_window$matchMedia === void 0 ? void 0 : $eaba9b7b73caa2db$var$_window$matchMedia.call($eaba9b7b73caa2db$var$_window, (0, $b1jzZ.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($eaba9b7b73caa2db$var$_window2 = window) === null || $eaba9b7b73caa2db$var$_window2 === void 0 || ($eaba9b7b73caa2db$var$_window2$matchMedia = $eaba9b7b73caa2db$var$_window2.matchMedia) === null || $eaba9b7b73caa2db$var$_window2$matchMedia === void 0 ? void 0 : $eaba9b7b73caa2db$var$_window2$matchMedia.call($eaba9b7b73caa2db$var$_window2, (0, $b1jzZ.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($eaba9b7b73caa2db$var$_window3 = window) === null || $eaba9b7b73caa2db$var$_window3 === void 0 || ($eaba9b7b73caa2db$var$_window3$matchMedia = $eaba9b7b73caa2db$var$_window3.matchMedia) === null || $eaba9b7b73caa2db$var$_window3$matchMedia === void 0 ? void 0 : $eaba9b7b73caa2db$var$_window3$matchMedia.call($eaba9b7b73caa2db$var$_window3, (0, $b1jzZ.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($eaba9b7b73caa2db$var$_window4 = window) === null || $eaba9b7b73caa2db$var$_window4 === void 0 || ($eaba9b7b73caa2db$var$_window4$matchMedia = $eaba9b7b73caa2db$var$_window4.matchMedia) === null || $eaba9b7b73caa2db$var$_window4$matchMedia === void 0 ? void 0 : $eaba9b7b73caa2db$var$_window4$matchMedia.call($eaba9b7b73caa2db$var$_window4, (0, $b1jzZ.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($eaba9b7b73caa2db$var$_window5 = window) === null || $eaba9b7b73caa2db$var$_window5 === void 0 || ($eaba9b7b73caa2db$var$_window5$matchMedia = $eaba9b7b73caa2db$var$_window5.matchMedia) === null || $eaba9b7b73caa2db$var$_window5$matchMedia === void 0 ? void 0 : $eaba9b7b73caa2db$var$_window5$matchMedia.call($eaba9b7b73caa2db$var$_window5, (0, $b1jzZ.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($eaba9b7b73caa2db$var$_window6 = window) === null || $eaba9b7b73caa2db$var$_window6 === void 0 || ($eaba9b7b73caa2db$var$_window6$matchMedia = $eaba9b7b73caa2db$var$_window6.matchMedia) === null || $eaba9b7b73caa2db$var$_window6$matchMedia === void 0 ? void 0 : $eaba9b7b73caa2db$var$_window6$matchMedia.call($eaba9b7b73caa2db$var$_window6, (0, $b1jzZ.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($eaba9b7b73caa2db$var$_window7 = window) === null || $eaba9b7b73caa2db$var$_window7 === void 0 || ($eaba9b7b73caa2db$var$_window7$matchMedia = $eaba9b7b73caa2db$var$_window7.matchMedia) === null || $eaba9b7b73caa2db$var$_window7$matchMedia === void 0 ? void 0 : $eaba9b7b73caa2db$var$_window7$matchMedia.call($eaba9b7b73caa2db$var$_window7, (0, $b1jzZ.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($eaba9b7b73caa2db$var$_window8 = window) === null || $eaba9b7b73caa2db$var$_window8 === void 0 || ($eaba9b7b73caa2db$var$_window8$matchMedia = $eaba9b7b73caa2db$var$_window8.matchMedia) === null || $eaba9b7b73caa2db$var$_window8$matchMedia === void 0 ? void 0 : $eaba9b7b73caa2db$var$_window8$matchMedia.call($eaba9b7b73caa2db$var$_window8, (0, $b1jzZ.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($eaba9b7b73caa2db$var$_window9 = window) === null || $eaba9b7b73caa2db$var$_window9 === void 0 || ($eaba9b7b73caa2db$var$_window9$matchMedia = $eaba9b7b73caa2db$var$_window9.matchMedia) === null || $eaba9b7b73caa2db$var$_window9$matchMedia === void 0 ? void 0 : $eaba9b7b73caa2db$var$_window9$matchMedia.call($eaba9b7b73caa2db$var$_window9, (0, $b1jzZ.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($eaba9b7b73caa2db$var$_window10 = window) === null || $eaba9b7b73caa2db$var$_window10 === void 0 || ($eaba9b7b73caa2db$var$_window10$matchMedia = $eaba9b7b73caa2db$var$_window10.matchMedia) === null || $eaba9b7b73caa2db$var$_window10$matchMedia === void 0 ? void 0 : $eaba9b7b73caa2db$var$_window10$matchMedia.call($eaba9b7b73caa2db$var$_window10, (0, $b1jzZ.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($eaba9b7b73caa2db$var$_window11 = window) === null || $eaba9b7b73caa2db$var$_window11 === void 0 || ($eaba9b7b73caa2db$var$_window11$matchMedia = $eaba9b7b73caa2db$var$_window11.matchMedia) === null || $eaba9b7b73caa2db$var$_window11$matchMedia === void 0 ? void 0 : $eaba9b7b73caa2db$var$_window11$matchMedia.call($eaba9b7b73caa2db$var$_window11, (0, $b1jzZ.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
var $eaba9b7b73caa2db$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $1oC0p.useRef)(listener);
    (0, $1oC0p.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $eaba9b7b73caa2db$var$queries[queryString];
    (0, $1oC0p.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $dH1HR.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});



parcelRegister("l5GWs", function(module, exports) {
$parcel$export(module.exports, "Help", function () { return $f5ab5ff1e230a7a9$export$1be7516c0280bee8; });

var $dX2dk = parcelRequire("dX2dk");

var $faFp0 = parcelRequire("faFp0");

var $1oC0p = parcelRequire("1oC0p");

var $8Wdv0 = parcelRequire("8Wdv0");

var $2zyTy = parcelRequire("2zyTy");

var $1HpEV = parcelRequire("1HpEV");

var $dzMzP = parcelRequire("dzMzP");
var $f5ab5ff1e230a7a9$var$_excluded = [
    "badge",
    "tooltip"
];
var $f5ab5ff1e230a7a9$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
var $f5ab5ff1e230a7a9$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var badge = props.badge, tooltip = props.tooltip, iconButtonProps = (0, $faFp0.default)(props, $f5ab5ff1e230a7a9$var$_excluded);
    var _useTheme = (0, $2zyTy.useTheme)(), navigation = _useTheme.mode.navigation;
    var button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $dzMzP.IconButton), (0, $dX2dk.default)({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8Wdv0))), {
            label: typeof tooltip === 'string' ? tooltip : 'Help Icon',
            secondaryColor: navigation.backgroundColor
        }),
        ref: ref,
        tooltip: tooltip
    }, iconButtonProps));
    return badge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1HpEV.BadgeContainer), {
        id: $f5ab5ff1e230a7a9$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, button) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        role: "listitem"
    }, button);
});
var $f5ab5ff1e230a7a9$export$2e2bcd8739ae039 = $f5ab5ff1e230a7a9$export$1be7516c0280bee8;

});
parcelRegister("8Wdv0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $681e362aa008ba44$var$_react = $681e362aa008ba44$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $rRAiF = parcelRequire("rRAiF");
function $681e362aa008ba44$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $681e362aa008ba44$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $681e362aa008ba44$var$_react.default.createElement($rRAiF.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><circle fill="inherit" cx="12" cy="18" r="1"/><path d="M15.89 9.05a3.975 3.975 0 00-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.992.992 0 00.982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 014.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 00-1 .987v2.014a1.001 1.001 0 002.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0015.89 9.05" fill="inherit"/></g></svg>`
    }, props));
$681e362aa008ba44$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $681e362aa008ba44$var$_default = $681e362aa008ba44$var$QuestionCircleIcon;
module.exports.default = $681e362aa008ba44$var$_default;

});

parcelRegister("1HpEV", function(module, exports) {
$parcel$export(module.exports, "BadgeContainer", function () { return $13cdb5f7591e63d4$export$f710265eb5a003da; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");
var $13cdb5f7591e63d4$var$badgeContainerStyles = (0, $3dJ4i.css)({
    position: 'absolute',
    insetBlockStart: "var(--ds-space-negative-050, -4px)",
    insetInlineEnd: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none'
});
var $13cdb5f7591e63d4$var$containerStyles = (0, $3dJ4i.css)({
    position: 'relative'
});
var $13cdb5f7591e63d4$export$f710265eb5a003da = function BadgeContainer(props) {
    var badgeId = props.id, Badge = props.badge, children = props.children, role = props.role;
    return (0, $3dJ4i.jsx)("div", {
        css: $13cdb5f7591e63d4$var$containerStyles,
        role: role
    }, children, (0, $3dJ4i.jsx)("div", {
        css: $13cdb5f7591e63d4$var$badgeContainerStyles,
        id: badgeId,
        "aria-hidden": true
    }, (0, $3dJ4i.jsx)(Badge, null)));
};

});


parcelRegister("gdwBs", function(module, exports) {
$parcel$export(module.exports, "Notifications", function () { return $bce72689b8d72298$export$36ba2f559d49a8f6; });

var $dX2dk = parcelRequire("dX2dk");

var $faFp0 = parcelRequire("faFp0");

var $1oC0p = parcelRequire("1oC0p");

var $fC90J = parcelRequire("fC90J");

var $1HpEV = parcelRequire("1HpEV");

var $dzMzP = parcelRequire("dzMzP");
var $bce72689b8d72298$var$_excluded = [
    "badge",
    "tooltip"
];
var $bce72689b8d72298$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
var $bce72689b8d72298$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var badge = props.badge, tooltip = props.tooltip, iconButtonProps = (0, $faFp0.default)(props, $bce72689b8d72298$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $1HpEV.BadgeContainer), {
        id: $bce72689b8d72298$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $dzMzP.IconButton), (0, $dX2dk.default)({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fC90J))), {
            label: typeof tooltip === 'string' ? tooltip : 'Notification Icon'
        }),
        tooltip: tooltip,
        ref: ref,
        "aria-describedby": $bce72689b8d72298$var$NOTIFICATIONS_BADGE_ID
    }, iconButtonProps)));
});
var $bce72689b8d72298$export$2e2bcd8739ae039 = $bce72689b8d72298$export$36ba2f559d49a8f6;

});
parcelRegister("fC90J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5e164faa4843ae2$var$_react = $b5e164faa4843ae2$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $rRAiF = parcelRequire("rRAiF");
function $b5e164faa4843ae2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b5e164faa4843ae2$var$NotificationIcon = (props)=>/*#__PURE__*/ $b5e164faa4843ae2$var$_react.default.createElement($rRAiF.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6.485 17.669a2 2 0 002.829 0l-2.829-2.83a2 2 0 000 2.83zm4.897-12.191l-.725.725c-.782.782-2.21 1.813-3.206 2.311l-3.017 1.509c-.495.248-.584.774-.187 1.171l8.556 8.556c.398.396.922.313 1.171-.188l1.51-3.016c.494-.988 1.526-2.42 2.311-3.206l.725-.726a5.048 5.048 0 00.64-6.356 1.01 1.01 0 10-1.354-1.494c-.023.025-.046.049-.066.075a5.043 5.043 0 00-2.788-.84 5.036 5.036 0 00-3.57 1.478z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$b5e164faa4843ae2$var$NotificationIcon.displayName = 'NotificationIcon';
var $b5e164faa4843ae2$var$_default = $b5e164faa4843ae2$var$NotificationIcon;
module.exports.default = $b5e164faa4843ae2$var$_default;

});


parcelRegister("da25C", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $994dd483444574d9$export$2e2bcd8739ae039; });

var $dX2dk = parcelRequire("dX2dk");

var $faFp0 = parcelRequire("faFp0");

var $eYHx9 = parcelRequire("eYHx9");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $6DIEl = parcelRequire("6DIEl");

var $4eREm = parcelRequire("4eREm");

var $2zyTy = parcelRequire("2zyTy");

var $72mK3 = parcelRequire("72mK3");
var $994dd483444574d9$var$_excluded = [
    "icon",
    "logo",
    "siteTitle",
    "onClick",
    "href",
    "onMouseDown",
    "testId",
    "logoMaxWidth"
];
var $994dd483444574d9$var$_css;
var $994dd483444574d9$var$VAR_LOGO_MAX_WIDTH = '--logo-max-width';
var $994dd483444574d9$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
var $994dd483444574d9$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
var $994dd483444574d9$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
var $994dd483444574d9$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
var $994dd483444574d9$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
var $994dd483444574d9$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
var $994dd483444574d9$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
var $994dd483444574d9$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
var $994dd483444574d9$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
var $994dd483444574d9$var$productHomeButtonStyles = (0, $3dJ4i.css)(($994dd483444574d9$var$_css = {
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:first-of-type': {
        marginLeft: 0
    },
    '&:hover': {
        backgroundColor: "var(".concat($994dd483444574d9$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER, ")"),
        boxShadow: "var(".concat($994dd483444574d9$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER, ")"),
        color: "var(".concat($994dd483444574d9$var$VAR_PRODUCT_HOME_COLOR_HOVER, ")")
    },
    '&:active': {
        backgroundColor: "var(".concat($994dd483444574d9$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE, ")"),
        boxShadow: "var(".concat($994dd483444574d9$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE, ")"),
        color: "var(".concat($994dd483444574d9$var$VAR_PRODUCT_HOME_COLOR_ACTIVE, ")")
    },
    '&:focus-visible': {
        backgroundColor: "var(".concat($994dd483444574d9$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS, ")"),
        color: "var(".concat($994dd483444574d9$var$VAR_PRODUCT_HOME_COLOR_FOCUS, ")"),
        outline: "var(--ds-border-width-outline, 2px)".concat(" solid ", "var(--ds-border-focused, #4C9AFF)")
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    'div&': {
        pointerEvents: 'none'
    }
}, (0, $eYHx9.default)($994dd483444574d9$var$_css, "@media (max-width: ".concat((0, $4eREm.PRODUCT_HOME_BREAKPOINT) - 0.1, "px)"), {
    margin: "0 ".concat("var(--ds-space-100, 8px)")
}), (0, $eYHx9.default)($994dd483444574d9$var$_css, "@media (min-width: ".concat((0, $4eREm.PRODUCT_HOME_BREAKPOINT), "px)"), {
    margin: "0 ".concat("var(--ds-space-200, 16px)")
}), $994dd483444574d9$var$_css));
var $994dd483444574d9$var$productLogoStyles = (0, $3dJ4i.css)((0, $eYHx9.default)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    maxWidth: "var(".concat($994dd483444574d9$var$VAR_LOGO_MAX_WIDTH, ")"),
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > span > svg': {
        maxWidth: "var(".concat($994dd483444574d9$var$VAR_LOGO_MAX_WIDTH, ")")
    }
}, "@media (max-width: ".concat((0, $4eREm.PRODUCT_HOME_BREAKPOINT) - 0.1, "px)"), {
    display: 'none'
}));
var $994dd483444574d9$var$customMaxHeightStyles = (0, $3dJ4i.css)({
    maxHeight: 28
});
var $994dd483444574d9$var$productIconStyles = (0, $3dJ4i.css)((0, $eYHx9.default)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > *': {
        maxHeight: 24
    }
}, "@media (min-width: ".concat((0, $4eREm.PRODUCT_HOME_BREAKPOINT), "px)"), {
    display: 'none'
}));
var $994dd483444574d9$var$siteTitleStyles = (0, $3dJ4i.css)({
    display: 'flex',
    // Overridden in PFF styles applied below; consolidate in FF cleanup
    marginRight: "var(--ds-space-050, 4px)",
    marginLeft: "var(--ds-space-050, 4px)",
    paddingRight: "var(--ds-space-200, 16px)",
    alignItems: 'center'
});
// When cleaning up feature flag, these styles can be moved into the above block
var $994dd483444574d9$var$featureFlaggedSiteTitleStyles = (0, $3dJ4i.css)((0, $eYHx9.default)({
    // Under the FF, we've made the site title handle it's spacing, with the
    // PrimaryItemsContainer not needing to worry about its paddingInlineStart.
    // This makes it cleaner for the title styles to appear and disappear with mq's
    marginRight: "var(--ds-space-100, 8px)"
}, "@media (max-width: ".concat((0, $4eREm.PRODUCT_HOME_BREAKPOINT) - 0.1, "px)"), {
    display: 'none'
}));
/**
 * __Product home__
 *
 * The ProductHome component displays the product visual identity composed of:
 * logo, icon, and optional text. Values for logo and icon are never displayed
 * at the same time, where icon is used only when space is restricted. Should be
 * passed into `AtlassianNavigation`'s `renderProductHome` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ var $994dd483444574d9$var$ProductHome = function ProductHome(_ref) {
    var _productHomeButtonDyn;
    var Icon = _ref.icon, Logo = _ref.logo, siteTitle = _ref.siteTitle, onClick = _ref.onClick, href = _ref.href, onMouseDown = _ref.onMouseDown, testId = _ref.testId, _ref$logoMaxWidth = _ref.logoMaxWidth, logoMaxWidth = _ref$logoMaxWidth === void 0 ? 260 : _ref$logoMaxWidth, rest = (0, $faFp0.default)(_ref, $994dd483444574d9$var$_excluded);
    var theme = (0, $2zyTy.useTheme)();
    var primaryButton = theme.mode.primaryButton;
    var _theme$mode$productHo = theme.mode.productHome, _theme$mode$productHo2 = _theme$mode$productHo.iconColor, iconColor = _theme$mode$productHo2 === void 0 ? 'inherit' : _theme$mode$productHo2, _theme$mode$productHo3 = _theme$mode$productHo.iconGradientStart, iconGradientStart = _theme$mode$productHo3 === void 0 ? 'inherit' : _theme$mode$productHo3, _theme$mode$productHo4 = _theme$mode$productHo.iconGradientStop, iconGradientStop = _theme$mode$productHo4 === void 0 ? 'inherit' : _theme$mode$productHo4, _theme$mode$productHo5 = _theme$mode$productHo.textColor, textColor = _theme$mode$productHo5 === void 0 ? theme.mode.productHome.color : _theme$mode$productHo5;
    var Tag = (0, $72mK3.getTag)(onClick, href);
    var preventFocusRing = function preventFocusRing(e) {
        e.preventDefault();
        onMouseDown && onMouseDown(e);
    };
    var productHomeButtonDynamicStyles = (_productHomeButtonDyn = {}, (0, $eYHx9.default)(_productHomeButtonDyn, $994dd483444574d9$var$VAR_PRODUCT_HOME_COLOR_ACTIVE, primaryButton.active.color), (0, $eYHx9.default)(_productHomeButtonDyn, $994dd483444574d9$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE, primaryButton.active.backgroundColor), (0, $eYHx9.default)(_productHomeButtonDyn, $994dd483444574d9$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE, primaryButton.active.boxShadow), (0, $eYHx9.default)(_productHomeButtonDyn, $994dd483444574d9$var$VAR_PRODUCT_HOME_COLOR_FOCUS, primaryButton.focus.color), (0, $eYHx9.default)(_productHomeButtonDyn, $994dd483444574d9$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS, primaryButton.focus.backgroundColor), (0, $eYHx9.default)(_productHomeButtonDyn, $994dd483444574d9$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS, primaryButton.focus.boxShadow), (0, $eYHx9.default)(_productHomeButtonDyn, $994dd483444574d9$var$VAR_PRODUCT_HOME_COLOR_HOVER, primaryButton.hover.color), (0, $eYHx9.default)(_productHomeButtonDyn, $994dd483444574d9$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER, primaryButton.hover.backgroundColor), (0, $eYHx9.default)(_productHomeButtonDyn, $994dd483444574d9$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER, primaryButton.hover.boxShadow), (0, $eYHx9.default)(_productHomeButtonDyn, $994dd483444574d9$var$VAR_LOGO_MAX_WIDTH, "".concat(logoMaxWidth, "px")), _productHomeButtonDyn);
    return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, (0, $3dJ4i.jsx)(Tag, (0, $dX2dk.default)({
        style: productHomeButtonDynamicStyles,
        css: $994dd483444574d9$var$productHomeButtonStyles,
        href: href,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && "".concat(testId, "-container")
    }, rest), (0, $3dJ4i.jsx)("div", {
        css: [
            $994dd483444574d9$var$customMaxHeightStyles,
            $994dd483444574d9$var$productLogoStyles
        ],
        "data-testid": testId && "".concat(testId, "-logo")
    }, (0, $3dJ4i.jsx)(Logo, {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor
    })), (0, $3dJ4i.jsx)("div", {
        css: [
            $994dd483444574d9$var$customMaxHeightStyles,
            $994dd483444574d9$var$productIconStyles
        ],
        "data-testid": testId && "".concat(testId, "-icon")
    }, (0, $3dJ4i.jsx)(Icon, {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    }))), siteTitle && (0, $3dJ4i.jsx)("div", {
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: [
            $994dd483444574d9$var$siteTitleStyles,
            (0, $6DIEl.getBooleanFF)('platform.design-system-team.navigation-v2-no-jank_5yhbd') && $994dd483444574d9$var$featureFlaggedSiteTitleStyles
        ],
        "data-testid": testId && "".concat(testId, "-site-title")
    }, siteTitle));
};
var $994dd483444574d9$export$2e2bcd8739ae039 = $994dd483444574d9$var$ProductHome;

});
parcelRegister("72mK3", function(module, exports) {
$parcel$export(module.exports, "getTag", function () { return $51fa5c5935ce01de$export$dad497fe1f6e27c0; });
var $51fa5c5935ce01de$export$dad497fe1f6e27c0 = function getTag(onClick, href) {
    if (href) return 'a';
    if (onClick) return 'button';
    return 'div';
};

});


parcelRegister("3T4xT", function(module, exports) {
$parcel$export(module.exports, "Profile", function () { return $2d4a08ce56b17945$export$5120f2d0b8d4cab8; });

var $dX2dk = parcelRequire("dX2dk");

var $1oC0p = parcelRequire("1oC0p");

var $dzMzP = parcelRequire("dzMzP");
var $2d4a08ce56b17945$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var labelProp = props.label, tooltip = props.tooltip;
    var label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    // All other implementations of IconButton within the components are using spread props, so
    // to use explicit props could cause regressions.
    // TODO: Remove these spread props for better static analysis
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $dzMzP.IconButton), (0, $dX2dk.default)({
        label: label,
        ref: ref
    }, props)));
});
var // This exists only to extract props.
// eslint-disable-next-line @repo/internal/react/use-noop
$2d4a08ce56b17945$export$2e2bcd8739ae039 = function(props) {};

});

parcelRegister("eI459", function(module, exports) {
$parcel$export(module.exports, "Search", function () { return $ab585763a2cf18fa$export$4b85d3515bd863a5; });

var $dX2dk = parcelRequire("dX2dk");

var $faFp0 = parcelRequire("faFp0");

var $eYHx9 = parcelRequire("eYHx9");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $jXNrD = parcelRequire("jXNrD");

var $4eREm = parcelRequire("4eREm");

var $2zyTy = parcelRequire("2zyTy");

var $dzMzP = parcelRequire("dzMzP");
var $ab585763a2cf18fa$var$_excluded = [
    "placeholder",
    "tooltip",
    "label",
    "value"
];
var $ab585763a2cf18fa$var$searchInputContainerStyles = (0, $3dJ4i.css)((0, $eYHx9.default)({
    position: 'relative',
    marginInlineEnd: "var(--ds-space-100, 8px)",
    marginInlineStart: "var(--ds-space-250, 20px)"
}, "@media (max-width: ".concat((0, $4eREm.CREATE_BREAKPOINT) - 1, "px)"), {
    display: 'none !important'
}));
var $ab585763a2cf18fa$var$searchInputIconStyles = (0, $3dJ4i.css)({
    width: '20px',
    height: '20px',
    position: 'absolute',
    insetBlockStart: '5px',
    insetInlineStart: '10px',
    pointerEvents: 'none'
});
var $ab585763a2cf18fa$var$newSearchBorderStyles = (0, $3dJ4i.css)({
    border: "var(--ds-border-width, 1px)".concat(" solid"),
    '&:focus': {
        boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " var(", (0, $4eREm.varSearchFocusBorderColor), ")")
    }
});
var $ab585763a2cf18fa$var$searchInputStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    width: '220px',
    height: "var(--ds-space-400, 32px)",
    padding: "0 ".concat("var(--ds-space-100, 8px)", " 0 ", "var(--ds-space-500, 40px)"),
    backgroundColor: "var(".concat((0, $4eREm.varSearchBackgroundColor), ")"),
    border: '2px solid',
    borderColor: "var(".concat((0, $4eREm.varSearchBorderColor), ")"),
    borderRadius: "var(--ds-border-radius-200, 6px)",
    color: "var(".concat((0, $4eREm.varSearchColor), ")"),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    outline: 'none',
    '::placeholder': {
        color: 'inherit'
    },
    '&:focus': {
        borderColor: "var(".concat((0, $4eREm.varSearchFocusBorderColor), ")")
    },
    '&:hover': {
        backgroundColor: "var(".concat((0, $4eREm.varSearchHoverBackgroundColor), ")")
    }
});
var $ab585763a2cf18fa$var$searchIconStyles = (0, $3dJ4i.css)((0, $eYHx9.default)({}, "@media (min-width: ".concat((0, $4eREm.CREATE_BREAKPOINT), "px)"), {
    display: 'none !important'
}));
var $ab585763a2cf18fa$var$SearchComponent = function SearchComponent(props) {
    var _searchInputDynamicSt;
    var onClick = props.onClick, placeholder = props.placeholder, label = props.label, value = props.value;
    var theme = (0, $2zyTy.useTheme)();
    var search = theme.mode.search;
    var onChange = function onChange() {
        // @ts-expect-error
        onClick && onClick.apply(void 0, arguments);
    };
    var onInputClick = function onInputClick() {
        // @ts-expect-error
        onClick && onClick.apply(void 0, arguments);
    };
    var searchInputDynamicStyles = (_searchInputDynamicSt = {}, (0, $eYHx9.default)(_searchInputDynamicSt, (0, $4eREm.varSearchBackgroundColor), search.default.backgroundColor), (0, $eYHx9.default)(_searchInputDynamicSt, (0, $4eREm.varSearchColor), search.default.color), (0, $eYHx9.default)(_searchInputDynamicSt, (0, $4eREm.varSearchBorderColor), search.default.borderColor), (0, $eYHx9.default)(_searchInputDynamicSt, (0, $4eREm.varSearchFocusBorderColor), search.focus.borderColor), (0, $eYHx9.default)(_searchInputDynamicSt, (0, $4eREm.varSearchHoverBackgroundColor), search.hover.backgroundColor), _searchInputDynamicSt);
    return (0, $3dJ4i.jsx)("div", {
        css: $ab585763a2cf18fa$var$searchInputContainerStyles,
        role: "search"
    }, (0, $3dJ4i.jsx)("div", {
        css: $ab585763a2cf18fa$var$searchInputIconStyles
    }, (0, $3dJ4i.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jXNrD))), {
        label: ""
    })), (0, $3dJ4i.jsx)("input", {
        style: searchInputDynamicStyles,
        css: [
            $ab585763a2cf18fa$var$searchInputStyles,
            $ab585763a2cf18fa$var$newSearchBorderStyles
        ],
        "aria-label": label,
        placeholder: placeholder,
        onChange: onChange,
        onClick: onInputClick,
        value: value
    }));
};
var $ab585763a2cf18fa$export$4b85d3515bd863a5 = function Search(props) {
    var placeholder = props.placeholder, tooltip = props.tooltip, label = props.label, value = props.value, iconButtonProps = (0, $faFp0.default)(props, $ab585763a2cf18fa$var$_excluded);
    return (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, (0, $3dJ4i.jsx)($ab585763a2cf18fa$var$SearchComponent, {
        onClick: iconButtonProps.onClick,
        placeholder: placeholder,
        label: label,
        value: value || ''
    }), (0, $3dJ4i.jsx)((0, $dzMzP.IconButton), (0, $dX2dk.default)({
        css: $ab585763a2cf18fa$var$searchIconStyles,
        icon: (0, $3dJ4i.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jXNrD))), {
            label: label
        }),
        tooltip: tooltip
    }, iconButtonProps)));
};
var $ab585763a2cf18fa$export$2e2bcd8739ae039 = $ab585763a2cf18fa$export$4b85d3515bd863a5;

});
parcelRegister("jXNrD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e889e1b08b2386e0$var$_react = $e889e1b08b2386e0$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $rRAiF = parcelRequire("rRAiF");
function $e889e1b08b2386e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e889e1b08b2386e0$var$SearchIcon = (props)=>/*#__PURE__*/ $e889e1b08b2386e0$var$_react.default.createElement($rRAiF.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M16.436 15.085l3.94 4.01a1 1 0 01-1.425 1.402l-3.938-4.006a7.5 7.5 0 111.423-1.406zM10.5 16a5.5 5.5 0 100-11 5.5 5.5 0 000 11z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$e889e1b08b2386e0$var$SearchIcon.displayName = 'SearchIcon';
var $e889e1b08b2386e0$var$_default = $e889e1b08b2386e0$var$SearchIcon;
module.exports.default = $e889e1b08b2386e0$var$_default;

});


parcelRegister("lGRrf", function(module, exports) {
$parcel$export(module.exports, "Settings", function () { return $fca6f903170cc10c$export$c72f6eaae7b9adff; });

var $dX2dk = parcelRequire("dX2dk");

var $faFp0 = parcelRequire("faFp0");

var $1oC0p = parcelRequire("1oC0p");

var $aWRp5 = parcelRequire("aWRp5");

var $dzMzP = parcelRequire("dzMzP");
var $fca6f903170cc10c$var$_excluded = [
    "tooltip"
];
var $fca6f903170cc10c$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(props, ref) {
    var tooltip = props.tooltip, iconButtonProps = (0, $faFp0.default)(props, $fca6f903170cc10c$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $dzMzP.IconButton), (0, $dX2dk.default)({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWRp5))), {
            label: typeof tooltip === 'string' ? tooltip : 'Settings Icon'
        }),
        ref: ref,
        tooltip: tooltip
    }, iconButtonProps)));
});
var $fca6f903170cc10c$export$2e2bcd8739ae039 = $fca6f903170cc10c$export$c72f6eaae7b9adff;

});
parcelRegister("aWRp5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f88bf0683389672$var$_react = $7f88bf0683389672$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $rRAiF = parcelRequire("rRAiF");
function $7f88bf0683389672$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7f88bf0683389672$var$SettingsIcon = (props)=>/*#__PURE__*/ $7f88bf0683389672$var$_react.default.createElement($rRAiF.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.701 16.7a5.002 5.002 0 110-10.003 5.002 5.002 0 010 10.004m8.368-3.117a1.995 1.995 0 01-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 00.315-.574 8.947 8.947 0 00-.836-1.993.477.477 0 00-.598-.195 2.04 2.04 0 01-1.29.08 1.988 1.988 0 01-1.404-1.395 2.04 2.04 0 01.076-1.297.478.478 0 00-.196-.597 8.98 8.98 0 00-1.975-.826.479.479 0 00-.574.314 1.995 1.995 0 01-1.885 1.346 1.994 1.994 0 01-1.884-1.345.482.482 0 00-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 00-.198.582A2.002 2.002 0 014.445 7.06a.478.478 0 00-.595.196 8.946 8.946 0 00-.833 1.994.48.48 0 00.308.572 1.995 1.995 0 011.323 1.877c0 .867-.552 1.599-1.324 1.877a.479.479 0 00-.308.57 8.99 8.99 0 00.723 1.79.477.477 0 00.624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 00.168.628 8.946 8.946 0 002.11.897.474.474 0 00.57-.313 1.995 1.995 0 011.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 00.57.313 8.964 8.964 0 002.084-.883.473.473 0 00.167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 00.628-.19 8.925 8.925 0 00.728-1.793.478.478 0 00-.314-.573" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$7f88bf0683389672$var$SettingsIcon.displayName = 'SettingsIcon';
var $7f88bf0683389672$var$_default = $7f88bf0683389672$var$SettingsIcon;
module.exports.default = $7f88bf0683389672$var$_default;

});





parcelRegister("2opLs", function(module, exports) {
$parcel$export(module.exports, "PaidAccountCreation", function () { return $d7f434f81ff32590$export$8cfb1818275d36da; });
/* paid-account-creation.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $ig7Vf = parcelRequire("ig7Vf");

var $gSzjE = parcelRequire("gSzjE");

var $jVa6Y = parcelRequire("jVa6Y");

var $7VwhR = parcelRequire("7VwhR");

var $doAVE = parcelRequire("doAVE");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $gx3aw = parcelRequire("gx3aw");

var $ea4mV = parcelRequire("ea4mV");

var $32ng3 = parcelRequire("32ng3");

var $1ka2O = parcelRequire("1ka2O");

var $bCs1B = parcelRequire("bCs1B");

var $l7ZAy = parcelRequire("l7ZAy");

var $3Souq = parcelRequire("3Souq");
const $d7f434f81ff32590$export$8cfb1818275d36da = ({ darkSolidTheme: darkSolidTheme, showFourSocialButtons: showFourSocialButtons, auxiaResponse: auxiaResponse, pageId: pageId })=>{
    const { product: product } = (0, $doAVE.useUserContext)();
    const i18n = (0, $8e22h.default)();
    const location = (0, $1ka2O.useLocation)();
    const jiraPlusExperiment = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).twcg1444JiraPlusOptIn);
    const jiraPlusExperimentPaid = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).twcg1444JiraPlusOptInPaid);
    const jiraPlusPage = (0, $kooLp.useLocalizedHref)("/software/jira/free");
    const getContinueUrl = ()=>{
        if (pageId === (0, $7VwhR.JIRA_PAID_FEATURES_PAGE_ID)) {
            if (jiraPlusExperiment.type === (0, $ea4mV.EnrollmentType).ENROLLED) {
                jiraPlusExperiment.fireExposure();
                if (jiraPlusExperiment.value) return `${(0, $7VwhR.getWacIntegrationUrl)()}${jiraPlusPage}`;
            }
        } else if (jiraPlusExperimentPaid.type === (0, $ea4mV.EnrollmentType).ENROLLED) {
            jiraPlusExperimentPaid.fireExposure();
            if (jiraPlusExperimentPaid.value) return `${(0, $7VwhR.getWacIntegrationUrl)()}${jiraPlusPage}?${0, $7VwhR.JIRA_PLUS_PAID_PARAM}=${0, $7VwhR.JIRA_PLUS_PAID_VALUE}`;
        }
    };
    const isAuxiaPage = (0, $doAVE.useJiraServiceManagementIntent)() && (0, $ig7Vf.isAuxiaServedPage)(auxiaResponse);
    const logInLink = (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
            text: text,
            "aria-label": text,
            type: "inline",
            href: (0, $7VwhR.getLoginUrl)(location),
            onClick: ()=>{
                if (isAuxiaPage) {
                    const anonymousId = decodeURIComponent((0, $gx3aw.Cookie).readCookie("ajs_anonymous_id") || "").replace(/['"]+/g, "");
                    (0, $gSzjE.sendAnalyticsToAuxia)({
                        anonymousId: anonymousId,
                        treatmentTrackingId: auxiaResponse.treatmentTrackingId,
                        treatmentId: auxiaResponse.treatmentId,
                        interactionType: "CLICKED",
                        interactionTimeMicros: (0, $gSzjE.convertDateTimeToInteractionTimeMicros)(Date.now()),
                        actionName: "login_button"
                    });
                }
            }
        });
    const enableCustomerServiceManagementVariant = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).enableCsmAjLogo) && pageId === "anchor-lp-jsm-csm";
    const loginText = i18n.formatMessage({
        id: "BxpUiSignup.SignupForm.existingProduct.confluence.embedded",
        defaultMessage: "Trying to access {product}? <logInLink>Log in</logInLink>"
    }, {
        product: enableCustomerServiceManagementVariant ? "Customer Service Management" : product === null || product === void 0 ? void 0 : product.description,
        logInLink: logInLink
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVa6Y.default), {
        getContinueUrl: getContinueUrl,
        Input: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                darkSolidTheme && "_ie4m121t _frvh121t _q7r4cd5j",
                !darkSolidTheme && "_frvh1p0d _ie4m1cjc"
            ]),
            style: {
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVa6Y.Input), {})
        }),
        Login: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_26vxviql",
                darkSolidTheme && "_43ds121t"
            ]),
            style: {
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
            },
            children: [
                enableCustomerServiceManagementVariant ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                    className: (0, $2jatx.default)([
                        "_1wyb12re _19pk14b4 _2hwxgrf3 _otyrgrf3 _18u0grf3 _y3gn1e5h"
                    ]),
                    style: {
                        "--_58aws": (0, $6ZVlx.default)((0, $7VwhR.fontSize).lg)
                    },
                    children: "Join the 300K+ customers that trust Atlassian to power team collaboration"
                }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bCs1B.AnimatedSocialProof), {}),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVa6Y.Login), {
                    loginText: loginText
                })
            ]
        }),
        Social: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                showFourSocialButtons && "_jk741ezz _zs121ylp _1b94glyw"
            ]),
            children: [
                !isAuxiaPage && !showFourSocialButtons && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVa6Y.Social), {
                    providers: {
                        google: "Google",
                        microsoft: "Microsoft"
                    }
                }),
                !isAuxiaPage && showFourSocialButtons && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVa6Y.Social), {}),
                isAuxiaPage && !showFourSocialButtons && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l7ZAy.AuxiaSocial), {
                    providers: {
                        google: "Google",
                        microsoft: "Microsoft"
                    },
                    auxiaResponse: auxiaResponse
                }),
                isAuxiaPage && showFourSocialButtons && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l7ZAy.AuxiaSocial), {})
            ]
        }),
        Submit: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                darkSolidTheme && "_7dirhyuj _d32v16l4 _6pup1s4t _4pkp16l4"
            ]),
            style: {
                "--_1f8eaoq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.yellow400"))
            },
            children: [
                !isAuxiaPage && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVa6Y.Submit), {}),
                isAuxiaPage && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3Souq.AuxiaSubmit), {
                    auxiaResponse: auxiaResponse
                })
            ]
        })
    });
};
const $d7f434f81ff32590$var$socialWrapperStyle = null;
const $d7f434f81ff32590$var$loginSocialProofCss = null;
const $d7f434f81ff32590$var$yellowButtonCss = null;
const $d7f434f81ff32590$var$whiteLinkCss = null;
const $d7f434f81ff32590$var$whiteTextCss = null;
const $d7f434f81ff32590$var$darkGrayTextCss = null;
const $d7f434f81ff32590$var$existingProductCss = null;

});
parcelRegister("ig7Vf", function(module, exports) {
$parcel$export(module.exports, "isAuxiaServedPage", function () { return $13d3bb964979ef44$export$d387d4c6b79063ea; });
$parcel$export(module.exports, "isAuxiaResponseMalformed", function () { return $13d3bb964979ef44$export$b9e49162afc62078; });

var $32ng3 = parcelRequire("32ng3");
function $13d3bb964979ef44$var$isValidAuxiaResponse(auxiaResponse) {
    return auxiaResponse !== null && auxiaResponse !== undefined && typeof auxiaResponse.treatmentId === "string" && typeof auxiaResponse.treatmentTrackingId === "string" && auxiaResponse.treatmentId.length > 0 && auxiaResponse.treatmentTrackingId.length > 0 && Array.isArray(auxiaResponse.auxiaTreatment) && auxiaResponse.auxiaTreatment.length > 0;
}
const $13d3bb964979ef44$export$d387d4c6b79063ea = (auxiaResponse)=>{
    const usingAuxiaTreatment = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).jsmPaidLpAuxiaIntegration);
    return usingAuxiaTreatment && $13d3bb964979ef44$var$isValidAuxiaResponse(auxiaResponse);
};
const $13d3bb964979ef44$export$b9e49162afc62078 = (auxiaResponse)=>{
    const usingAuxiaTreatment = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).jsmPaidLpAuxiaIntegration);
    return usingAuxiaTreatment && !$13d3bb964979ef44$var$isValidAuxiaResponse(auxiaResponse);
};

});

parcelRegister("gSzjE", function(module, exports) {
$parcel$export(module.exports, "convertDateTimeToInteractionTimeMicros", function () { return $cc4cbbe75ecd9df3$export$1219d02973c84a52; });
$parcel$export(module.exports, "sendAnalyticsToAuxia", function () { return $cc4cbbe75ecd9df3$export$3d1788c6d7ad0255; });
const $cc4cbbe75ecd9df3$var$setWindowAnalyticsObject = ({ interactionType: interactionType, wasSent: wasSent })=>{
    if (interactionType === "VIEWED") // @ts-ignore
    window.sentViewedAuxiaAnalytics = wasSent.toString();
    else if (interactionType === "CLICKED") // @ts-ignore
    window.sentClickedAuxiaAnalytics = wasSent.toString();
};
const $cc4cbbe75ecd9df3$export$1219d02973c84a52 = (dateTime)=>{
    const microSeconds = dateTime * 1000;
    return microSeconds.toString();
};
const $cc4cbbe75ecd9df3$export$3d1788c6d7ad0255 = async ({ anonymousId: anonymousId, treatmentTrackingId: treatmentTrackingId, treatmentId: treatmentId, interactionType: interactionType, interactionTimeMicros: interactionTimeMicros, actionName: actionName })=>{
    const url = "https://apis.auxia.io/v1/LogTreatmentInteraction";
    const auxiaRequest = {
        projectId: "1921",
        userId: anonymousId,
        treatmentTrackingId: treatmentTrackingId,
        treatmentId: treatmentId,
        surface: "LANDING_PAGE_JSM",
        interactionType: interactionType,
        interactionTimeMicros: interactionTimeMicros,
        languageCode: "en",
        actionName: actionName || ""
    };
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-api-key": "AIzaSyCUlO-ukAKTA1Khu87fez3UspN5PEtFOsY"
            },
            body: JSON.stringify(auxiaRequest)
        });
        const data = await response.json();
        const stringData = JSON.stringify(data);
        const responseContainsError = stringData !== "{}";
        if (responseContainsError) throw Error(`Auxia did not properly receive analytics: ${stringData}`);
        $cc4cbbe75ecd9df3$var$setWindowAnalyticsObject({
            interactionType: interactionType,
            wasSent: true
        });
    } catch (e) {
        console.error(`sendAnalyticsToAuxia call error:
                        Request Body: ${JSON.stringify(auxiaRequest)}
                        Error: ${e}
                    `);
    }
};

});

parcelRegister("bCs1B", function(module, exports) {
$parcel$export(module.exports, "AnimatedSocialProof", function () { return $cda7c4fda7a7cb96$export$b9b8b5eca0edeb76; });
/* animated-social-proof.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
parcelRequire("lXokJ");
var $bmyHB = parcelRequire("bmyHB");
var $2KJKq = parcelRequire("2KJKq");
var $8Uvps = parcelRequire("8Uvps");
var $ecrbE = parcelRequire("ecrbE");
var $kEiKm = parcelRequire("kEiKm");
var $keghS = parcelRequire("keghS");
var $helsO = parcelRequire("helsO");
const $cda7c4fda7a7cb96$var$carouselCss = null;
const $cda7c4fda7a7cb96$var$trackCss = null;
const $cda7c4fda7a7cb96$var$imageCss = null;
const $cda7c4fda7a7cb96$var$logos = [
    (0, $2KJKq.DominosLogo),
    (0, $helsO.SquareLogo),
    (0, $8Uvps.EbayLogo),
    (0, $bmyHB.CiscoLogo),
    (0, $ecrbE.FordLogo),
    (0, $keghS.PaypalLogo),
    (0, $kEiKm.NasaLogo)
];
const $cda7c4fda7a7cb96$export$b9b8b5eca0edeb76 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "animated-social-proof",
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _4t3ildb6 _kqswh2mm _1bsb1osq _1mjbglyw"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_y44v9j94 _1e0c1txw _kqswstnw"
            ]),
            children: [
                ...$cda7c4fda7a7cb96$var$logos,
                ...$cda7c4fda7a7cb96$var$logos
            ].map((Logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4t3ildb6 _1bsbymf6 _12l2zwfg"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)(Logo, {})
                }, index))
        })
    });

});
parcelRegister("lXokJ", function(module, exports) {
$parcel$export(module.exports, "CiscoLogo", function () { return (parcelRequire("bmyHB")).CiscoLogo; });
$parcel$export(module.exports, "DominosLogo", function () { return (parcelRequire("2KJKq")).DominosLogo; });
$parcel$export(module.exports, "EbayLogo", function () { return (parcelRequire("8Uvps")).EbayLogo; });
$parcel$export(module.exports, "FordLogo", function () { return (parcelRequire("ecrbE")).FordLogo; });
$parcel$export(module.exports, "NasaLogo", function () { return (parcelRequire("kEiKm")).NasaLogo; });
$parcel$export(module.exports, "PaypalLogo", function () { return (parcelRequire("keghS")).PaypalLogo; });
$parcel$export(module.exports, "SquareLogo", function () { return (parcelRequire("helsO")).SquareLogo; });
parcelRequire("bmyHB");
parcelRequire("2KJKq");
parcelRequire("8Uvps");
parcelRequire("ecrbE");
parcelRequire("kEiKm");
parcelRequire("keghS");
parcelRequire("helsO");

});
parcelRegister("bmyHB", function(module, exports) {
$parcel$export(module.exports, "CiscoLogo", function () { return $85f2815b49fbc3e5$export$c0ee1f55c8145cdb; });

var $7VQPk = parcelRequire("7VQPk");
const $85f2815b49fbc3e5$export$c0ee1f55c8145cdb = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 79 42",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.2429424,41.0366151 L25.691892,41.0366151 L25.691892,27.4402999 L22.2429424,27.4402999 L22.2429424,41.0366151 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M53.4978468,31.3359257 C53.356853,31.2637727 52.2457684,30.6093615 50.5963441,30.6093615 C48.3677661,30.6093615 46.8208827,32.1541075 46.8208827,34.236813 C46.8208827,36.2574334 48.300305,37.8659425 50.5963441,37.8659425 C52.2181094,37.8659425 53.3463965,37.2252908 53.4978468,37.1447479 L53.4978468,40.7936775 C53.0644091,40.9148275 51.8878872,41.2782774 50.3561825,41.2782774 C46.4764936,41.2782774 43.0720684,38.6176764 43.0720684,34.236813 C43.0720684,30.1757722 46.1526803,27.1987047 50.3561825,27.1987047 C51.9728882,27.1987047 53.1716723,27.590009 53.4978468,27.6863249 L53.4978468,31.3359257 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M17.5025508,31.3359257 C17.3639182,31.2637727 16.2551948,30.6093615 14.6057704,30.6093615 C12.3721328,30.6093615 10.8262613,32.1541075 10.8262613,34.236813 C10.8262613,36.2574334 12.3077075,37.8659425 14.6057704,37.8659425 C16.2271984,37.8659425 17.354811,37.2252908 17.5025508,37.1447479 L17.5025508,40.7936775 C17.07451,40.9148275 15.8983255,41.2782774 14.3581881,41.2782774 C10.481535,41.2782774 7.08115739,38.6176764 7.08115739,34.236813 C7.08115739,30.1757722 10.161432,27.1987047 14.3581881,27.1987047 C15.9802907,27.1987047 17.1787375,27.590009 17.5025508,27.6863249 L17.5025508,31.3359257 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M64.3466401,30.6607076 C62.3008817,30.6607076 60.78132,32.2621693 60.78132,34.236813 C60.78132,36.215484 62.3008817,37.8156032 64.3466401,37.8156032 C66.3900373,37.8156032 67.9136467,36.215484 67.9136467,34.236813 C67.9136467,32.2621693 66.3900373,30.6607076 64.3466401,30.6607076 M71.5673408,34.236813 C71.5673408,38.1263646 68.5491304,41.2782774 64.3466401,41.2782774 C60.1438125,41.2782774 57.1293124,38.1263646 57.1293124,34.236813 C57.1293124,30.3529666 60.1438125,27.1987047 64.3466401,27.1987047 C68.5491304,27.1987047 71.5673408,30.3529666 71.5673408,34.236813"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M38.7701066,30.5307315 C38.7188362,30.5142873 37.2663983,30.1155999 36.0736858,30.1155999 C34.6917448,30.1155999 33.9412398,30.5760369 33.9412398,31.2301125 C33.9412398,32.0583621 34.9541685,32.3459674 35.5221911,32.5245042 L36.4730556,32.8262046 C38.7117528,33.5339754 39.7310902,35.0592569 39.7310902,36.7154206 C39.7310902,40.1307757 36.7125425,41.2781767 34.0734636,41.2781767 C32.2381839,41.2781767 30.5206239,40.9425812 30.3512965,40.9070081 L30.3512965,37.7779159 C30.6552088,37.8544316 32.1012378,38.2843294 33.6079819,38.2843294 C35.3231808,38.2843294 36.1124759,37.7839566 36.1124759,37.0144361 C36.1124759,36.325123 35.4297694,35.9271068 34.575037,35.6596372 C34.3655703,35.5905045 34.0518761,35.4928462 33.8383616,35.4237136 C31.917069,34.8189705 30.316554,33.6964036 30.316554,31.4459004 C30.316554,28.9027578 32.229414,27.1945769 35.4085191,27.1945769 C37.0876263,27.1945769 38.6672284,27.5999762 38.7701066,27.6278306 L38.7701066,30.5307315 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M3.42405648,12.8286741 C3.42405648,11.8910203 2.65567435,11.1308966 1.71223062,11.1308966 C0.770136118,11.1308966 6.74611175e-05,11.8910203 6.74611175e-05,12.8286741 L6.74611175e-05,16.3970608 C6.74611175e-05,17.3397485 0.770136118,18.0998723 1.71223062,18.0998723 C2.65567435,18.0998723 3.42405648,17.3397485 3.42405648,16.3970608 L3.42405648,12.8286741 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M12.8283386,8.14366055 C12.8283386,7.20667798 12.0596192,6.44521184 11.1165128,6.44521184 C10.1734064,6.44521184 9.40434963,7.20667798 9.40434963,8.14366055 L9.40434963,16.3969601 C9.40434963,17.3396478 10.1734064,18.0997716 11.1165128,18.0997716 C12.0596192,18.0997716 12.8283386,17.3396478 12.8283386,16.3969601 L12.8283386,8.14366055 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.2328907,1.73395472 C22.2328907,0.796972141 21.4634966,0.0368483835 20.5203902,0.0368483835 C19.5776211,0.0368483835 18.808227,0.796972141 18.808227,1.73395472 L18.808227,19.789327 C18.808227,20.7310079 19.5776211,21.4918029 20.5203902,21.4918029 C21.4634966,21.4918029 22.2328907,20.7310079 22.2328907,19.789327 L22.2328907,1.73395472 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.6367681,8.14366055 C31.6367681,7.20667798 30.8677113,6.44521184 29.9242676,6.44521184 C28.9814985,6.44521184 28.212779,7.20667798 28.212779,8.14366055 L28.212779,16.3969601 C28.212779,17.3396478 28.9814985,18.0997716 29.9242676,18.0997716 C30.8677113,18.0997716 31.6367681,17.3396478 31.6367681,16.3969601 L31.6367681,8.14366055 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M41.0304588,12.8286741 C41.0304588,11.8910203 40.266799,11.1308966 39.3284148,11.1308966 C38.385983,11.1308966 37.6169263,11.8910203 37.6169263,12.8286741 L37.6169263,16.3970608 C37.6169263,17.3397485 38.385983,18.0998723 39.3284148,18.0998723 C40.266799,18.0998723 41.0304588,17.3397485 41.0304588,16.3970608 L41.0304588,12.8286741 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M50.4383164,8.14366055 C50.4383164,7.20667798 49.6746566,6.44521184 48.7318875,6.44521184 C47.7911422,6.44521184 47.0254585,7.20667798 47.0254585,8.14366055 L47.0254585,16.3969601 C47.0254585,17.3396478 47.7911422,18.0997716 48.7318875,18.0997716 C49.6746566,18.0997716 50.4383164,17.3396478 50.4383164,16.3969601 L50.4383164,8.14366055 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M59.8490074,1.73395472 C59.8490074,0.796972141 59.0846729,0.0368483835 58.1425784,0.0368483835 C57.1987974,0.0368483835 56.4354748,0.796972141 56.4354748,1.73395472 L56.4354748,19.789327 C56.4354748,20.7310079 57.1987974,21.4918029 58.1425784,21.4918029 C59.0846729,21.4918029 59.8490074,20.7310079 59.8490074,19.789327 L59.8490074,1.73395472 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M69.2578432,8.14366055 C69.2578432,7.20667798 68.4941833,6.44521184 67.5298267,6.44521184 C66.5863829,6.44521184 65.8227231,7.20667798 65.8227231,8.14366055 L65.8227231,16.3969601 C65.8227231,17.3396478 66.5863829,18.0997716 67.5298267,18.0997716 C68.4941833,18.0997716 69.2578432,17.3396478 69.2578432,16.3969601 L69.2578432,8.14366055 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M78.6469129,12.8286741 C78.6469129,11.8910203 77.8808919,11.1308966 76.9404839,11.1308966 C75.9973775,11.1308966 75.2316938,11.8910203 75.2316938,12.8286741 L75.2316938,16.3970608 C75.2316938,17.3397485 75.9973775,18.0998723 76.9404839,18.0998723 C77.8808919,18.0998723 78.6469129,17.3397485 78.6469129,16.3970608 L78.6469129,12.8286741 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M76.6735065,39.2465823 L76.6735065,39.4596855 L76.0639953,39.4596855 L76.0639953,41.0366486 L75.8133773,41.0366486 L75.8133773,39.4596855 L75.2011676,39.4596855 L75.2011676,39.2465823 L76.6735065,39.2465823 Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M76.8013453,39.2465823 L77.1936317,39.2465823 L77.7312968,40.714477 L77.741416,40.714477 L78.2618785,39.2465823 L78.6467442,39.2465823 L78.6467442,41.0366486 L78.3893801,41.0366486 L78.3893801,39.5677472 L78.3809474,39.5677472 L77.835187,41.0366486 L77.5973865,41.0366486 L77.0644437,39.5677472 L77.052638,39.5677472 L77.052638,41.0366486 L76.8013453,41.0366486 L76.8013453,39.2465823 Z"
            })
        ]
    });

});

parcelRegister("2KJKq", function(module, exports) {
$parcel$export(module.exports, "DominosLogo", function () { return $23f7dfd84bf81e71$export$3a87515d6bae358a; });

var $7VQPk = parcelRequire("7VQPk");
const $23f7dfd84bf81e71$export$3a87515d6bae358a = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 2318.3 500",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1331.1,323.5c-25-58.4-111.2-40.3-134.8-2.8v-29.2h-75.1v207.1h77.8V394.4c0-38.9,8.3-41.7,29.2-43.1 c20.8-1.4,29.2,1.4,29.2,43.1l1.4,104.2h75.1v-107c0-19.5,4.2-37.5,25-37.5c25-1.4,30.6,1.4,30.6,32v114h79.2V345.7 C1470.1,272.1,1365.9,270.7,1331.1,323.5z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M986.4,276.2c-61.2,0-111.2,50-111.2,111.2s50,111.2,111.2,111.2s111.2-50,111.2-111.2 S1047.6,276.2,986.4,276.2z M986.4,426.3c-22.2,0-38.9-18.1-38.9-38.9c0-22.2,18.1-38.9,38.9-38.9c20.8,0,38.9,18.1,38.9,38.9 C1025.4,408.3,1007.3,426.3,986.4,426.3z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M775.2,224.8c-15.3-6.9-30.6-12.5-47.3-13.9c-23.6-2.8-47.3-4.2-70.9-4.2h-86.2v291.9h79.2 c26.4,0,52.8-1.4,77.8-4.2c16.7-2.8,33.4-6.9,48.6-13.9c23.6-12.5,44.5-30.6,59.8-52.8c27.8-45.9,27.8-104.2,0-150.1 C821.1,255.4,800.2,237.3,775.2,224.8z M765.5,387.4c-5.6,9.7-13.9,19.5-25,25c-5.6,2.8-12.5,5.6-19.5,6.9 c-11.1,1.4-20.8,2.8-32,1.4h-32V283.2h36.1c9.7,0,19.5,0,29.2,1.4c6.9,1.4,13.9,2.8,19.5,6.9c9.7,5.6,18.1,13.9,25,25 c5.6,11.1,8.3,23.6,8.3,34.7C773.8,363.8,771,376.3,765.5,387.4z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("rect", {
                x: 1502.1,
                y: 287.4,
                width: 77.8,
                height: 209.9
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M2140,245.7c2.8-12.5,2.8-26.4-2.8-37.5c-6.9-15.3-22.2-25-38.9-25c-19.5-1.4-37.5,12.5-41.7,30.6 c-5.6,22.2,6.9,44.5,29.2,51.4c5.6,1.4,11.1,0,6.9,6.9c-4.2,5.6-9.7,11.1-15.3,15.3l8.3,12.5 C2119.2,281.8,2135.9,263.7,2140,245.7z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1964.9,276.2c-61.2,0-111.2,50-111.2,111.2s50,111.2,111.2,111.2s111.2-50,111.2-111.2 S2026.1,276.2,1964.9,276.2z M1964.9,426.3c-22.2,0-38.9-18.1-38.9-38.9c0-20.8,18.1-38.9,38.9-38.9s38.9,18.1,38.9,38.9 C2003.8,408.3,1987.1,426.3,1964.9,426.3z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M2227.6,358.2c-38.9,0-36.1-26.4-12.5-27.8c25-1.4,50,5.6,69.5,20.8l25-48.6 c-68.1-40.3-183.5-34.7-186.2,38.9l0,0c-1.4,41.7,30.6,62.5,95.9,69.5c47.3,5.6,33.4,26.4,6.9,29.2c-26.4,2.8-51.4-9.7-77.8-25 l-33.4,50c91.7,58.4,198.7,32,202.9-36.1C2322.1,388.8,2290.1,356.8,2227.6,358.2z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1691.1,320.7v-29.2h-75.1v207.1h75.1V394.4c0-34.7,15.3-41.7,32-43.1c20.8-2.8,36.1,1.4,36.1,43.1l1.4,104.2 h75.1V347.1C1834.3,272.1,1720.3,272.1,1691.1,320.7z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1541,183.1c-23.6,0-43.1,19.5-43.1,43.1c0,23.6,19.5,43.1,43.1,43.1s43.1-19.5,43.1-43.1 C1584.1,202.6,1564.6,183.1,1541,183.1z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M494.4,151.1L348.5,5.2l0,0c-6.9-6.9-16.7-6.9-23.6,0L170.6,158.1l169.6,169.6l154.3-152.9l0,0 C501.4,167.8,501.4,158.1,494.4,151.1z M368,190.1c-16.7,16.7-43.1,16.7-58.4,0c-16.7-16.7-16.7-43.1,0-58.4l0,0 c16.7-16.7,43.1-16.7,58.4,0C383.3,147,383.3,173.4,368,190.1z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M160.9,169.2L5.2,323.5l0,0l0,0c-6.9,6.9-6.9,16.7,0,23.6l145.9,145.9l0,0c6.9,6.9,16.7,6.9,23.6,0L329,340.2 L160.9,169.2z M130.3,366.6c-16.7,15.3-43.1,15.3-58.4,0c-16.7-16.7-16.7-43.1,0-58.4s43.1-15.3,58.4,0 C145.6,323.5,145.6,349.9,130.3,366.6z M192.8,366.6c-16.7-15.3-16.7-43.1,0-58.4l0,0c16.7-16.7,43.1-16.7,58.4,0 c16.7,16.7,16.7,43.1,0,58.4C234.5,383.3,209.5,383.3,192.8,366.6z"
            })
        ]
    });

});

parcelRegister("8Uvps", function(module, exports) {
$parcel$export(module.exports, "EbayLogo", function () { return $31671601fcd49ae7$export$6e7d7fb1946ca256; });

var $7VQPk = parcelRequire("7VQPk");
const $31671601fcd49ae7$export$6e7d7fb1946ca256 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 100 44",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M13.039,8.84c-12.47,0-13,9.69-12.9,12.23,0,0-.62,11.35,12.58,11.35,11.35,0,11.89-7.12,11.89-7.12h-5.22s-1,3.94-6.67,3.83C5.469,29,5.2,21.95,5.2,21.95h20.11S26.829,8.84,13.039,8.84ZM5.389,18.5s.34-6.34,7.52-6.34,7.15,6.34,7.15,6.34Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M39.249,8.84c-6.26,0-9,3.72-9,3.72V0h-5l.08,26.51s0,3.08-.22,5.14h4.88l.21-3s2.28,3.75,8.94,3.75,11.92-4.09,12.05-11.7S45.549,8.86,39.249,8.84ZM38.1,29c-7.92.11-7.79-8.4-7.79-8.4s-.29-8.2,7.77-8.38,7.79,8.56,7.79,8.56S46.029,28.92,38.1,29Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M74.429,26.4c0-3.43.11-6.48,0-8.65-.13-2.52.11-8.54-10.7-9,0,0-10.39-.94-11.46,6.77h5.3s.4-3.54,5.81-3.43c5.08.11,6,2.6,6,5.68h-5.83c-2.63,0-11.84.3-12.69,5.92-1,6.67,4.92,8.73,9.58,8.7s7.31-1.42,9.27-3.91l.21,3.11h4.63S74.429,29.83,74.429,26.4Zm-13.14,2.81s-5,0-5.33-4c-.32-4.28,7.77-4,7.77-4h5.7S70.339,29.32,61.289,29.21Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("polygon", {
                points: "71.679 9.67 77.509 9.67 86.049 26.69 94.599 9.67 99.869 9.67 84.449 40 78.799 40 83.269 31.57 71.679 9.67"
            })
        ]
    });

});

parcelRegister("ecrbE", function(module, exports) {
$parcel$export(module.exports, "FordLogo", function () { return $81c63495eccae022$export$22ac95c9dec2accf; });

var $7VQPk = parcelRequire("7VQPk");
const $81c63495eccae022$export$22ac95c9dec2accf = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 500 175",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M250,1C112.68,1,1.37,39.72,1.37,87.51S112.68,174,250,174,498.63,135.3,498.63,87.51,387.31,1,250,1Zm0,165.58c-132.49,0-239.89-35.38-239.89-79S117.51,8.46,250,8.46,489.88,43.85,489.88,87.51,382.49,166.55,250,166.55Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M195.67,76.48c6.47-.82,16-1.73,22.16-2.08,1.36-.08,1.64-.06,2.19.61a20.27,20.27,0,0,0,5.91,4.77,4.58,4.58,0,0,0,2.12.78,2.7,2.7,0,0,0,2.07-1,2,2,0,0,0,.47-2.24c-.37-.64-4.63-3-4.77-3.95-.09-.61.58-.74.58-.74a13.9,13.9,0,0,0,8.37-6.81c1.95-3.74,2.27-8.72-1.29-11.48-3.13-2.45-7.85-2.05-11.61,1.32a14.05,14.05,0,0,0-4.4,12.24c.09.72,0,1-.94,1-5.66.45-11.12.61-17.18.93-.41,0-.54-.24-.3-.53,7-12.12,17.41-20.76,29-29.28.76-.57.52-1.67.49-2.58,20.84,4.52,41,12.95,62.58,12.78,8.94-.08,17.49-1.44,25.67-5.93,7.19-3.91,10.11-7.55,10.33-11.31.17-2.62-1.64-4.26-4.22-3.7-21.85,5-42.67,5-64.4,2.33-24.66-3-48.32-9.14-72.85-9.14-3.69,0-7.39.14-11.13.45-23.71,2-46.27,15.35-46.32,35.62,0,10.27,7.28,18.61,18.61,18.24,13.29-.46,24.22-11.11,29.95-24.54,2.17-5.11-1.85-7.22-3.77-4.29a33.85,33.85,0,0,1-13.42,12c-6.27,3.06-12.95,2.23-15-2.85-2.85-7.18,3.08-17.9,16.61-23,19.55-7.24,40-2.45,59.67,1.25.27,0,1.32.58.4,1.05a57,57,0,0,0-12.39,8.14A101.62,101.62,0,0,0,196,57.14c-3.9,4.74-6.67,9-10.32,13.67a1.44,1.44,0,0,1-1.11.64C175.61,73,166.9,74,158.92,79.51c-1.64,1.14-2.35,3.15-1.36,4.71a3.09,3.09,0,0,0,4.38.46,26.85,26.85,0,0,1,15.92-5.61c.25,0,.37.07.45.22a.48.48,0,0,1-.09.41c-8.77,12.17-11,14.92-17.56,22.46a128,128,0,0,1-10.4,10.55c-15,13.91-31.08,13.67-36.87,5a14.83,14.83,0,0,1-.73-15.29c2.79-5.59,8.41-9.67,13.1-12.06,1.74-.89,2.24-3.12.5-5.15-1.1-1.31-3.79-1.55-5.79-1.18-6.13,1.13-13.39,5.77-17.66,11.35a31,31,0,0,0-6.43,22.39c1.46,15.41,14.12,24.29,28.51,24.18,11.46-.09,22.24-3.55,35.22-16.73,12.09-12.29,23.12-30.63,33.45-47.66C193.88,77,194.12,76.67,195.67,76.48Zm30.49-17.79a3,3,0,0,1,3.94-.46c1.15,1,.61,3.43-.56,5.14a9.46,9.46,0,0,1-5.39,3.88H224c-.33,0-.6-.23-.75-1A8.77,8.77,0,0,1,226.16,58.69Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M404,58.15H390.71c-1,0-1.49.13-1.95,1-1.54,2.93-20.15,30.82-23.61,36.23-.57.82-1.29.7-1.38-.23-.34-3.22-3.12-6.91-7.5-8.68a18.91,18.91,0,0,0-10-1.15c-6.12.82-11.57,4-16.37,7.69-7.21,5.5-13.45,12.62-21.49,17.88C304,113.8,298,116.28,294,112.56c-3.64-3.38-3.23-10.88,2.33-16.69.6-.6,1.3-.09,1.19.45a7.36,7.36,0,0,0,2.12,7.07,7.9,7.9,0,0,0,8.88,1,11.59,11.59,0,0,0,6.18-8.91,10.16,10.16,0,0,0-9.32-11.57c-4.64-.32-9.08,1.29-13.4,4.87a25.5,25.5,0,0,0-5.28,5.8c-.47.65-1.17.72-1.14-.26.21-7.57-2.93-11.84-9.19-12-4.87-.11-10.06,2.52-14.12,5.76-4.43,3.56-8.32,8.28-12.48,12.73-.52.55-1,.52-1.11-.54-.13-5-1.4-9.89-3.72-13.34a3.08,3.08,0,0,0-4-1,29.48,29.48,0,0,0-4.72,2.82,2.67,2.67,0,0,0-.8,3A35.14,35.14,0,0,1,234.11,115c-2.79,6.61-8.23,12.55-14.61,14.58-4.2,1.32-8.58.67-11.29-3.06-3.71-5.14-2.21-14.1,3.32-21.52,4.9-6.55,12-10.7,19-13.39a1.1,1.1,0,0,0,.77-1.55c-.39-1.17-1-2.74-1.24-3.46-.66-1.72-2.46-2-4.68-1.76a39.6,39.6,0,0,0-14.31,4.8c-12,6.4-18,18.79-20.58,25.43a25.72,25.72,0,0,1-3.76,6.93c-1.88,2.36-4.25,4.52-8.58,8.32a1.55,1.55,0,0,0-.34,1.76c.44.9,2.7,4.08,3.32,4.38A2,2,0,0,0,183,136a44.67,44.67,0,0,0,8.42-7.52c.63-.74,1.26-.42,1.59.72A18.59,18.59,0,0,0,205,142c11,3.71,22.33-1.64,30.92-11,5.45-5.92,7.43-9.73,9.52-12.32C249,114.29,256,104.47,264.3,98.17c3.05-2.34,6.67-4.12,8.48-2.94,1.46,1,1.93,3.15-.41,7.4-8.49,15.5-21,33.72-23.27,38.13-.43.78,0,1.37.75,1.37,4.45,0,8.85,0,12.88,0a1.51,1.51,0,0,0,1.3-.81c6.52-10.2,12.65-19.9,19.22-29.94.37-.59.71-.13.72.13.15,2.32.71,5.51,2.1,7.6a11.38,11.38,0,0,0,9.9,5.56c3.11,0,4.69-.44,8-1.7a27.46,27.46,0,0,0,6.59-3.53c1-.69,1.16.46,1.13.64-1.51,8.09.36,17.68,8.41,21.66,9.62,4.74,20.2-1.92,26.3-7.95.58-.58,1.22-.52,1.29.73a11.07,11.07,0,0,0,3.07,7c5.1,5.11,15.39,3.08,25.72-4.92,6.63-5.11,13.58-12.35,19.84-20a.89.89,0,0,0,0-1.26c-1-1-2.33-2.13-3.28-3a1.18,1.18,0,0,0-1.43,0c-6.42,6.12-12.21,13.09-20.56,18.85-2.83,2-7.32,3.57-9.34.83-.79-1.06-.7-2.53.08-4.45,2.43-6.08,41-64.82,43-68.3C405.15,58.59,404.79,58.15,404,58.15ZM353.8,108.46c.08.46.66.89,1.23,1.09.21.07.32.23.1.69a59.09,59.09,0,0,1-5.2,8.61,32.38,32.38,0,0,1-6.62,7.14c-3,2.48-6.9,5.13-10.58,5.13a6.64,6.64,0,0,1-3.17-.76c-2-1-2.85-3.81-2.82-6.06.11-6.32,2.92-12.81,8.11-19.19,6.33-7.8,13.33-11.84,17.92-9.63,4.76,2.27,3.25,7.76,1.12,12.09A1.18,1.18,0,0,0,353.8,108.46Z"
            })
        ]
    });

});

parcelRegister("kEiKm", function(module, exports) {
$parcel$export(module.exports, "NasaLogo", function () { return $cf7af220a252a559$export$e44efe2f415651b3; });

var $7VQPk = parcelRequire("7VQPk");
const $cf7af220a252a559$export$e44efe2f415651b3 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "2.834 70.312 187.088 52.134",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M102.379 121.166h25.672c3.836 0 6.984-1.574 9.541-4.723 2.459-3.049 3.738-6.688 3.738-10.818 0-8.361-10.721-14.263-14.854-14.263h-14.065c-1.082 0-1.969-.492-2.656-1.278-.689-.886-1.082-1.869-1.082-3.05 0-1.377.393-2.557 1.082-3.541.787-.983 1.77-1.573 2.951-1.573h26.361V71.394h-26.854c-4.82 0-8.559 1.476-11.215 4.328-2.359 2.656-3.541 6.197-3.541 10.427 0 4.131 1.182 7.771 3.541 10.72 2.656 3.246 5.805 4.92 9.641 4.92h16.231c.982 0 1.77.295 2.359 1.08.689.787.984 1.771.984 2.854 0 1.279-.492 2.459-1.279 3.443-.885.885-1.869 1.377-3.146 1.377H99.82l-.393-.689-9.738-31.279-.492-.984c-2.361-4.82-6.295-7.18-11.705-7.18-2.951 0-5.607.688-7.968 2.164-2.459 1.475-4.033 3.639-4.918 6.394l-13.083 42.098 11.902.1 12-37.476c.295-1.181.984-1.771 1.869-1.771.492 0 .885.196 1.18.492.295.393.492.787.59 1.279l12.098 37.476h11.217v-.001zM13.851 86.739v34.328H2.834V83.001c0-4.918 1.181-8.361 3.738-10.426 1.967-1.476 4.918-2.263 9.049-2.263 3.344 0 6.197.984 8.754 2.853 2.557 1.869 4.229 4.426 5.115 7.574l7.18 25.279 1.181 3.443c.098.688.492 1.18.885 1.572.492.395.983.592 1.574.395.984-.098 1.476-.689 1.476-1.574V71.493h11.312v37.869c0 4.23-.983 7.379-3.049 9.641-1.967 2.262-4.918 3.443-8.853 3.443-3.443 0-6.296-.689-8.558-1.869-2.754-1.377-4.525-3.541-5.312-6.395l-8.262-28.82-.59-1.869c-.197-.688-.59-1.18-1.082-1.672-.492-.394-1.082-.492-1.672-.394-.59.099-.983.394-1.377.984a3.398 3.398 0 0 0-.492 1.77v2.558zm176.071 34.427-12.787-42.591-.492-.984c-2.361-4.82-6.295-7.18-11.705-7.18-2.951 0-5.607.688-7.967 2.164-2.461 1.475-4.033 3.639-4.92 6.394l-13.082 42.098 11.902.1 12-37.476c.295-1.181.984-1.771 1.869-1.771.492 0 .885.196 1.18.492.297.393.492.787.592 1.279l12.098 37.476h11.312v-.001z"
        })
    });

});

parcelRegister("keghS", function(module, exports) {
$parcel$export(module.exports, "PaypalLogo", function () { return $0fb5b24cc361caa4$export$de02d99730715183; });

var $7VQPk = parcelRequire("7VQPk");
const $0fb5b24cc361caa4$export$de02d99730715183 = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 500 121",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M44,28.51h34.1c18.31,0,25.2,9.26,24.14,22.9C100.52,73.89,86.93,86.33,68.9,86.33H59.8c-2.47,0-4.14,1.63-4.81,6.07l-3.9,25.77c-.26,1.68-1.14,2.66-2.46,2.78H27.25c-2,0-2.73-1.54-2.21-4.88L38.1,33.4C38.63,30.08,40.44,28.51,44,28.51Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M192.08,27c11.5,0,22.12,6.24,20.67,21.79-1.73,18.45-11.67,28.72-27.3,28.76H171.81c-2,0-2.91,1.6-3.43,4.89L165.75,99.2c-.39,2.54-1.69,3.79-3.62,3.79h-12.7c-2,0-2.73-1.29-2.28-4.19l10.5-67.28c.52-3.31,1.78-4.54,4-4.54ZM171.39,63h10.34c6.47-.25,10.77-4.73,11.2-12.81.27-5-3.1-8.56-8.47-8.54l-9.73.05L171.39,63Zm75.88,34.84c1.16-1,2.34-1.6,2.17-.3l-.41,3.12c-.22,1.62.43,2.49,1.95,2.49h11.28c1.9,0,2.83-.77,3.29-3.7l7-43.65c.35-2.19-.18-3.26-1.85-3.26h-12.4c-1.12,0-1.67.62-2,2.33l-.46,2.69c-.24,1.4-.88,1.64-1.48.23-2.1-5-7.47-7.22-15-7.06-17.4.36-29.14,13.57-30.39,30.5-1,13.1,8.42,23.39,20.79,23.39,9,0,13-2.68,17.51-6.78Zm-9.44-6.7c-7.49,0-12.72-6-11.63-13.3a16.2,16.2,0,0,1,15.58-13.3c7.5,0,12.72,6,11.63,13.3a16.21,16.21,0,0,1-15.58,13.3ZM294.6,52.39H283.2c-2.36,0-3.32,1.72-2.57,3.92l14.21,41.6-14,19.79c-1.17,1.65-.27,3.16,1.38,3.16h12.86a4,4,0,0,0,3.83-1.87l43.68-62.68c1.35-1.93.72-4-1.49-4H328.94c-2.09,0-2.93.82-4.12,2.56L306.59,81.35l-8.1-26.49C298,53.23,296.79,52.39,294.6,52.39Z",
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M388.06,27c11.51,0,22.13,6.24,20.67,21.79C407,67.22,397.07,77.49,381.44,77.53H367.8c-2,0-2.91,1.6-3.43,4.89L361.74,99.2c-.4,2.54-1.7,3.79-3.62,3.79h-12.7c-2,0-2.73-1.29-2.28-4.19l10.5-67.28c.51-3.31,1.78-4.54,4-4.54ZM367.38,63h10.34c6.47-.25,10.77-4.73,11.2-12.81.27-5-3.1-8.56-8.47-8.54l-9.74.05L367.38,63Zm75.88,34.84c1.16-1,2.34-1.6,2.17-.3l-.41,3.12c-.22,1.62.43,2.49,2,2.49h11.28c1.9,0,2.82-.77,3.29-3.7l6.95-43.65c.35-2.19-.18-3.26-1.84-3.26H454.24c-1.12,0-1.66.62-1.95,2.33l-.46,2.69c-.24,1.4-.88,1.64-1.48.23-2.11-5-7.47-7.22-15-7.06-17.41.36-29.14,13.57-30.4,30.5-1,13.1,8.42,23.39,20.79,23.39,9,0,13-2.68,17.52-6.78Zm-9.44-6.7c-7.5,0-12.72-6-11.63-13.3a16.2,16.2,0,0,1,15.58-13.3c7.49,0,12.72,6,11.63,13.3a16.21,16.21,0,0,1-15.58,13.3Zm52,12.09h-13a1.53,1.53,0,0,1-1.6-1.8l11.45-72.49a2.25,2.25,0,0,1,2.17-1.8h13a1.53,1.53,0,0,1,1.6,1.8L488,101.42A2.26,2.26,0,0,1,485.86,103.22Z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.72.05H56.86c9.61,0,21,.31,28.64,7,5.1,4.5,7.77,11.66,7.15,19.34C90.56,52.5,75,67.1,54.06,67.1H37.22c-2.86,0-4.76,1.9-5.57,7L27,104c-.3,1.93-1.14,3.08-2.68,3.21h-21c-2.34,0-3.17-1.78-2.56-5.65L15.84,5.72C16.44,1.88,18.54.05,22.72.05Z",
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M32.14,71.13l6-37.73c.53-3.32,2.34-4.89,5.94-4.89h34.1A33.35,33.35,0,0,1,91.92,31C88.5,54.21,73.49,67.1,53.84,67.1H37C34.79,67.1,33.14,68.23,32.14,71.13Z"
            })
        ]
    });

});

parcelRegister("helsO", function(module, exports) {
$parcel$export(module.exports, "SquareLogo", function () { return $15b0470e32db7f40$export$dcc1072f6b07484d; });

var $7VQPk = parcelRequire("7VQPk");
const $15b0470e32db7f40$export$dcc1072f6b07484d = ()=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        opacity: 0.8,
        viewBox: "0 0 2048.9 500",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M318.2,303c0,8.4-6.8,15.2-15.1,15.2H197c-8.3,0-15.1-6.8-15.1-15.2V197c0-8.3,6.8-15.1,15.1-15.1h106.1 c8.3,0,15.1,6.8,15.1,15.1V303z M409.1,382.6c0,14.6-11.9,26.5-26.5,26.5H117.4c-14.6,0-26.5-11.9-26.5-26.5V117.4 c0-14.6,11.9-26.5,26.5-26.5h265.2c14.6,0,26.5,11.9,26.5,26.5V382.6z M416.7,0H83.3C37.5,0,0,37.5,0,83.3v333.3 C0,462.5,37.5,500,83.3,500h333.3c45.8,0,83.3-37.5,83.3-83.3V83.3C500,37.5,462.5,0,416.7,0"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M731.4,414.2c-29.6,0-58.1-11.4-78.2-31.5c-17.9-17.9-27.8-41.1-27.8-65.4h30c0,16.3,6.7,32,19,44.2 c14.5,14.4,35.3,22.7,57,22.7h0.3c41.9,0,75.9-29.3,75.9-65.3c0-27-15-48.5-87.7-65.3c-29.6-6.8-49.5-16-62.8-28.8 c-14.1-13.7-21-31.9-21-55.8c0-47,42.1-85.3,94-85.3c24.8,0,48.2,8.5,65.9,24.1c18.2,16,28.3,37.6,28.3,60.9h-30 c0-30.3-28.8-54.9-64.2-54.9c-34.7,0-64,25.3-64,55.3c0,27.4,9.4,43.5,60.7,55.3c54.7,12.6,110.8,33.8,110.9,94.5 c0,25.8-11.2,50-31.5,68c-19.9,17.6-46.4,27.3-74.4,27.3H731.4z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M995.8,201.4c-53.9,0-92.8,40.2-92.8,93.7c0,53.1,39.8,92.1,92.8,92.1c51.5,0,90.8-41.9,90.8-92.5 C1086.7,244.1,1047.3,201.4,995.8,201.4 M1085,499.6V368.1h-0.8c-19.5,29.8-53,45.2-88.3,45.2c-68,0-121.9-51-121.9-119.4 c0-68,55.2-118.6,121.9-118.6c35.3,0,68.8,15.3,88.3,45.6h0.8v-39.8h29v318.5H1085z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1530.6,201.4c-53.9,0-92.8,40.2-92.8,93.7c0,53.1,39.8,92.1,92.8,92.1c51.4,0,90.8-41.9,90.8-92.5 C1621.3,244.1,1582,201.4,1530.6,201.4 M1619.7,407.9v-39.8h-0.8c-19.9,29.8-53.1,45.2-88.3,45.2c-68,0-121.9-51-121.9-119.4 c0-68,55.1-118.6,121.9-118.6c35.7,0,68.9,15,88.3,45.6h0.8v-39.8h29v226.8H1619.7z"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1735.7,275.2v132.7h-29.1V181.1h29.1v32.8h0.8c12.5-29,34.4-36.5,63.9-38.6V206 C1760.6,209.3,1735.7,234.6,1735.7,275.2"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1930.3,201.4c-45.2,0-81.3,33.2-88.4,77.5H2019C2011.6,234.6,1975.9,201.4,1930.3,201.4 M2048.5,305.1H1842 c2.1,44.8,43.6,82.1,88,82.1c34.8,0,68.8-19.9,81.3-53.5h30.6c-16.5,47.3-61.3,79.6-111.5,79.6c-65.5,0-118.2-53.5-118.2-118.6 c0-64.7,52.7-119.4,117.8-119.4c66.4,0,119,56,119,121.5C2048.9,299.6,2048.5,302.1,2048.5,305.1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M1339.3,408.2v-35.4h-0.8c-13.3,28-42.9,40.9-72.9,40.9c-29.6,0-59.6-10.4-78.3-34.1 c-16.2-20.4-20-47.9-20-73.3V180.3h29.2v125.4c0,47.1,17.1,81.7,69.2,81.7c19.1,0,34.2-5,48.3-18.4c20-19.1,23.7-41.7,23.7-68.3 V180.3h29.2v227.9H1339.3z"
            })
        ]
    });

});



parcelRegister("l7ZAy", function(module, exports) {
$parcel$export(module.exports, "AuxiaSocial", function () { return $94b9107219516ada$export$fe45cc996003fded; });
/* paid-jsm-account-creation-social-auxia.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $ig7Vf = parcelRequire("ig7Vf");

var $gSzjE = parcelRequire("gSzjE");

var $jVa6Y = parcelRequire("jVa6Y");

var $gx3aw = parcelRequire("gx3aw");
const $94b9107219516ada$export$fe45cc996003fded = ({ providers: providers, auxiaResponse: auxiaResponse })=>{
    const intl = (0, $8e22h.default)();
    const { onClickSocialButton: onClickSocialButton } = (0, $jVa6Y.useAccountCreationContext)();
    if (providers === undefined) providers = {
        google: "Google",
        microsoft: "Microsoft",
        apple: "Apple",
        slack: "Slack"
    };
    const buttons = Object.entries(providers);
    const buttonGridCss = null;
    const buttonListCss = null;
    /* eslint-disable jsx-a11y/no-redundant-roles */ /* added role="list" to ul for safari https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility  */ return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        role: "list",
        className: (0, $2jatx.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            buttons.length > 1 && "_1e0c11p5 _zulp7vkz _yv0efsjm"
        ]),
        children: buttons.map(([provider, label])=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jVa6Y.LogoButton), {
                    "aria-label": intl.formatMessage({
                        id: "social.label.signup",
                        defaultMessage: "sign up with {provider}"
                    }, {
                        provider: label
                    }),
                    onClick: ()=>{
                        if ((0, $ig7Vf.isAuxiaServedPage)(auxiaResponse)) {
                            const anonymousId = decodeURIComponent((0, $gx3aw.Cookie).readCookie("ajs_anonymous_id") || "").replace(/['"]+/g, "");
                            (0, $gSzjE.sendAnalyticsToAuxia)({
                                anonymousId: anonymousId,
                                treatmentTrackingId: auxiaResponse.treatmentTrackingId,
                                treatmentId: auxiaResponse.treatmentId,
                                interactionType: "CLICKED",
                                interactionTimeMicros: (0, $gSzjE.convertDateTimeToInteractionTimeMicros)(Date.now()),
                                actionName: `${provider}_login`
                            });
                        }
                        return onClickSocialButton(provider);
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jVa6Y.ProviderLogo), {
                            logo: provider
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            children: label
                        })
                    ]
                })
            }, provider))
    });
};

});

parcelRegister("3Souq", function(module, exports) {
$parcel$export(module.exports, "AuxiaSubmit", function () { return $c17f6bc250444eac$export$f9bc420969cdc1a3; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $ig7Vf = parcelRequire("ig7Vf");

var $gSzjE = parcelRequire("gSzjE");

var $5qUgh = parcelRequire("5qUgh");

var $jVa6Y = parcelRequire("jVa6Y");

var $gx3aw = parcelRequire("gx3aw");
const $c17f6bc250444eac$export$f9bc420969cdc1a3 = ({ buttonText: buttonText, auxiaResponse: auxiaResponse })=>{
    const intl = (0, $8e22h.default)();
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted, formError: formError, onClickSubmitButton: onClickSubmitButton } = (0, $jVa6Y.useAccountCreationContext)();
    if (buttonText === undefined) buttonText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.submit",
        defaultMessage: "Sign up"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
        type: "submit",
        isDisabled: isSubmitting || hasSubmitted && !formError,
        isFullWidth: true,
        isLoading: isSubmitting || hasSubmitted && !formError,
        onClick: ()=>{
            if ((0, $ig7Vf.isAuxiaServedPage)(auxiaResponse)) {
                const anonymousId = decodeURIComponent((0, $gx3aw.Cookie).readCookie("ajs_anonymous_id") || "").replace(/['"]+/g, "");
                (0, $gSzjE.sendAnalyticsToAuxia)({
                    anonymousId: anonymousId,
                    treatmentTrackingId: auxiaResponse.treatmentTrackingId,
                    treatmentId: auxiaResponse.treatmentId,
                    interactionType: "CLICKED",
                    interactionTimeMicros: (0, $gSzjE.convertDateTimeToInteractionTimeMicros)(Date.now()),
                    actionName: "sign_up"
                });
            }
            return onClickSubmitButton();
        },
        children: buttonText
    });
};

});



parcelRegister("cqYjz", function(module, exports) {
$parcel$export(module.exports, "PaidHeroSectionTypes", function () { return $c0ef82fc39e5a653$export$f14a1c5ae1fdb785; });
/* paid-hero-section-types.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
const $c0ef82fc39e5a653$var$heroStyles = {
    "jira-software": "_bfhkuzct _1itk1mj5 _ouxlsfij _12vemgnk _1lrw16om _1rmv1nmc",
    "jira-software-paid-ai": "",
    "jira-software-anchor": "_syazr3uz _bfhkdoyu _1ndau67f _1twl8n31 _r8nt1nn1 _7gaj1h6o",
    "jira-software-rebranded-anchor": "_1pfh1wqb _kqswh2mm _1kt9b3bt _1cs8stnw _iajmgktf _z5wtidpf _1enw53f4 _1rusuzct _1fkrymf6 _7dwz16qr _8kay1h6o _1g0v1oqz _dsq4glyw _aetrb3bt _18postnw _1hfkuzct _19nq1h39 _g0nfuuw1 _1czdidpf _1gufidpf _clh31mo7 _1tlb1h6o _1bqq1oqz _11fnglyw",
    "jira-service-management": "_ct361wug _11q71yp8",
    "jira-service-management-anchor": "_syazr3uz _bfhkdoyu _1ndau67f _1twl8n31 _r8nt1nn1 _7gaj1h6o",
    "confluence-paid": "_16qs1qj0 _1itk1yrd _ouxlroey _12veeva1 _1lrw13e2",
    "confluence-anchor": "_16qs1qj0 _1itkr87c _ouxl1ssb _12vemgnk _1lrw1dfr _1rmvw151 _1f9f8d6s _r2cimgnk _u6yg1f51",
    "confluence-rebranded-anchor": "_1pfh1wqb _kqswh2mm _1kt9b3bt _1cs8stnw _iajmgktf _z5wtidpf _1enw53f4 _1rusuzct _1fkrymf6 _7dwz16qr _8kay1h6o _1g0v1oqz _dsq4glyw _aetrb3bt _18postnw _1hfkuzct _19nq1h39 _g0nfuuw1 _1czdidpf _1gufidpf _clh31mo7 _1tlb1h6o _1bqq1oqz _11fnglyw"
};
const $c0ef82fc39e5a653$var$JSMRebrandedAnchorBackground = null;
const $c0ef82fc39e5a653$var$darkThemeEmailForm = null;
const $c0ef82fc39e5a653$var$defaultHeroStyles = null;
const $c0ef82fc39e5a653$var$padding = null;
const $c0ef82fc39e5a653$export$f14a1c5ae1fdb785 = ({ darkSolidTheme: darkSolidTheme, landingType: landingType, heroComponent: heroComponent, showAnimatedHero: showAnimatedHero, showNewHero: showNewHero })=>{
    const customHero = !darkSolidTheme && showNewHero && $c0ef82fc39e5a653$var$heroStyles[landingType];
    const defaultHero = !darkSolidTheme && !showNewHero && $c0ef82fc39e5a653$var$defaultHeroStyles;
    const isRebrandedJSMHero = darkSolidTheme && showNewHero && landingType === "jira-service-management-anchor";
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        id: "start-trial",
        className: (0, $2jatx.default)([
            showAnimatedHero && darkSolidTheme && "_bfhk17la _syazcd5j _n3c5cd5j _h4c66nkb _4pvyr2ho _1ajj1s4t _235jr2ho _dadmcd5j _128a121t _1ro31q34",
            showAnimatedHero && !darkSolidTheme && showNewHero && $c0ef82fc39e5a653$var$heroStyles[landingType],
            showAnimatedHero && !darkSolidTheme && !showNewHero && "_bfhkuzct _1itk1mj5 _ouxlsfij _12vemgnk _1lrw16om _ij141nmc",
            !showAnimatedHero && $c0ef82fc39e5a653$var$heroStyles[landingType],
            isRebrandedJSMHero && "_bfhk1ism",
            "_1q511wqb"
        ]),
        style: {
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1vwzriw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.yellow")),
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_1oxqp4m": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.yellow300"))
        },
        children: heroComponent
    });
};
$c0ef82fc39e5a653$export$f14a1c5ae1fdb785.displayName = "PaidHero";

});

parcelRegister("cf7Ff", function(module, exports) {
$parcel$export(module.exports, "PaidTabsSection", function () { return $b500bda1d0e4abed$export$4db38360327330ee; });
/* paid-tabs-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $kbpa7 = parcelRequire("kbpa7");
parcelRequire("ispZY");
var $n8zeI = parcelRequire("n8zeI");
const $b500bda1d0e4abed$var$anchorStyles = null;
const $b500bda1d0e4abed$var$jsmAndConfTabsStyles = null;
const $b500bda1d0e4abed$export$4db38360327330ee = (tabsProps)=>{
    const { styles: tabsStyles, landingType: landingType } = tabsProps, otherTabsProps = (0, $aPnCa._)(tabsProps, [
        "styles",
        "landingType"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_11q7cd5j",
            landingType === "jira-software-anchor" && "_wndr138k _irhiangw _jwciangw _x5s11kwk _1hhbidpf _19e6idpf _1rvsidpf _13bjgktf _1m99glyw _ez63b3bt _kljastnw _11p1rdoj _o15y1skh _s0awdlk8 _1rflidpf _4yy7idpf _1mneidpf _1moqidpf _1b72idpf _1sjjidpf _1gum1fm0 _7iau7ogb _1hqaidpf _1bch1ylp _1yb1idpf _79pazwfg _1rhwidpf _iwhj1ylp _ddh0idpf _1fdoidpf _qaxvidpf",
            landingType === "jira-service-management-anchor" && "_wndr138k _irhiangw _jwciangw _x5s11kwk _1hhbidpf _19e6idpf _1rvsidpf _13bjgktf _1m99glyw _ez63b3bt _kljastnw _11p1rdoj _o15y1skh _s0awdlk8 _1rflidpf _4yy7idpf _1mneidpf _1moqidpf _1b72idpf _1sjjidpf _1gum1fm0 _7iau7ogb _1hqaidpf _1bch1ylp _1yb1idpf _79pazwfg _1rhwidpf _iwhj1ylp _ddh0idpf _1fdoidpf _qaxvidpf",
            landingType === "jira-service-management-anchor" && "_kbzo164k _1spxkxyg _balx1vrj _fptx164k",
            landingType === "confluence-rebranded-anchor" && "_wndr138k _irhiangw _jwciangw _x5s11kwk _1hhbidpf _19e6idpf _1rvsidpf _13bjgktf _1m99glyw _ez63b3bt _kljastnw _11p1rdoj _o15y1skh _s0awdlk8 _1rflidpf _4yy7idpf _1mneidpf _1moqidpf _1b72idpf _1sjjidpf _1gum1fm0 _7iau7ogb _1hqaidpf _1bch1ylp _1yb1idpf _79pazwfg _1rhwidpf _iwhj1ylp _ddh0idpf _1fdoidpf _qaxvidpf",
            landingType === "confluence-rebranded-anchor" && "_kbzo164k _1spxkxyg _balx1vrj _fptx164k",
            "tabs-section"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $n8zeI.PaidTabs), (0, $6ogO3._)({}, otherTabsProps))
    });
};
$b500bda1d0e4abed$export$4db38360327330ee.displayName = "PaidTabs";

});
parcelRegister("ispZY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("n8zeI")).PaidTabs; });

var $n8zeI = parcelRequire("n8zeI");

});
parcelRegister("n8zeI", function(module, exports) {
$parcel$export(module.exports, "PaidTabs", function () { return $52515045d7ff7678$export$699a6a05a32d157; });
/* paid-tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("jJLMp");
var $i5Yp0 = parcelRequire("i5Yp0");

var $kaZQn = parcelRequire("kaZQn");

var $jMhSx = parcelRequire("jMhSx");
parcelRequire("a5uC7");
var $leg8m = parcelRequire("leg8m");

var $cDJ3u = parcelRequire("cDJ3u");
const $52515045d7ff7678$var$tabCustomStyles = null;
const $52515045d7ff7678$var$tabSectionTitleStyles = null;
const $52515045d7ff7678$var$singleTabStyles = null;
const $52515045d7ff7678$var$pullQuotesContainerStyles = null;
const $52515045d7ff7678$var$renderChecklist = (tab)=>{
    var _tab_listItems;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $leg8m.default), {
        title: tab.title,
        listItems: (_tab_listItems = tab.listItems) !== null && _tab_listItems !== void 0 ? _tab_listItems : [],
        imageSrc: tab.picture.image.src,
        imageAlt: tab.picture.image.alt
    });
};
const $52515045d7ff7678$var$renderBodyText = (tab)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cDJ3u.default), {
        headerText: tab.title,
        headerType: "h3",
        bodyText: tab.body,
        imageLink: tab.picture.image.src,
        imageAltText: tab.picture.image.alt,
        alignItems: "top",
        rowProps: "4-8",
        className: "simple-image-text-side-tabs"
    });
};
const $52515045d7ff7678$var$generateTabs = (tabsViaProps)=>{
    const transformedTabs = tabsViaProps.map((tab)=>{
        var _tab_listItems;
        var _tab_pullQuote_isShowBorder;
        return {
            textLabel: tab.textLabel,
            id: tab.id,
            component: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
                children: [
                    ((_tab_listItems = tab.listItems) === null || _tab_listItems === void 0 ? void 0 : _tab_listItems.length) ? $52515045d7ff7678$var$renderChecklist(tab) : $52515045d7ff7678$var$renderBodyText(tab),
                    tab.pullQuote && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1q517vkz"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $i5Yp0.PullQuote), {
                            logoSrc: tab.pullQuote.logoSrc,
                            logoAltText: tab.pullQuote.logoAltText,
                            quoteBlurb: tab.pullQuote.quoteBlurb || "",
                            quoteCompany: tab.pullQuote.quoteCompany || "",
                            quoteName: tab.pullQuote.quoteName || "",
                            isShowBorder: (_tab_pullQuote_isShowBorder = tab.pullQuote.isShowBorder) !== null && _tab_pullQuote_isShowBorder !== void 0 ? _tab_pullQuote_isShowBorder : false,
                            isUsingTextQuotationMarks: tab.pullQuote.isUsingTextQuotationMarks
                        })
                    })
                ]
            })
        };
    });
    return transformedTabs;
};
const $52515045d7ff7678$export$699a6a05a32d157 = ({ headerText: headerText, tabStyles: tabStyles, tabs: tabs, tabsConfig: tabsConfig, dataProductKey: dataProductKey, layout: layout = "8" })=>{
    var _tabs_;
    tabs = tabsConfig ? $52515045d7ff7678$var$generateTabs(tabsConfig) : tabs !== null && tabs !== void 0 ? tabs : [];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_19pk1ylp _otyr1wqb _btm9gktf _hywlokh7 _rpgtoxwj _1dl31k92 _1o4gidpf _1g2bidpf _16rridpf _1x1cidpf _1j4q1oe7 _1w42mw4m _1i7w1bqd _1qf41k92 _11451k8s"
        ]),
        children: tabs.length === 1 ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _ca0qidpf _u5f31wqb _n3tdidpf _19bv1wqb _1kmxidpf _1ggmzwfg _1ykzidpf _1maezwfg _11ebviql _1kll1k8s"
            ]),
            children: (_tabs_ = tabs[0]) === null || _tabs_ === void 0 ? void 0 : _tabs_.component
        }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: layout,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_y3gn1h6o _1wyb1k8s _6rth1ylp _k48pbfng _syaz1bqd _1gw8ahaf"
                        ]),
                        children: headerText
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kaZQn.default), {
                    tabContentType: "custom",
                    tabs: tabs,
                    id: "tabs",
                    label: "tabs",
                    colors: tabStyles,
                    dataProductKey: dataProductKey
                })
            ]
        })
    });
};

});





//# sourceMappingURL=confluence-software-anchor-lp-automation.18594751.js.map
